/*
 * @license
 * Palo Alto Theme (c)
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e) {
  "use strict";
  (!(function () {
    const t = { NODE_ENV: "production" };
    try {
      if (process) return ((process.env = Object.assign({}, process.env)), void Object.assign(process.env, t));
    } catch (t) {}
    globalThis.process = { env: t };
  })(),
    (window.theme = window.theme || {}),
    (window.theme.sizes = { mobile: 480, small: 768, large: 1024, widescreen: 1440 }),
    (window.theme.keyboardKeys = {
      TAB: "Tab",
      ENTER: "Enter",
      NUMPADENTER: "NumpadEnter",
      ESCAPE: "Escape",
      SPACE: "Space",
      LEFTARROW: "ArrowLeft",
      RIGHTARROW: "ArrowRight",
    }),
    (window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
    (window.theme.getWindowWidth = function () {
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }),
    (window.theme.getWindowHeight = function () {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    }),
    (window.theme.isDesktop = function () {
      return window.theme.getWindowWidth() >= window.theme.sizes.small;
    }),
    (window.theme.isMobile = function () {
      return window.theme.getWindowWidth() < window.theme.sizes.small;
    }));
  ((window.theme.formatMoney = function (t, e) {
    "string" == typeof t && (t = t.replace(".", ""));
    let i = "";
    const s = /\{\{\s*(\w+)\s*\}\}/,
      o = e || "${{amount}}";
    function n(t, e = 2, i = ",", s = ".") {
      if (isNaN(t) || null == t) return 0;
      const o = (t = (t / 100).toFixed(e)).split(".");
      return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`) + (o[1] ? s + o[1] : "");
    }
    switch (o.match(s)[1]) {
      case "amount":
        i = n(t, 2);
        break;
      case "amount_no_decimals":
        i = n(t, 0);
        break;
      case "amount_with_comma_separator":
        i = n(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        i = n(t, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        i = n(t, 2, "'", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        i = n(t, 0, " ", "");
        break;
      case "amount_with_space_separator":
        i = n(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        i = n(t, 2, " ", ".");
    }
    return o.replace(s, i);
  }),
    (window.theme.debounce = function (t, e) {
      let i;
      return function () {
        if (t) {
          const s = () => t.apply(this, arguments);
          (clearTimeout(i), (i = setTimeout(s, e)));
        }
      };
    }));
  const i = {
      body: "body",
      main: "[data-main]",
      collectionFilters: "[data-collection-filters]",
      footer: '[data-section-type*="footer"]',
      header: "[data-header-height]",
      stickyHeader: '[data-site-header][data-position="fixed"]',
      announcementBar: "[data-announcement-bar]",
      collectionStickyBar: "[data-collection-sticky-bar]",
      logoTextLink: "[data-logo-text-link]",
    },
    s = {
      templateCollection: "template-collection",
      templateSearch: "template-search",
      supportsTransparentHeader: "supports-transparent-header",
    };
  window.theme.getScreenOrientation = function () {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
        ? "landscape"
        : void 0;
  };
  let o = window.theme.getScreenOrientation();
  function n() {
    (document.addEventListener("theme:resize", r),
      window.theme.setVars(),
      document.dispatchEvent(new CustomEvent("theme:vars"), { bubbles: !1 }));
  }
  function r() {
    a(!0);
  }
  function a(t = !1) {
    const e = document.querySelector(i.body),
      n = document.querySelector(i.collectionFilters),
      r = null !== document.querySelector(i.logoTextLink);
    let {
      windowHeight: a,
      headerHeight: l,
      headerInitialHeight: h,
      announcementBarHeight: d,
      footerHeight: u,
      collectionStickyBarHeight: p,
    } = window.theme.readHeights();
    r &&
      (l = (function () {
        (document.documentElement.style.setProperty("--header-height", "auto"),
          document.documentElement.style.setProperty("--header-sticky-height", "auto"));
        const t = document.querySelector(i.header).offsetHeight;
        return (
          requestAnimationFrame(() => {
            (document.documentElement.style.setProperty("--header-height", `${t}px`),
              document.documentElement.style.setProperty("--header-sticky-height", `${t}px`));
          }),
          t
        );
      })());
    const m =
      window.isHeaderTransparent &&
      document.querySelector(i.main).firstElementChild.classList.contains(s.supportsTransparentHeader)
        ? a - d
        : a - h - d;
    let g = c() ? a - window.stickyHeaderHeight : a;
    const y = e.classList.contains(s.templateCollection),
      f = e.classList.contains(s.templateSearch),
      v = (y && n) || (f && n);
    if (
      (document.documentElement.style.setProperty("--footer-height", `${u}px`),
      document.documentElement.style.setProperty("--content-full", `${m}px`),
      document.documentElement.style.setProperty("--content-min", a - l - u + "px"),
      document.documentElement.style.setProperty("--collection-sticky-bar-height", `${p}px`),
      v && (g = a),
      !t)
    )
      return void document.documentElement.style.setProperty("--full-height", `${g}px`);
    const w = window.theme.getScreenOrientation();
    w !== o && (document.documentElement.style.setProperty("--full-height", `${g}px`), (o = w));
  }
  function l(t) {
    const e = document.querySelector(t);
    return e ? e.clientHeight : 0;
  }
  function c() {
    return document.querySelector(i.stickyHeader);
  }
  ((window.theme.readHeights = function () {
    var t, e;
    const s = {};
    return (
      (s.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (s.footerHeight = l(i.footer)),
      (s.headerHeight = l(i.header)),
      (s.stickyHeaderHeight = c() ? window.stickyHeaderHeight : 0),
      (s.headerInitialHeight =
        parseInt(
          (null === (t = document.querySelector(i.header)) || void 0 === t ? void 0 : t.dataset.height) ||
            (null === (e = document.querySelector(i.header)) || void 0 === e ? void 0 : e.offsetHeight),
        ) || 0),
      (s.announcementBarHeight = l(i.announcementBar)),
      (s.collectionStickyBarHeight = l(i.collectionStickyBar)),
      s
    );
  }),
    (window.theme.setVars = function () {
      a();
    }),
    window.addEventListener("DOMContentLoaded", n),
    document.addEventListener("shopify:section:load", n),
    (window.theme.scrollTo = (t) => {
      const { stickyHeaderHeight: e } = window.theme.readHeights();
      window.scrollTo({ top: t + Math.round(window.scrollY) - e, left: 0, behavior: "smooth" });
    }));
  const h = {
    state: { firstFocusable: null, lastFocusable: null, trigger: null, mainTrigger: null },
    trapFocus: function (t) {
      var e = Array.from(
        t.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'),
      ).filter(function (t) {
        var e = t.offsetWidth,
          i = t.offsetHeight;
        return 0 !== e && 0 !== i && "none" !== getComputedStyle(t).getPropertyValue("display");
      });
      ((e = e.filter(function (t) {
        return !t.classList.contains("deferred-media__poster");
      })),
        (this.state.firstFocusable = e[0]),
        (this.state.lastFocusable = e[e.length - 1]),
        t.elementToFocus || (t.elementToFocus = this.state.firstFocusable || t.container),
        this._setupHandlers(),
        document.addEventListener("focusin", this._onFocusInHandler),
        document.addEventListener("focusout", this._onFocusOutHandler),
        t.container.setAttribute("tabindex", "-1"),
        t.elementToFocus.focus());
    },
    removeTrapFocus: function (t) {
      const e = !document.body.classList.contains("no-outline");
      (t && t.container && t.container.removeAttribute("tabindex"),
        document.removeEventListener("focusin", this._onFocusInHandler),
        this.state.trigger && e && this.state.trigger.focus());
    },
    _manageFocus: function (t) {
      t.code === theme.keyboardKeys.TAB &&
        (t.target !== this.state.lastFocusable || t.shiftKey || (t.preventDefault(), this.state.firstFocusable.focus()),
        t.target === this.state.firstFocusable && t.shiftKey && (t.preventDefault(), this.state.lastFocusable.focus()));
    },
    _onFocusOut: function () {
      document.removeEventListener("keydown", this._manageFocusHandler);
    },
    _onFocusIn: function (t) {
      (t.target !== this.state.lastFocusable && t.target !== this.state.firstFocusable) ||
        document.addEventListener("keydown", this._manageFocusHandler);
    },
    _setupHandlers: function () {
      (this._onFocusInHandler || (this._onFocusInHandler = this._onFocusIn.bind(this)),
        this._onFocusOutHandler || (this._onFocusOutHandler = this._onFocusIn.bind(this)),
        this._manageFocusHandler || (this._manageFocusHandler = this._manageFocus.bind(this)));
    },
  };
  ((window.theme = window.theme || {}),
    (window.theme.a11y = h),
    (window.theme.throttle = (t, e) => {
      let i, s;
      return function o(...n) {
        const r = Date.now();
        ((s = clearTimeout(s)),
          !i || r - i >= e ? (t.apply(null, n), (i = r)) : (s = setTimeout(o.bind(null, ...n), e - (r - i))));
      };
    }),
    (window.theme.wrap = (t, e = "", i) => {
      const s = i || document.createElement("div");
      return (
        s.classList.add(e),
        s.setAttribute("data-scroll-lock-scrollable", ""),
        t.parentNode.insertBefore(s, t),
        s.appendChild(t)
      );
    }),
    (window.theme.wrapElements = function (t) {
      t.querySelectorAll("table").forEach((t) => {
        window.theme.wrap(t, "table-wrapper");
      });
    }),
    window.addEventListener("DOMContentLoaded", window.theme.wrapElements(document)),
    document.addEventListener("shopify:section:load", (t) => window.theme.wrapElements(t.target)));
  const d = {};
  function u(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return d[t.url]
        ? d[t.url]
        : (function (t, e) {
            const i = new Promise((i, s) => {
              "text" === e
                ? fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      i(t);
                    })
                    .catch((t) => {
                      s(t);
                    })
                : (function (t, e, i) {
                    let s = document.getElementsByTagName("head")[0],
                      o = !1,
                      n = document.createElement("script");
                    ((n.src = t),
                      (n.onload = n.onreadystatechange =
                        function () {
                          o || (this.readyState && "loaded" != this.readyState && "complete" != this.readyState)
                            ? i()
                            : ((o = !0), e());
                        }),
                      s.appendChild(n));
                  })(
                    t,
                    function () {
                      i();
                    },
                    function () {
                      s();
                    },
                  );
            });
            return ((d[t] = i), i);
          })(t.url, t.type);
    if (t.json)
      return d[t.json]
        ? Promise.resolve(d[t.json])
        : window
            .fetch(t.json)
            .then((t) => t.json())
            .then((e) => ((d[t.json] = e), e));
    if (t.name) {
      const e = "".concat(t.name, t.version);
      return d[e]
        ? d[e]
        : (function (t) {
            const e = "".concat(t.name, t.version),
              i = new Promise((e, i) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: (t) => {
                        !(function (t, e, i) {
                          i ? e(i) : t();
                        })(e, i, t);
                      },
                    },
                  ]);
                } catch (t) {
                  i(t);
                }
              });
            return ((d[e] = i), i);
          })(t);
    }
    return Promise.reject();
  }
  ((window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1));
  const p = "[data-video-id]",
    m = "loaded",
    g = "data-enable-sound",
    y = "data-enable-background",
    f = "data-enable-autoplay",
    v = "data-enable-loop",
    w = "data-video-id",
    b = "data-video-type";
  const S = {
      videoIframe: "[data-video-id]",
      videoWrapper: ".video-wrapper",
      youtubeWrapper: "[data-youtube-wrapper]",
    },
    E = "data-section-id",
    L = "data-enable-sound",
    k = "data-check-player-visibility",
    A = "data-video-id",
    C = "data-video-type",
    q = "loaded",
    T = [];
  const P = "[data-notification-form]",
    x = "[data-notification]",
    I = "[data-popup-close]",
    H = "pswp--success",
    F = "notification-popup-visible";
  const M = "html5",
    D = "youtube",
    O = "vimeo",
    B = "[data-deferred-media]",
    z = "[data-deferred-media-button]",
    _ = "[data-product-single-media-wrapper]",
    $ = "[data-video]",
    R = ".media--hidden",
    V = "media--hidden",
    N = "loaded",
    W = "data-section-id",
    U = "data-autoplay-video",
    j = "data-media-id";
  let G = class {
    init() {
      this.container.querySelectorAll($).forEach((t) => {
        const e = t.querySelector(z);
        (e && e.addEventListener("click", this.loadContent.bind(this, t)), this.autoplayVideo && this.loadContent(t));
      });
    }
    loadContent(t) {
      if (t.querySelector(B).getAttribute(N)) return;
      const e = document.createElement("div");
      e.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
      const i = t.dataset.mediaId,
        s = e.querySelector("video, iframe"),
        o = this.hostFromVideoElement(s),
        n = t.querySelector(B);
      (n.appendChild(s),
        n.setAttribute("loaded", !0),
        (this.players[i] = {
          mediaId: i,
          sectionId: this.id,
          container: t,
          element: s,
          host: o,
          ready: () => {
            this.createPlayer(i);
          },
        }));
      const r = this.players[i];
      switch (r.host) {
        case M:
          this.loadVideo(r, M);
          break;
        case O:
          window.isVimeoAPILoaded
            ? this.loadVideo(r, O)
            : u({ url: "https://player.vimeo.com/api/player.js" }).then(() => this.loadVideo(r, O));
          break;
        case D:
          window.isYoutubeAPILoaded
            ? this.loadVideo(r, D)
            : u({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadVideo(r, D));
      }
    }
    hostFromVideoElement(t) {
      if ("VIDEO" === t.tagName) return M;
      if ("IFRAME" === t.tagName) {
        if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(t.src)) return D;
        if (t.src.includes("vimeo.com")) return O;
      }
      return null;
    }
    loadVideo(t, e) {
      t.host === e && t.ready();
    }
    createPlayer(t) {
      const e = this.players[t];
      switch (e.host) {
        case M:
          (e.element.addEventListener("play", () => {
            e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
          }),
            e.element.addEventListener("pause", () => {
              e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
            }),
            this.autoplayVideo && this.observeVideo(e, t));
          break;
        case O:
          ((e.player = new Vimeo.Player(e.element)),
            e.player.play(),
            e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }),
            (window.isVimeoAPILoaded = !0),
            e.player.on("play", () => {
              e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
            }),
            e.player.on("pause", () => {
              e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
            }),
            this.autoplayVideo && this.observeVideo(e, t));
          break;
        case D:
          if (e.host == D && e.player) return;
          YT.ready(() => {
            const i = e.container.dataset.videoId;
            ((e.player = new YT.Player(e.element, {
              videoId: i,
              events: {
                onReady: (t) => {
                  (t.target.playVideo(),
                    e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }));
                },
                onStateChange: (t) => {
                  (1 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }),
                    2 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 }),
                    0 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 }));
                },
              },
            })),
              (window.isYoutubeAPILoaded = !0),
              this.autoplayVideo && this.observeVideo(e, t));
          });
      }
      (e.container.addEventListener("theme:media:visible", (t) => this.onVisible(t)),
        e.container.addEventListener("theme:media:hidden", (t) => this.onHidden(t)),
        e.container.addEventListener("xrLaunch", (t) => this.onHidden(t)));
    }
    observeVideo(t) {
      new IntersectionObserver(
        (e, i) => {
          e.forEach((e) => {
            const i = 0 == e.intersectionRatio,
              s = !t.element.closest(R);
            i ? this.pauseVideo(t) : s && this.playVideo(t);
          });
        },
        { rootMargin: "200px", threshold: [0, 0.25, 0.75, 1] },
      ).observe(t.element);
    }
    playVideo(t) {
      (t.player && t.player.playVideo
        ? t.player.playVideo()
        : t.element && t.element.play
          ? t.element.play()
          : t.player && t.player.play && t.player.play(),
        t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }));
    }
    pauseVideo(t) {
      if (t.player && t.player.pauseVideo) "1" == t.player.playerInfo.playerState && t.player.pauseVideo();
      else if (t.player && t.player.pause) t.player.pause();
      else if (t.element && !t.element.paused) {
        var e;
        if ("function" == typeof t.element.pause) null === (e = t.element) || void 0 === e || e.pause();
      }
    }
    onHidden(t) {
      if (void 0 !== t.target.dataset.mediaId) {
        const e = t.target.dataset.mediaId,
          i = this.players[e];
        this.pauseVideo(i);
      }
    }
    onVisible(t) {
      if (void 0 !== t.target.dataset.mediaId) {
        const e = t.target.dataset.mediaId,
          i = this.players[e];
        (setTimeout(() => {
          this.playVideo(i);
        }, 50),
          this.pauseContainerMedia(e));
      }
    }
    pauseOtherMedia(t, e) {
      const i = `[${j}="${t}"]`,
        s = e.querySelectorAll(`${_}:not(${i})`);
      s.length &&
        s.forEach((t) => {
          (t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(V));
        });
    }
    constructor(t) {
      ((this.container = t),
        (this.id = this.container.getAttribute(W)),
        (this.autoplayVideo = "true" === this.container.getAttribute(U)),
        (this.players = {}),
        (this.pauseContainerMedia = (t, e = this.container) => this.pauseOtherMedia(t, e)),
        this.init());
    }
  };
  const K = "[data-collapsible]",
    Q = "toggle-ellipsis",
    X = "[data-content]",
    Y = "[data-actions]",
    J = "[data-height]",
    Z = "[data-collapsible-content]",
    tt = "[data-collapsible-container]",
    et = "[data-collapsible-single]",
    it = "[data-collapsible-trigger]",
    st = "is-expanded",
    ot = "is-open",
    nt = "aria-expanded",
    rt = "aria-controls",
    at = "data-collapsible-trigger-mobile",
    lt = "data-collapsible-transition-override",
    ct = 500,
    ht = {};
  let dt = class {
    init() {
      (window.addEventListener("theme:resize:width", this.onResizeEvent),
        this.triggers.forEach((t) => {
          (t.addEventListener("click", this.collapsibleToggleEvent),
            t.addEventListener("keyup", this.collapsibleToggleEvent));
        }),
        this.container.addEventListener("theme:ellipsis:toggle", (t) => {
          this.handleEllipsisToggle(t);
        }));
    }
    handleEllipsisToggle(t) {
      const { dropdownHeight: e = 0, isExpanded: i = !1 } = t.detail,
        s = t.target.closest(K);
      if (!s) return;
      const o = s.querySelector(it);
      if (!o) return;
      const n = o.getAttribute(rt),
        r = document.getElementById(n);
      if (!r) return;
      const a = s.querySelector(J),
        l = (a && parseInt(a.dataset.height, 10)) || 0;
      this.setDropdownHeight(r, i ? e : l);
    }
    collapsibleToggle(t) {
      t.preventDefault();
      const e = t.target.matches(it) ? t.target : t.target.closest(it),
        i = e.getAttribute(rt),
        s = document.getElementById(i),
        o = e.hasAttribute(at),
        n = e.classList.contains(st),
        r = t.code === theme.keyboardKeys.SPACE,
        a = t.code === theme.keyboardKeys.ESCAPE,
        l = window.innerWidth < theme.sizes.small;
      (this.isTransitioning && !this.transitionOverride) ||
        ((!t.code || r || a) &&
          ((!n && a) ||
            (o && !l) ||
            ((this.isTransitioning = !0),
            (e.disabled = !0),
            this.single && this.closeOtherItems(e),
            requestAnimationFrame(() => {
              n ? this.closeItem(s, e) : this.openItem(s, e);
            }))));
    }
    closeOtherItems(t) {
      const e = t.closest(et);
      this.triggers.forEach((i) => {
        if (t === i || !i.classList.contains(st)) return;
        const s = i.closest(et);
        if (e !== s) return;
        const o = document.getElementById(i.getAttribute(rt));
        requestAnimationFrame(() => this.closeItem(o, i));
      });
    }
    openItem(t, e) {
      const i = t.querySelector(Z).offsetHeight;
      (this.setDropdownHeight(t, i),
        this.handleTransitioning(t, !0),
        this.updateAttributes(e, t, !0),
        e.dispatchEvent(new CustomEvent("theme:form:sticky", { bubbles: !0, detail: { element: "accordion" } })));
    }
    closeItem(t, e) {
      let i = t.querySelector(Z).offsetHeight;
      (this.setDropdownHeight(t, i),
        this.handleTransitioning(t, !1),
        this.updateAttributes(e, t, !1),
        requestAnimationFrame(() => {
          ((i = 0), this.setDropdownHeight(t, 0));
        }));
    }
    setDropdownHeight(t, e) {
      t.style.height = `${e}px`;
    }
    handleTransitioning(t, e = !1) {
      (this.resetHeightTimer && clearTimeout(this.resetHeightTimer),
        e
          ? (this.resetHeightTimer = setTimeout(() => {
              (t.querySelector(Q) || (t.style.height = "auto"), (this.isTransitioning = !1));
            }, ct))
          : ((this.isTransitioning = !1),
            (this.resetHeightTimer = setTimeout(() => {
              t.style.height = "";
            }, ct))));
    }
    updateAttributes(t, e, i) {
      (e.classList.toggle(st, i),
        t.setAttribute(nt, i),
        t.classList.toggle(st, i),
        setTimeout(() => {
          t.disabled = !1;
        }, ct));
    }
    onResize() {
      if (!this.container.querySelector(`.${st}`)) return;
      const t = Array.from(document.querySelectorAll(`${K}:has(.${st})`)),
        e = document.querySelectorAll(`${K}:has(${Q}.${ot})`);
      (t.forEach((t) => {
        const e = t.querySelector(Q);
        (null == e ? void 0 : e.classList.contains(ot)) && this.updateDropdownHeight(t);
      }),
        e.forEach((e) => {
          t.includes(e) || this.updateDropdownHeight(e, !0);
        }));
    }
    onUnload() {
      (this.triggers.forEach((t) => {
        (t.removeEventListener("click", this.collapsibleToggleEvent),
          t.removeEventListener("keyup", this.collapsibleToggleEvent));
      }),
        window.removeEventListener("theme:resize:width", this.onResizeEvent));
    }
    constructor(t) {
      var e, i, s;
      ((s = (t, e = !1) => {
        const i = t.querySelector(tt),
          s = t.querySelector(Q),
          o = s.querySelector(Y),
          n = s.querySelector(X).offsetHeight + 2 * o.offsetHeight;
        (e || this.setDropdownHeight(i, n), s.style.setProperty("--height", `${n}px`));
      }),
        (i = "updateDropdownHeight") in (e = this)
          ? Object.defineProperty(e, i, { value: s, enumerable: !0, configurable: !0, writable: !0 })
          : (e[i] = s),
        (this.container = t),
        (this.single = this.container.querySelector(et)),
        (this.triggers = this.container.querySelectorAll(it)),
        (this.resetHeightTimer = 0),
        (this.isTransitioning = !1),
        (this.transitionOverride = this.container.hasAttribute(lt)),
        (this.collapsibleToggleEvent = (t) => window.theme.throttle(this.collapsibleToggle(t), 1250)),
        (this.onResizeEvent = () => this.onResize()),
        this.init());
    }
  };
  const ut = {
      onLoad() {
        ht[this.id] = new dt(this.container);
      },
      onUnload() {
        ht[this.id].onUnload();
      },
    },
    pt = {
      aos: "[data-aos]:not(.aos-animate)",
      aosAnchor: "[data-aos-anchor]",
      animatable: "[data-aos], [data-aos-anchor]",
      watchMutations:
        '[id^="api-cart-items-"], [data-collection-filters], [data-collection-products], #AjaxinateLoop, [data-tab="resultsProducts"]',
      textHighlight: "text-highlight",
      counterUps: "text-count-up",
      flickitySlider: ".flickity-slider",
      slide: "[data-slide]",
      carouselMobile: ".carousel--mobile",
    },
    mt = { aosAnimate: "aos-animate", isLoading: "is-loading", isSelected: ".is-selected" },
    gt = {
      aos: "data-aos",
      aosAnchor: "data-aos-anchor",
      aosIntersection: "data-aos-intersection",
      aosDebounce: "data-aos-debounce",
      aosCustomInit: "data-aos-custom-init",
      aosWatchAnchors: "data-aos-watch-anchors",
      aosTrigger: "data-aos-trigger",
      aosCarouselMobile: "data-aos-carousel-mobile",
      aosCarouselDesktop: "data-aos-carousel-desktop",
    },
    yt = 0.1,
    ft = 0;
  let vt = new Set();
  function wt(t) {
    t.length &&
      (t.forEach((t) => {
        const e = t.dataset.aosAnchor;
        let i;
        ("" != e && (i = document.querySelector(e)), i && !vt.has(t) && vt.add(i));
      }),
      vt.forEach((t) => {
        bt.observe(t);
      }));
  }
  const bt = new IntersectionObserver(
    (t, e) => {
      t.forEach((t) => {
        const i = t.target,
          s = t.intersectionRatio,
          o = t.isIntersecting;
        let n,
          r = yt;
        i.hasAttribute(gt.aosIntersection) && (r = Number(i.getAttribute(gt.aosIntersection)));
        let a = ft;
        (i.hasAttribute(gt.aosDebounce) && (a = Number(i.getAttribute(gt.aosDebounce))),
          o &&
            s > r &&
            (0 !== a ? (n && clearTimeout(n), (n = setTimeout(() => St(i), a))) : St(i), e.unobserve(i), vt.delete(i)));
      });
    },
    { root: null, rootMargin: "0px", threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.5, 0.75, 1] },
  );
  function St(t) {
    if (!t) return;
    if ((Et(t), t.hasAttribute(gt.aosCarouselDesktop) && window.theme.isDesktop())) {
      if (t.querySelector(pt.flickitySlider)) {
        const e = t.querySelectorAll(pt.slide),
          i = [...e].filter((t) => {
            if (t.matches(mt.isSelected)) return t;
          }),
          s = [...e].filter((t) => {
            if (!t.matches(mt.isSelected)) return t;
          });
        if (i.length > 0) {
          const t = i[i.length - 1].id;
          (i[i.length - 1].setAttribute(gt.aosTrigger, `#${t}`),
            s.forEach((e) => {
              e.querySelectorAll(pt.animatable).forEach((e) => {
                e.setAttribute(gt.aosAnchor, `#${t}`);
              });
            }));
        }
      }
    }
    if (t.hasAttribute(gt.aosCarouselMobile) && window.theme.isMobile()) {
      const e = t.querySelector(pt.carouselMobile);
      if (e) {
        const t = [...e.children],
          i = t[0].id;
        t.length > 1 &&
          (t[0].setAttribute(gt.aosTrigger, `#${i}`),
          t.forEach((t) => {
            t.querySelectorAll(pt.animatable).forEach((t) => {
              t.setAttribute(gt.aosAnchor, `#${i}`);
            });
          }));
      }
    }
    if (t.hasAttribute(gt.aosTrigger)) {
      const e = t.getAttribute(gt.aosTrigger);
      document.querySelectorAll(`[${gt.aosAnchor}="${e}"]`).forEach((t) => Et(t));
    }
    let e = t.querySelectorAll(pt.aos);
    if (t.hasAttribute(gt.aosWatchAnchors)) {
      e = [...e].filter((e) => {
        const i = !!e.hasAttribute(gt.aosAnchor) && e.getAttribute(gt.aosAnchor);
        if (i && `#${t.id}` === i) return e;
      });
    }
    e.forEach((e) => {
      e.hasAttribute(gt.aosCustomInit)
        ? t.dispatchEvent(new CustomEvent("theme:target:animate", { bubbles: !0, detail: e }))
        : Et(e);
    });
  }
  function Et(t) {
    (requestAnimationFrame(() => t.classList.add(mt.aosAnimate)),
      (function (t) {
        const e = t.querySelectorAll(pt.textHighlight);
        e.forEach((t) => t.shouldAnimate());
      })(t),
      (function (t) {
        const e = t.querySelectorAll(pt.counterUps);
        e.forEach((t) => t.shouldAnimate());
      })(t));
  }
  function Lt() {
    (wt(document.querySelectorAll(pt.aosAnchor)),
      (function () {
        const t = (t) => t instanceof HTMLElement;
        new MutationObserver((e) => {
          for (const i of e) {
            if ("childList" === !i.type) return;
            const e = i.target,
              s = [...i.addedNodes],
              o = [...i.removedNodes],
              n =
                e.matches(pt.watchMutations) ||
                s.some((e) => !!t(e) && e.matches(pt.watchMutations)) ||
                o.some((e) => !!t(e) && e.matches(pt.watchMutations)),
              r = e.matches(pt.animatable) || s.some((e) => !!t(e) && e.matches(pt.animatable)),
              a = null !== e.querySelector(`[${gt.aosAnchor}="#${e.id}"]`);
            (r || a || n) && wt(e.querySelectorAll(pt.aosAnchor));
          }
        }).observe(document.body, { attributes: !1, childList: !0, subtree: !0 });
      })());
  }
  function kt(t, e, i = [], s = !1) {
    const o = new FormData(t),
      n = new URLSearchParams(o);
    if (!e) return n.toString();
    const r = new FormData(e),
      a = new URLSearchParams(r),
      l = [];
    for (const t of o.entries()) "" === t[1] && l.push(t[0]);
    for (const t of r.entries()) "" === t[1] && l.push(t[0]);
    for (let t = 0; t < l.length; t++) {
      const e = l[t];
      (n.has(e) && n.delete(e), a.has(e) && a.delete(e));
    }
    for (const t of n.keys()) a.has(t) && a.delete(t);
    if (i.length > 0)
      for (let t = 0; t < i.length; t++) {
        const e = i[t];
        (n.has(e) && n.delete(e), a.has(e) && a.delete(e));
      }
    return (s && (a.has("type") && a.delete("type"), n.set("type", s)), `${n.toString()}&${a.toString()}`);
  }
  const At = "[data-custom-scrollbar]",
    Ct = "[data-custom-scrollbar-items]",
    qt = "[data-custom-scrollbar-thumb]",
    Tt = ".current";
  let Pt = class {
    calculateTrack(t) {
      if (!t)
        return (
          this.scrollbar.style.setProperty("--thumb-scale", 0),
          void this.scrollbar.style.setProperty("--thumb-position", "0px")
        );
      const e = t.clientWidth / this.scrollbarThumb.parentElement.clientWidth,
        i = t.offsetLeft / this.scrollbarThumb.parentElement.clientWidth;
      (this.scrollbar.style.setProperty("--thumb-scale", e),
        this.scrollbar.style.setProperty("--thumb-position", this.trackWidth * i + "px"));
    }
    calculateScrollbar() {
      if (this.scrollbarItems.children.length) {
        const t = [...this.scrollbarItems.children];
        ((this.trackWidth = 0),
          t.forEach((t) => {
            this.trackWidth += t.getBoundingClientRect().width + parseInt(window.getComputedStyle(t).marginRight);
          }),
          this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}px`));
      }
    }
    onScrollbarChange(t) {
      t &&
        t.detail &&
        t.detail.element &&
        this.container.contains(t.detail.element) &&
        this.calculateTrack(t.detail.element);
    }
    events() {
      (document.addEventListener("theme:resize:width", this.calcScrollbarEvent),
        document.addEventListener("theme:custom-scrollbar:change", this.onScrollbarChangeEvent));
    }
    unload() {
      (document.removeEventListener("theme:resize:width", this.calcScrollbarEvent),
        document.removeEventListener("theme:custom-scrollbar:change", this.onScrollbarChangeEvent));
    }
    constructor(t) {
      ((this.container = t),
        (this.scrollbarItems = t.querySelector(Ct)),
        (this.scrollbar = t.querySelector(At)),
        (this.scrollbarThumb = t.querySelector(qt)),
        (this.trackWidth = 0),
        (this.calcScrollbarEvent = () => this.calculateScrollbar()),
        (this.onScrollbarChangeEvent = (t) => this.onScrollbarChange(t)),
        this.scrollbar &&
          this.scrollbarItems &&
          (this.events(),
          this.calculateScrollbar(),
          this.scrollbarItems.children.length && this.calculateTrack(this.scrollbarItems.querySelector(Tt))));
    }
  };
  const xt = "[data-tooltip]",
    It = "[data-tooltip-container]",
    Ht = "[data-aos]",
    Ft = "tooltip-default",
    Mt = "is-animating",
    Dt = "is-visible",
    Ot = "is-hiding",
    Bt = "data-aos",
    zt = "data-tooltip",
    _t = "data-tooltip-container",
    $t = "data-tooltip-stop-mouseenter",
    Rt = {};
  let Vt = class {
    init() {
      if (!document.querySelector(It)) {
        const t = `<div class="${this.rootClass}__arrow"></div><div class="${this.rootClass}__inner"><div class="${this.rootClass}__text label-typography"></div></div>`,
          e = document.createElement("div");
        ((e.className = `${this.rootClass} ${this.isAnimatingClass}`),
          e.setAttribute(_t, ""),
          (e.innerHTML = t),
          document.body.appendChild(e));
      }
      (this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
        this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
        document.addEventListener("theme:tooltip:close", this.removePinEvent));
      const t = document.querySelector(It);
      theme.settings.animationsEnabled &&
        this.animatedContainer &&
        ("hero" === this.animatedContainer.getAttribute(Bt)
          ? this.animatedContainer.addEventListener("animationend", () => {
              t.classList.remove(Mt);
            })
          : this.animatedContainer.addEventListener("transitionend", (e) => {
              "transform" === e.propertyName && t.classList.remove(Mt);
            }));
    }
    addPin(t = !1) {
      const e = document.querySelector(It);
      if (e && ((t && !this.tooltip.hasAttribute($t)) || !t)) {
        const t = e.querySelector(`.${this.rootClass}__arrow`),
          i = e.querySelector(`.${this.rootClass}__inner`),
          s = e.querySelector(`.${this.rootClass}__text`);
        (this.label.includes("ß") &&
          (this.label = this.label.replace(/ß/g, '<span style="text-transform: lowercase;">ß</span>')),
          (s.innerHTML = this.label));
        const o = i.offsetWidth,
          n = this.tooltip.getBoundingClientRect(),
          r = n.top,
          a = n.width,
          l = r + n.height + window.scrollY;
        let c = n.left - o / 2 + a / 2;
        const h = 24,
          d = c + o - window.theme.getWindowWidth() + h;
        (d > 0 && (c -= d),
          c < 0 && (c = 0),
          (t.style.left = `${n.left + a / 2}px`),
          e.style.setProperty("--tooltip-top", `${l}px`),
          (i.style.transform = `translateX(${c}px)`),
          e.classList.remove(Ot));
        const u = (t) => {
          t.target === i &&
            (("transform" !== t.propertyName && "opacity" !== t.propertyName) ||
              requestAnimationFrame(() => (e.style.transform = "translate(0, -100%)")),
            e.removeEventListener("transitionend", u));
        };
        (e.addEventListener("transitionend", u),
          e.classList.add(Dt),
          document.addEventListener("theme:scroll", this.removePinEvent));
      }
    }
    removePin(t, e = !1, i = !1) {
      const s = document.querySelector(It),
        o = s.classList.contains(Dt);
      s &&
        ((e && !this.tooltip.hasAttribute($t)) || !e) &&
        (o &&
          (i || t.detail.hideTransition) &&
          (s.classList.add(Ot),
          this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
          (this.hideTransitionTimeout = setTimeout(() => {
            s.classList.remove(Ot);
          }, this.transitionSpeed))),
        s.classList.remove(Dt),
        document.removeEventListener("theme:scroll", this.removePinEvent));
    }
    unload() {
      (this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent),
        this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent),
        document.removeEventListener("theme:tooltip:close", this.removePinEvent),
        document.removeEventListener("theme:scroll", this.removePinEvent));
    }
    constructor(t) {
      ((this.tooltip = t),
        this.tooltip.hasAttribute(zt) &&
          ((this.rootClass = Ft),
          (this.isAnimatingClass = Mt),
          (this.label = this.tooltip.getAttribute(zt)),
          (this.transitionSpeed = 200),
          (this.hideTransitionTimeout = 0),
          (this.animatedContainer = this.tooltip.closest(Ht)),
          (this.addPinEvent = () => this.addPin()),
          (this.addPinMouseEvent = () => this.addPin(!0)),
          (this.removePinEvent = (t) => window.theme.throttle(this.removePin(t), 50)),
          (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
          this.init()));
    }
  };
  const Nt = {
      onLoad() {
        Rt[this.id] = [];
        this.container.querySelectorAll(xt).forEach((t) => {
          Rt[this.id].push(new Vt(t));
        });
      },
      onUnload() {
        Rt[this.id].forEach((t) => {
          "function" == typeof t.unload && t.unload();
        });
      },
    },
    Wt = "[data-range-slider]",
    Ut = "[data-range-left]",
    jt = "[data-range-right]",
    Gt = "[data-range-line]",
    Kt = "[data-range-holder]",
    Qt = "data-se-min",
    Xt = "data-se-max",
    Yt = "data-se-min-value",
    Jt = "data-se-max-value",
    Zt = "data-se-step",
    te = "data-range-filter-update",
    ee = "[data-field-price-min]",
    ie = "[data-field-price-max]",
    se = "is-initialized";
  function oe() {
    this.entries = [];
  }
  function ne(t, e) {
    re(t);
    var i = (function (t, e) {
      (re(t),
        (function (t) {
          if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
          if (0 === t.length) throw new Error(t + " is empty.");
          if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
          if ("string" != typeof t[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " + t[0].name + ". Value should be string.",
            );
        })(e));
      var i = [];
      return (
        e.forEach(function (e) {
          for (var s = 0; s < t.options.length; s++) {
            if ((t.options[s].name || t.options[s]).toLowerCase() === e.name.toLowerCase()) {
              i[s] = e.value;
              break;
            }
          }
        }),
        i
      );
    })(t, e);
    return (function (t, e) {
      (re(t),
        (function (t) {
          if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.");
        })(e));
      var i = t.variants.filter(function (t) {
        return e.every(function (e, i) {
          return t.options[i] === e;
        });
      });
      return i[0] || null;
    })(t, i);
  }
  function re(t) {
    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.");
  }
  ((oe.prototype.add = function (t, e, i) {
    (this.entries.push({ element: t, event: e, fn: i }), t.addEventListener(e, i));
  }),
    (oe.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return (t.element.removeEventListener(t.event, t.fn), !1);
      });
    }));
  var ae = '[name="id"]',
    le = '[name="selling_plan"]',
    ce = '[name^="options"]',
    he = '[name="quantity"]',
    de = '[name^="properties"]';
  const ue = { color: "ash" },
    pe = "[data-swatch]",
    me = "[data-product-block]",
    ge = "[data-product-image-hover]",
    ye = "[data-button-quick-view]",
    fe = "[data-grid-image]",
    ve = "[data-grid-link]",
    we = "[data-swatches-more]",
    be = "[data-section-type]",
    Se = "[data-swatches-container]",
    Ee = "[data-swatches-label]",
    Le = "[data-swatches-button]",
    ke = "[data-option-position]",
    Ae = "[data-slider]",
    Ce = ".variant__labels--hide",
    qe = {
      mediaVisible: "product__media--featured-visible",
      mediaHoverVisible: "product__media__hover-img--visible",
      noImage: "swatch__link--no-image",
      noOutline: "no-outline",
      isVisible: "is-visible",
      selectorLarge: "selector-wrapper--large",
    },
    Te = "data-swatch",
    Pe = "data-swatch-handle",
    xe = "data-swatch-label",
    Ie = "data-swatch-image",
    He = "data-swatch-image-id",
    Fe = "data-swatch-variant",
    Me = "data-variant-id",
    De = "data-variant-secondary-id";
  let Oe = {};
  const Be = {};
  let ze = class {
      init() {
        (this.setStyles(),
          this.variant && this.outer && this.handleClicks(),
          !this.image && this.swatchLink && this.swatchLink.classList.add(qe.noImage));
      }
      setStyles() {
        "native" == window.theme.settings.colorSwatchesType ||
          (this.colorMatch &&
            this.colorMatch.hex &&
            this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
          this.colorMatch &&
            this.colorMatch.path &&
            this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`));
      }
      handleClicks() {
        (this.swatchLink.addEventListener("click", (t) => {
          const e = !document.body.classList.contains(qe.noOutline),
            i = this.swatchLink.getAttribute(Fe);
          e || (t.preventDefault(), this.updateImagesAndLinksOnEvent(i));
        }),
          this.swatchLink.addEventListener("keyup", (t) => {
            const e = !document.body.classList.contains(qe.noOutline),
              i = this.swatchLink.getAttribute(Fe);
            (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER) ||
              e ||
              (t.preventDefault(),
              this.swatchLink.dispatchEvent(new Event("mouseenter", { bubbles: !0 })),
              this.updateImagesAndLinksOnEvent(i));
          }));
      }
      updateImagesAndLinksOnEvent(t) {
        (this.updateLinks(), this.replaceImages(t));
      }
      updateLinks() {
        ((this.linkElements = this.outer.querySelectorAll(ve)),
          (this.quickView = this.outer.querySelector(ye)),
          this.linkElements.length &&
            this.linkElements.forEach((t) => {
              const e =
                ((i = t.getAttribute("href")),
                (s = this.variant),
                /variant=/.test(i)
                  ? i.replace(/(variant=)[^&]+/, "$1" + s)
                  : /\?/.test(i)
                    ? i.concat("&variant=").concat(s)
                    : i.concat("?variant=").concat(s));
              var i, s;
              t.setAttribute("href", e);
            }),
          this.quickView && "quick_buy" === theme.settings.quickBuy && this.quickView.setAttribute(Me, this.variant));
      }
      replaceImages(t) {
        const e = this.outer.querySelector(`[${De}="${t}"]`),
          i = this.outer.querySelector(`[${Me}="${t}"]`),
          s = [...this.outer.querySelectorAll(fe)].find((t) => t.classList.contains(qe.mediaVisible));
        if (i && this.imageId) {
          if (!e || !s) return;
          const t = () => {
            (requestAnimationFrame(() => {
              (s.classList.remove(qe.mediaVisible),
                i.classList.add(qe.mediaVisible),
                requestAnimationFrame(() => {
                  e.classList.remove(qe.mediaVisible);
                }));
            }),
              e.removeEventListener("animationend", t));
          };
          (requestAnimationFrame(() => {
            e.classList.add(qe.mediaVisible);
          }),
            e.addEventListener("animationend", t));
        }
        ("image" === theme.settings.productGridHover && (this.hoverImages = this.outer.querySelectorAll(ge)),
          this.hoverImages.length > 1 &&
            this.hoverImages.forEach((t) => {
              (t.classList.remove(qe.mediaHoverVisible),
                t.getAttribute(Me) === this.variant
                  ? t.classList.add(qe.mediaHoverVisible)
                  : this.hoverImages[0].classList.add(qe.mediaHoverVisible));
            }));
      }
      constructor(t) {
        ((this.element = t),
          (this.swatchLink = this.element.nextElementSibling),
          (this.colorString = t.getAttribute(Te)),
          (this.image = this.element.getAttribute(Ie)),
          (this.imageId = this.element.getAttribute(He)),
          (this.variant = this.element.getAttribute(Fe)),
          (this.outer = this.element.closest(me)),
          (this.hoverImages = []));
        const e = new (class {
          getColor() {
            return this.match;
          }
          init() {
            return u({ json: theme.assets.swatches })
              .then((t) => this.matchColors(t, this.settings.color))
              .catch((t) => {
                (console.log("failed to load swatch colors script"), console.log(t));
              });
          }
          matchColors(t, e) {
            let i = "#E5E5E5",
              s = null;
            const o = theme.assets.base || "/",
              n = e.toLowerCase().replace(/\s/g, ""),
              r = t.colors;
            if (r) {
              let t = null;
              if (
                r.filter((e, i) => {
                  if (Object.keys(e).toString().toLowerCase().replace(/\s/g, "") === n) return ((t = i), e);
                }).length &&
                null !== t
              ) {
                const e = Object.values(r[t])[0];
                ((i = e),
                  (e.includes(".jpg") || e.includes(".jpeg") || e.includes(".png") || e.includes(".svg")) &&
                    ((s = `${o}${e}`), (i = "#888888")));
              }
            }
            return { color: this.settings.color, path: s, hex: i };
          }
          constructor(t = {}) {
            ((this.settings = { ...ue, ...t }), (this.match = this.init()));
          }
        })({ color: this.colorString });
        e.getColor().then((t) => {
          ((this.colorMatch = t), this.init());
        });
      }
    },
    _e = class extends HTMLElement {
      init() {
        ((this.swatchElements = this.querySelectorAll(pe)),
          this.swatchElements.forEach((t) => {
            new ze(t);
          }),
          this.handleShowMore());
      }
      handleShowMore() {
        ((this.initialHeight = this.offsetHeight), (this.expandedHeight = this.initialHeight));
        const t = this.closest(be),
          e = this.querySelector(we);
        e &&
          (null == e ||
            e.addEventListener("click", () => {
              this.classList.add(qe.isVisible);
            }),
          null == t ||
            t.addEventListener("touchstart", (t) => {
              this.contains(t.target) ||
                (this.classList.remove(qe.isVisible), this.dispatchEvent(new Event("mouseleave", { bubbles: !0 })));
            }),
          this.addEventListener("mouseenter", () => {
            const t = (e) => {
              this.expandedHeight = this.offsetHeight;
              const i = e.target.closest(Ae);
              (this.expandedHeight > this.initialHeight &&
                i &&
                requestAnimationFrame(() => i.dispatchEvent(new CustomEvent("theme:slider:resize", { bubbles: !1 }))),
                this.removeEventListener("animationstart", t));
            };
            this.addEventListener("animationstart", t);
          }),
          this.addEventListener("mouseleave", () => {
            const t = (e) => {
              const i = e.target.closest(Ae);
              (this.expandedHeight > this.initialHeight &&
                i &&
                requestAnimationFrame(() => i.dispatchEvent(new CustomEvent("theme:slider:resize", { bubbles: !1 }))),
                this.removeEventListener("animationstart", t));
            };
            this.addEventListener("animationstart", t);
          }));
      }
      constructor() {
        (super(),
          (this.handle = this.getAttribute(Pe)),
          (this.label = this.getAttribute(xe).trim().toLowerCase()),
          (function (t) {
            const e = `${theme.routes.root}products/${t}.js`;
            return window
              .fetch(e)
              .then((t) => t.json())
              .catch((t) => {
                console.error(t);
              });
          })(this.handle).then((t) => {
            ((this.product = t),
              (this.colorOption = t.options.find((t) => t.name.toLowerCase() === this.label || null)),
              this.colorOption && ((this.swatches = this.colorOption.values), this.init()));
          }));
      }
    },
    $e = class {
      checkSwatchesHeight(t) {
        const e = t.querySelector(Ee),
          i = Boolean(e.closest(Ce)),
          s = i ? 1 : e.offsetHeight,
          o = t.querySelector(Le),
          n = parseInt(window.getComputedStyle(t).getPropertyValue("padding-top")),
          r = i ? 0 : parseInt(window.getComputedStyle(e).getPropertyValue("margin-bottom")),
          a = parseInt(window.getComputedStyle(o).getPropertyValue("margin-bottom")),
          l = t.closest(ke);
        (l.classList.remove(qe.selectorLarge, qe.selectorVisible),
          t.style.removeProperty("--swatches-max-height"),
          requestAnimationFrame(() => {
            t.offsetHeight - n > s + r + 2 * o.offsetHeight + 2 * a &&
              (t.style.setProperty("--swatches-max-height", `${t.offsetHeight}px`), l.classList.add(qe.selectorLarge));
          }));
      }
      onUnload() {
        this.swatchesContainers.forEach((t) => {
          document.removeEventListener("theme:resize:width", this.checkSwatchesHeightOnResize);
        });
      }
      constructor(t) {
        ((this.container = t),
          (this.swatchesContainers = this.container.querySelectorAll(Se)),
          this.swatchesContainers.forEach((t) => {
            ((this.checkSwatchesHeightOnResize = () => this.checkSwatchesHeight(t)),
              this.checkSwatchesHeight(t),
              document.addEventListener("theme:resize:width", this.checkSwatchesHeightOnResize));
          }));
      }
    };
  const Re = (t) => {
      Oe = [];
      t.querySelectorAll(pe).forEach((t) => {
        Oe.push(new ze(t));
      });
    },
    Ve = {
      onLoad() {
        Re(this.container);
      },
    },
    Ne = {
      onLoad() {
        Be[this.id] = new $e(this.container);
      },
      onUnload() {
        Be[this.id].onUnload();
      },
    },
    We = 0,
    Ue = "[data-button-quick-view]",
    je = "[data-quick-view-items-template]",
    Ge = "[data-cart-drawer]",
    Ke = "[data-shop-the-look-quick-view-button]",
    Qe = "[data-shop-the-look-thumb]",
    Xe = "[data-quick-view-item-holder]",
    Ye = "is-loading",
    Je = "is-active",
    Ze = "js-quick-view-from-cart",
    ti = "popup-quick-view pswp--not-close-btn",
    ei = "popup-quick-view popup-quick-view--shop-the-look pswp--not-close-btn",
    ii = "data-handle",
    si = "data-variant-id",
    oi = "data-shop-the-look-quick-view",
    ni = "data-hotspot",
    ri = "data-initialized",
    ai = {
      history: !1,
      focus: !1,
      mainClass: ti,
      showHideOpacity: !1,
      closeOnVerticalDrag: !1,
      closeOnScroll: !1,
      modal: !1,
      escKey: !1,
    };
  let li = class {
    popupInit(t) {
      var e, i;
      const s = this.loadPhotoswipe.pswpElement.querySelector(`[${ni}="${t.getAttribute(ni)}"]`),
        o = this.loadPhotoswipe.pswpElement.querySelectorAll(Xe);
      (s.classList.add(Je),
        o.forEach((t) => {
          t !== s && t.classList.remove(Je);
        }),
        this.toggleQuickViewButtonsLoadingClasses(!0),
        this.toggleQuickViewThumbsLoadingClasses(!0));
      const n = (t) => {
        ("quickViewAnimateInUp" === t.animationName &&
          requestAnimationFrame(() => {
            this.toggleQuickViewThumbsLoadingClasses(!1);
          }),
          "quickViewAnimateOutDown" === t.animationName &&
            this.loadPhotoswipe.pswpElement.removeEventListener("animationend", n));
      };
      (this.loadPhotoswipe.pswpElement.addEventListener("animationend", n),
        null === (e = this.loadPhotoswipe) ||
          void 0 === e ||
          null === (i = e.popup) ||
          void 0 === i ||
          i.listen("destroy", () => {
            (this.toggleQuickViewButtonsLoadingClasses(!1), this.toggleQuickViewThumbsLoadingClasses(!1));
          }));
    }
    toggleQuickViewButtonsLoadingClasses(t = !0) {
      var e, i;
      t
        ? null === (i = this.buttonsQuickView) ||
          void 0 === i ||
          i.forEach((t) => {
            t.classList.add(Ye);
          })
        : null === (e = this.buttonsQuickView) ||
          void 0 === e ||
          e.forEach((t) => {
            t.classList.remove(Ye);
          });
    }
    toggleQuickViewThumbsLoadingClasses(t = !0) {
      var e, i, s;
      ((this.buttonsShopTheLookThumb =
        null === (e = this.loadPhotoswipe) || void 0 === e ? void 0 : e.pswpElement.querySelectorAll(Qe)),
      t)
        ? null === (s = this.buttonsShopTheLookThumb) ||
          void 0 === s ||
          s.forEach((t) => {
            t.classList.add(Ye);
          })
        : null === (i = this.buttonsShopTheLookThumb) ||
          void 0 === i ||
          i.forEach((t) => {
            t.classList.remove(Ye);
          });
    }
    initPhotoswipe(t) {
      t.preventDefault();
      const e = t.target.matches(Ue) ? t.target : t.target.closest(Ue),
        i = window.innerWidth < theme.sizes.small;
      let s = "",
        o = !1;
      if (e.hasAttribute(oi)) {
        if (!i) return;
        o = !0;
      }
      ((ai.mainClass = ti),
        e.classList.add(Ye),
        e.closest(Ge) && document.body.classList.add(Ze),
        (this.a11y.state.trigger = e),
        (this.a11y.state.mainTrigger = this.a11y.state.trigger),
        e.hasAttribute(si) && (s = `&variant=${e.getAttribute(si)}`));
      const n = `${theme.routes.root}products/${e.getAttribute(ii)}?section_id=api-quickview${s}`;
      if (o) {
        ((ai.mainClass = ei),
          this.buttonsQuickView.forEach((t) => {
            t.classList.add(Ye);
          }));
        const t = new XMLSerializer(),
          i = this.container.querySelector(je).content.firstElementChild.cloneNode(!0),
          s = t.serializeToString(i);
        this.loadPhotoswipeWithTemplate(s, e);
      } else this.loadPhotoswipeFromFetch(n, e);
    }
    loadPhotoswipeWithTemplate(t, e) {
      const i = [{ html: t }];
      this.loadPhotoswipe = new window.theme.LoadPhotoswipe(i, ai, We, e);
    }
    loadPhotoswipeFromFetch(t, e) {
      fetch(t)
        .then((t) => t.text())
        .then((t) => {
          const i = [{ html: t }];
          this.loadPhotoswipe = new window.theme.LoadPhotoswipe(i, ai, We, e);
        })
        .catch((t) => console.log("error: ", t));
    }
    constructor(t) {
      var e, i;
      ((this.container = t),
        (this.a11y = window.theme.a11y),
        (this.buttonsQuickView = this.container.querySelectorAll(Ue)),
        (this.buttonsShopTheLookQuickView = this.container.querySelectorAll(Ke)),
        (this.popupInitCallback = (t) => this.popupInit(t)),
        null === (e = this.buttonsQuickView) ||
          void 0 === e ||
          e.forEach((t) => {
            t.hasAttribute(ri) ||
              (t.addEventListener("click", (t) => this.initPhotoswipe(t)),
              t.addEventListener("theme:popup:init", () => {
                (t.classList.remove(Ye), t.hasAttribute(oi) && this.popupInitCallback(t));
              }),
              t.setAttribute(ri, ""));
          }),
        null === (i = this.buttonsShopTheLookQuickView) ||
          void 0 === i ||
          i.forEach((t) => {
            t.addEventListener("click", () => {
              const t = [...this.buttonsQuickView].find((t) => t.hasAttribute(oi));
              null == t || t.dispatchEvent(new Event("click"));
            });
          }));
    }
  };
  const ci = "[data-product]",
    hi = "[data-popup-close]",
    di = "js-quick-view-visible",
    ui = {};
  let pi = class {
    popupClose() {
      const t = document.querySelector(ci);
      if (t) {
        t.querySelector(hi).dispatchEvent(new Event("click"));
      }
    }
    onBlockSelect() {
      this.body.classList.contains(di) && this.popupClose();
    }
    onDeselect() {
      this.body.classList.contains(di) && this.popupClose();
    }
    onUnload() {
      this.body.classList.contains(di) && this.popupClose();
    }
    constructor(t) {
      ((this.container = t), (this.body = document.body), new li(this.container));
    }
  };
  const mi = {
      onLoad() {
        ui[this.id] = new pi(this.container);
      },
      onBlockSelect() {
        ui[this.id].onBlockSelect();
      },
      onDeselect() {
        ui[this.id].onDeselect();
      },
      onUnload() {
        ui[this.id].onUnload();
      },
    },
    gi = "#AjaxinateLoop",
    yi = "#AjaxinatePagination",
    fi = "[data-product-block]",
    vi = "[data-promo]",
    wi = "data-ajaxinate-id",
    bi = "data-columns-tablet",
    Si = "data-columns-mobile",
    Ei = "is-loaded",
    Li = "loaded-item",
    ki = "collection-promo--full",
    Ai = "collection-promo--two-columns",
    Ci = "collection-promo--grid-second",
    qi = "collection-promo--grid-third",
    Ti = "collection-promo--grid-even",
    Pi = "collection-promo--one-column";
  let xi = {},
    Ii = class {
      init() {
        (this.loadMoreFix(),
          (this.ajaxinateContainer = this.container.querySelectorAll(gi)),
          this.ajaxinateContainer.forEach((e) => {
            const i = `${gi}[${wi}="${e.dataset.ajaxinateId}"]`,
              s = `${yi}[${wi}="${e.dataset.ajaxinateId}"]`;
            if (e.children.length > 0) {
              const o = new t({ container: i, pagination: s, method: "scroll" }),
                n = e.querySelectorAll(vi),
                r = Number(e.getAttribute(bi)),
                a = Number(e.getAttribute(Si));
              if (r >= 3) {
                let t = 0;
                if (
                  (n.forEach((e) => {
                    e.classList.contains(ki)
                      ? e.classList.contains(qi)
                        ? (t += 1)
                        : e.classList.contains(Ci)
                          ? (t += 2)
                          : (t += 3)
                      : e.classList.contains(Ai)
                        ? e.classList.contains(qi)
                          ? (t += 1)
                          : (t += 2)
                        : (t += 1);
                  }),
                  t > 0)
                ) {
                  let i = r - (t % r);
                  (i === r && (i = 0), e.classList.add(`grid--empty-items-tablet-${i}`));
                }
              }
              if (2 === a) {
                let t = 0;
                if (
                  (n.forEach((e) => {
                    (e.classList.contains(Ti) || e.classList.contains(Pi)) && (t += 1);
                  }),
                  t > 0)
                ) {
                  let i = a - (t % a);
                  (i === a && (i = 0), e.classList.add(`grid--empty-items-mobile-${i}`));
                }
              }
              (e.classList.add(Ei), this.endlessScroll.push(o));
            }
          }));
      }
      update(e) {
        this.ajaxinateContainer = this.container.querySelectorAll(gi);
        const i = (t) => t.settings.container === e,
          s = this.endlessScroll.find(i);
        if (s) {
          const t = this.endlessScroll.findIndex(i);
          (this.endlessScroll.splice(t, 1), (s.settings.method = "scroll"), s.destroy());
        }
        const o = [...this.ajaxinateContainer].find((t) => `${gi}[${wi}="${t.dataset.ajaxinateId}"]` === e);
        if (!o) return;
        const n = `${gi}[${wi}="${o.dataset.ajaxinateId}"]`,
          r = `${yi}[${wi}="${o.dataset.ajaxinateId}"]`;
        if (!(o.children.length > 0)) return;
        const a = new t({ container: n, pagination: r, method: "scroll" });
        (o.classList.add(Ei), this.endlessScroll.push(a));
      }
      loadMoreFix() {
        t.prototype.loadMore = function () {
          ((this.request = new XMLHttpRequest()),
            (this.request.onreadystatechange = function () {
              if (!this.request.responseXML) return;
              if (4 === !this.request.readyState || 200 === !this.request.status) return;
              const t = this.request.responseXML.querySelector(this.settings.container),
                e = this.request.responseXML.querySelector(this.settings.pagination);
              (t.querySelectorAll(fi).forEach((t) => t.classList.add(Li)),
                this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
                null == e
                  ? this.removePaginationElement()
                  : ((this.paginationElement.innerHTML = e.innerHTML),
                    this.settings.callback &&
                      "function" == typeof this.settings.callback &&
                      this.settings.callback(this.request.responseXML),
                    this.initialize()));
            }.bind(this)),
            this.request.open("GET", this.nextPageUrl, !0),
            (this.request.responseType = "document"),
            this.request.send());
        };
      }
      unload() {
        this.endlessScroll.length > 0 &&
          (this.endlessScroll.forEach((t) => {
            ((t.settings.method = "scroll"), t.destroy());
          }),
          this.ajaxinateContainer.forEach((t) => t.classList.remove(Ei)));
      }
      constructor(t) {
        ((this.container = t), (this.endlessScroll = []), theme.settings.enableInfinityScroll && this.init());
      }
    };
  const Hi = {
      onLoad() {
        xi = new Ii(this.container);
      },
      onUnload: function () {
        "function" == typeof xi.unload && xi.unload();
      },
    },
    Fi = 300,
    Mi = "[data-toggle-filters]",
    Di = "[data-close-filters]",
    Oi = "[data-open-filters]",
    Bi = "[data-collection-wrapper]",
    zi = "[data-collapsible-trigger]",
    _i = "[data-sort-toggle]",
    $i = "[data-collection-sort-options]",
    Ri = "[data-input-sort]",
    Vi = "[data-collection-filters]",
    Ni = "[data-collection-filters-list]",
    Wi = "[data-collection-sticky-bar]",
    Ui = "[data-collection-filter]",
    ji = "[data-collection-filter-tag]",
    Gi = "[data-collection-filter-tag-button]",
    Ki = "[data-collection-filters-form]",
    Qi = "[data-filter-reset-button]",
    Xi = "[data-filter-tag-reset-button]",
    Yi = '[data-section-type="popups"]',
    Ji = "[data-collection-products]",
    Zi = "[data-products-count]",
    ts = "[data-field-price-min]",
    es = "[data-field-price-max]",
    is = "[data-se-min-value]",
    ss = "[data-se-max-value]",
    os = "data-se-min-value",
    ns = "data-se-max-value",
    rs = "data-se-min",
    as = "data-se-max",
    ls = "[data-tooltip]",
    cs = "[data-tooltip-container]",
    hs = "[data-show-more]",
    ds = "[data-show-more-actions]",
    us = "[data-show-more-container]",
    ps = "[data-show-more-trigger]",
    ms = "[data-search-performed]",
    gs = "[data-search-form]",
    ys = "[data-custom-scrollbar]",
    fs = "is-active",
    vs = "is-expanded",
    ws = "is-visible",
    bs = "is-loading",
    Ss = "popup--visible",
    Es = "collection__filters--visible",
    Ls = "collection__sort__option-wrapper--visible",
    ks = "data-filter-active",
    As = "data-prevent-scroll-lock",
    Cs = "data-filters-default-state",
    qs = "tabindex",
    Ts = "aria-expanded",
    Ps = "data-current-type",
    xs = {};
  let Is = class {
    initFacetedFilters() {
      "tag" != this.filterMode &&
        "group" != this.filterMode &&
        this.enableFilters &&
        (this.rangeSlider = new (class {
          init() {
            if (((this.slider = this.container.querySelector(Wt)), !this.slider)) return;
            ((this.resizeFilters = window.theme.debounce(this.reset.bind(this), 50)),
              (this.onMoveEvent = (t) => this.onMove(t)),
              (this.onStopEvent = (t) => this.onStop(t)),
              (this.onStartEvent = (t) => this.onStart(t)),
              (this.startX = 0),
              (this.x = 0),
              (this.touchLeft = this.slider.querySelector(Ut)),
              (this.touchRight = this.slider.querySelector(jt)),
              (this.lineSpan = this.slider.querySelector(Gt)),
              (this.min = parseFloat(this.slider.getAttribute(Qt))),
              (this.max = parseFloat(this.slider.getAttribute(Xt))),
              (this.step = 0),
              (this.normalizeFact = 20));
            let t = this.min;
            this.slider.hasAttribute(Yt) && (t = parseFloat(this.slider.getAttribute(Yt)));
            let e = this.max;
            (this.slider.hasAttribute(Jt) && (e = parseFloat(this.slider.getAttribute(Jt))),
              t < this.min && (t = this.min),
              e > this.max && (e = this.max),
              t > e && (t = e),
              this.slider.getAttribute(Zt) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(Zt)))),
              this.reset(),
              window.addEventListener("theme:resize", this.resizeFilters),
              (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
              (this.selectedTouch = null),
              (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
              this.setMinValue(t),
              this.setMaxValue(e),
              this.touchLeft.addEventListener("mousedown", this.onStartEvent),
              this.touchRight.addEventListener("mousedown", this.onStartEvent),
              this.touchLeft.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
              this.touchRight.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
              this.slider.classList.add(se));
          }
          reset() {
            ((this.touchLeft.style.left = "0px"),
              (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
              (this.lineSpan.style.marginLeft = "0px"),
              (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
              (this.startX = 0),
              (this.x = 0),
              (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
              (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact));
          }
          setMinValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            ((this.touchLeft.style.left =
              Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px"),
              (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
              (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
              this.slider.setAttribute(Yt, t));
          }
          setMaxValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            ((this.touchRight.style.left =
              Math.ceil(
                e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact,
              ) + "px"),
              (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
              (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
              this.slider.setAttribute(Jt, t));
          }
          onStart(t) {
            t.preventDefault();
            let e = t;
            (t.touches && (e = t.touches[0]),
              t.currentTarget === this.touchLeft
                ? (this.x = this.touchLeft.offsetLeft)
                : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft),
              (this.startX = e.pageX - this.x),
              (this.selectedTouch = t.currentTarget),
              document.addEventListener("mousemove", this.onMoveEvent),
              document.addEventListener("mouseup", this.onStopEvent),
              document.addEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
              document.addEventListener("touchend", this.onStopEvent, { passive: !0 }));
          }
          onMove(t) {
            let e = t;
            (t.touches && (e = t.touches[0]),
              (this.x = e.pageX - this.startX),
              this.selectedTouch === this.touchLeft
                ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
                    ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10)
                    : this.x < 0 && (this.x = 0),
                  (this.selectedTouch.style.left = this.x + "px"))
                : this.selectedTouch === this.touchRight &&
                  (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
                    ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
                    : this.x > this.maxX && (this.x = this.maxX),
                  (this.selectedTouch.style.left = this.x + "px")),
              (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
              (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
              this.calculateValue(),
              this.slider.getAttribute("on-change") &&
                new Function("min, max", this.slider.getAttribute("on-change"))(
                  this.slider.getAttribute(Yt),
                  this.slider.getAttribute(Jt),
                ),
              this.onChange(this.slider.getAttribute(Yt), this.slider.getAttribute(Jt)));
          }
          onStop(t) {
            (document.removeEventListener("mousemove", this.onMoveEvent),
              document.removeEventListener("mouseup", this.onStopEvent),
              document.removeEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
              document.removeEventListener("touchend", this.onStopEvent, { passive: !0 }),
              (this.selectedTouch = null),
              this.calculateValue(),
              this.onChanged(this.slider.getAttribute(Yt), this.slider.getAttribute(Jt)));
          }
          onChange(t, e) {
            const i = this.slider.closest(Kt);
            if (i) {
              const s = i.querySelector(ee),
                o = i.querySelector(ie);
              s && o && ((s.value = parseInt(t)), (o.value = parseInt(e)));
            }
          }
          onChanged(t, e) {
            this.slider.hasAttribute(te) &&
              this.slider.dispatchEvent(new CustomEvent("theme:filter:range-update", { bubbles: !0 }));
          }
          calculateValue() {
            const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let e = this.lineSpan.offsetLeft / this.initialValue,
              i = e + t;
            if (
              ((e = e * (this.max - this.min) + this.min), (i = i * (this.max - this.min) + this.min), 0 !== this.step)
            ) {
              let t = Math.floor(e / this.step);
              ((e = this.step * t), (t = Math.floor(i / this.step)), (i = this.step * t));
            }
            (this.selectedTouch === this.touchLeft && this.slider.setAttribute(Yt, e),
              this.selectedTouch === this.touchRight && this.slider.setAttribute(Jt, i));
          }
          unload() {
            (document.removeEventListener("theme:filters:init", this.initListener),
              window.removeEventListener("theme:resize", this.resizeFilters));
          }
          constructor(t) {
            ((this.container = t),
              this.init(),
              (this.initListener = () => this.init()),
              document.addEventListener("theme:filters:init", this.initListener));
          }
        })(this.container));
    }
    initTooltips() {
      var t, e;
      ((this.tooltips = this.container.querySelectorAll(ls)), window.innerWidth < theme.sizes.small) &&
        (this.tooltips = null === (e = this.productGrid) || void 0 === e ? void 0 : e.querySelectorAll(ls));
      (null === (t = this.tooltips) ||
        void 0 === t ||
        t.forEach((t) => {
          new Vt(t);
        }),
        this.handleVisibleTooltips());
    }
    handleVisibleTooltips() {
      if (this.tooltips.length > 0) {
        const t = document.querySelector(cs);
        t.classList.contains(ws) && t.classList.remove(ws);
      }
    }
    updateRange() {
      const t = this.filtersForm.querySelector(is),
        e = this.filtersForm.querySelector(ss),
        i = this.filtersForm.querySelector(ts),
        s = this.filtersForm.querySelector(es);
      if (t.hasAttribute(os) && e.hasAttribute(ns)) {
        const o = parseFloat(i.placeholder, 10),
          n = parseFloat(s.placeholder, 10),
          r = parseFloat(t.getAttribute(os), 10),
          a = parseFloat(e.getAttribute(ns), 10);
        (o === r && n === a) ||
          ((i.value = parseInt(r)),
          (s.value = parseInt(a)),
          this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })));
      }
    }
    onSubmitHandler(t) {
      t.preventDefault();
      const e = new FormData(this.filtersForm),
        i = new URLSearchParams(e),
        s = [];
      let o = "";
      this.isSearchPage &&
        ((this.searchForm = this.container.querySelector(gs)), (this.currentType = this.container.getAttribute(Ps)));
      const n = this.filtersForm.querySelector(is),
        r = this.filtersForm.querySelector(ss),
        a = this.filtersForm.querySelector(ts),
        l = this.filtersForm.querySelector(es);
      if (n && r && a && l && n.hasAttribute(rs) && r.hasAttribute(as)) {
        const t = parseFloat(n.getAttribute(rs), 10),
          e = parseFloat(r.getAttribute(as), 10),
          o = a.value ? parseFloat(a.value, 10) : t,
          c = l.value ? parseFloat(l.value, 10) : e;
        o <= t &&
          c >= e &&
          (s.push("filter.v.price.gte"),
          s.push("filter.v.price.lte"),
          i.delete("filter.v.price.gte"),
          i.delete("filter.v.price.lte"));
      }
      if (((o = i.toString()), this.isSearchPage)) {
        o = kt(this.searchForm, this.filtersForm, s);
        let t = "";
        ("all" === this.currentType && (t = "&type=product"), o.indexOf("&type=product") > -1 && (t = ""), (o += t));
      }
      this.renderSection(o, t);
    }
    onHistoryChange(t) {
      var e;
      if (!this.filters) return;
      let i = (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || "";
      if (this.isSearchPage) {
        t.state || (i = window.location.search);
        if (!(i.indexOf("type=product") > -1)) return;
      }
      this.renderSection(i, null, !1);
    }
    renderSection(t, e, i = !0) {
      this.startLoading();
      const s = `${window.location.pathname}?section_id=${this.sectionId}&${t}`,
        o = (t) => t.url === s;
      (this.filterData.some(o) ? this.renderSectionFromCache(o, e) : this.renderSectionFromFetch(s, e),
        i && this.updateURLHash(t));
    }
    renderSectionFromFetch(t) {
      fetch(t)
        .then((t) => t.text())
        .then((e) => {
          const i = e;
          ((this.filterData = [...this.filterData, { html: i, url: t }]),
            (this.inputSort = this.container.querySelectorAll(Ri)),
            this.renderFilters(i),
            this.bindFilterButtonsEvents(),
            this.hideFiltersOnMobile(),
            this.renderProductGrid(i),
            this.updateProductsCount(i),
            this.finishLoading(),
            this.mobileFiltersScrollLock(),
            this.handleSearchPageActiveTab());
        });
    }
    renderSectionFromCache(t, e) {
      const i = this.filterData.find(t).html;
      (this.renderFilters(i, e),
        this.hideFiltersOnMobile(),
        this.renderProductGrid(i),
        this.updateProductsCount(i),
        this.finishLoading(),
        this.mobileFiltersScrollLock(),
        this.handleSearchPageActiveTab());
    }
    handleSearchPageActiveTab() {
      this.isSearchPage &&
        ((this.scrollable = this.container.querySelector(ys)),
        this.scrollable && !this.customScrollbar && (this.customScrollbar = new Pt(this.container)));
    }
    renderProductGrid(t) {
      const e = new DOMParser().parseFromString(t, "text/html").querySelector(Ji);
      e &&
        ((this.productGrid.innerHTML = e.innerHTML),
        this.initProductGridEvents(theme.settings.enableInfinityScroll),
        this.filterShowMore());
    }
    updateProductsCount(t) {
      const e = new DOMParser().parseFromString(t, "text/html").querySelector(Zi);
      e && (this.productsCount.innerHTML = e.innerHTML);
    }
    renderFilters(t) {
      const e = new DOMParser().parseFromString(t, "text/html").querySelector(Vi);
      e &&
        ((this.filters.innerHTML = e.innerHTML),
        (this.filtersForm = document.querySelector(Ki)),
        this.bindFilterButtonsEvents(),
        this.bindToggleButtonsEvents(),
        Re(this.container),
        (this.collapsible = new dt(this.container)),
        document.dispatchEvent(new CustomEvent("theme:filters:init", { bubbles: !0 })));
    }
    updateURLHash(t) {
      history.pushState({ searchParams: t }, "", `${window.location.pathname}${t && "?".concat(t)}`);
    }
    bindFilterButtonsEvents() {
      (this.inputSort.length > 0 &&
        this.inputSort.forEach((t) => {
          t.addEventListener("change", this.updateCollectionFormSortEvent);
        }),
        this.filtersForm &&
          (this.filtersForm.addEventListener("input", this.debouncedSubmitEvent.bind(this)),
          this.filtersForm.addEventListener("theme:filter:range-update", this.updateRangeEvent)),
        this.collectionSortOptions && this.collectionSortOptions.addEventListener("keyup", this.onTabHandlerEvent),
        "tag" != this.filterMode &&
          "group" != this.filterMode &&
          this.enableFilters &&
          this.container.querySelectorAll(Qi).forEach((t) => {
            t.addEventListener("click", this.onFilterResetClick, { once: !0 });
          }));
    }
    onFilterResetClick(t) {
      (t.preventDefault(), this.renderSection(new URL(t.currentTarget.href).searchParams.toString()));
    }
    bindToggleButtonsEvents() {
      var t;
      (this.container.querySelectorAll(Mi).forEach((t) => {
        t.addEventListener("click", this.onFilterToggleClick);
      }),
        this.container.querySelectorAll(Di).forEach((t) => {
          t.addEventListener("click", this.hideFiltersDrawer);
        }),
        this.container.querySelectorAll(Oi).forEach((t) => {
          t.addEventListener("click", this.showFiltersDrawer);
        }),
        null === (t = this.container.querySelector(Bi)) ||
          void 0 === t ||
          t.addEventListener("keyup", this.onKeyUpHandler));
    }
    onTabHandler(t) {
      if (
        t.code === theme.keyboardKeys.SPACE ||
        t.code === theme.keyboardKeys.ENTER ||
        t.code === theme.keyboardKeys.NUMPADENTER
      ) {
        const e = t.target.previousElementSibling.value;
        (this.filtersForm.querySelectorAll(Ri).forEach((t) => {
          (t.checked && (t.checked = !1), t.value === e && (t.checked = !0));
        }),
          this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })),
          t.target.dispatchEvent(new Event("click", { bubbles: !0 })));
      }
    }
    onKeyUpHandler(t) {
      t.code === theme.keyboardKeys.ESCAPE && this.hideFiltersDrawer();
    }
    onFilterToggleClick(t) {
      (t.preventDefault(), window.theme.setVars());
      this.filters.classList.contains(Es) ? this.hideFiltersDrawer() : this.showFiltersDrawer();
    }
    sortDropdownToggle() {
      this.collectionSortOptions && this.collectionSortOptions.classList.toggle(Ls);
    }
    bodyClick(t) {
      if (!this.collectionSortOptions) return;
      const e = this.sortToggle.contains(t.target);
      this.collectionSortOptions.classList.contains(Ls) && !e && this.sortDropdownToggle();
    }
    updateCollectionFormSort(t) {
      const e = t.target,
        i = e.value,
        s = e.closest($i);
      (this.container.querySelectorAll(Ri).forEach((t) => {
        t.value === i && (t.checked = !0);
      }),
        null !== s && this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })));
    }
    showFiltersDrawer() {
      ((this.a11y.state.trigger = document.querySelector(Mi)),
        this.a11y.trapFocus({ container: this.filters }),
        this.mobileFiltersScrollLock());
    }
    mobileFiltersScrollLock() {
      if (window.innerWidth < theme.sizes.small) {
        const t = document.querySelector(Ni);
        (this.filters.classList.contains(Es) || this.filters.classList.add(Es),
          document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: t })));
      }
    }
    hideFiltersOnMobile() {
      const t = this.container.querySelectorAll(`${zi}:not(${ps})`);
      window.innerWidth < theme.sizes.small &&
        requestAnimationFrame(() => {
          t.forEach((t) => {
            const e = "true" === t.getAttribute(ks);
            t.classList.contains(vs) && !e && t.dispatchEvent(new Event("click"));
          });
        });
    }
    showFiltersOnDesktop() {
      const t = this.container.querySelectorAll(`${zi}:not(${ps})`),
        e = this.container.getAttribute(Cs),
        i = "first-open" === e,
        s = "open" === e,
        o = "closed" === e,
        n = this.enableSorting ? 1 : 0;
      t.forEach((t, e) => {
        const r = t.classList.contains(vs),
          a = "true" === t.getAttribute(ks),
          l = a && !r && s;
        (a && !l) ||
          (((o && r) || (i && !r && e === n) || (i && r && e !== n) || (s && !r) || l) &&
            t.dispatchEvent(new Event("click")));
      });
    }
    hideFiltersDrawer() {
      let t = this.filters.classList.contains(Es),
        e = this.container.classList.contains(bs);
      (t && (this.filters.classList.remove(Es), this.a11y.removeTrapFocus()),
        e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Fi })));
    }
    filtersResizeEvents() {
      window.innerWidth >= theme.sizes.small
        ? (this.showFiltersOnDesktop(), this.hideFiltersDrawer())
        : this.hideFiltersOnMobile();
    }
    filterShowMore() {
      ((this.showMore = this.container.querySelectorAll(hs)),
        0 !== this.showMore.length &&
          this.showMore.forEach((t) => {
            const e = t.querySelector(zi),
              i = t.querySelector(ds);
            if (!i) return;
            const s = i.querySelector(ps),
              o = i.querySelector(us),
              n = o.querySelectorAll(window.theme.focusable);
            ("true" === o.getAttribute(Ts) ||
              n.forEach((t) => {
                t.setAttribute(qs, "-1");
              }),
              s.addEventListener("keyup", (t) => {
                (t.code !== theme.keyboardKeys.SPACE &&
                  t.code !== theme.keyboardKeys.ENTER &&
                  t.code !== theme.keyboardKeys.NUMPADENTER) ||
                  this.updateShowMoreFocusableElements(t, n);
              }),
              s.addEventListener("click", (t) => {
                this.updateShowMoreFocusableElements(t, n);
              }),
              e.addEventListener("keyup", (t) => {
                (t.code !== theme.keyboardKeys.SPACE &&
                  t.code !== theme.keyboardKeys.ENTER &&
                  t.code !== theme.keyboardKeys.NUMPADENTER) ||
                  this.updateCollapsedContainerFocusableElements(e, s, n);
              }),
              e.addEventListener("click", () => {
                this.updateCollapsedContainerFocusableElements(e, s, n);
              }));
          }));
    }
    updateCollapsedContainerFocusableElements(t, e, i) {
      requestAnimationFrame(() => {
        const s = "true" === t.getAttribute(Ts),
          o = "true" === e.getAttribute(Ts);
        i.forEach((t) => {
          (!s && o && t.setAttribute(qs, "-1"), s && o && t.removeAttribute(qs));
        });
      });
    }
    updateShowMoreFocusableElements(t, e) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const i = "true" === t.target.getAttribute(Ts);
          e.forEach((t, e) => {
            if (i) return (t.removeAttribute(qs), void (0 === e && t.focus()));
            t.setAttribute(qs, "-1");
          });
        });
      });
    }
    initTagFilters() {
      ("tag" != this.filterMode && "group" != this.filterMode) ||
        !this.enableFilters ||
        ((this.tags = this.container.dataset.tags.split("+").filter((t) => t)),
        this.bindFilterTagButtonsEvents(),
        this.bindSortChangeEvent());
    }
    renderTagFiltersProducts(t) {
      (this.startLoading(),
        "object" == typeof this.endlessCollection && this.endlessCollection.unload(),
        fetch(t)
          .then((t) => t.text())
          .then((e) => {
            const i = e,
              s = new DOMParser().parseFromString(i, "text/html"),
              o = s.querySelector(Ji).innerHTML,
              n = s.querySelector(Vi).innerHTML;
            ((this.productGrid.innerHTML = o),
              (this.filters.innerHTML = n),
              (this.inputSort = this.container.querySelectorAll(Ri)),
              (this.filtersForm = document.querySelector(Ki)),
              (this.filterData = [...this.filterData, { html: i, url: t }]),
              (this.alreadyClicked = !1),
              this.bindFilterTagButtonsEvents(),
              this.bindFilterButtonsEvents(),
              this.bindSortChangeEvent(),
              this.bindToggleButtonsEvents(),
              this.initProductGridEvents(theme.settings.enableInfinityScroll),
              this.updateProductsCount(i),
              this.mobileFiltersScrollLock(),
              this.hideFiltersOnMobile(),
              Re(this.container),
              (this.collapsible = new dt(this.container)),
              this.filterShowMore(),
              history.replaceState && window.history.pushState({ path: t }, "", t));
          })
          .catch((t) => {
            (this.finishLoading(), console.log(`Error: ${t}`));
          }));
    }
    bindFilterTagButtonsEvents() {
      (this.container.querySelectorAll(Gi).forEach((t) => {
        t.addEventListener("click", this.onFilterTagButtonClick.bind(this));
      }),
        this.container.querySelectorAll(Xi).forEach((t) => {
          t.addEventListener("click", this.onFilterTagClearClick);
        }),
        this.container.querySelectorAll(Qi).forEach((t) => {
          t.addEventListener("click", this.onFilterTagResetClick);
        }));
    }
    bindSortChangeEvent() {
      this.container.querySelectorAll(Ri).forEach((t) => {
        t.addEventListener("input", this.debouncedSortEvent.bind(this));
      });
    }
    onFilterTagButtonClick(t) {
      if ((t.preventDefault(), this.alreadyClicked)) return;
      this.alreadyClicked = !0;
      const e = t.currentTarget,
        i = e.dataset.tag;
      if (e.parentNode.classList.contains(fs)) {
        let t = this.tags.indexOf(i);
        (e.parentNode.classList.remove(fs), t > -1 && this.tags.splice(t, 1));
      } else (e.parentNode.classList.add(fs), this.tags.push(i));
      let s = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
      (this.container.querySelector(Ui).classList.remove(vs),
        this.container.querySelector(Ui).setAttribute(Ts, !1),
        this.container.setAttribute("data-tags", "[" + this.tags + "]"),
        this.renderTagFiltersProducts(s));
    }
    onFilterTagClearClick(t) {
      if ((t.preventDefault(), this.alreadyClicked)) return;
      this.alreadyClicked = !0;
      const e = t.currentTarget.dataset.tag,
        i = this.tags.indexOf(e);
      i > -1 && this.tags.splice(i, 1);
      const s = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
      (this.container.setAttribute("data-tags", "[" + this.tags + "]"), this.renderTagFiltersProducts(s));
    }
    onSortChange() {
      let t = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
      this.renderTagFiltersProducts(t);
    }
    getSortValue() {
      let t = "";
      return (
        this.inputSort.forEach((e) => {
          e.checked && (t = e.value);
        }),
        t
      );
    }
    onFilterTagResetClick(t) {
      if ((null == t || t.preventDefault(), this.alreadyClicked)) return;
      ((this.alreadyClicked = !0),
        this.container.querySelectorAll(ji).forEach((t) => {
          t.classList.remove(fs);
        }),
        this.container.querySelectorAll(Ui).forEach((t) => {
          (t.classList.remove(vs), t.setAttribute(Ts, !1));
        }),
        (this.tags = []),
        this.container.setAttribute("data-tags", ""));
      let e = this.collectionHandle + "/?sort_by=" + this.getSortValue();
      this.renderTagFiltersProducts(e);
    }
    getProductsOffsetTop() {
      return (
        this.productGrid.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        this.filtersStickyBar.offsetHeight
      );
    }
    getStickyBarOffsetTop() {
      return this.filtersStickyBar.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
    }
    initProductGridEvents(t) {
      if (t) return (this.initInfinityScroll(), void this.initProductGridEvents(!1));
      ((this.productGridEvents = new pi(this.container)),
        this.initTooltips(),
        setTimeout(() => {
          this.finishLoading();
        }, 1.5 * Fi));
    }
    initInfinityScroll() {
      if (this.isSearchPage) {
        if (!this.enableFilters) return;
        document.dispatchEvent(new CustomEvent("theme:tab:ajaxinate", { bubbles: !0, detail: "product" }));
      } else
        ("object" == typeof this.endlessCollection && this.endlessCollection.unload(),
          (this.endlessCollection = new Ii(this.container)),
          0 !== this.endlessCollection.endlessScroll.length &&
            (this.endlessCollection.endlessScroll[0].settings.callback = () => this.initProductGridEvents(!1)));
    }
    startLoading() {
      (this.container.classList.add(bs),
        window.innerWidth >= theme.sizes.small &&
          document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })));
      let t = this.getProductsOffsetTop();
      window.scrollTo({ top: t, left: 0, behavior: "smooth" });
    }
    finishLoading() {
      const t = document.querySelectorAll(`${Yi} .${Ss}`),
        e = t.length > 0;
      if ((this.container.classList.remove(bs), e)) {
        let e = 0;
        ([...t].forEach((t) => {
          t.hasAttribute(As) && (e += 1);
        }),
          e === t.length &&
            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Fi })));
      } else
        window.innerWidth >= theme.sizes.small &&
          document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: Fi }));
    }
    onDeselect() {
      this.productGridEvents && this.productGridEvents.onDeselect();
    }
    onUnload() {
      ("object" == typeof this.endlessCollection && this.endlessCollection.unload(),
        this.productGridEvents && this.productGridEvents.onUnload(),
        this.collapsible && this.collapsible.onUnload(),
        this.rangeSlider && this.rangeSlider.unload(),
        this.filters && document.removeEventListener("theme:resize:width", this.resizeEvent),
        document.removeEventListener("click", this.bodyClickEvent),
        this.groupTagFilters.length > 0 && this.onFilterTagResetClick(),
        this.finishLoading());
    }
    constructor(t) {
      var e;
      ((this.container = t),
        (this.sectionId = t.dataset.sectionId),
        (this.enableFilters = "true" === t.dataset.enableFilters),
        (this.enableSorting = "true" === t.dataset.enableSorting),
        (this.filterMode = t.dataset.filterMode),
        (this.collectionHandle = this.container.dataset.collection),
        (this.isSearchPage = null != t.closest(ms)),
        (this.productGrid = this.container.querySelector(Ji)),
        (this.productsCount = this.container.querySelector(Zi)),
        (this.groupTagFilters = this.container.querySelectorAll(Ui)),
        (this.filters = this.container.querySelector(Vi)),
        (this.filterTriggers = this.container.querySelectorAll(zi)),
        (this.filtersStickyBar = this.container.querySelector(Wi)),
        (this.filtersForm = this.container.querySelector(Ki)),
        (this.inputSort = this.container.querySelectorAll(Ri)),
        (this.sortToggle = this.container.querySelector(_i)),
        (this.collectionSortOptions = this.container.querySelector($i)),
        (this.a11y = window.theme.a11y),
        (this.filterData = []),
        (this.rangeSlider = null),
        (this.sortDropdownEvent = () => this.sortDropdownToggle()),
        (this.onTabHandlerEvent = (t) => this.onTabHandler(t)),
        (this.updateCollectionFormSortEvent = (t) => this.updateCollectionFormSort(t)),
        (this.bodyClickEvent = (t) => this.bodyClick(t)),
        (this.onFilterResetClick = this.onFilterResetClick.bind(this)),
        (this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this)),
        (this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this)),
        (this.onFilterToggleClick = this.onFilterToggleClick.bind(this)),
        (this.onKeyUpHandler = this.onKeyUpHandler.bind(this)),
        (this.updateRangeEvent = this.updateRange.bind(this)),
        (this.debouncedSubmitEvent = window.theme.debounce((t) => {
          this.onSubmitHandler(t);
        }, 500)),
        (this.debouncedSortEvent = window.theme.debounce((t) => {
          this.onSortChange(t);
        }, 500)),
        (this.productGridEvents = {}),
        this.filters &&
          ((this.hideFiltersDrawer = this.hideFiltersDrawer.bind(this)),
          (this.showFiltersDrawer = this.showFiltersDrawer.bind(this)),
          (this.resizeEvent = window.theme.debounce(() => {
            this.filtersResizeEvents();
          }, 500)),
          this.filtersResizeEvents(),
          document.addEventListener("theme:resize:width", this.resizeEvent)),
        this.initTagFilters(),
        this.initFacetedFilters(),
        this.bindToggleButtonsEvents(),
        this.bindFilterButtonsEvents(),
        this.initProductGridEvents(theme.settings.enableInfinityScroll),
        Re(this.container),
        (this.collapsible = new dt(this.container)),
        window.theme.setVars(),
        window.addEventListener("popstate", this.onHistoryChange.bind(this)),
        null === (e = this.sortToggle) || void 0 === e || e.addEventListener("click", this.sortDropdownEvent),
        document.addEventListener("click", this.bodyClickEvent),
        this.filterShowMore());
    }
  };
  const Hs = {
      onLoad() {
        xs[this.id] = new Is(this.container);
      },
      onDeselect() {
        xs[this.id].onDeselect();
      },
      onUnload() {
        xs[this.id].onUnload();
      },
    },
    Fs = "[data-aos]",
    Ms = "[data-aos-anchor]",
    Ds = "[data-tabs-link]",
    Os = "[data-tab]",
    Bs = "[data-tab-ref]",
    zs = "[data-custom-scrollbar]",
    _s = "[data-custom-scrollbar-holder]",
    $s = "[data-slider]",
    Rs = "[data-tabs-contents]",
    Vs = "[data-search-form]",
    Ns = "[data-all-types-container]",
    Ws = "[data-collection-filters-form]",
    Us = "[data-current-page]",
    js = "[data-tooltip]",
    Gs = "[data-collection-products]",
    Ks = "#AjaxinateLoop",
    Qs = "current",
    Xs = "hide",
    Ys = "alt",
    Js = "aos-animate",
    Zs = "is-loaded",
    to = "data-tabs-link",
    eo = "data-tab",
    io = "data-tab-ref",
    so = "data-start-index",
    oo = "data-search-performed",
    no = "data-type",
    ro = "data-current-type",
    ao = "data-all-types",
    lo = "data-current-page",
    co = "data-ajaxinate-id",
    ho = {};
  let uo = class {
    assignSearchPageArguments() {
      this.isSearchPage &&
        ((this.searchForm = this.container.querySelector(Vs)),
        (this.searchFormData = new FormData(this.searchForm)),
        (this.searchTerm = encodeURIComponent(this.searchFormData.get("q"))),
        (this.currentType = this.container.getAttribute(ro)),
        (this.sectionId = this.container.dataset.sectionId),
        (this.searchForAllTypes = "true" === this.container.getAttribute(ao)),
        (this.fetchURL = ""),
        (this.searchParams = ""),
        (this.cachedResults = {}),
        this.handleTabsHistory(),
        this.infiniteScrollListener(),
        this.initInfinityScroll(this.currentType));
    }
    init() {
      const t = this.container.querySelectorAll(Ds),
        e = this.container.querySelector(
          `[${to}="${this.container.hasAttribute(so) ? this.container.getAttribute(so) : 0}"]`,
        ),
        i = this.container.querySelector(
          `[${eo}="${this.container.hasAttribute(so) ? this.container.getAttribute(so) : 0}"]`,
        );
      (null == i || i.classList.add(Qs),
        null == e || e.classList.add(Qs),
        this.checkVisibleTabsLinks(),
        t.forEach((t) => {
          this.handleTabsNavListeners(t);
        }));
    }
    handleTabsHistory() {
      (window.addEventListener("popstate", this.onHistoryChange.bind(this)),
        (this.openTabFromHistoryEvent = (t) => this.openTabFromHistory(t)),
        this.tabsLink.forEach((t) => {
          t.addEventListener("theme:tab:open-from-history", this.openTabFromHistoryEvent);
        }));
    }
    handleTabsNavListeners(t) {
      const e = t.getAttribute(to),
        i = this.container.querySelector(`[${eo}="${e}"]`);
      i &&
        (t.addEventListener("click", (e) => {
          (this.isSearchPage && this.handleURLSearchParams(e, !0), this.tabChange(t, i));
        }),
        t.addEventListener("keyup", (e) => {
          (e.code !== theme.keyboardKeys.SPACE &&
            e.code !== theme.keyboardKeys.ENTER &&
            e.code !== theme.keyboardKeys.NUMPADENTER) ||
            (this.isSearchPage && this.handleURLSearchParams(e, !0), this.tabChange(t, i));
        }));
    }
    openTabFromHistory(t) {
      const e = t.target,
        i = this.container.querySelector(t.detail.element).getAttribute(to),
        s = this.container.querySelector(`[${eo}="${i}"]`);
      s && (this.handleURLSearchParams(t, !1), this.tabChange(e, s));
    }
    handleURLSearchParams(t, e = !0) {
      const i = t.target.matches(Ds) ? t.target : t.target.closest(Ds),
        s = i.getAttribute(no),
        o = i.getAttribute(to),
        n = this.container.querySelector(`[${eo}="${o}"]`).querySelector(Us),
        r = document.querySelector(Ws);
      let a = n ? `&page=${n.getAttribute(lo)}` : "";
      if (((this.searchParams = kt(this.searchForm, r, [], s)), "product" === s)) {
        const t = this.searchParams.replace("&type=product", "");
        this.searchParams = `${t}&type=product`;
      } else this.searchParams = `q=${this.searchTerm}&type=${s}`;
      (theme.settings.enableInfinityScroll || "" === a || (this.searchParams += a),
        (this.fetchURL = `${theme.routes.searchUrl}?${this.searchParams}&section_id=${this.sectionId}`),
        e &&
          history.pushState(
            { searchParams: this.searchParams },
            "",
            `${window.location.pathname}${this.searchParams && "?".concat(this.searchParams)}`,
          ));
    }
    tabChangeFetchContent(t, e) {
      const i = t.getAttribute(no),
        s = t.getAttribute(to),
        o = this.container.querySelector(`[${eo}="${s}"]`),
        n = this.currentType === i;
      if (this.cachedResults[s] || n)
        return (
          "product" !== i || this.searchFilters || (this.searchFilters = new Is(this.container)),
          void requestAnimationFrame(() => {
            (this.handleActiveTabClasses(t, e),
              this.scrollToCurrentTabLink(t),
              this.triggerTabAnimations(e),
              this.checkVisibleTabsLinks(),
              this.updateAjaxify(e, i));
          })
        );
      fetch(this.fetchURL)
        .then((t) => {
          if (!t.ok) {
            throw new Error(t.status);
          }
          return t.text();
        })
        .then((n) => {
          const r = new DOMParser().parseFromString(n, "text/html").querySelector(`[${eo}="${s}"]`).innerHTML;
          var a;
          this.searchForAllTypes && (null === (a = this.container.querySelector(Ns)) || void 0 === a || a.remove());
          ((this.cachedResults[s] = r),
            (o.innerHTML = r),
            "product" !== i || this.searchFilters || (this.searchFilters = new Is(this.container)),
            requestAnimationFrame(() => {
              (this.handleActiveTabClasses(t, e),
                this.scrollToCurrentTabLink(t),
                this.triggerTabAnimations(e),
                this.checkVisibleTabsLinks(),
                this.initInfinityScroll(i));
            }));
        })
        .catch((t) => {
          throw t;
        });
    }
    onHistoryChange(t) {
      var e;
      const i = (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || window.location.search,
        s = i.indexOf("type=product") > -1,
        o = i.indexOf("type=article") > -1,
        n = i.indexOf("type=page") > -1,
        r = s || o || n,
        a = this.container.querySelector(`${Ds}[${no}="product"]`),
        l = this.container.querySelector(`${Ds}[${no}="article"]`),
        c = this.container.querySelector(`${Ds}[${no}="page"]`);
      r
        ? (s &&
            (null == a ||
              a.dispatchEvent(
                new CustomEvent("theme:tab:open-from-history", {
                  bubbles: !0,
                  detail: { element: `[${no}="product"]` },
                }),
              )),
          o &&
            (null == l ||
              l.dispatchEvent(
                new CustomEvent("theme:tab:open-from-history", {
                  bubbles: !0,
                  detail: { element: `[${no}="article"]` },
                }),
              )),
          n &&
            (null == c ||
              c.dispatchEvent(
                new CustomEvent("theme:tab:open-from-history", { bubbles: !0, detail: { element: `[${no}="page"]` } }),
              )))
        : (window.location = i);
    }
    initCustomScrollbar() {
      this.scrollable && !this.customScrollbar && (this.customScrollbar = new Pt(this.container));
    }
    infiniteScrollListener() {
      theme.settings.enableInfinityScroll &&
        ((this.ajaxifyFromFiltersEvent = (t) => this.ajaxifyFromFilters(t)),
        document.addEventListener("theme:tab:ajaxinate", this.ajaxifyFromFiltersEvent));
    }
    ajaxifyFromFilters(t) {
      this.initInfinityScroll(t.detail);
    }
    initInfinityScroll(t) {
      if (!theme.settings.enableInfinityScroll) return;
      if (0 === this.container.querySelectorAll(Ks).length) return;
      const e = this.container.querySelector(`${Os}.${Qs}`),
        i = null == e ? void 0 : e.querySelector(Ks),
        s = null == i ? void 0 : i.classList.contains(Zs);
      e
        ? (!i && this.endlessCollection && this.updateAjaxinateInstancesSettings(t), i && !s && this.initAjaxyfy(t))
        : this.initAjaxyfy(t);
    }
    updateAjaxinateInstancesSettings(t) {
      setTimeout(() => {
        if (0 === this.endlessCollection.endlessScroll.length) return;
        [...this.endlessCollection.endlessScroll].forEach((t) => {
          const e = t.containerElement,
            i = [...this.tab].find((t) => t.classList.contains(Qs));
          !(null !== e.closest(`${Os}.${Qs}`)) && i && (t.settings.method = "click");
        });
        const e = () => this.initProductGridEvents();
        if ("product" === t || "all" === t) {
          const t = (t) =>
              t.settings.container.indexOf("resultsProducts") > -1 || t.settings.container.indexOf("allTypes") > -1,
            i = [...this.endlessCollection.endlessScroll].find(t);
          if (!i) return;
          i.settings.callback = e;
        }
      });
    }
    initAjaxyfy(t) {
      if ("object" != typeof this.endlessCollection)
        return ((this.endlessCollection = new Ii(this.container)), void this.updateAjaxinateInstancesSettings(t));
      this.endlessCollection.endlessScroll.length > 0 &&
        (this.endlessCollection.unload(),
        (this.endlessCollection = new Ii(this.container)),
        this.updateAjaxinateInstancesSettings(t));
    }
    updateAjaxify(t, e) {
      var i;
      if (0 === (null === (i = this.endlessCollection) || void 0 === i ? void 0 : i.endlessScroll.length)) return;
      const s = t.querySelector(Ks),
        o = `${Ks}[${co}="${null == s ? void 0 : s.dataset.ajaxinateId}"]`;
      s && (this.endlessCollection.update(o), this.updateAjaxinateInstancesSettings(e));
    }
    initProductGridEvents() {
      ((this.productGridEvents = new pi(this.container)), this.initTooltips());
    }
    initTooltips() {
      var t, e;
      ((this.tooltips = this.container.querySelectorAll(js)),
      (this.productGrid = this.container.querySelector(Gs)),
      window.innerWidth < theme.sizes.small) &&
        (this.tooltips = null === (e = this.productGrid) || void 0 === e ? void 0 : e.querySelectorAll(js));
      null === (t = this.tooltips) ||
        void 0 === t ||
        t.forEach((t) => {
          new Vt(t);
        });
    }
    tabChange(t, e) {
      t.classList.contains(Qs) ||
        (this.isSearchPage
          ? this.tabChangeFetchContent(t, e)
          : (this.handleActiveTabClasses(t, e),
            this.scrollToCurrentTabLink(t),
            this.triggerTabAnimations(e),
            this.handleTabSliders(e),
            this.checkVisibleTabsLinks()));
    }
    handleActiveTabClasses(t, e) {
      var i;
      const s = this.container.querySelector(`${Os}.${Qs}`),
        o = this.container.querySelector(`${Ds}.${Qs}`);
      (null == s || s.classList.remove(Qs),
        null == o || o.classList.remove(Qs),
        t.classList.add(Qs),
        e.classList.add(Qs),
        t.classList.contains(Xs) && e.classList.add(Xs),
        null === (i = this.tabRef) ||
          void 0 === i ||
          i.forEach((t) => {
            const i = t.classList.contains(Qs),
              s = t.getAttribute(io) === e.getAttribute(eo);
            t.classList.toggle(Qs, !i && s);
          }));
    }
    scrollToCurrentTabLink(t) {
      const e = t.closest(_s) ? t.closest(_s) : t.parentElement,
        i = parseInt(window.getComputedStyle(e).getPropertyValue("padding-left"));
      (e.scrollTo({ top: 0, left: t.offsetLeft - e.offsetWidth / 2 + t.offsetWidth / 2 + i, behavior: "smooth" }),
        t.dispatchEvent(new CustomEvent("theme:custom-scrollbar:change", { bubbles: !0, detail: { element: t } })));
    }
    triggerTabAnimations(t) {
      if ("false" == theme.settings.animationsEnabled) return;
      document.dispatchEvent(new CustomEvent("theme:scroll"));
      const e = this.tabsContents.querySelector(`[${eo}="resultsProducts"]`);
      if (e && e.classList.contains(Qs)) {
        wt(this.tabsContents.querySelectorAll(Ms));
      } else
        (this.tabsContents.querySelectorAll(Fs).forEach((t) => {
          t.classList.remove(Js);
        }),
          this.animateElementsTimer && clearTimeout(this.animateElementsTimer),
          (this.animateElementsTimer = setTimeout(() => {
            t.querySelectorAll(Fs).forEach((t) => {
              t.classList.add(Js);
            });
          }, 150)));
    }
    handleInactiveTabsAnimations() {
      this.tab.forEach((t) => {
        t.classList.contains(Qs) ||
          t.querySelectorAll(Fs).forEach((t) => {
            requestAnimationFrame(() => t.classList.remove(Js));
          });
      });
    }
    handleTabSliders(t) {
      const e = t.querySelector($s);
      e && e.dispatchEvent(new CustomEvent("theme:tab:change", { bubbles: !1 }));
    }
    checkVisibleTabsLinks() {
      const t = this.container.querySelectorAll(Ds),
        e = this.container.querySelectorAll(`${Ds}.${Xs}`);
      t.length - e.length < 2 ? this.container.classList.add(Ys) : this.container.classList.remove(Ys);
    }
    onBlockSelect(t) {
      const e = t.target;
      e &&
        (e.dispatchEvent(new Event("click")),
        e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
    }
    onUnload() {
      (this.customScrollbar && this.customScrollbar.unload(),
        this.isSearchPage &&
          theme.settings.enableInfinityScroll &&
          document.removeEventListener("theme:tab:ajaxinate", this.ajaxifyFromFiltersEvent),
        document.removeEventListener("theme:scroll", this.inactiveTabsAnimationsCallback));
    }
    constructor(t) {
      ((this.container = t),
        (this.tabsContents = t.querySelector(Rs)),
        (this.animateElementsTimer = null),
        (this.isSearchPage = null != t.closest(`[${oo}="true"]`)),
        this.container &&
          ((this.scrollable = this.container.querySelector(zs)),
          (this.tabRef = this.container.querySelectorAll(Bs)),
          (this.tabsLink = this.container.querySelectorAll(Ds)),
          (this.tab = this.container.querySelectorAll(Os)),
          this.assignSearchPageArguments(),
          this.init(),
          this.initCustomScrollbar(),
          this.isSearchPage || this.initTooltips(),
          (this.inactiveTabsAnimationsCallback = window.theme.debounce(() => this.handleInactiveTabsAnimations(), 200)),
          document.addEventListener("theme:scroll", this.inactiveTabsAnimationsCallback),
          this.container.addEventListener("mouseenter", () => {
            this.handleInactiveTabsAnimations();
          })));
    }
  };
  const po = {
      onLoad() {
        ho[this.id] = new uo(this.container);
      },
      onBlockSelect(t) {
        ho[this.id].onBlockSelect(t);
      },
      onUnload() {
        ho[this.id].onUnload();
      },
    },
    mo = "[data-drawer]",
    go = "[data-drawer-toggle]",
    yo = "[data-scroll]",
    fo = "[data-quick-view-item]",
    vo = "[data-quick-view-focus]",
    wo = "[data-mobile-menu]",
    bo = "[data-drawer-block-menu]",
    So = "[data-nav-items-compress]",
    Eo = "[data-popdown-toggle]",
    Lo = "[data-nav-search-open]",
    ko = "[data-nav-link-mobile]",
    Ao = "[data-mobile-menu-trigger]",
    Co = "[data-collapsible-trigger]",
    qo = "[data-scrollable-menu-blocks]",
    To = "is-open",
    Po = "js-drawer-open",
    xo = "js-drawer-open--inner",
    Io = "js-drawer-open--inner-qv",
    Ho = "cv-h",
    Fo = "shopify-section-mobile-menu",
    Mo = "drawer__content-scroll--has-scroll",
    Do = "data-drawer",
    Oo = "data-drawer-header",
    Bo = "data-drawer-section",
    zo = "aria-expanded",
    _o = "aria-controls",
    $o = "aria-hidden",
    Ro = "data-mobile-menu-trigger",
    Vo = "data-drawer-block";
  let No = {},
    Wo = class {
      initListeners() {
        (this.drawerToggleButtons.forEach((t) => {
          t.addEventListener("click", this.drawerToggleEvent);
        }),
          this.drawers.forEach((t) => {
            (t.addEventListener("keyup", this.keyPressCloseEvent),
              (this.collapsible = new dt(t)),
              (this.tabs = new uo(t)));
          }),
          document.addEventListener("click", this.drawerCloseEvent),
          document.addEventListener("theme:drawer:closing", this.drawerCloseEvent),
          document.addEventListener("theme:drawer:opening", this.drawerOpenEvent),
          window.addEventListener("resize", this.checkScroll),
          document.addEventListener("theme:drawer:open", this.checkScroll),
          this.checkScroll());
      }
      initMutationObserver() {
        ((this.mutationObserver = new MutationObserver((t) => {
          t.some(
            (t) =>
              "childList" === t.type ||
              ("attributes" === t.type && ("style" === t.attributeName || "class" === t.attributeName)),
          ) && this.checkScroll();
        })),
          this.drawerMenus.forEach((t) => {
            this.mutationObserver.observe(t, { childList: !0, subtree: !0, attributes: !0 });
          }));
      }
      toggle(t) {
        t.preventDefault();
        const e = document.querySelector(`#${t.target.getAttribute(_o)}`);
        if (!e) return;
        e.classList.contains(To) ? this.close() : this.open(t);
      }
      open(t) {
        let e = t.detail.element;
        e || (e = t.target);
        const i = e.getAttribute(_o);
        let s;
        if (e.hasAttribute(Ro)) {
          const t = document.querySelector(`mobile-menu[${Oo}]`),
            e = document.querySelector(`mobile-menu[${Bo}]`);
          s = ("new" === theme.settings.mobileMenuType && e) || t;
        } else s = document.querySelector(`#${i}`);
        if (!s) return;
        const o = s.querySelector(yo) || s;
        (document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: o })),
          document.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !0 })),
          this.body.classList.add(Po),
          ((null == i ? void 0 : i.includes("size-chart")) || (null == i ? void 0 : i.includes("popup-text"))) &&
            (this.body.classList.add(xo), i.includes("quickview") && this.body.classList.add(Io)),
          s.classList.add(To),
          s.setAttribute($o, !1),
          s.classList.remove(Ho),
          e.setAttribute(zo, !0));
        const n = (t) => {
          const i = "transform" === t.propertyName || "top" === t.propertyName;
          t.target === s &&
            i &&
            ((this.a11y.state.trigger = e),
            this.a11y.trapFocus({ container: s }),
            s.removeEventListener("transitionend", n));
        };
        s.addEventListener("transitionend", n);
      }
      close(t = !1) {
        if (!this.body.classList.contains(Po)) return;
        const e = document.querySelector(`${mo}.${To}`);
        (this.drawerToggleButtons.forEach((t) => {
          t.setAttribute(zo, !1);
        }),
          this.a11y.removeTrapFocus({ container: e }),
          null == e || e.classList.remove(To));
        const i = (t) => {
          t.target === e &&
            (requestAnimationFrame(() => {
              (null == e || e.classList.add(Ho),
                document.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: !0 })),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                null == e || e.setAttribute($o, !0));
            }),
            null == e || e.removeEventListener("transitionend", i));
        };
        if (
          (null == e || e.addEventListener("transitionend", i),
          this.body.classList.remove(Po),
          this.body.classList.remove(xo),
          this.body.classList.contains(Io))
        ) {
          if ((this.body.classList.remove(Io), t && t.code === theme.keyboardKeys.ESCAPE))
            return ((this.a11y.state.trigger = this.a11y.state.mainTrigger), void this.a11y.state.trigger.focus());
          const e = this.a11y.state.trigger.closest(vo);
          (this.a11y.trapFocus({ container: e, elementToFocus: this.a11y.state.trigger }),
            (this.a11y.state.trigger = this.a11y.state.mainTrigger));
        }
      }
      checkScroll() {
        const t = document.querySelector(qo);
        if (!t) return;
        const e = t.scrollHeight > t.clientHeight;
        t.classList.toggle(Mo, e);
      }
      onUnload() {
        (this.close(),
          this.drawerToggleButtons.forEach((t) => {
            t.removeEventListener("click", this.drawerToggleEvent);
          }),
          this.drawers.forEach((t) => {
            t.removeEventListener("keyup", this.keyPressCloseEvent);
          }),
          document.removeEventListener("click", this.drawerCloseEvent),
          document.removeEventListener("theme:drawer:closing", this.drawerCloseEvent),
          document.removeEventListener("theme:drawer:opening", this.drawerOpenEvent),
          window.removeEventListener("resize", this.checkScroll),
          document.removeEventListener("theme:drawer:open", this.checkScroll),
          this.mutationObserver && this.mutationObserver.disconnect(),
          this.collapsible && this.collapsible.onUnload(),
          this.tabs && this.tabs.onUnload());
      }
      constructor(t) {
        ((this.container = t),
          (this.body = document.body),
          (this.drawers = this.container.querySelectorAll(mo)),
          (this.drawerToggleButtons = this.container.querySelectorAll(go)),
          (this.a11y = window.theme.a11y),
          this.container.hasAttribute(Do) && (this.drawers = [this.container]),
          (this.drawerToggleEvent = window.theme.throttle((t) => {
            this.toggle(t);
          }, 150)),
          (this.drawerOpenEvent = (t) => {
            this.open(t);
          }),
          (this.keyPressCloseEvent = window.theme.throttle((t) => {
            t.code === theme.keyboardKeys.ESCAPE && this.close(t);
          }, 150)),
          (this.drawerCloseEvent = (t) => {
            const e = document.querySelector(`${mo}.${To}`);
            let i = !1;
            if (!e) return;
            "click" === t.type && (i = t.target.matches(go));
            const s = !!e && e.contains(t.target),
              o = e.closest(fo),
              n = !!o && o.contains(t.target);
            i || s || n || this.close();
          }),
          (this.drawerMenus = document.querySelectorAll(bo)),
          (this.checkScroll = this.checkScroll.bind(this)),
          this.initListeners(),
          this.initMutationObserver());
      }
    };
  const Uo = {
    onLoad() {
      No[this.id] = new Wo(this.container);
    },
    onUnload() {
      No[this.id].onUnload();
    },
  };
  let jo = class extends HTMLElement {
    connectedCallback() {
      ((this.drawerInstance = new Wo(this.container)),
        this.initMobileNav(),
        document.addEventListener("shopify:block:select", this.showDrawerOnSelect),
        document.addEventListener("shopify:section:load", this.showDrawerOnSelect),
        document.addEventListener("shopify:section:select", this.showDrawerOnSelect),
        document.addEventListener("shopify:section:deselect", this.hideDrawerOnDeselect));
    }
    initMobileNav() {
      const t = this.container.querySelector(go),
        e = this.container.querySelectorAll(Lo);
      if (
        (null == e ||
          e.forEach((e) => {
            e.addEventListener("click", (e) => {
              e.preventDefault();
              const i = document.querySelector(wo),
                s = document.querySelector(So);
              let o = matchMedia("(pointer:coarse)").matches;
              window.innerWidth < theme.sizes.small && window.Shopify.designMode && (o = !0);
              const n = o ? (null == i ? void 0 : i.querySelector(Eo)) : null == s ? void 0 : s.querySelector(Eo);
              t.dispatchEvent(new Event("click", { bubbles: !0 }));
              const r = (t) => {
                t.target === this.container &&
                  (requestAnimationFrame(() =>
                    null == n ? void 0 : n.dispatchEvent(new Event("click", { bubbles: !0 })),
                  ),
                  this.container.removeEventListener("transitionend", r));
              };
              this.container.addEventListener("transitionend", r);
            });
          }),
        "link" === theme.settings.mobileMenuBehaviour)
      )
        return;
      const i = this.container.querySelectorAll(ko);
      i.length &&
        i.forEach((t) => {
          t.addEventListener("click", (e) => {
            const i = t.parentNode.querySelectorAll(Co).length,
              s = t.nextElementSibling;
            i && (e.preventDefault(), s.dispatchEvent(new Event("click"), { bubbles: !0 }));
          });
        });
    }
    showDrawerOnSelect(t) {
      if (t.target.classList.contains(Fo) || t.target.hasAttribute(Vo)) {
        if (
          !(t.target.querySelector("mobile-menu") || t.target.closest("mobile-menu")) ||
          "old" === theme.settings.mobileMenuType
        )
          return;
        if (!document.body.classList.contains(Po)) {
          const t = document.querySelector(Ao);
          null == t || t.dispatchEvent(new Event("click", { bubbles: !0 }));
        }
      }
    }
    hideDrawerOnDeselect(t) {
      if (t.target.classList.contains(Fo) || t.target.hasAttribute(Vo)) {
        if (!(t.target.querySelector("mobile-menu") || t.target.closest("mobile-menu"))) return;
        document.body.classList.contains(Po) &&
          document.dispatchEvent(new CustomEvent("theme:drawer:closing", { bubbles: !0 }));
      }
    }
    disconnectedCallback() {
      (this.drawerInstance && (this.drawerInstance.onUnload(), (this.drawerInstance = null)),
        document.removeEventListener("shopify:block:select", this.showDrawerOnSelect),
        document.removeEventListener("shopify:section:load", this.showDrawerOnSelect),
        document.removeEventListener("shopify:section:select", this.showDrawerOnSelect),
        document.removeEventListener("shopify:section:deselect", this.hideDrawerOnDeselect));
    }
    constructor() {
      (super(),
        (this.container = this),
        (this.drawerInstance = null),
        (this.showDrawerOnSelect = this.showDrawerOnSelect.bind(this)),
        (this.hideDrawerOnDeselect = this.hideDrawerOnDeselect.bind(this)));
    }
  };
  customElements.get("mobile-menu") || customElements.define("mobile-menu", jo);
  const Go = { loading: "is-loading", imgIn: "img-in" },
    Ko = { img: "img.is-loading", section: "[data-section-type]" };
  function Qo(t) {
    t.querySelectorAll(Ko.img).forEach((t) => {
      if (t.complete) {
        (t.classList.remove(Go.loading), t.parentNode.classList.remove(Go.loading));
        const e = t.closest(Ko.section);
        e && e.classList.add(Go.imgIn);
      }
    });
  }
  const Xo = (t, e = !1, i = "block") => {
      t && (e ? t.style.removeProperty("display") : (t.style.display = i));
    },
    Yo = (t) => {
      t && (t.style.display = "none");
    },
    Jo = "[data-store-availability-list]",
    Zo = {
      close: ".js-modal-close",
      open: ".js-modal-open-store-availability-modal",
      openClass: "modal--is-active",
      openBodyClass: "modal--is-visible",
      closeModalOnClick: !1,
      scrollIntoView: !1,
    };
  const tn = "body",
    en = "[data-store-availability-modal]",
    sn = "[data-store-availability-modal-open]",
    on = "[data-store-availability-modal-close]",
    nn = "[data-store-availability-modal-product__title]",
    rn = "store-availabilities-modal--active";
  const an = "[data-product-form]",
    ln = "[data-option-position]",
    cn = '[name^="options"], [data-popout-option]',
    hn = "sold-out",
    dn = "unavailable",
    un = "data-option-position",
    pn = "data-value";
  const mn = 1,
    gn = "data-notification-popup",
    yn = { history: !1, focus: !1, mainClass: "pswp--notification pswp--not-close-btn", closeOnVerticalDrag: !1 };
  let fn = class {
    init() {
      const t = [{ html: this.notificationPopupHtml }];
      ((this.a11y.state.trigger = this.button), new window.theme.LoadPhotoswipe(t, yn, mn));
    }
    constructor(t) {
      ((this.button = t),
        (this.a11y = window.theme.a11y),
        (this.notificationPopupHtml = this.button.getAttribute(gn)),
        "" !== this.notificationPopupHtml.trim() && this.init());
    }
  };
  const vn = "[data-product]",
    wn = "[data-product-form]",
    bn = "[data-add-to-cart]",
    Sn = "[data-add-to-cart-text]",
    En = "[data-buy-it-now]",
    Ln = "[data-compare-price]",
    kn = "[data-form-wrapper]",
    An = "[data-site-header]",
    Cn = "[data-item-count-for-variant]",
    qn = "[data-max-inventory]",
    Tn = "[data-product-select]",
    Pn = "_preorder",
    xn = "[data-price-wrapper]",
    In = "[data-price-off]",
    Hn = "[data-price-off-amount]",
    Fn = "[data-product-slide]",
    Mn = "[data-product-image]",
    Dn = "[data-product-single-media-slider]",
    On = "[data-product-json]",
    Bn = "[data-product-price]",
    zn = "[data-product-unit-price]",
    _n = "[data-product-base]",
    $n = "[data-product-unit]",
    Rn = "[data-subscription-watch-price]",
    Vn = "[data-subscription-selectors]",
    Nn = "[data-toggles-group]",
    Wn = "data-group-toggle",
    Un = "[data-plan-description]",
    jn = "[data-remaining-count]",
    Gn = "[data-remaining-wrapper]",
    Kn = "[data-product-remaining-json]",
    Qn = "[data-store-availability-container]",
    Xn = "[data-upsell-btn]",
    Yn = ".shopify-section",
    Jn = "[data-quick-view-item]",
    Zn = "[data-notification-button-text]",
    tr = "[data-swatches-container]",
    er = "[data-swatches-more]",
    ir = "[data-option-position]",
    sr = "[data-variant-buttons]",
    or = "[data-variant-option-image]",
    nr = ".shopify-payment-button__button--unbranded",
    rr = "[data-variant-final-sale-metafield]",
    ar = "[data-final-sale-badge]",
    lr = "hidden",
    cr = "variant--soldout",
    hr = "variant--unavailabe",
    dr = "product__price--sale",
    ur = "product__price--hidden",
    pr = "count-is-low",
    mr = "count-is-in",
    gr = "count-is-out",
    yr = "count-is-unavailable",
    fr = "selector-wrapper--visible",
    vr = "data-image-id",
    wr = "data-tall-layout",
    br = "data-enable-history-state",
    Sr = "data-notification-popup",
    Er = "data-swatch-variant",
    Lr = "data-atc-button",
    kr = "data-max-inventory-reached",
    Ar = "data-error-message-position",
    Cr = "data-variant-title",
    qr = "data-final-sale";
  let Tr = {},
    Pr = class {
      init() {
        let t = null;
        const e = this.container.querySelector(On);
        (e && (t = e.innerHTML),
          t
            ? ((this.productJSON = JSON.parse(t)),
              this.linkForm(),
              (this.sellout = new (class {
                init() {
                  this.update();
                }
                update() {
                  (this.getCurrentState(),
                    this.optionElements.forEach((t) => {
                      const e = t.value || t.getAttribute(pn),
                        i = t.closest(ln);
                      if (!i) return;
                      const s = i.getAttribute(un),
                        o = parseInt(s, 10) - 1;
                      let n = [...this.selections];
                      n[o] = e;
                      const r = this.productJSON.variants.find((t) => {
                        let e = !0;
                        for (let i = 0; i < n.length; i++) t.options[i] !== n[i] && (e = !1);
                        return e;
                      });
                      (t.parentElement.classList.remove(hn, dn),
                        void 0 === r
                          ? t.parentElement.classList.add(dn)
                          : !1 === (null == r ? void 0 : r.available) && t.parentElement.classList.add(hn));
                    }));
                }
                getCurrentState() {
                  for (var t of ((this.formData = new FormData(this.form)),
                  (this.selections = []),
                  this.formData.entries()))
                    t[0].includes("options[") && this.selections.push(t[1]);
                }
                constructor(t, e) {
                  ((this.container = t),
                    (this.productJSON = e),
                    (this.form = this.container.querySelector(an)),
                    (this.formData = new FormData(this.form)),
                    (this.optionElements = this.container.querySelectorAll(cn)),
                    this.productJSON && this.form && this.init());
                }
              })(this.container, this.productJSON)))
            : console.error("Missing product JSON"),
          this.hasVariantOptionWithImage &&
            ((this.variantButtonsContainer = this.variantOptionImages[0].closest(sr)),
            this.equalizeImageOptionContainers()));
      }
      resizeEvents() {
        this.hasVariantOptionWithImage && this.equalizeImageOptionContainers();
      }
      linkForm() {
        this.productForm = new (class {
          destroy() {
            this._listeners.removeAll();
          }
          options() {
            return this._serializeInputValues(this.optionInputs, function (t) {
              return ((t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t);
            });
          }
          variant() {
            const t = this.options();
            return t.length ? ne(this.product, t) : this.product.variants[0];
          }
          plan(t) {
            let e = { allocation: null, group: null, detail: null };
            const i = new FormData(this.form).get("selling_plan");
            return (
              i &&
                t &&
                (e.allocation = t.selling_plan_allocations.find(function (t) {
                  return t.selling_plan_id.toString() === i.toString();
                })),
              e.allocation &&
                (e.group = this.product.selling_plan_groups.find(function (t) {
                  return t.id.toString() === e.allocation.selling_plan_group_id.toString();
                })),
              e.group &&
                (e.detail = e.group.selling_plans.find(function (t) {
                  return t.id.toString() === i.toString();
                })),
              e && e.allocation && e.detail && e.allocation ? e : null
            );
          }
          properties() {
            return this._serializeInputValues(this.propertyInputs, function (t) {
              return ((t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t);
            });
          }
          quantity() {
            return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
          }
          getFormState() {
            const t = this.variant();
            return {
              options: this.options(),
              variant: t,
              properties: this.properties(),
              quantity: this.quantity(),
              plan: this.plan(t),
            };
          }
          _setIdInputValue(t) {
            (t && t.id ? (this.variantElement.value = t.id.toString()) : (this.variantElement.value = ""),
              this.variantElement.dispatchEvent(new Event("change")));
          }
          _onSubmit(t, e) {
            ((e.dataset = this.getFormState()), t.onFormSubmit && t.onFormSubmit(e));
          }
          _onOptionChange(t) {
            this._setIdInputValue(t.dataset.variant);
          }
          _onFormEvent(t) {
            return void 0 === t
              ? Function.prototype.bind()
              : function (e) {
                  ((e.dataset = this.getFormState()), this._setIdInputValue(e.dataset.variant), t(e));
                }.bind(this);
          }
          _initInputs(t, e) {
            return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(
              function (t) {
                return (this._listeners.add(t, "change", this._onFormEvent(e)), t);
              }.bind(this),
            );
          }
          _serializeInputValues(t, e) {
            return t.reduce(function (t, i) {
              return (
                (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) &&
                  t.push(e({ name: i.name, value: i.value })),
                t
              );
            }, []);
          }
          _validateProductObject(t) {
            if ("object" != typeof t) throw new TypeError(t + " is not an object.");
            if (void 0 === t.variants[0].options)
              throw new TypeError(
                "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route",
              );
            return t;
          }
          constructor(t, e, i) {
            ((this.element = t),
              (this.form = "FORM" == this.element.tagName ? this.element : this.element.querySelector("form")),
              (this.product = this._validateProductObject(e)),
              (this.variantElement = this.element.querySelector(ae)),
              (i = i || {}),
              (this._listeners = new oe()),
              this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)),
              (this.optionInputs = this._initInputs(ce, i.onOptionChange)),
              (this.planInputs = this._initInputs(le, i.onPlanChange)),
              (this.quantityInputs = this._initInputs(he, i.onQuantityChange)),
              (this.propertyInputs = this._initInputs(de, i.onPropertyChange)));
          }
        })(this.productForm, this.productJSON, {
          onOptionChange: this.onOptionChange.bind(this),
          onPlanChange: this.onPlanChange.bind(this),
          onQuantityChange: this.onQuantityChange.bind(this),
        });
        const t = this.productForm.getFormState();
        if ((this.pushState(t, !0), this.subsToggleListeners(), this.swatchesContainer)) {
          this.observeSwatch(t);
          const e = this.swatchesContainer.closest(ir),
            i = e.querySelector(er);
          null == i ||
            i.addEventListener("click", (t) => {
              (t.preventDefault(), e.classList.contains(fr) ? e.classList.remove(fr) : e.classList.add(fr));
            });
        }
        ((this.checkLiveCartInfoCallback = () => this.checkLiveCartInfo()),
          document.addEventListener("theme:cart:close", this.checkLiveCartInfoCallback));
      }
      onOptionChange(t) {
        (this.pushState(t.dataset), this.updateProductImage(t));
      }
      onPlanChange(t) {
        this.subPrices && this.pushState(t.dataset);
      }
      onQuantityChange(t) {
        this.pushState(t.dataset);
      }
      pushState(t, e = !1) {
        var i;
        ((this.productState = this.setProductState(t)),
          this.updateAddToCartState(t),
          this.updateProductPrices(t),
          this.updateSaleText(t),
          this.updateSubscriptionText(t),
          this.updateTitleAttr(t),
          this.fireHookEvent(t),
          this.updateRemaining(t),
          this.checkLiveCartInfo(t),
          null === (i = this.sellout) || void 0 === i || i.update(t),
          this.enableHistoryState && !e && this.updateHistoryState(t),
          this.storeAvailability &&
            (t.variant
              ? this.storeAvailability.updateContent(t.variant.id, this.productForm.product.title)
              : this.storeAvailability.clearContent()));
      }
      updateTitleAttr(t) {
        const e = t.variant;
        if (!e) return;
        let i = this.productForm.product.title;
        (e.public_title && (i += ` - ${e.title}`), this.productForm.element.setAttribute(Cr, i));
      }
      updateAddToCartState(t) {
        const e = t.variant,
          i = this.container.querySelectorAll(xn),
          s = this.container.querySelectorAll(bn),
          o = this.container.querySelectorAll(Sn),
          n = this.container.querySelectorAll(kn),
          r = this.container.querySelector(En);
        let a = theme.strings.add_to_cart;
        (theme.settings.atcButtonShowPrice &&
          (a = `${a}<span data-product-price class="product__price--regular"></span> <s data-compare-price class="product__price--compare"></s>`),
          this.productJSON.tags.includes(Pn) && (a = theme.strings.preorder),
          null == i ||
            i.forEach((t) => {
              t.hasAttribute(Lr) || t.classList.toggle(ur, !e);
            }),
          null == s ||
            s.forEach((t) => {
              var i;
              if (t.matches(Xn)) return;
              if (((t.disabled = !0), null == r || r.classList.add(lr), !e)) return;
              if (((t.disabled = !1), e.available && (null == r || r.classList.remove(lr)), !t.hasAttribute(Sr)))
                return;
              const s = t.id.replace("AddToCart", "NotificationForm"),
                o = this.sessionStorage.getItem("notification_form_id");
              let n = !1,
                a = e.id,
                l = e.name,
                c = e.title;
              if (o) {
                const t = o.substring(0, o.lastIndexOf("--")),
                  e = o.split("--").slice(-1)[0];
                ((n = s === t),
                  n &&
                    ((this.latestVariantId = a),
                    (this.latestVariantName = l),
                    (this.latestVariantTitle = c),
                    (a = Number(e)),
                    this.productJSON.variants.forEach((t) => {
                      t.id === a && ((l = t.name), (c = t.title));
                    })));
              }
              let h = t.getAttribute(Sr);
              const d =
                null === (i = new DOMParser().parseFromString(h, "text/html").querySelector(Zn)) || void 0 === i
                  ? void 0
                  : i.innerHTML;
              if ("" != this.latestVariantId && "" != this.latestVariantTitle) {
                var u;
                ((h = h.replaceAll(this.latestVariantId, a)),
                  (h = h.replaceAll(
                    `<p class='product__notification__subtitle'>${this.latestVariantTitle}</p>`,
                    `<p class='product__notification__subtitle'>${c}</p>`,
                  )),
                  (h = h.replaceAll(`value='${this.latestVariantName}'>`, `value='${l}'>`)));
                const t =
                  null === (u = new DOMParser().parseFromString(h, "text/html").querySelector(Zn)) || void 0 === u
                    ? void 0
                    : u.innerHTML;
                h = h.replace(t, d);
              }
              (t.setAttribute(Sr, h),
                n && (this.scrollToForm(this.product.closest(Yn)), new fn(t)),
                (this.latestVariantId = a),
                (this.latestVariantName = l),
                (this.latestVariantTitle = c));
            }),
          null == o ||
            o.forEach((t) => {
              if (e) {
                if (e.available) t.innerHTML = a;
                else if (((t.innerHTML = theme.strings.sold_out), t.parentNode.hasAttribute(Sr))) {
                  if (t.closest(Jn)) return;
                  t.innerHTML = `${theme.strings.sold_out} - ${theme.strings.newsletter_product_availability}`;
                }
              } else t.innerHTML = theme.strings.unavailable;
            }),
          null == n ||
            n.forEach((t) => {
              if (!e) return (t.classList.add(hr), void t.classList.remove(cr));
              const i = t.querySelector(Tn);
              if ((i && (i.value = e.id), !e.available)) return (t.classList.add(cr), void t.classList.remove(hr));
              t.classList.remove(cr, hr);
            }));
      }
      updateHistoryState(t) {
        const e = t.variant,
          i = t.plan,
          s = window.location.href;
        if (e && s.includes("/product")) {
          const t = new window.URL(s),
            o = t.searchParams;
          (o.set("variant", e.id),
            i && i.detail && i.detail.id && this.productState.hasPlan
              ? o.set("selling_plan", i.detail.id)
              : o.delete("selling_plan"),
            (t.search = o.toString()));
          const n = t.toString();
          window.history.replaceState({ path: n }, "", n);
        }
      }
      updateRemaining(t) {
        const e = t.variant,
          i = [mr, gr, yr, pr];
        if (e && this.remainingWrapper && this.remainingJSON) {
          const t = this.remainingJSON[e.id];
          (("out" === t || t < 1) &&
            (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(gr)),
            ("in" === t || t >= this.remainingMaxInt) &&
              (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(mr)),
            ("low" === t || (t > 0 && t < this.remainingMaxInt)) &&
              (this.remainingWrapper.classList.remove(...i),
              this.remainingWrapper.classList.add(pr),
              this.remainingCount && (this.remainingCount.innerHTML = t)));
        } else
          !e &&
            this.remainingWrapper &&
            (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(yr));
      }
      checkLiveCartInfo(t) {
        const e = (t || this.productForm.getFormState()).variant;
        if (!e) return;
        const i = `${theme.routes.root}products/${this.productJSON.handle}?section_id=api-live-cart-info&variant=${e.id}`;
        fetch(i)
          .then((t) => t.text())
          .then((t) => {
            const e = new DOMParser().parseFromString(t, "text/html"),
              i = Number(e.querySelector(Cn).innerHTML),
              s = e.querySelector(qn).innerHTML,
              o = Number(s),
              n = Boolean(this.productForm.quantity() + i > o),
              r = "" !== s && n,
              a = "" !== s && i === o ? "form" : "cart";
            (this.productForm.element.setAttribute(kr, r), this.productForm.element.setAttribute(Ar, a));
          })
          .catch((t) => console.log("error: ", t));
      }
      equalizeImageOptionContainers() {
        if (this.variantOptionImages.length <= 1) return;
        const t = [...this.variantOptionImages].map((t) => Math.floor(t.offsetHeight)),
          e = [...this.variantOptionImages].map((t) => Math.floor(t.offsetWidth)),
          i = Math.max(...e),
          s = Math.max(...t);
        (this.variantButtonsContainer.style.setProperty("--option-image-width", i + "px"),
          this.variantButtonsContainer.style.setProperty("--option-image-height", s + "px"));
      }
      getBaseUnit(t) {
        return 1 === t.unit_price_measurement.reference_value
          ? t.unit_price_measurement.reference_unit
          : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
      }
      subsToggleListeners() {
        this.container.querySelectorAll(Nn).forEach((t) => {
          t.addEventListener(
            "change",
            function (t) {
              const e = t.target.value.toString(),
                i = this.container.querySelector(`[${Wn}="${e}"]`),
                s = this.container.querySelectorAll(`[${Wn}]`);
              if (i) {
                i.classList.remove(lr);
                const t = i.querySelector('[name="selling_plan"]');
                ((t.checked = !0), t.dispatchEvent(new Event("change")));
              }
              s.forEach((t) => {
                if (t !== i) {
                  t.classList.add(lr);
                  t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                    ((t.checked = !1), t.dispatchEvent(new Event("change")));
                  });
                }
              });
            }.bind(this),
          );
        });
      }
      updateSaleText(t) {
        this.productState.planSale
          ? this.updateSaleTextSubscription(t)
          : this.productState.onSale
            ? this.updateSaleTextStandard(t)
            : this.priceOffWrap && this.priceOffWrap.classList.add(lr);
      }
      isVariantFinalSale(t) {
        var e;
        const i = null === (e = document.querySelector(rr)) || void 0 === e ? void 0 : e.textContent;
        if (!i) return;
        const s = JSON.parse(i);
        let o = !1;
        return (
          s.forEach((e) => {
            Number(e.variant_id) === t.id && (o = "true" === e.metafield_value);
          }),
          o
        );
      }
      updateSaleTextStandard(t) {
        var e, i;
        if (!this.priceOffWrap) return;
        const s = t.variant,
          o = null === (e = this.priceOffWrap) || void 0 === e ? void 0 : e.querySelector(ar),
          n = null == s ? void 0 : s.compare_at_price,
          r = null == s ? void 0 : s.price;
        if (window.theme.settings.showSavingBadge)
          if (window.theme.settings.savingBadgeType && "percentage" === window.theme.settings.savingBadgeType) {
            const t = (n - r) / n,
              e = Math.floor(100 * t);
            this.priceOffAmount.innerHTML = `${e}%`;
          } else {
            const t = n - r;
            this.priceOffAmount.innerHTML = window.theme.formatMoney(t, theme.moneyFormat);
          }
        const a =
          (null === (i = this.priceOffWrap) || void 0 === i ? void 0 : i.hasAttribute(qr)) ||
          this.isVariantFinalSale(s);
        (o && o.classList.toggle(lr, !a), this.priceOffWrap.classList.remove(lr));
      }
      updateSaleTextSubscription(t) {
        const e = t.variant,
          i = this.productForm.product.selling_plan_groups.find(
            (t) => t.id === e.selling_plan_allocations[0].selling_plan_group_id,
          ),
          s = t.plan ? t.plan.detail.price_adjustments[0] : i.selling_plans[0].price_adjustments[0],
          o = s.value || 0,
          n = "percentage" === s.value_type ? `${o}%` : window.theme.formatMoney(e.price - o, theme.moneyFormat);
        ((this.priceOffAmount.innerHTML = n), this.priceOffWrap.classList.remove(lr));
      }
      updateSubscriptionText(t) {
        t.plan && this.planDecription && null !== t.plan.detail.description
          ? ((this.planDecription.innerHTML = t.plan.detail.description), this.planDecription.classList.remove(lr))
          : this.planDecription && this.planDecription.classList.add(lr);
      }
      updateProductPrices(t) {
        const e = t.variant,
          i = t.plan;
        (this.container.querySelectorAll(xn).forEach((t) => {
          const s = t.querySelector(Ln),
            o = t.querySelector(Bn);
          let n = "",
            r = "";
          if ((this.productState.available && ((n = e.compare_at_price), (r = e.price)), this.productState.hasPlan)) {
            r = i ? i.allocation.price : e.selling_plan_allocations[0].per_delivery_price;
          }
          if (this.productState.planSale) {
            const t = i ? i.allocation.price : e.selling_plan_allocations[0].per_delivery_price;
            ((n = i ? i.allocation.compare_at_price : e.selling_plan_allocations[0].compare_at_price), (r = t));
          }
          if (
            (s &&
              (this.productState.onSale || this.productState.planSale
                ? (s.classList.remove(lr), o.classList.add(dr))
                : (s.classList.add(lr), o.classList.remove(dr)),
              (s.innerHTML = theme.settings.currency_code_enable
                ? window.theme.formatMoney(n, theme.moneyWithCurrencyFormat)
                : window.theme.formatMoney(n, theme.moneyFormat))),
            o)
          ) {
            if (t.hasAttribute(Lr)) {
              r *= this.productForm.quantity();
            }
            o.innerHTML =
              0 === r
                ? window.theme.strings.free
                : theme.settings.currency_code_enable
                  ? window.theme.formatMoney(r, theme.moneyWithCurrencyFormat)
                  : window.theme.formatMoney(r, theme.moneyFormat);
          }
        }),
          this.hasUnitPricing && this.updateProductUnits(t));
      }
      updateProductUnits(t) {
        const e = t.variant,
          i = t.plan;
        let s = null;
        if (
          (((e && e.unit_price) || (!i && !e.requires_selling_plan)) && (s = e.unit_price),
          i &&
            (null == i ? void 0 : i.allocation) &&
            (null == i ? void 0 : i.allocation.unit_price) &&
            (s = i.allocation.unit_price),
          !i && e.requires_selling_plan && e.selling_plan_allocations && e.selling_plan_allocations.length > 0)
        ) {
          s = e.selling_plan_allocations[0].unit_price;
        }
        if (s) {
          const t = this.getBaseUnit(e),
            i = 0 === s ? window.theme.strings.free : window.theme.formatMoney(s, theme.moneyFormat);
          ((this.container.querySelector(zn).innerHTML = i),
            (this.container.querySelector(_n).innerHTML = t),
            Xo(this.container.querySelector($n)));
        } else Yo(this.container.querySelector($n));
      }
      fireHookEvent(t) {
        const e = t.variant;
        this.container.dispatchEvent(new CustomEvent("theme:variant:change", { detail: { variant: e }, bubbles: !0 }));
      }
      setProductState(t) {
        const e = t.variant,
          i = t.plan,
          s = {
            available: !0,
            soldOut: !1,
            onSale: !1,
            showUnitPrice: !1,
            requiresPlan: !1,
            hasPlan: !1,
            planPerDelivery: !1,
            planSale: !1,
          };
        if (e) {
          const t = e.requires_selling_plan || !1;
          (e.available || (s.soldOut = !0),
            e.compare_at_price > e.price && (s.onSale = !0),
            e.unit_price && (s.showUnitPrice = !0),
            this.product && this.product.requires_selling_plan && (s.requiresPlan = !0),
            i &&
              this.subPrices &&
              ((s.hasPlan = !0),
              i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0),
              e.price > i.allocation.price && (s.planSale = !0)),
            !i &&
              t &&
              ((s.hasPlan = !0),
              e.selling_plan_allocations[0].per_delivery_price !== e.selling_plan_allocations[0].price &&
                (s.planPerDelivery = !0),
              e.price > e.selling_plan_allocations[0].price && (s.planSale = !0)));
        } else s.available = !1;
        return s;
      }
      updateProductImage(t) {
        const e = t.dataset.variant;
        if (!e || !(null == e ? void 0 : e.featured_media)) return;
        const i = this.container.querySelector(`${Mn}[${vr}="${e.featured_media.id}"]`),
          s = null == i ? void 0 : i.closest(Fn);
        if (s) {
          const t = parseInt([...s.parentElement.children].indexOf(s)),
            o = this.container.querySelector(Dn),
            n = window.theme.Flickity.data(o);
          if (n && n.isActive) {
            const t = o.querySelector(`[data-id="${e.featured_media.id}"]`);
            if (t) {
              const e = parseInt([...t.parentNode.children].indexOf(t));
              n.select(e);
            }
            return;
          }
          if (this.tallLayout) {
            const e = i.getBoundingClientRect().top;
            if (0 === t && e + window.scrollY > window.pageYOffset) return;
            (document.dispatchEvent(
              new CustomEvent("theme:tooltip:close", { bubbles: !1, detail: { hideTransition: !1 } }),
            ),
              window.theme.scrollTo(e));
          }
        }
      }
      observeSwatch(t) {
        const e = this.swatchesContainer.querySelector(`[${Er}*="${t.variant.id}"]`);
        (this.swatchesContainer.closest(ir).classList.remove(fr),
          new IntersectionObserver(
            (t, e) => {
              t.forEach((t) => {
                0 == t.intersectionRatio && this.swatchesContainer.closest(ir).classList.add(fr);
              });
            },
            { root: this.container, threshold: [0.95, 1] },
          ).observe(e));
      }
      observeContainer() {
        let t = this.buyItNow.querySelector(nr);
        if (t)
          return (
            t.classList.add(window.theme.settings.buynowButtonColor),
            t.classList.add(window.theme.settings.buynowButtonStyle),
            t.classList.add(window.theme.settings.buynowButtonSize),
            void this.insertHoverElement(t)
          );
        ((this.mutationObserver = new MutationObserver((t) => {
          for (const i of t)
            if ("childList" === i.type) {
              const t = i.target.querySelector(nr);
              var e;
              if (t)
                (this.insertHoverElement(t),
                  null === (e = this.mutationObserver) || void 0 === e || e.disconnect(),
                  (this.mutationObserver = null));
            }
        })),
          this.mutationObserver.observe(this.buyItNow, { childList: !0, subtree: !0 }));
      }
      insertHoverElement(t) {
        const e = t.innerHTML;
        t.innerHTML = `<hover-button>${e}</hover-button>`;
      }
      scrollToForm(t) {
        var e;
        const i = null === (e = document.querySelector(An)) || void 0 === e ? void 0 : e.dataset.height;
        visibilityHelper.isElementPartiallyVisible(t) ||
          visibilityHelper.isElementTotallyVisible(t) ||
          setTimeout(() => {
            const e = t.getBoundingClientRect().top - i;
            window.scrollTo({ top: e, left: 0, behavior: "smooth" });
          }, 400);
      }
      onUnload() {
        (this.productForm && this.productForm.destroy(),
          this.hasVariantOptionWithImage && window.removeEventListener("theme:resize:width", this.onResizeCallback),
          document.removeEventListener("theme:cart:close", this.checkLiveCartInfoCallback));
      }
      constructor(t) {
        ((this.container = t),
          (this.product = this.container.querySelector(vn)),
          (this.productForm = this.container.querySelector(wn)),
          (this.tallLayout = "true" === this.container.getAttribute(wr)),
          (this.addToCartButton = this.container.querySelector(bn)),
          (this.buyItNow = this.container.querySelector(En)),
          (this.hasPaymentButton = null !== this.buyItNow),
          (this.variantOptionImages = this.container.querySelectorAll(or)),
          (this.hasVariantOptionWithImage = this.variantOptionImages.length > 0),
          this.product &&
            this.productForm &&
            ((this.storeAvailabilityContainer = this.container.querySelector(Qn)),
            (this.enableHistoryState = "true" === this.container.getAttribute(br)),
            (this.hasUnitPricing = this.container.querySelector($n)),
            (this.subSelectors = this.container.querySelector(Vn)),
            (this.subPrices = this.container.querySelector(Rn)),
            (this.priceOffWrap = this.container.querySelector(In)),
            (this.priceOffAmount = this.container.querySelector(Hn)),
            (this.planDecription = this.container.querySelector(Un)),
            (this.swatchesContainer = this.container.querySelector(tr)),
            (this.latestVariantId = ""),
            (this.latestVariantName = ""),
            (this.latestVariantTitle = ""),
            (this.sellout = null),
            (this.sessionStorage = window.sessionStorage),
            (this.remainingWrapper = this.container.querySelector(Gn)),
            this.remainingWrapper &&
              ((this.remainingMaxInt = parseInt(this.remainingWrapper.dataset.remainingMax, 10)),
              (this.remainingCount = this.container.querySelector(jn)),
              (this.remainingJSONWrapper = this.container.querySelector(Kn)),
              (this.remainingJSON = null),
              this.remainingJSONWrapper &&
                "" !== this.remainingJSONWrapper.innerHTML &&
                (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML))),
            this.storeAvailabilityContainer &&
              (this.storeAvailability = new (class {
                updateContent(t, e) {
                  this._fetchStoreAvailabilities(t, e);
                }
                clearContent() {
                  this.container.innerHTML = "";
                }
                _initModal() {
                  return new (class {
                    init() {
                      (this.openElement.addEventListener("click", this.open.bind(this)),
                        this.modal
                          .querySelector(this.config.close)
                          .addEventListener("click", this.closeModal.bind(this)));
                    }
                    open(t) {
                      let e = !1;
                      if ((t ? t.preventDefault() : (e = !0), this.modalIsOpen && !e)) return void this.closeModal();
                      (this.modal.classList.add(this.config.openClass),
                        this.nodes.parents.forEach((t) => {
                          t.classList.add(this.config.openBodyClass);
                        }),
                        (this.modalIsOpen = !0));
                      const i = document.querySelector(Jo);
                      (document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: i })),
                        this.config.scrollIntoView && this.scrollIntoView(),
                        this.bindEvents(),
                        this.a11y.trapFocus({ container: this.modal }));
                    }
                    closeModal() {
                      if (this.modalIsOpen) {
                        (document.activeElement.blur(), this.modal.classList.remove(this.config.openClass));
                        var t = this;
                        (this.nodes.parents.forEach(function (e) {
                          e.classList.remove(t.config.openBodyClass);
                        }),
                          (this.modalIsOpen = !1),
                          this.openElement.focus(),
                          this.unbindEvents(),
                          this.a11y.removeTrapFocus({ container: this.modal }),
                          document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 })));
                      }
                    }
                    bindEvents() {
                      ((this.keyupHandler = this.keyupHandler.bind(this)),
                        (this.clickHandler = this.clickHandler.bind(this)),
                        document.body.addEventListener("keyup", this.keyupHandler),
                        document.body.addEventListener("click", this.clickHandler));
                    }
                    unbindEvents() {
                      (document.body.removeEventListener("keyup", this.keyupHandler),
                        document.body.removeEventListener("click", this.clickHandler));
                    }
                    keyupHandler(t) {
                      t.code === theme.keyboardKeys.ESCAPE && this.closeModal();
                    }
                    clickHandler(t) {
                      !this.config.closeModalOnClick ||
                        this.modal.contains(t.target) ||
                        t.target.matches(this.config.open) ||
                        this.closeModal();
                    }
                    scrollIntoView() {
                      this.focusOnOpen.scrollIntoView({ behavior: "smooth" });
                    }
                    constructor(t, e) {
                      if (((this.modal = document.getElementById(t)), !this.modal)) return !1;
                      ((this.nodes = { parents: [document.querySelector("html"), document.body] }),
                        (this.config = Object.assign(Zo, e)),
                        (this.modalIsOpen = !1),
                        (this.focusOnOpen = this.config.focusOnOpen
                          ? document.getElementById(this.config.focusOnOpen)
                          : this.modal),
                        (this.openElement = document.querySelector(this.config.open)),
                        (this.a11y = window.theme.a11y),
                        this.init());
                    }
                  })("StoreAvailabilityModal", {
                    close: on,
                    open: sn,
                    closeModalOnClick: !0,
                    openClass: rn,
                    scrollIntoView: !1,
                  });
                }
                _fetchStoreAvailabilities(t, e) {
                  const i = "/variants/" + t + "/?section_id=store-availability";
                  this.clearContent();
                  const s = this;
                  fetch(i)
                    .then(function (t) {
                      return t.text();
                    })
                    .then(function (t) {
                      const i = document.querySelector(tn);
                      let o = i.querySelector(en);
                      (o && o.remove(),
                        (s.container.innerHTML = t),
                        (s.container.innerHTML = s.container.firstElementChild.innerHTML),
                        "" !== s.container.firstElementChild.innerHTML.trim()
                          ? s.container.querySelector(sn) &&
                            ((s.modal = s._initModal()),
                            s._updateProductTitle(e),
                            (o = s.container.querySelector(en)),
                            o && i.appendChild(o))
                          : s.clearContent());
                    });
                }
                _updateProductTitle(t) {
                  this.container.querySelector(nn).textContent = t;
                }
                constructor(t) {
                  this.container = t;
                }
              })(this.storeAvailabilityContainer)),
            this.init(),
            this.hasVariantOptionWithImage &&
              ((this.onResizeCallback = () => this.resizeEvents()),
              window.addEventListener("theme:resize:width", this.onResizeCallback)),
            this.hasPaymentButton && ((this.mutationObserver = null), this.observeContainer())));
      }
    };
  const xr = {
      onLoad() {
        Tr[this.id] = new Pr(this.container);
      },
      onUnload() {
        Tr[this.id].onUnload();
      },
    },
    Ir = "[data-add-to-cart]",
    Hr = "[data-deferred-media]",
    Fr = "[data-deferred-media-button]",
    Mr = "[data-popup-close]",
    Dr = "[data-quick-view-inner]",
    Or = "[data-quick-view-item-holder]",
    Br = "[data-product]",
    zr = "[data-product-form]",
    _r = "[data-product-single-media-slider]",
    $r = "[data-product-single-media-wrapper]",
    Rr = "[data-model]",
    Vr = "[data-product-json]",
    Nr = "[data-quick-view-foot-inner]",
    Wr = "[data-shop-the-look-thumb]",
    Ur = "[data-tooltip]",
    jr = "[data-drawer-toggle]",
    Gr = "[data-quick-view-focus]",
    Kr = "has-media-active",
    Qr = "is-active",
    Xr = "is-loading",
    Yr = "media--hidden",
    Jr = "no-outline",
    Zr = "notification-popup-visible",
    ta = "popup-quick-view--animate-in",
    ea = "popup-quick-view--animate-out",
    ia = "popup-quick-view--animated",
    sa = "popup-quick-view",
    oa = "js-quick-view-visible",
    na = "js-quick-view-from-cart",
    ra = "js-drawer-open",
    aa = "id",
    la = "data-media-id",
    ca = "data-section-id",
    ha = "loaded",
    da = "data-quick-view-onboarding",
    ua = "data-hotspot",
    pa = "data-hotspot-ref",
    ma = "AddToCartForm--",
    ga = "AddToCart--";
  const ya = 400,
    fa = ".pswp",
    va = ".pswp__custom-close",
    wa = "iframe, video",
    ba = ".pswp__custom-iframe",
    Sa = ".pswp__thumbs",
    Ea = ".pswp__button, .pswp__caption-close",
    La = "is-current",
    ka = "pswp--custom-loader",
    Aa = "pswp--custom-opening",
    Ca = "pswp__loader",
    qa = "pswp--open",
    Ta = "pswp__button--close",
    Pa = "pswp--notification",
    xa = "popup-quick-view",
    Ia = "js-drawer-open-cart",
    Ha = "popup-quick-view--animate-out",
    Fa = "data-pswp-option-classes",
    Ma = "data-video-type",
    Da = `<div class="${Ca}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;
  ((window.theme = window.theme || {}),
    (window.theme.LoadPhotoswipe = class {
      init() {
        (document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
          this.pswpElement.classList.add(Aa),
          this.initLoader(),
          u({ url: window.theme.assets.photoswipe })
            .then(() => this.loadPopup())
            .catch((t) => console.error(t)));
      }
      initLoader() {
        if (this.pswpElement.classList.contains(ka) && "" !== this.options && this.options.mainClass) {
          this.pswpElement.setAttribute(Fa, this.options.mainClass);
          let t = document.createElement("div");
          ((t.innerHTML = Da), (t = t.firstChild), this.pswpElement.appendChild(t));
        } else this.pswpElement.setAttribute(Fa, "");
      }
      loadPopup() {
        const t = window.themePhotoswipe.PhotoSwipe.default,
          e = window.themePhotoswipe.PhotoSwipeUI.default;
        (this.pswpElement.classList.remove(Aa),
          (this.popup = new t(this.pswpElement, e, this.items, this.options)),
          this.popup.listen("afterInit", this.dispatchPopupInitEventCallback),
          this.popup.listen("imageLoadComplete", this.setCurrentThumbCallback),
          this.popup.listen("imageLoadComplete", this.loadingStateCallback),
          this.popup.listen("beforeChange", this.setCurrentThumbCallback),
          this.popup.listen("close", this.onCloseCallback),
          this.popup.init(),
          this.initPopupCallback());
      }
      loadingState(t) {
        t === this.options.index && this.pswpElement.classList.contains(ka) && this.pswpElement.classList.remove(ka);
      }
      initPopupCallback() {
        (this.isVideo && this.hideUnusedButtons(),
          this.initVideo(),
          this.thumbsActions(),
          this.a11y.trapFocus({ container: this.pswpElement }),
          this.pswpElement.classList.contains(xa) &&
            new (class {
              initTooltips() {
                ((this.tooltips = this.pswpElement.querySelectorAll(Ur)),
                  this.tooltips.forEach((t) => {
                    new Vt(t);
                  }));
              }
              handleDraggable(t, e) {
                t && ((t.options.draggable = Boolean(e)), t.updateDraggable());
              }
              initItems(t, e) {
                (this.addFormSuffix(t),
                  this.initProductSlider(t, e),
                  this.initProductVideo(t),
                  this.initProductModel(t),
                  this.initShopifyXrLaunch(t),
                  Re(t),
                  this.pswpElement.querySelectorAll(jr).length && new Wo(t),
                  window.theme.wrapElements(t));
                const i = new Pr(t.parentNode);
                (this.productForms.push(i),
                  Shopify.PaymentButton && Shopify.PaymentButton.init(),
                  t.classList.remove(Xr));
              }
              init() {
                (document.addEventListener("submit", this.prevent3dModelSubmitEvent),
                  this.popupCloseButtons.forEach((t) => {
                    (t.addEventListener("keyup", (t) => {
                      (t.code !== theme.keyboardKeys.ENTER &&
                        t.code !== theme.keyboardKeys.NUMPADENTER &&
                        t.code !== theme.keyboardKeys.SPACE) ||
                        this.closePopup(t);
                    }),
                      t.addEventListener("click", (t) => {
                        this.closePopup(t);
                      }));
                  }),
                  this.pswpElement.addEventListener("click", this.outerCloseEvent),
                  document.dispatchEvent(new CustomEvent("theme:popup:open", { bubbles: !0 })),
                  this.popup.listen("preventDragEvent", (t, e, i) => {
                    i.prevent = !1;
                  }),
                  this.pswpElement.addEventListener("mousedown", () => {
                    this.popup.framework.unbind(window, "pointermove pointerup pointercancel", this.popup);
                  }),
                  this.popup.listen("initialZoomInEnd", () => {
                    document.body.classList.add(oa);
                    const t = this.quickViewItemHolders.length > 0,
                      e = this.quickViewInner.querySelector(Gr),
                      i = this.quickViewInner.querySelector(`${Or}.${Qr}`),
                      s = t ? i.querySelector(Gr) : e;
                    this.a11y.trapFocus({ container: s });
                  }),
                  this.pswpElement.addEventListener("animationend", this.closeOnAnimationEndEvent),
                  this.popup.listen("destroy", () => {
                    (this.flkty.length > 0 &&
                      requestAnimationFrame(() => {
                        this.flkty.forEach((t) => t.pausePlayer());
                      }),
                      document.body.classList.remove(oa),
                      document.removeEventListener("keyup", this.closeOnEscapeEvent),
                      document.addEventListener("keyup", this.closeOnEscapeEvent),
                      this.pswpElement.removeEventListener("click", this.outerCloseEvent),
                      this.pswpElement.removeEventListener("animationend", this.closeOnAnimationEndEvent),
                      document.removeEventListener("submit", this.prevent3dModelSubmitEvent),
                      this.deferredMedias.forEach((t) => {
                        t.removeAttribute(ha);
                        const e = t.closest($r);
                        (e.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), e.classList.add(Yr));
                      }));
                  }),
                  document.addEventListener("keyup", this.closeOnEscapeEvent),
                  document.addEventListener("theme:cart:added", () => {
                    this.pswpElement.classList.contains(sa) && this.pswpElement.classList.add(ea);
                  }),
                  this.animateInQuickview(),
                  this.initShopTheLookListeners());
              }
              initShopTheLookListeners() {
                var t;
                null === (t = this.buttonsShopTheLookThumb) ||
                  void 0 === t ||
                  t.forEach((t) => {
                    t.addEventListener("click", (t) => {
                      t.preventDefault();
                      const e = t.target.matches(Wr) ? t.target : t.target.closest(Wr),
                        i = this.pswpElement.querySelector(`[${ua}="${e.getAttribute(pa)}"]`),
                        s = i.querySelector(Gr);
                      !e.classList.contains(Qr) &&
                        i &&
                        (this.flkty.length > 0 &&
                          requestAnimationFrame(() => {
                            this.flkty.forEach((t) => {
                              t.resize();
                              const e = this.quickViewInner.querySelectorAll($r);
                              e.length &&
                                e.forEach((t) => {
                                  (t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }),
                                    t.classList.add(Yr));
                                });
                            });
                          }),
                        i.classList.add(Qr),
                        this.quickViewItemHolders.forEach((t) => {
                          t !== i && t.classList.remove(Qr);
                        }),
                        this.a11y.trapFocus({ container: s }));
                    });
                  });
              }
              prevent3dModelSubmit(t) {
                t.submitter.closest(Hr) && t.submitter.closest(zr) && t.preventDefault();
              }
              closeQuickviewOnMobile() {
                window.innerWidth < window.theme.sizes.large &&
                  document.body.classList.contains(oa) &&
                  this.popup.close();
              }
              animateInQuickview() {
                (this.pswpElement.classList.add(ta),
                  this.quickViewFoot.addEventListener("animationend", (t) => {
                    this.handleAnimatedState(t);
                  }),
                  this.pswpElement.addEventListener("animationend", (t) => {
                    this.handleAnimatedState(t, !0);
                  }));
              }
              handleAnimatedState(t, e = !1) {
                if ("quickViewAnimateInUp" == t.animationName) {
                  if (e && window.innerWidth >= window.theme.sizes.small) return;
                  (this.pswpElement.classList.add(ia),
                    this.pswpElement.classList.remove(ta),
                    document.body.classList.remove(na),
                    Qo(this.pswpElement));
                }
              }
              closePopup(t) {
                (null == t || t.preventDefault(),
                  document.body.classList.contains(ra) &&
                    document.dispatchEvent(new CustomEvent("theme:drawer:closing", { bubbles: !0 })),
                  this.pswpElement.classList.add(ea),
                  this.swatchesContainer.onUnload());
              }
              closeOnAnimationEnd(t) {
                ("quickViewAnimateOutRight" != t.animationName && "quickViewAnimateOutDown" != t.animationName) ||
                  (this.popup.template.classList.remove(ea, ia),
                  this.popup.close(),
                  this.productForms.length > 0 && this.productForms.forEach((t) => t.onUnload()));
              }
              closeOnEscape(t) {
                const e = document.body.classList.contains(oa),
                  i = document.body.classList.contains(Zr);
                t.code === theme.keyboardKeys.ESCAPE && e && !i && this.closePopup(t);
              }
              initProductSlider(t, e) {
                const i = t.querySelector(_r),
                  s = t.querySelectorAll($r);
                if (s.length > 1) {
                  const o = new window.theme.Flickity(i, {
                    wrapAround: !0,
                    cellAlign: "left",
                    pageDots: !1,
                    prevNextButtons: !0,
                    adaptiveHeight: !1,
                    pauseAutoPlayOnHover: !1,
                    selectedAttraction: 0.2,
                    friction: 1,
                    autoPlay: !1,
                    on: {
                      ready: () => {
                        requestAnimationFrame(() => {
                          o.resize();
                        });
                      },
                      settle: () => {
                        const e = o.selectedElement.getAttribute(la);
                        this.switchMedia(t, e);
                      },
                    },
                  });
                  (this.flkty.push(o),
                    s.length &&
                      s.forEach((t) => {
                        (t.addEventListener("theme:media:play", () => {
                          (this.handleDraggable(this.flkty[e], !1), t.closest(_r).classList.add(Kr));
                        }),
                          t.addEventListener("theme:media:pause", () => {
                            (this.handleDraggable(this.flkty[e], !0), t.closest(_r).classList.remove(Kr));
                          }));
                      }),
                    window.theme.flickitySmoothScrolling(i));
                }
              }
              switchMedia(t, e) {
                const i = this.quickViewInner.querySelectorAll($r),
                  s = t.querySelector(`${$r}[${la}="${e}"]`),
                  o = !document.body.classList.contains(Jr);
                (i.length &&
                  i.forEach((t) => {
                    (t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(Yr));
                  }),
                  o && s.focus(),
                  s.closest(_r).classList.remove(Kr),
                  s.classList.remove(Yr),
                  s.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 }));
                const n = s.querySelector(Hr);
                n && "true" !== n.getAttribute(ha) && s.querySelector(Fr).dispatchEvent(new Event("click"));
              }
              initProductVideo(t) {
                const e = new G(t);
                this.videos.push(e);
              }
              initProductModel(t) {
                const e = t.getAttribute(ca),
                  i = t.querySelectorAll(Rr);
                i.length &&
                  i.forEach((t) => {
                    theme.ProductModel.init(t, e);
                  });
              }
              initShopifyXrLaunch(t) {
                document.addEventListener("shopify_xr_launch", () => {
                  t.querySelector(`${Rr}:not(.${Yr})`).dispatchEvent(new CustomEvent("xrLaunch"));
                });
              }
              addFormSuffix(t) {
                const e = `${t.getAttribute(ca)}-${JSON.parse(t.querySelector(Vr).innerHTML).handle}`,
                  i = t.querySelector(zr),
                  s = t.querySelector(Ir);
                (i.setAttribute(aa, ma + e), s.setAttribute(aa, ga + e));
              }
              constructor(t, e) {
                ((this.popup = t),
                  (this.pswpElement = e),
                  (this.quickViewFoot = this.pswpElement.querySelector(Nr)),
                  (this.quickViewInner = this.pswpElement.querySelector(Dr)),
                  (this.product = this.pswpElement.querySelectorAll(Br)),
                  (this.flkty = []),
                  (this.videos = []),
                  (this.productForms = []),
                  (this.deferredMedias = this.pswpElement.querySelectorAll(Hr)),
                  (this.buttonsShopTheLookThumb = this.pswpElement.querySelectorAll(Wr)),
                  (this.quickViewItemHolders = this.pswpElement.querySelectorAll(Or)),
                  (this.popupCloseButtons = this.quickViewInner.querySelectorAll(Mr)),
                  (this.a11y = window.theme.a11y),
                  (this.prevent3dModelSubmitEvent = (t) => this.prevent3dModelSubmit(t)),
                  (this.closeOnAnimationEndEvent = (t) => this.closeOnAnimationEnd(t)),
                  (this.closeOnEscapeEvent = (t) => this.closeOnEscape(t)),
                  (this.outerCloseEvent = (t) => {
                    if (!this.quickViewInner.contains(t.target)) {
                      const e = this.quickViewInner.nextElementSibling;
                      if (e && e.contains(t.target)) return;
                      this.closePopup(t);
                    }
                  }),
                  this.product.forEach((t, e) => {
                    t.hasAttribute(da) || this.initItems(t, e);
                  }),
                  this.init(),
                  this.initTooltips(),
                  (this.swatchesContainer = new $e(this.pswpElement)));
              }
            })(this.popup, this.pswpElement),
          this.pswpElement.classList.contains(Pa) &&
            new (class {
              init() {
                this.popup.listen("preventDragEvent", (t, e, i) => {
                  i.prevent = !1;
                });
                const t = -1 !== window.location.search.indexOf("?contact_posted=true");
                this.notificationForm = this.pswpElement.querySelector(P);
                const e = this.pswpElement.querySelector(I);
                (document.body.classList.add(F),
                  this.pswpElement.addEventListener("mousedown", () => {
                    this.popup.framework.unbind(window, "pointermove pointerup pointercancel", this.popup);
                  }),
                  t && this.pswpElement.classList.add(H),
                  this.notificationForm.addEventListener("submit", (t) => this.notificationSubmitEvent(t)),
                  this.pswpElement.addEventListener("click", this.outerCloseEvent),
                  e.addEventListener("click", () => {
                    this.popup.close();
                  }),
                  this.popup.listen("destroy", () => {
                    (this.notificationRemoveStorage(),
                      this.pswpElement.removeEventListener("click", this.outerCloseEvent),
                      document.body.classList.remove(F));
                  }));
              }
              notificationSubmitEvent(t) {
                this.notificationStopSubmit &&
                  (t.preventDefault(),
                  this.notificationRemoveStorage(),
                  this.notificationWriteStorage(),
                  (this.notificationStopSubmit = !1),
                  this.notificationForm.submit());
              }
              notificationWriteStorage() {
                void 0 !== this.sessionStorage &&
                  this.sessionStorage.setItem("notification_form_id", this.notificationForm.id);
              }
              notificationRemoveStorage() {
                this.sessionStorage.removeItem("notification_form_id");
              }
              constructor(t, e) {
                ((this.popup = t),
                  (this.pswpElement = e),
                  (this.notificationForm = null),
                  (this.notificationStopSubmit = !0),
                  (this.sessionStorage = window.sessionStorage));
                const i = this.pswpElement.querySelector(x);
                ((this.outerCloseEvent = (t) => {
                  i.contains(t.target) || this.popup.close();
                }),
                  this.init());
              }
            })(this.popup, this.pswpElement),
          (this.closePopup = () => {
            this.pswpElement.classList.contains(xa) ? this.pswpElement.classList.add(Ha) : this.popup.close();
          }),
          this.closeBtn && this.closeBtn.addEventListener("click", this.closePopup),
          document.addEventListener("theme:cart:added", this.closePopup));
      }
      dispatchPopupInitEvent() {
        this.triggerBtn && this.triggerBtn.dispatchEvent(new CustomEvent("theme:popup:init", { bubbles: !0 }));
      }
      initVideo() {
        const t = this.pswpElement.querySelector(ba);
        if (t) {
          const e = t.getAttribute(Ma);
          ((this.isVideo = !0),
            "youtube" == e
              ? new (class {
                  init() {
                    window.isYoutubeAPILoaded
                      ? this.loadYoutubePlayer()
                      : u({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadYoutubePlayer());
                  }
                  loadYoutubePlayer() {
                    const t = {
                      height: "720",
                      width: "1280",
                      playerVars: this.videoOptionsVars,
                      events: {
                        onReady: (t) => {
                          const e = t.target.getIframe().id;
                          ("true" === document.querySelector(`#${e}`).getAttribute(L)
                            ? t.target.unMute()
                            : t.target.mute(),
                            t.target.playVideo(),
                            this.checkPlayerVisibilityFlag &&
                              (this.checkPlayerVisibility(e),
                              window.addEventListener(
                                "scroll",
                                window.theme.throttle(() => {
                                  this.checkPlayerVisibility(e);
                                }, 150),
                              )));
                        },
                        onStateChange: (t) => {
                          (0 == t.data && t.target.playVideo(),
                            1 == t.data && t.target.getIframe().parentElement.classList.add(q));
                        },
                      },
                    };
                    ((t.videoId = this.videoID),
                      this.videoID.length &&
                        YT.ready(() => {
                          T[this.playerID] = new YT.Player(this.playerID, t);
                        }),
                      (window.isYoutubeAPILoaded = !0));
                  }
                  checkPlayerVisibility(t) {
                    let e;
                    if ("string" == typeof t) e = t;
                    else {
                      if (null == t.data) return;
                      e = t.data.id;
                    }
                    const i = document.getElementById(e + "-container");
                    if (!i) return;
                    const s = T[e],
                      o = i.getBoundingClientRect();
                    let n =
                      visibilityHelper.isElementPartiallyVisible(i) || visibilityHelper.isElementTotallyVisible(i);
                    (o.top < 0 && i.clientHeight + o.top >= 0 && (n = !0),
                      n && s && "function" == typeof s.playVideo
                        ? s.playVideo()
                        : !n && s && "function" == typeof s.pauseVideo && s.pauseVideo());
                  }
                  onUnload() {
                    const t = "youtube-" + this.container.getAttribute(E);
                    T[t] && T[t].destroy();
                  }
                  constructor(t) {
                    ((this.container = t),
                      (this.player = this.container.querySelector(S.videoIframe)),
                      this.player &&
                        ((this.videoOptionsVars = {}),
                        (this.videoID = this.player.getAttribute(A)),
                        (this.videoType = this.player.getAttribute(C)),
                        "youtube" == this.videoType &&
                          ((this.checkPlayerVisibilityFlag = "true" === this.player.getAttribute(k)),
                          (this.playerID = this.player.querySelector(S.youtubeWrapper)
                            ? this.player.querySelector(S.youtubeWrapper).id
                            : this.player.id),
                          this.player.hasAttribute(S.dataHideOptions) &&
                            (this.videoOptionsVars = {
                              cc_load_policy: 0,
                              iv_load_policy: 3,
                              modestbranding: 1,
                              playsinline: 1,
                              autohide: 0,
                              controls: 0,
                              branding: 0,
                              showinfo: 0,
                              rel: 0,
                              fs: 0,
                              wmode: "opaque",
                            }),
                          this.init(),
                          this.container.addEventListener(
                            "touchstart",
                            function (t) {
                              if (t.target.matches(S.videoWrapper) || t.target.closest(S.videoWrapper)) {
                                const e = t.target.querySelector(S.videoIframe).id;
                                T[e].playVideo();
                              }
                            },
                            { passive: !0 },
                          ))));
                  }
                })(t.parentElement)
              : "vimeo" == e &&
                new (class {
                  init() {
                    this.loadVimeoPlayer();
                  }
                  loadVimeoPlayer() {
                    const t = "https://vimeo.com/" + this.videoID;
                    let e = "";
                    const i = this.player,
                      s = {
                        url: t,
                        background: this.enableBackground,
                        muted: this.disableSound,
                        autoplay: this.enableAutoplay,
                        loop: this.enableLoop,
                      };
                    for (let t in s) e += encodeURIComponent(t) + "=" + encodeURIComponent(s[t]) + "&";
                    fetch(`https://vimeo.com/api/oembed.json?${e}`)
                      .then((t) => t.json())
                      .then(function (t) {
                        ((i.innerHTML = t.html),
                          setTimeout(function () {
                            i.parentElement.classList.add(m);
                          }, 1e3));
                      })
                      .catch(function () {
                        console.log("error");
                      });
                  }
                  constructor(t) {
                    ((this.container = t),
                      (this.player = this.container.querySelector(p)),
                      this.player &&
                        ((this.videoID = this.player.getAttribute(w)),
                        (this.videoType = this.player.getAttribute(b)),
                        (this.enableBackground = "true" === this.player.getAttribute(y)),
                        (this.disableSound = "false" === this.player.getAttribute(g)),
                        (this.enableAutoplay = "false" !== this.player.getAttribute(f)),
                        (this.enableLoop = "false" !== this.player.getAttribute(v)),
                        "vimeo" == this.videoType && this.init()));
                  }
                })(t.parentElement));
        }
      }
      thumbsActions() {
        this.popupThumbsContainer &&
          this.popupThumbsContainer.firstChild &&
          (this.popupThumbsContainer.addEventListener("wheel", (t) => this.stopDisabledScroll(t)),
          this.popupThumbsContainer.addEventListener("mousewheel", (t) => this.stopDisabledScroll(t)),
          this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) => this.stopDisabledScroll(t)),
          (this.popupThumbs = this.pswpElement.querySelectorAll(`${Sa} > *`)),
          this.popupThumbs.forEach((t, e) => {
            t.addEventListener("click", (i) => {
              (i.preventDefault(),
                t.parentElement.querySelector(`.${La}`).classList.remove(La),
                t.classList.add(La),
                this.popup.goTo(e));
            });
          }));
      }
      hideUnusedButtons() {
        this.pswpElement.querySelectorAll(Ea).forEach((t) => {
          t.classList.contains(Ta) || (t.style.display = "none");
        });
      }
      stopDisabledScroll(t) {
        t.stopPropagation();
      }
      onClose() {
        const t = this.pswpElement.querySelector(wa);
        if ((t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild))
          for (; this.popupThumbsContainer.firstChild; )
            this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
        this.pswpElement.setAttribute(Fa, "");
        const e = this.pswpElement.querySelector(`.${Ca}`);
        (e && this.pswpElement.removeChild(e),
          document.body.classList.contains(Ia) || this.a11y.removeTrapFocus(),
          document.removeEventListener("theme:cart:added", this.closePopup),
          setTimeout(() => {
            const t = this.recentlyOpenedPopupsCount(),
              e = document.body.classList.contains(Ia);
            0 !== t || e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
          }, ya));
      }
      recentlyOpenedPopupsCount() {
        let t = 0;
        return (
          this.pswpElements.forEach((e) => {
            e.classList.contains(qa) && (t += 1);
          }),
          t
        );
      }
      setCurrentThumb() {
        if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) return;
        const t = this.pswpElement.querySelector(`${Sa} > .${La}`);
        if ((t && t.classList.remove(La), !this.popupThumbs)) return;
        const e = this.popupThumbs[this.popup.getCurrentIndex()];
        (e.classList.add(La), this.scrollThumbs(e));
      }
      scrollThumbs(t) {
        const e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
          i = t.offsetLeft;
        if (e <= i + t.offsetWidth || e > i) {
          const e = parseInt(window.getComputedStyle(t).marginLeft);
          this.popupThumbsContainer.scrollTo({ top: 0, left: i - e, behavior: "smooth" });
        }
      }
      constructor(t, e = "", i = 0, s = null) {
        ((this.items = t),
          (this.triggerBtn = s),
          (this.pswpElements = document.querySelectorAll(fa)),
          (this.pswpElement = this.pswpElements[i]),
          (this.popup = null),
          (this.popupThumbs = null),
          (this.popupThumbsContainer = this.pswpElement.querySelector(Sa)),
          (this.closeBtn = this.pswpElement.querySelector(va)));
        ((this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
          (this.onCloseCallback = () => this.onClose()),
          (this.dispatchPopupInitEventCallback = () => this.dispatchPopupInitEvent()),
          (this.setCurrentThumbCallback = () => this.setCurrentThumb()),
          (this.loadingStateCallback = (t) => this.loadingState(t)),
          (this.a11y = window.theme.a11y),
          this.init());
      }
    }));
  const Oa = "body",
    Ba = "[data-main]",
    za = "[data-site-header]",
    _a = "[data-prevent-transparent-header]",
    $a = "supports-transparent-header",
    Ra = "data-transparent",
    Va = () => {
      const t = document.querySelector(Oa),
        e = t.querySelector(za);
      if (!e) return;
      const i = "true" === e.getAttribute(Ra),
        s = t.querySelector(Ba).children[0];
      if (!s) return;
      const o = s.querySelector(`${_a}:first-of-type`);
      window.isHeaderTransparent = i && s.classList.contains($a) && !o;
    },
    Na = ".section-footer--parallax",
    Wa = "[data-section-type]",
    Ua = ":scope > [data-wave]",
    ja = ".wavy:not(.site-footer)",
    Ga = ".parallax-shadow:not(.site-footer)",
    Ka = "wavy",
    Qa = "parallax-shadow",
    Xa = "parallax-rounded-corners",
    Ya = "section-footer--parallax",
    Ja = "body--rounded-corners-large",
    Za = "data-parallax-wavy",
    tl = (t) => {
      const e = t,
        i = document.querySelectorAll(ja),
        s = document.querySelectorAll(Ga);
      (i.forEach((t) => {
        t.classList.remove(Ka);
        [...t.querySelectorAll(Ua)].map((t) => t.remove());
      }),
        s.forEach((t) => {
          (t.classList.remove(Qa), t.classList.remove(Xa), document.body.classList.remove(Ja));
          [...t.querySelectorAll(Ua)].map((t) => t.remove());
        }));
      const o = document.querySelectorAll(Na);
      if (o.length > 0) {
        const t = o[0].querySelector(Wa);
        t.hasAttribute(Za) && t.classList.add(Ka);
      }
      e.classList.contains(Ya) || document.dispatchEvent(new CustomEvent("theme:footer:unload"));
    };
  ((window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []));
  const el = window.Shopify.theme.sections.registered,
    il = window.Shopify.theme.sections.instances,
    sl = { id: "data-section-id", type: "data-section-type" };
  let ol = class {
      getStack() {
        return this.callStack;
      }
      constructor(t = null, e = []) {
        ((this.type = t),
          (this.components = (function (t) {
            if ((void 0 !== t && "object" != typeof t) || null === t)
              throw new TypeError("Theme Sections: The components object provided is not a valid");
            return t;
          })(e)),
          (this.callStack = {
            onLoad: [],
            onUnload: [],
            onSelect: [],
            onDeselect: [],
            onBlockSelect: [],
            onBlockDeselect: [],
            onReorder: [],
          }),
          e.forEach((t) => {
            for (const [e, i] of Object.entries(t)) {
              const t = this.callStack[e];
              Array.isArray(t) && "function" == typeof i
                ? t.push(i)
                : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(i));
            }
          }));
      }
    },
    nl = class {
      callFunctions(t, e = null) {
        this.callStack[t].forEach((t) => {
          const i = { id: this.id, type: this.type, container: this.container };
          e ? t.call(i, e) : t.call(i);
        });
      }
      onLoad() {
        this.callFunctions("onLoad");
      }
      onUnload() {
        this.callFunctions("onUnload");
      }
      onSelect(t) {
        this.callFunctions("onSelect", t);
      }
      onDeselect(t) {
        this.callFunctions("onDeselect", t);
      }
      onBlockSelect(t) {
        this.callFunctions("onBlockSelect", t);
      }
      onBlockDeselect(t) {
        this.callFunctions("onBlockDeselect", t);
      }
      onReorder(t) {
        this.callFunctions("onReorder", t);
      }
      constructor(t, e) {
        ((this.container = (function (t) {
          if (!(t instanceof Element))
            throw new TypeError(
              "Theme Sections: Attempted to load section. The section container provided is not a DOM element.",
            );
          if (null === t.getAttribute(sl.id))
            throw new Error(
              "Theme Sections: The section container provided does not have an id assigned to the " +
                sl.id +
                " attribute.",
            );
          return t;
        })(t)),
          (this.id = t.getAttribute(sl.id)),
          (this.type = e.type),
          (this.callStack = e.getStack()));
        try {
          this.onLoad();
        } catch (t) {
          (console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t));
        }
      }
    };
  function rl(t, e) {
    if ("string" != typeof t)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered",
      );
    if (void 0 !== el[t])
      throw new Error(
        'Theme Sections: A section of type "' +
          t +
          '" has already been registered. You cannot register the same section type twice',
      );
    Array.isArray(e) || (e = [e]);
    const i = new ol(t, e);
    return ((el[t] = i), el);
  }
  function al(t, e) {
    ((t = dl(t)),
      void 0 === e && (e = document.querySelectorAll("[" + sl.type + "]")),
      (e = ul(e)),
      t.forEach(function (t) {
        const i = el[t];
        void 0 !== i &&
          (e = e.filter(function (e) {
            return (
              !(cl(e).length > 0) &&
              null !== e.getAttribute(sl.type) &&
              (e.getAttribute(sl.type) !== t || (il.push(new nl(e, i)), !1))
            );
          }));
      }));
  }
  function ll(t) {
    cl(t).forEach(function (t) {
      var e = il
        .map(function (t) {
          return t.id;
        })
        .indexOf(t.id);
      (il.splice(e, 1), t.onUnload());
    });
  }
  function cl(t) {
    var e = [];
    if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
    if (t instanceof Element || i instanceof Element)
      ul(t).forEach(function (t) {
        e = e.concat(
          il.filter(function (e) {
            return e.container === t;
          }),
        );
      });
    else if ("string" == typeof t || "string" == typeof i) {
      dl(t).forEach(function (t) {
        e = e.concat(
          il.filter(function (e) {
            return e.type === t;
          }),
        );
      });
    }
    return e;
  }
  function hl(t) {
    for (var e, i = 0; i < il.length; i++)
      if (il[i].id === t) {
        e = il[i];
        break;
      }
    return e;
  }
  function dl(t) {
    return (
      "*" === t
        ? (t = Object.keys(el))
        : "string" == typeof t
          ? (t = [t])
          : t.constructor === nl
            ? (t = [t.prototype.type])
            : Array.isArray(t) &&
              t[0].constructor === nl &&
              (t = t.map(function (t) {
                return t.type;
              })),
      (t = t.map(function (t) {
        return t.toLowerCase();
      }))
    );
  }
  function ul(t) {
    return (
      NodeList.prototype.isPrototypeOf(t) && t.length > 0
        ? (t = Array.prototype.slice.call(t))
        : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
          ? (t = [])
          : !Array.isArray(t) && t instanceof Element && (t = [t]),
      t
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + sl.id + '="' + e + '"]');
      (!0 === window.Shopify.visualPreviewMode && null === i && (i = t.target.querySelector(`[${sl.id}]`)),
        null !== i && al(i.getAttribute(sl.type), i));
    }),
    document.addEventListener("shopify:section:reorder", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + sl.id + '="' + e + '"]');
      "object" == typeof cl(i)[0] &&
        cl(i).forEach(function (t) {
          t.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + sl.id + '="' + e + '"]');
      "object" == typeof cl(i)[0] && ll(i);
    }),
    document.addEventListener("shopify:section:select", function (t) {
      var e = hl(t.detail.sectionId);
      "object" == typeof e && e.onSelect(t);
    }),
    document.addEventListener("shopify:section:deselect", function (t) {
      var e = hl(t.detail.sectionId);
      "object" == typeof e && e.onDeselect(t);
    }),
    document.addEventListener("shopify:block:select", function (t) {
      var e = hl(t.detail.sectionId);
      "object" == typeof e && e.onBlockSelect(t);
    }),
    document.addEventListener("shopify:block:deselect", function (t) {
      var e = hl(t.detail.sectionId);
      "object" == typeof e && e.onBlockDeselect(t);
    }));
  const pl = '[data-parallax="card-scrolling"]',
    ml = () => {
      setTimeout(() => {
        window.Shopify.theme.sections.instances
          .filter((t) => {
            const e = "slider" === t.type,
              i = "banner-image" === t.type,
              s = t.container.matches(pl);
            return (e && s) || (i && s);
          })
          .forEach((t) => {
            (ll(t.id), setTimeout(() => al(t.id)));
          });
      });
    },
    gl = {
      overflowBackground: "[data-overflow-background]",
      overflowFrame: "[data-overflow-frame]",
      overflowContent: "[data-overflow-content]",
      overflowContainer: "[data-overflow-container]",
      overflowWrapper: "[data-overflow-wrapper]",
    };
  function yl(t, e) {
    let i = 0;
    e.forEach((t) => {
      i = t.offsetHeight > i ? t.offsetHeight : i;
    });
    const s = t.querySelectorAll(gl.overflowBackground);
    [t, ...s].forEach((t) => {
      t.style.setProperty("min-height", `calc(${i}px + var(--header-height))`);
    });
  }
  function fl(t) {
    if (window.innerWidth < window.theme.sizes.small) {
      return void t.querySelectorAll(gl.overflowFrame).forEach((t) => {
        const e = t.querySelectorAll(gl.overflowContent);
        yl(t, e);
      });
    }
    let e = 0;
    const i = t.querySelectorAll(gl.overflowFrame);
    t.querySelectorAll(gl.overflowContent).forEach((t) => {
      t.offsetHeight > e && (e = t.offsetHeight);
    });
    ([...i, ...t.querySelectorAll(gl.overflowBackground)].forEach((t) => {
      t.style.setProperty("min-height", `${e}px`);
    }),
      t.style.setProperty("min-height", `${e}px`));
  }
  function vl(t) {
    const e = t.querySelectorAll(gl.overflowContainer);
    e &&
      e.forEach((t) => {
        const e = t.querySelectorAll(gl.overflowContent);
        (yl(t, e),
          document.addEventListener("theme:resize", () => {
            yl(t, e);
          }));
      });
    const i = t.querySelectorAll(gl.overflowWrapper);
    i &&
      i.forEach((t) => {
        (fl(t),
          document.addEventListener("theme:resize", () => {
            fl(t);
          }));
      });
  }
  function wl() {
    (document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
      window.lastWindowWidth !== window.innerWidth &&
        (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })),
        (window.lastWindowWidth = window.innerWidth)));
  }
  window.lastWindowWidth = window.innerWidth;
  let bl = window.pageYOffset,
    Sl = null,
    El = null,
    Ll = null,
    kl = null,
    Al = 0;
  const Cl = { quickViewVisible: "js-quick-view-visible", cartDrawerOpen: "js-drawer-open-cart" };
  function ql(t) {
    setTimeout(() => {
      (Al && clearTimeout(Al),
        e.disablePageScroll(t.detail, { allowTouchMove: (t) => "TEXTAREA" === t.tagName }),
        document.documentElement.setAttribute("data-scroll-locked", ""));
    });
  }
  function Tl(t) {
    const e = t.detail;
    e ? (Al = setTimeout(Pl, e)) : Pl();
  }
  function Pl() {
    document.body.classList.contains(Cl.quickViewVisible) ||
      document.body.classList.contains(Cl.cartDrawerOpen) ||
      (e.clearQueueScrollLocks(), e.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked"));
  }
  const xl = "img",
    Il = "template",
    Hl = ".shopify-section",
    Fl = "[data-deferred-content]",
    Ml = "[data-product-image]",
    Dl = "srcset",
    Ol = "data-loaded",
    Bl = "data-deferred-container";
  let zl = class extends HTMLElement {
    connectedCallback() {
      0 != this.deferredTriggers.length
        ? this.deferredTriggers.forEach((t) => {
            t.addEventListener(
              "mouseenter",
              () => {
                this.hasAttribute(Ol) || this.loadTemplate();
              },
              { once: !0 },
            );
          })
        : this.container.addEventListener(
            "mouseenter",
            () => {
              this.hasAttribute(Ol) || this.loadTemplate();
            },
            { once: !0 },
          );
    }
    loadTemplate() {
      var t;
      const e = document.createElement("div"),
        i = this.querySelector(Il);
      if (!i || !(null == i || null === (t = i.content) || void 0 === t ? void 0 : t.firstElementChild)) return;
      e.appendChild(i.content.firstElementChild.cloneNode(!0));
      const s = e.querySelector(Fl);
      if (!s) return;
      (this.append(s), this.setAttribute(Ol, !0));
      s.querySelectorAll(xl).length > 0 && this.reloadSrcset(this);
    }
    reloadSrcset(t) {
      t &&
        t.querySelectorAll(xl).forEach((t) => {
          if (!t.parentNode.matches(Ml)) {
            const e = t.getAttribute(Dl);
            (t.setAttribute(Dl, ""), t.setAttribute(Dl, e));
          }
        });
    }
    constructor() {
      (super(),
        (this.container = this),
        this.hasAttribute(Bl) && (this.container = this.closest(this.getAttribute(Bl)) || this.closest(Hl)),
        (this.deferredTriggers = this.container.querySelectorAll(this.dataset.deferredTriggers)));
    }
  };
  function _l(t) {
    return new Promise((e) => {
      function i(s) {
        s.target == t && (t.removeEventListener("animationend", i), t.removeEventListener("transitionend", i), e());
      }
      (null == t || t.addEventListener("animationend", i), null == t || t.addEventListener("transitionend", i));
    });
  }
  const $l = "[data-aos]",
    Rl = "[data-has-highlight]",
    Vl = "[data-highlight-holder]",
    Nl = "path",
    Wl = "sup",
    Ul = ".flickity-enabled",
    jl = "[data-slide].is-selected",
    Gl = "[data-sticky-text]",
    Kl = "text-count-up",
    Ql = ".text-reveal__cropper",
    Xl = "data-highlight-type",
    Yl = "data-is-active",
    Jl = "is-active",
    Zl = "overflow-hidden",
    tc = {
      "circle-hand-drawn": {
        keyframes: [
          { strokeDashoffset: "1", opacity: "0" },
          { opacity: "1", offset: 0.01 },
          { strokeDashoffset: "0", opacity: "1" },
        ],
        timing: { duration: 1e3, delay: 0, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.7, 0, 0.3, 1)" },
      },
      circle: {
        keyframes: [
          { strokeDashoffset: "506", opacity: "0" },
          { opacity: "1", offset: 0.01 },
          { strokeDashoffset: "0", opacity: "1" },
        ],
        timing: { duration: 800, delay: 0, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.6, 0, 0.4, 1)" },
      },
      highlight: {
        keyframes: [{ transform: "scaleX(0)" }, { transform: "scaleX(1)" }],
        timing: {
          duration: 600,
          delay: 200,
          iterations: 1,
          fill: "forwards",
          easing: "ease",
          pseudoElement: "::before",
        },
        keyframesHover: [{ transform: "scaleY(0.1)" }, { transform: "scaleY(1)" }],
      },
      "highlight-color": {
        keyframes: [
          { backgroundSize: "200% 100%", backgroundPosition: "100% 0" },
          { backgroundSize: "200% 100%", backgroundPosition: "0 0", offset: 0.2 },
          { backgroundSize: "1100% 100%", backgroundPosition: "0 0" },
        ],
        timing: { duration: 2e3, delay: 200, iterations: 1, fill: "forwards", easing: "cubic-bezier(0, 0, 0.9, 0.4)" },
      },
      "alternate-font": {
        keyframes: [{ opacity: "0" }, { opacity: "1" }],
        timing: { duration: 400, delay: 0, iterations: 1, fill: "forwards", easing: "ease-out" },
        keyframesHover: [{ opacity: "1" }, { opacity: "0.7" }],
      },
      squiggle: {
        keyframes: [{ maskPosition: "100% 0" }, { maskPosition: "0 0" }],
        timing: { duration: 1200, delay: 200, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.6, 0, 0.4, 1)" },
      },
      stroke: {
        keyframes: [{ backgroundPosition: "100% 0" }, { backgroundPosition: "0 0" }],
        timing: {
          duration: 1200,
          delay: 0,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0.25, 0.1, 0.9, 0.3)",
        },
      },
      underline: {
        keyframes: [{ transform: "scaleX(0)" }, { transform: "scaleX(1)" }],
        timing: {
          duration: 900,
          delay: 200,
          iterations: 1,
          fill: "forwards",
          easing: "ease",
          pseudoElement: "::before",
        },
      },
      "underline-hand-drawn": {
        keyframes: [
          { strokeDashoffset: "1", opacity: "0" },
          { opacity: "1", offset: 0.01 },
          { strokeDashoffset: "0", opacity: "1" },
        ],
        timing: { duration: 1e3, delay: 0, iterations: 1, fill: "forwards", easing: "cubic-bezier(0.7, 0, 0.3, 1)" },
      },
    };
  let ec = class extends HTMLElement {
    connectedCallback() {
      ((this.timeout = null),
        (this.controller = new AbortController()),
        this.type &&
          this.target &&
          ((this.animation = this.target.animate(tc[this.type].keyframes, tc[this.type].timing)),
          this.animation.pause(),
          this.bindAnimation("init"),
          this.bindAnimation("pause"),
          this.modifyDefaults("slider"),
          this.animation &&
            (this.link && this.listen(),
            theme.settings.animationsEnabled || (this.animation.play(), this.bindAnimation("play")))));
    }
    disconnectedCallback() {
      this.controller.abort();
    }
    attributeChangedCallback(t, e, i) {
      const s = t === Yl,
        o = null === e && s,
        n = "true" === i;
      (s && n && !("true" === e && "true" === i) && this.triggerAnimation(), o || n || this.reset());
    }
    triggerAnimation() {
      const t = this.closest($l);
      var e;
      t
        ? (null === (e = this.textRevealCropper) || void 0 === e || e.classList.add(Zl),
          this.textCountUp
            ? (clearTimeout(this.timeout),
              (this.timeout = setTimeout(() => {
                var t;
                (null === (t = this.textRevealCropper) || void 0 === t || t.classList.remove(Zl),
                  this.setAnimationDelay(0),
                  this.animate());
              }, 100)))
            : _l(t).then(() => {
                var e;
                const i = 1e3 * (window.getComputedStyle(t).getPropertyValue("animation-delay") || 0).replace("s", ""),
                  s = Math.max(i - 250, 0);
                (null === (e = this.textRevealCropper) || void 0 === e || e.classList.remove(Zl),
                  this.setAnimationDelay(s),
                  this.animate());
              }))
        : this.animate();
    }
    listen() {
      (this.link.addEventListener("mouseenter", (t) => this.onMouseenter(t), { signal: this.controller.signal }),
        this.link.addEventListener("mouseleave", (t) => this.onMouseleave(t), { signal: this.controller.signal }));
    }
    animate() {
      this.animation &&
        (this.animation.play(), this.bindAnimation("play"), (this.animation.onfinish = () => this.onFinish()));
    }
    shouldAnimate() {
      requestAnimationFrame(() => {
        let t = !0;
        Boolean(this.closest(Ul)) && (t = Boolean(this.closest(jl)));
        const e = this.closest(Gl);
        (e && (t = Boolean(e.classList.contains(Jl))), this.setTriggerAttribute(t));
      });
    }
    setTriggerAttribute(t = !0) {
      this.setAttribute(Yl, t);
    }
    reset() {
      this.animation &&
        (this.animation.cancel(), this.bindAnimation("cancel"), this.setAnimationDelay(tc[this.type].timing.delay));
    }
    onMouseenter(t) {
      (t.stopImmediatePropagation(),
        this.setAnimationDelay(0),
        this.modifyDefaults("mouseenter"),
        "alternate-font" !== this.type && this.animation.reverse(),
        this.bindAnimation("mouseenter"));
    }
    onMouseleave(t) {
      (t.stopImmediatePropagation(),
        this.modifyDefaults("mouseleave"),
        "alternate-font" !== this.type && this.animation.reverse(),
        this.bindAnimation("mouseleave"));
    }
    onFinish() {
      if (this.hasAttribute(Yl)) {
        const t = "true" === this.getAttribute(Yl) ? 0 : tc[this.type].timing.delay;
        this.setAnimationDelay(t);
      } else this.setAnimationDelay(0);
    }
    setAnimationDelay(t = 0) {
      this.animation.effect.getTiming().delay !== t &&
        (this.animation.effect.updateTiming({ delay: t }), this.bindAnimation("delay"));
    }
    modifyDefaults(t = "mouseenter", e) {
      if ((e || (e = this.animation), "mouseenter" === t))
        return (
          tc[this.type].keyframesHover && e.effect.setKeyframes(tc[this.type].keyframesHover),
          "highlight" === this.type && e.effect.updateTiming({ duration: 350, fill: "both" }),
          "highlight-color" === this.type && e.effect.updateTiming({ duration: 800 }),
          void ("underline" === this.type && e.effect.updateTiming({ duration: 400 }))
        );
      if ("mouseleave" === t)
        return (
          tc[this.type].keyframesHover && e.effect.setKeyframes(tc[this.type].keyframes),
          void (
            ("highlight" !== this.type && "highlight-color" !== this.type && "underline" !== this.type) ||
            e.effect.updateTiming({ duration: tc[this.type].timing.duration })
          )
        );
      if (
        "slider" === t &&
        (theme.settings.animationsEnabled ||
          ((tc[this.type].timing.delay = 300), e.effect.updateTiming({ delay: tc[this.type].timing.delay })),
        this.closest(Ul))
      ) {
        const t = tc[this.type].timing.delay + 200;
        "highlight" === this.type && e.effect.updateTiming({ delay: t });
      }
    }
    bindAnimation(t = !1) {
      if (
        this.bind &&
        t &&
        ("init" === t && (this.boundAnimation = this.bind.animate(tc[this.type].keyframes, tc[this.type].timing)),
        "pause" === t && this.boundAnimation.pause(),
        "play" === t && this.boundAnimation.play(),
        "cancel" === t && this.boundAnimation.cancel(),
        "mouseenter" === t && (this.modifyDefaults("mouseenter", this.boundAnimation), this.boundAnimation.reverse()),
        "mouseleave" === t && (this.modifyDefaults("mouseleave", this.boundAnimation), this.boundAnimation.reverse()),
        "delay" === t)
      ) {
        const t = this.animation.effect.getTiming().delay;
        this.boundAnimation.effect.getTiming().delay !== t && this.boundAnimation.effect.updateTiming({ delay: t });
      }
    }
    constructor() {
      (super(),
        (this.animation = null),
        (this.bind = null),
        (this.boundAnimation = null),
        (this.link = this.closest(Rl)),
        (this.type = this.getAttribute(Xl)),
        (this.highlightHolder = this.querySelector(Vl)),
        (this.textCountUp = this.closest(Kl)),
        (this.sup = this.querySelector(Wl)),
        (this.textRevealCropper = this.closest(Ql)),
        (this.target = this.highlightHolder),
        ("circle-hand-drawn" !== this.type && "circle" !== this.type && "underline-hand-drawn" !== this.type) ||
          (this.target = this.querySelector(Nl)),
        ("highlight-color" !== this.type && "stroke" !== this.type && "alternate-font" !== this.type) ||
          (this.sup && (this.bind = this.sup)));
    }
  };
  var ic, sc, oc;
  ((oc = [Yl]),
    (sc = "observedAttributes") in (ic = ec)
      ? Object.defineProperty(ic, sc, { value: oc, enumerable: !0, configurable: !0, writable: !0 })
      : (ic[sc] = oc));
  const nc = ".shopify-section",
    rc = "[data-slider]",
    ac = "[data-hover-slideshow-holder]",
    lc = "[data-hover-slideshow-item]",
    cc = "[data-hover-slideshow-progress]",
    hc = ".flickity-button",
    dc = "fill";
  let uc = class extends HTMLElement {
    get holder() {
      return this.querySelector(ac);
    }
    get items() {
      return [...this.querySelectorAll(lc)];
    }
    get progress() {
      return this.querySelector(cc);
    }
    connectedCallback() {
      "slideshow" !== theme.settings.productGridHover || window.theme.touch || this.init();
    }
    init() {
      ((this.section = this.closest(nc)),
        (this.outerSliders = this.section.querySelectorAll(rc)),
        (this.autoplaySpeed = 2200),
        (this.timer = 0),
        (this.flkty = new window.theme.Flickity.data(this.holder)),
        !this.flkty.isActive &&
          this.items.length > 1 &&
          ((this.flkty = new window.theme.Flickity(this.holder, {
            draggable: !this.outerSliders.length,
            cellSelector: lc,
            contain: !0,
            wrapAround: !0,
            imagesLoaded: !0,
            pageDots: !1,
            prevNextButtons: !1,
            adaptiveHeight: !1,
            pauseAutoPlayOnHover: !1,
            selectedAttraction: 0.2,
            friction: 1,
            on: {
              ready: () => {
                (this.section.style.setProperty("--autoplay-speed", `${this.autoplaySpeed}ms`),
                  setTimeout(() => this.flkty.resize(), 1e3));
              },
              change: () => {
                (this.timer && clearTimeout(this.timer),
                  this.progress.classList.remove(dc),
                  this.progress.offsetWidth,
                  requestAnimationFrame(() => this.progress.classList.add(dc)),
                  (this.timer = setTimeout(() => this.progress.classList.remove(dc), this.autoplaySpeed)));
              },
              dragEnd: () => {
                this.flkty.playPlayer();
              },
            },
          })),
          this.addEventListener("mouseenter", () => {
            (this.progress.classList.add(dc),
              this.timer && clearTimeout(this.timer),
              (this.timer = setTimeout(() => this.progress.classList.remove(dc), this.autoplaySpeed)),
              (this.flkty.options.autoPlay = this.autoplaySpeed),
              this.flkty.playPlayer());
          }),
          this.addEventListener("mouseleave", () => {
            (this.flkty.stopPlayer(), this.timer && clearTimeout(this.timer), this.progress.classList.remove(dc));
          })),
        this.addEventListener("click", (t) => {
          t.target.matches(hc) && t.preventDefault();
        }));
    }
    constructor() {
      super();
    }
  };
  const pc = "btn--top",
    mc = "btn--right",
    gc = "btn--bottom",
    yc = "btn--left",
    fc = "btn--text";
  let vc = class extends HTMLElement {
    connectedCallback() {
      this.button.classList.contains(fc) || this.button.addEventListener("mouseenter", this.detectEntrySide);
    }
    detectEntrySide(t) {
      const e = this.button.getBoundingClientRect();
      this.class && this.button.classList.remove(this.class);
      const i = t.clientX,
        s = t.clientY,
        o = i - e.left,
        n = e.right - i,
        r = s - e.top,
        a = e.bottom - s;
      ((this.class = o < n && o < r && o < a ? yc : n < o && n < r && n < a ? mc : r < o && r < n && r < a ? pc : gc),
        this.button.classList.add(this.class));
    }
    disconnectedCallback() {
      this.button.removeEventListener("mouseenter", this.detectEntrySide);
    }
    constructor() {
      (super(),
        (this.button = this.parentElement),
        (this.class = ""),
        (this.detectEntrySide = this.detectEntrySide.bind(this)));
    }
  };
  const wc = {
      inputSearch: 'input[type="search"]',
      inputType: 'input[name="type"]',
      form: "form",
      allVisibleElements: '[role="option"]',
      ariaSelected: '[aria-selected="true"]',
      selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
      popularSearches: "[data-popular-searches]",
      popdownBody: "[data-popdown-body]",
      mainInputSearch: "[data-main-input-search]",
      predictiveSearchResults: "[data-predictive-search-results]",
      predictiveSearch: "predictive-search",
      searchForm: "search-form",
    },
    bc = "is-searched",
    Sc = "template-search";
  let Ec = class extends HTMLElement {
    getQuery() {
      return this.input.value.trim();
    }
    onFocus() {
      this.currentSearchTerm = this.getQuery();
    }
    onChange() {
      (this.classList.toggle(bc, !this.isFormCleared()), (this.searchTerm = this.getQuery()));
    }
    isFormCleared() {
      return 0 === this.input.value.length;
    }
    submit() {
      this.form.submit();
    }
    reset() {
      this.input.val = "";
    }
    onFormSubmit(t) {
      (this.getQuery().length && !this.querySelector(wc.selectedLink)) || t.preventDefault();
    }
    onKeydown(t) {
      ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
    }
    onKeyup(t) {
      switch ((!this.getQuery().length && this.predictiveSearch && this.close(!0), t.preventDefault(), t.code)) {
        case "ArrowUp":
          this.switchOption("up");
          break;
        case "ArrowDown":
          this.switchOption("down");
          break;
        case "Enter":
          this.selectOption();
      }
    }
    switchOption(t) {
      const e = "up" === t,
        i =
          this.classList.contains(bc) && this.predictiveSearchResults
            ? this.predictiveSearchResults
            : this.popularSearches;
      if (!i) return;
      this.selectedElement = i.querySelector(wc.ariaSelected);
      const s = Array.from(i.querySelectorAll(wc.allVisibleElements)).filter((t) => null !== t.offsetParent);
      let o = 0;
      if (e && !this.selectedElement) return;
      let n = -1,
        r = 0;
      for (; -1 === n && r <= s.length; ) (s[r] === this.selectedElement && (n = r), r++);
      (!e && this.selectedElement ? (o = n === s.length - 1 ? 0 : n + 1) : e && (o = 0 === n ? s.length - 1 : n - 1),
        o !== n && ((this.activeElement = s[o]), this.handleFocusableDescendants()));
    }
    selectOption() {
      const t = this.querySelector(wc.selectedOption);
      t && t.click();
    }
    handleFocusableDescendants(t = !1) {
      const e = this.selectedElement ? this.selectedElement : this.querySelector(wc.ariaSelected);
      var i;
      if ((e && e.setAttribute("aria-selected", !1), !this.activeElement || t))
        return (
          (this.selectedElement = null),
          null === (i = this.activeElement) || void 0 === i || i.setAttribute("aria-selected", !1),
          this.input.setAttribute("aria-expanded", !1),
          void this.input.setAttribute("aria-activedescendant", "")
        );
      (this.activeElement.setAttribute("aria-selected", !0),
        this.input.setAttribute("aria-activedescendant", this.activeElement.id));
    }
    constructor() {
      var t;
      (super(),
        (this.input = this.querySelector(wc.inputSearch)),
        (this.form = this.querySelector(wc.form)),
        (this.popdownBody = this.closest(wc.popdownBody)),
        (this.popularSearches =
          null === (t = this.popdownBody) || void 0 === t ? void 0 : t.querySelector(wc.popularSearches)),
        (this.predictiveSearchResults = this.querySelector(wc.predictiveSearchResults)),
        (this.predictiveSearch = this.matches(wc.predictiveSearch)),
        (this.searchForm = this.matches(wc.searchForm)),
        (this.selectedElement = null),
        (this.activeElement = null),
        (this.searchTerm = ""),
        (this.currentSearchTerm = ""),
        (this.isSearchPage = document.body.classList.contains(Sc)),
        this.input.addEventListener(
          "input",
          window.theme
            .debounce((t) => {
              this.onChange(t);
            }, 300)
            .bind(this),
        ),
        this.input.addEventListener("focus", this.onFocus.bind(this)),
        this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
        this.addEventListener("keyup", this.onKeyup.bind(this)),
        this.addEventListener("keydown", this.onKeydown.bind(this)),
        this.isSearchPage &&
          ((this.mainInputType = document.querySelector(`${wc.mainInputSearch} ${wc.inputType}`)),
          (this.inputType = this.querySelector(wc.inputType)),
          (this.inputType.value = this.mainInputType.value)));
    }
  };
  customElements.define("search-form", Ec);
  const Lc = "predictive-search",
    kc = "#shopify-section-api-predictive-search",
    Ac = "[data-predictive-search-results]",
    Cc = "[data-predictive-search-status]",
    qc = "[data-predictive-search-live-region-count-value]",
    Tc = "[data-search-results-wrapper]",
    Pc = "reset",
    xc = "data-aos-anchor",
    Ic = "aria-hidden",
    Hc = "open",
    Fc = "loading",
    Mc = "data-loading-text",
    Dc = "results";
  customElements.define(
    "predictive-search",
    class extends Ec {
      connectedCallback() {
        this.predictiveSearchResults.addEventListener("transitionend", (t) => {
          t.target !== this.predictiveSearchResults ||
            this.getQuery().length ||
            (this.classList.remove(Pc), requestAnimationFrame(() => this.clearResultsHTML()));
        });
      }
      onChange() {
        (super.onChange(),
          this.classList.remove(Pc),
          this.searchTerm.length
            ? requestAnimationFrame(() => this.getSearchResults(this.searchTerm))
            : this.classList.add(Pc));
      }
      onFocus() {
        (super.onFocus(),
          this.currentSearchTerm.length &&
            (this.searchTerm !== this.currentSearchTerm
              ? this.onChange()
              : "true" === this.getAttribute(Dc)
                ? this.open()
                : this.getSearchResults(this.searchTerm)));
      }
      getSearchResults(t) {
        const e = t.replace(" ", "-").toLowerCase(),
          i = parseInt(window.theme.settings.suggestionsResultsLimit);
        let s = "query";
        ((s += window.theme.settings.suggestArticles ? ",article" : ""),
          (s += window.theme.settings.suggestCollections ? ",collection" : ""),
          (s += window.theme.settings.suggestProducts ? ",product" : ""),
          (s += window.theme.settings.suggestPages ? ",page" : ""),
          this.setLiveRegionLoadingState(),
          this.cachedResults[e]
            ? this.renderSearchResults(this.cachedResults[e])
            : fetch(
                `${theme.routes.predictiveSearchUrl}?q=${encodeURIComponent(t)}&resources[type]=${s}&resources[limit]=${i}&section_id=api-predictive-search`,
                { signal: this.abortController.signal },
              )
                .then((t) => {
                  if (!t.ok) {
                    var e = new Error(t.status);
                    throw (this.close(), e);
                  }
                  return t.text();
                })
                .then((t) => {
                  const i = new DOMParser().parseFromString(t, "text/html").querySelector(kc).innerHTML;
                  (this.allPredictiveSearchInstances.forEach((t) => {
                    t.cachedResults[e] = i;
                  }),
                    this.renderSearchResults(i));
                })
                .catch((t) => {
                  if (20 !== (null == t ? void 0 : t.code)) throw (this.close(), t);
                }));
      }
      switchOption(t) {
        (super.switchOption(t), this.statusElement && (this.statusElement.textContent = ""));
      }
      setLiveRegionLoadingState() {
        ((this.statusElement = this.statusElement || this.querySelector(Cc)),
          (this.loadingText = this.loadingText || this.getAttribute(Mc)),
          this.setLiveRegionText(this.loadingText),
          this.setAttribute(Fc, !0));
      }
      setLiveRegionText(t) {
        (this.statusElement.setAttribute(Ic, "false"),
          (this.statusElement.textContent = t),
          setTimeout(() => {
            this.statusElement.setAttribute(Ic, "true");
          }, 1e3));
      }
      renderSearchResults(t) {
        this.predictiveSearchResults.innerHTML = t;
        const e = this.predictiveSearchResults.parentElement.id,
          i = this.predictiveSearchResults.querySelector(Tc),
          s = i.id;
        ((i.id = `${s}--${e}`),
          i.setAttribute(xc, `#${i.id}`),
          this.setAttribute(Dc, !0),
          this.setLiveRegionResults(),
          this.open());
      }
      setLiveRegionResults() {
        (this.removeAttribute(Fc), this.setLiveRegionText(this.querySelector(qc).textContent));
      }
      open() {
        this.setAttribute(Hc, !0);
      }
      close(t = !1) {
        this.closeResults(t);
      }
      closeResults(t = !1) {
        (t && (this.reset(), this.removeAttribute(Dc), this.classList.remove(Pc)),
          this.removeAttribute(Fc),
          this.removeAttribute(Hc));
      }
      clearResultsHTML() {
        this.predictiveSearchResults.innerHTML = "";
      }
      constructor() {
        (super(),
          (this.abortController = new AbortController()),
          (this.allPredictiveSearchInstances = document.querySelectorAll(Lc)),
          (this.predictiveSearchResults = this.querySelector(Ac)),
          (this.cachedResults = {}));
      }
    },
  );
  let Oc = class extends HTMLElement {
    constructor() {
      (super(),
        document.addEventListener("DOMContentLoaded", () => {
          document.documentElement.classList.remove("page-loading");
        }));
    }
  };
  const Bc = (t) => {
      (clearTimeout(t.countUpTimeout),
        t._countUpOrigInnerHTML && ((t.innerHTML = t._countUpOrigInnerHTML), (t._countUpOrigInnerHTML = void 0)),
        (t.style.visibility = ""));
    },
    zc = (t, e = {}) => {
      const { duration: i = 1e3, delay: s = 16 } = e,
        o = i / s,
        n = t.toString().split(/(<[^>]+>|[0-9.][,.0-9]*[0-9]*)/),
        r = [];
      for (let t = 0; t < o; t++) r.push("");
      for (let t = 0; t < n.length; t++)
        if (/([0-9.][,.0-9]*[0-9]*)/.test(n[t]) && !/<[^>]+>/.test(n[t])) {
          let e = n[t];
          const i = [...e.matchAll(/[.,]/g)]
            .map((t) => ({ char: t[0], i: e.length - t.index - 1 }))
            .sort((t, e) => t.i - e.i);
          e = e.replace(/[.,]/g, "");
          let s = r.length - 1;
          for (let t = o; t >= 1; t--) {
            let n = parseInt((e / o) * t, 10);
            ((n = i.reduce(
              (t, { char: e, i: i }) => (t.length <= i ? t : t.slice(0, -i) + e + t.slice(-i)),
              n.toString(),
            )),
              (r[s--] += n));
          }
        } else for (let e = 0; e < o; e++) r[e] += n[t];
      return ((r[r.length] = t.toString()), r);
    };
  const _c = "data-count-up-duration",
    $c = "data-count-up-init";
  let Rc = class extends HTMLElement {
    connectedCallback() {
      theme.settings.animationsEnabled || this.startCountUp();
    }
    attributeChangedCallback(t, e, i) {
      null === e && t === $c && "true" === i && this.startCountUp();
    }
    shouldAnimate() {
      requestAnimationFrame(() => this.setTriggerAttribute());
    }
    setTriggerAttribute(t = !0) {
      this.setAttribute($c, t);
    }
    startCountUp() {
      ((t, e = {}) => {
        const { action: i = "start", duration: s = 1e3, delay: o = 16 } = e;
        if ("stop" === i) return void Bc(t);
        if ((Bc(t), !/[0-9]/.test(t.innerHTML))) return;
        const n = zc(t.innerHTML, {
          duration: s || t.getAttribute("data-duration"),
          delay: o || t.getAttribute("data-delay"),
        });
        ((t._countUpOrigInnerHTML = t.innerHTML), (t.innerHTML = n[0] || "&nbsp;"), (t.style.visibility = "visible"));
        const r = function () {
          ((t.innerHTML = n.shift() || "&nbsp;"),
            n.length
              ? (clearTimeout(t.countUpTimeout), (t.countUpTimeout = setTimeout(r, o)))
              : (t._countUpOrigInnerHTML = void 0));
        };
        t.countUpTimeout = setTimeout(r, o);
      })(this, { duration: this.duration, delay: 0.016 * this.duration });
    }
    constructor() {
      (super(),
        (this.container = this),
        (this.countUpDuration = this.getAttribute(_c)),
        (this.duration = (100 / parseInt(this.countUpDuration, 10)) * 1e3));
    }
  };
  (!(function (t, e, i) {
    e in t ? Object.defineProperty(t, e, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = i);
  })(Rc, "observedAttributes", [$c]),
    (window.requestIdleCallback =
      window.requestIdleCallback ||
      function (t) {
        var e = Date.now();
        return setTimeout(function () {
          t({
            didTimeout: !1,
            timeRemaining: function () {
              return Math.max(0, 50 - (Date.now() - e));
            },
          });
        }, 1);
      }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (t) {
        clearTimeout(t);
      }),
    window.addEventListener("resize", window.theme.debounce(wl, 50)),
    (function () {
      let t;
      (window.addEventListener(
        "scroll",
        function () {
          (t && window.cancelAnimationFrame(t),
            (t = window.requestAnimationFrame(function () {
              !(function () {
                const t = window.pageYOffset;
                (t > bl ? ((El = !0), (Sl = !1)) : t < bl ? ((El = !1), (Sl = !0)) : ((Sl = null), (El = null)),
                  (bl = t),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll", { detail: { up: Sl, down: El, position: t }, bubbles: !1 }),
                  ),
                  Sl &&
                    !Ll &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 }),
                    ),
                  El &&
                    !kl &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:down", { detail: { position: t }, bubbles: !1 }),
                    ),
                  (kl = El),
                  (Ll = Sl));
              })();
            })));
        },
        { passive: !0 },
      ),
        window.addEventListener("theme:scroll:lock", ql),
        window.addEventListener("theme:scroll:unlock", Tl));
    })(),
    "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className = document.documentElement.className.replace(
          "no-touch",
          "supports-touch",
        )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    document.addEventListener(
      "load",
      (t) => {
        if ("img" == t.target.tagName.toLowerCase() && t.target.classList.contains(Go.loading)) {
          (t.target.classList.remove(Go.loading), t.target.parentNode.classList.remove(Go.loading));
          const e = t.target.closest(Ko.section);
          e && e.classList.add(Go.imgIn);
        }
      },
      !0,
    ));
  const Vc = window.theme.debounce(() => {
    Va();
  }, 300);
  function Nc(t) {
    ((this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null));
  }
  (window.addEventListener("DOMContentLoaded", () => {
    (vl(document), Qo(document), window.theme.settings.animationsEnabled && Lt());
  }),
    document.addEventListener("shopify:section:load", (t) => {
      const e = t.target;
      (window.dispatchEvent(new Event("resize"), { bubbles: !0 }),
        vl(e),
        Vc(),
        tl(e),
        ml(),
        window.theme.settings.animationsEnabled && Lt());
    }),
    document.addEventListener("shopify:section:reorder", (t) => {
      const e = t.target;
      (Vc(), tl(e), ml(), window.theme.settings.animationsEnabled && Lt());
    }),
    document.addEventListener("shopify:section:unload", (t) => {
      const e = t.target;
      (Vc(), tl(e), ml());
    }),
    customElements.get("text-highlight") || customElements.define("text-highlight", ec),
    customElements.get("deferred-loading") || customElements.define("deferred-loading", zl),
    customElements.get("loading-overlay") || customElements.define("loading-overlay", Oc),
    customElements.get("text-count-up") || customElements.define("text-count-up", Rc),
    customElements.get("hover-slideshow") || customElements.define("hover-slideshow", uc),
    customElements.get("hover-button") || customElements.define("hover-button", vc),
    (function () {
      function t(t) {
        var e = window.innerWidth || document.documentElement.clientWidth,
          i = window.innerHeight || document.documentElement.clientHeight,
          s = t.getBoundingClientRect();
        return s.top >= 0 && s.bottom <= i && s.left >= 0 && s.right <= e;
      }
      function e(t) {
        var e = window.innerWidth || document.documentElement.clientWidth,
          i = window.innerHeight || document.documentElement.clientHeight,
          s = t.getBoundingClientRect(),
          o = (s.left >= 0 && s.left <= e) || (s.right >= 0 && s.right <= e),
          n = (s.top >= 0 && s.top <= i) || (s.bottom >= 0 && s.bottom <= i);
        return o && n;
      }
      window.visibilityHelper = {
        isElementTotallyVisible: t,
        isElementPartiallyVisible: e,
        inViewportPartially: function (t, i) {
          function s() {
            var s = e(t);
            s != o && ((o = s), "function" == typeof i && i(s, t));
          }
          var o = e(t);
          (window.addEventListener("load", s),
            window.addEventListener("resize", s),
            window.addEventListener("scroll", s));
        },
        inViewportTotally: function (e, i) {
          function s() {
            var s = t(e);
            s != o && ((o = s), "function" == typeof i && i(s, e));
          }
          var o = t(e);
          (window.addEventListener("load", s),
            window.addEventListener("resize", s),
            window.addEventListener("scroll", s));
        },
      };
    })(),
    (Nc.prototype = Error.prototype));
  const Wc = {
      cartDrawerEnabled: "drawer" === window.theme.settings.cartType,
      timers: { addProductTimeout: 1e3 },
      animations: { data: "data-aos", method: "fade-up" },
    },
    Uc = {
      outerSection: "[data-section-id]",
      aos: "[data-aos]",
      additionalCheckoutButtons: "[data-additional-checkout-button]",
      apiContent: "[data-api-content]",
      apiLineItems: "[data-api-line-items]",
      apiUpsellItems: "[data-api-upsell-items]",
      apiCartPrice: "[data-api-cart-price]",
      buttonAddToCart: "[data-add-to-cart]",
      upsellButtonByHandle: "[data-handle]",
      cartCloseError: "[data-cart-error-close]",
      cartDrawer: "[data-cart-drawer]",
      cartDrawerTemplate: "[data-cart-drawer-template]",
      cartDrawerToggle: "[data-cart-drawer-toggle]",
      cartDrawerBody: "[data-cart-drawer-body]",
      cartErrors: "[data-cart-errors]",
      cartForm: "[data-cart-form]",
      cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
      cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
      cartCheckoutButton: "[data-cart-checkout-button]",
      cartItemRemove: "[data-item-remove]",
      cartItemsQty: "[data-cart-items-qty]",
      cartTotal: "[data-cart-total]",
      cartTotalPrice: "[data-cart-total-price]",
      cartMessage: "[data-cart-message]",
      cartMessageDefault: "[data-message-default]",
      cartPage: "[data-cart-page]",
      cartProgress: "[data-cart-message-progress]",
      emptyMessage: "[data-empty-message]",
      emptyMessageBottom: "[data-empty-message-bottom]",
      buttonHolder: "[data-foot-holder]",
      item: "[data-cart-item]",
      itemsHolder: "[data-items-holder]",
      itemsWrapper: "[data-items-wrapper]",
      formCloseError: "[data-close-error]",
      formErrorsContainer: "[data-cart-errors-container]",
      upsellHolder: "[data-upsell-holder]",
      errorMessage: "[data-error-message]",
      termsErrorMessage: "[data-terms-error-message]",
      pairProductsHolder: "[data-pair-products-holder]",
      cartNoteHolder: "[data-cart-notes-holder]",
      pairProducts: "[data-pair-products]",
      priceHolder: "[data-cart-price-holder]",
      leftToSpend: "[data-left-to-spend]",
      quickBuyForm: "[data-quickbuy-form]",
      qtyInput: "[data-quantity-field]",
      productItem: "[data-product-block]",
      productMediaContainer: "[data-product-media-container]",
      formWrapper: "[data-form-wrapper]",
      productForm: "[data-product-form], [data-product-form-upsell]",
      popupQuickView: ".popup-quick-view",
      popupClose: "[data-popup-close]",
      error: "[data-error]",
      quickViewOnboarding: "[data-quick-view-onboarding]",
      flickityEnabled: ".flickity-enabled",
      noscript: "noscript",
      qtySelect: "[data-quantity-select]",
      links: "a, button",
    },
    jc = "hidden",
    Gc = "is-hidden",
    Kc = "js-drawer-open-cart",
    Qc = "is-open",
    Xc = "is-visible",
    Yc = "is-expanded",
    Jc = "is-loading",
    Zc = "is-disabled",
    th = "is-success",
    eh = "cart__toggle--has-items",
    ih = "variant--soldout",
    sh = "is-removed",
    oh = "aos-animate",
    nh = "is-updated",
    rh = "no-outline",
    ah = "product-grid-item__image--error",
    lh = "cv-h",
    ch = "is-selected",
    hh = "data-limit",
    dh = "data-cart-message",
    uh = "data-cart-total",
    ph = "aria-expanded",
    mh = "disabled",
    gh = "name",
    yh = "value",
    fh = "data-id",
    vh = "data-item",
    wh = "data-item-index",
    bh = "data-item-title",
    Sh = "data-atc-trigger",
    Eh = "data-notification-popup",
    Lh = "data-recipient-errors",
    kh = "data-max-inventory-reached",
    Ah = "data-error-message-position",
    Ch = "data-variant-title",
    qh = "data-quantity-max",
    Th = "tabindex";
  let Ph = {},
    xh = class {
      init() {
        var t;
        ((this.cartToggleButtons = document.querySelectorAll(Uc.cartDrawerToggle)),
          (this.cartPage = document.querySelector(Uc.cartPage)),
          (this.cartDrawer = document.querySelector(Uc.cartDrawer)),
          (this.cart = this.cartDrawer || this.cartPage),
          (this.cartCount = this.getCartItemCount()),
          this.assignArguments(),
          (this.recipientErrors = "true" === (null === (t = this.form) || void 0 === t ? void 0 : t.getAttribute(Lh))),
          (this.flktyUpsell = null),
          (this.form = null),
          (this.variantTitle = null),
          (this.collapsible = null),
          (this.a11y = window.theme.a11y),
          (this.build = this.build.bind(this)),
          (this.addToCart = this.addToCart.bind(this)),
          (this.updateCart = this.updateCart.bind(this)),
          (this.openCartDrawer = this.openCartDrawer.bind(this)),
          (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
          (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
          (this.formSubmitHandler = window.theme.throttle(this.formSubmitHandler.bind(this), 50)),
          (this.closeCartError = () => {
            this.cartErrorHolder.classList.remove(Yc);
          }),
          (this.cartDrawerCloseEvent = null),
          (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
          (this.isCartPage = Boolean(this.cart && null === this.cartDrawer)),
          (this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this)),
          (this.totalItems = 0),
          (this.isCartDrawerOpen = !1),
          (this.isCartDrawerLoaded = !1),
          (this.cartDiscounts = 0),
          (this.cartDrawerEnabled = Wc.cartDrawerEnabled),
          (this.cartUpdateFailed = !1),
          (this.showCannotAddMoreInCart = !1),
          this.cartEvents(),
          this.cartAddEvent(),
          this.cartDrawerToggleEvents(),
          this.initCartUpdate(),
          this.buttonHolder && (this.collapsible = new dt(this.buttonHolder)),
          this.isCartPage && this.renderPairProducts(),
          document.addEventListener("theme:popup:open", this.closeCartDrawer));
      }
      assignArguments() {
        var t;
        ((this.outerSection = null === (t = this.cart) || void 0 === t ? void 0 : t.closest(Uc.outerSection)),
          (this.cartDrawerBody = document.querySelector(Uc.cartDrawerBody)),
          (this.emptyMessage = document.querySelector(Uc.emptyMessage)),
          (this.emptyMessageBottom = document.querySelector(Uc.emptyMessageBottom)),
          (this.buttonHolder = document.querySelector(Uc.buttonHolder)),
          (this.itemsHolder = document.querySelector(Uc.itemsHolder)),
          (this.cartItemsQty = document.querySelector(Uc.cartItemsQty)),
          (this.itemsWrapper = document.querySelector(Uc.itemsWrapper)),
          (this.items = document.querySelectorAll(Uc.item)),
          (this.cartTotal = document.querySelector(Uc.cartTotal)),
          (this.cartTotalPrice = document.querySelector(Uc.cartTotalPrice)),
          (this.cartMessage = document.querySelectorAll(Uc.cartMessage)),
          (this.cartOriginalTotal = document.querySelector(Uc.cartOriginalTotal)),
          (this.cartErrorHolder = document.querySelector(Uc.cartErrors)),
          (this.cartCloseErrorMessage = document.querySelector(Uc.cartCloseError)),
          (this.pairProductsHolder = document.querySelector(Uc.pairProductsHolder)),
          (this.cartNoteHolder = document.querySelector(Uc.cartNoteHolder)),
          (this.pairProducts = document.querySelector(Uc.pairProducts)),
          (this.priceHolder = document.querySelector(Uc.priceHolder)),
          (this.upsellHolders = document.querySelectorAll(Uc.upsellHolder)),
          (this.cartTermsCheckbox = document.querySelector(Uc.cartTermsCheckbox)),
          (this.cartCheckoutButtonWrapper = document.querySelector(Uc.cartCheckoutButtonWrapper)),
          (this.cartCheckoutButton = document.querySelector(Uc.cartCheckoutButton)),
          (this.cartForm = document.querySelector(Uc.cartForm)),
          (this.cartItemCount = 0),
          (this.subtotal = window.theme.subtotal),
          (this.button = null));
        const { headerInitialHeight: e, announcementBarHeight: i } = window.theme.readHeights();
        ((this.headerInitialHeight = e),
          (this.announcementBarHeight = i),
          this.cartMessage.length > 0 &&
            (this.cartFreeLimitShipping =
              100 * Number(this.cartMessage[0].getAttribute(hh)) * window.Shopify.currency.rate),
          this.updateProgress());
      }
      initCartUpdate() {
        var t;
        ((this.items = document.querySelectorAll(Uc.item)),
          null === (t = this.items) ||
            void 0 === t ||
            t.forEach((t) => {
              this.cartUpdateEvent(t);
            }));
      }
      cartUpdateEvent(t) {
        t.addEventListener("theme:cart:update", (e) => {
          this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t);
        });
      }
      cartEvents() {
        const t = document.querySelectorAll(Uc.cartItemRemove);
        ((this.totalItems = t.length),
          null == t ||
            t.forEach((t) => {
              const e = t.closest(Uc.item);
              t.addEventListener("click", (i) => {
                (i.preventDefault(),
                  t.classList.contains(Zc) || this.updateCart({ id: e.getAttribute(fh), quantity: 0 }, e));
              });
            }),
          this.cartCloseErrorMessage &&
            (this.cartCloseErrorMessage.removeEventListener("click", this.closeCartError),
            this.cartCloseErrorMessage.addEventListener("click", this.closeCartError)),
          this.cartTermsCheckbox &&
            (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler),
            this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler),
            this.cartForm.removeEventListener("submit", this.formSubmitHandler),
            this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler),
            this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler),
            this.cartForm.addEventListener("submit", this.formSubmitHandler)));
      }
      cartAddEvent() {
        document.addEventListener("click", (t) => {
          const e = t.target,
            i = null == e ? void 0 : e.matches(Uc.buttonAddToCart),
            s = null == e ? void 0 : e.closest(Uc.buttonAddToCart);
          if (i || s) {
            var o, n, r;
            (t.preventDefault(),
              (this.button = i ? e : s),
              (this.form = e.closest("form")),
              (this.recipientErrors =
                "true" === (null === (o = this.form) || void 0 === o ? void 0 : o.getAttribute(Lh))),
              (this.formWrapper = this.button.closest(Uc.formWrapper)));
            const a = null === (n = this.formWrapper) || void 0 === n ? void 0 : n.classList.contains(ih),
              l = this.button.hasAttribute(mh),
              c = this.button.closest(Uc.quickViewOnboarding),
              h = this.button.hasAttribute(Sh),
              d = this.button.hasAttribute(Eh),
              u = null === (r = this.form) || void 0 === r ? void 0 : r.querySelector('[type="file"]');
            if (l || u || c) return;
            if (a && d) return void new fn(this.button);
            h && (this.a11y.state.trigger = this.button);
            let p = new FormData(this.form);
            [...this.form.elements].some((t) => t.closest(Uc.noscript)) &&
              (p = this.handleFormDataDuplicates([...this.form.elements], p));
            const m = this.form.getAttribute(kh),
              g = this.form.getAttribute(Ah);
            ((this.variantTitle = this.form.getAttribute(Ch)),
              (this.showCannotAddMoreInCart = !1),
              "true" === m && "cart" === g && (this.showCannotAddMoreInCart = !0),
              this.addToCart(p),
              document.dispatchEvent(new CustomEvent("theme:cart:add", { bubbles: !0, detail: { selector: e } })));
          }
        });
      }
      handleFormDataDuplicates(t, e) {
        return t.length && "object" == typeof e
          ? (t.forEach((t) => {
              if (t.closest(Uc.noscript)) {
                const i = t.getAttribute(gh),
                  s = t.value;
                if (i) {
                  const t = e.getAll(i);
                  (t.length > 1 && t.splice(t.indexOf(s), 1), e.delete(i), e.set(i, t[0]));
                }
              }
            }),
            e)
          : e;
      }
      getCart() {
        if (this.cartDrawer && !this.isCartDrawerLoaded) {
          const t = !1;
          this.renderCartDrawer(t);
        }
        fetch(theme.routes.cart_url + "?section_id=api-cart-items")
          .then(this.handleErrors)
          .then((t) => t.text())
          .then((t) => {
            const e = document.createElement("div");
            e.innerHTML = t;
            const i = e.querySelector(Uc.apiContent);
            this.build(i);
          })
          .catch((t) => console.log(t));
      }
      addToCart(t) {
        (this.cartDrawerEnabled && this.button && (this.button.classList.add(Jc), this.button.setAttribute(mh, !0)),
          fetch(theme.routes.cart_add_url, {
            method: "POST",
            headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
            body: t,
          })
            .then((t) => t.json())
            .then((t) => {
              ((this.button.disabled = !0),
                this.addLoadingClass(),
                (t.status && (this.addToCartError(t), this.removeLoadingClass(), !this.showCannotAddMoreInCart)) ||
                  (this.hideAddToCartErrorMessage(),
                  this.cartDrawerEnabled
                    ? (this.getCart(),
                      this.showCannotAddMoreInCart && this.updateErrorText(this.variantTitle),
                      this.scrollToCartTop())
                    : (window.location = theme.routes.cart_url)));
            })
            .catch((t) => console.log(t)));
      }
      updateCart(t = {}, e = null) {
        let i = t.quantity;
        (null !== e && (i ? e.classList.add(Jc) : e.classList.add(sh)),
          this.disableCartButtons(),
          this.addLoadingClass());
        const s = this.cart.querySelector(`[${vh}="${t.id}"]`) || e,
          o = (null == s ? void 0 : s.hasAttribute(wh)) ? parseInt(s.getAttribute(wh)) : 0,
          n = (null == s ? void 0 : s.hasAttribute(bh)) ? s.getAttribute(bh) : null;
        if (0 === o) return;
        const r = { line: o, quantity: i };
        fetch(theme.routes.cart_change_url, {
          method: "post",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(r),
        })
          .then((t) => {
            if (400 === t.status) {
              const e = new Error(t.status);
              throw (this.cartDrawerEnabled ? this.getCart() : (window.location = theme.routes.cart_url), e);
            }
            return t.text();
          })
          .then((t) => {
            if (JSON.parse(t).errors)
              return (
                (this.cartUpdateFailed = !0),
                this.updateErrorText(n),
                this.toggleErrorMessage(),
                this.resetLineItem(e),
                this.enableCartButtons(),
                this.removeLoadingClass(),
                void this.scrollToCartTop()
              );
            this.getCart();
          })
          .catch((t) => {
            (console.log(t), this.enableCartButtons(), this.removeLoadingClass());
          });
      }
      resetLineItem(t) {
        const e = t.querySelector(Uc.qtyInput),
          i = t.querySelector(Uc.qtySelect);
        let s = e.getAttribute(yh);
        const o = e.getAttribute(qh);
        (e && (e.value > o && (s = o), (e.value = s), i && (i.innerText = s)), t.classList.remove(Jc));
      }
      disableCartButtons() {
        const t = this.cart.querySelectorAll("input"),
          e = this.cart.querySelectorAll(`button, ${Uc.cartItemRemove}`);
        (t.length &&
          t.forEach((t) => {
            (t.classList.add(Zc), t.blur(), (t.disabled = !0));
          }),
          e.length &&
            e.forEach((t) => {
              t.setAttribute(mh, !0);
            }));
      }
      enableCartButtons() {
        const t = this.cart.querySelectorAll("input"),
          e = this.cart.querySelectorAll(`button, ${Uc.cartItemRemove}`);
        (t.length &&
          t.forEach((t) => {
            (t.classList.remove(Zc), (t.disabled = !1));
          }),
          e.length &&
            e.forEach((t) => {
              t.removeAttribute(mh);
            }));
      }
      updateErrorText(t) {
        this.cartErrorHolder.querySelector(Uc.errorMessage).innerText = t;
      }
      toggleErrorMessage() {
        if (this.cartErrorHolder) {
          if (
            (this.cartErrorHolder.classList.toggle(Yc, this.cartUpdateFailed || this.showCannotAddMoreInCart),
            this.cartUpdateFailed)
          ) {
            const t = this.cartErrorHolder.querySelector(Uc.cartCloseError);
            this.focusOnErrorMessage(this.cartErrorHolder, t);
          }
          ((this.showCannotAddMoreInCart = !1), (this.cartUpdateFailed = !1));
        }
      }
      handleErrors(t) {
        return t.ok
          ? t
          : t.json().then(function (e) {
              throw new Nc({ status: t.statusText, headers: t.headers, json: e });
            });
      }
      addToCartError(t) {
        const e = this.button.closest(Uc.quickBuyForm),
          i = this.button.closest(Uc.upsellHolder),
          s = !document.body.classList.contains(rh);
        let o = (
          this.button.closest(Uc.productForm)
            ? this.button.closest(Uc.productForm)
            : this.button.closest(Uc.upsellHolder)
        ).querySelector(Uc.formErrorsContainer);
        (i && (o = i.querySelector(Uc.formErrorsContainer)),
          this.cartDrawerEnabled &&
            this.button &&
            null !== this.button.closest(Uc.cartDrawer) &&
            !this.button.closest(Uc.cartDrawer) &&
            this.closeCartDrawer(),
          this.button.classList.remove(Jc),
          this.button.removeAttribute(mh));
        const n = e
          ? ""
          : `\n      <button type="button" class="errors__button-close" data-close-error>\n        ${theme.icons.close}\n      </button>\n    `;
        let r = `${t.message}: ${t.description}`;
        if (
          (t.message === t.description && (r = t.message),
          this.recipientErrors &&
            t.description &&
            "object" == typeof t.description &&
            (r = Object.entries(t.description)
              .map(([t, e]) => `${e}`)
              .join("<br>")),
          (o.innerHTML = `\n      <div class="errors" data-error autofocus>\n        ${r}\n        ${n}\n      </div>\n    `),
          e)
        ) {
          const t = o.closest(Uc.productItem);
          if (!t) return;
          const e = t.querySelector(Uc.productMediaContainer);
          if (!e) return;
          (e.classList.add(ah),
            o.querySelector(Uc.error).addEventListener("animationend", () => {
              (e.classList.remove(ah), (o.innerHTML = ""), s || document.activeElement.blur());
            }));
        } else
          (o.classList.add(Xc),
            o.addEventListener("transitionend", () => {
              (this.resizeSliders(o), o.scrollIntoView({ behavior: "smooth", block: "end" }));
            }),
            this.handleCloseErrorMessages(o));
      }
      handleCloseErrorMessages(t) {
        const e = t.querySelector(Uc.formCloseError);
        (null == e ||
          e.addEventListener("click", (e) => {
            const i = e.target;
            (i.matches(Uc.formCloseError) || i.closest(Uc.formCloseError)) &&
              (e.preventDefault(),
              t.classList.remove(Xc),
              t.querySelector(Uc.error).addEventListener("transitionend", () => {
                ((t.innerHTML = ""), this.resizeSliders(i));
              }));
          }),
          this.focusOnErrorMessage(t, e));
      }
      focusOnErrorMessage(t, e) {
        !document.body.classList.contains(rh) &&
          t.addEventListener("transitionend", () => {
            requestAnimationFrame(() => (null == e ? void 0 : e.focus({ focusVisible: !0 })));
          });
      }
      hideAddToCartErrorMessage() {
        const t = this.button.closest(Uc.upsellHolder)
            ? this.button.closest(Uc.upsellHolder)
            : this.button.closest(Uc.productForm),
          e = null == t ? void 0 : t.querySelector(Uc.formErrorsContainer);
        null == e || e.classList.remove(Xc);
      }
      resizeSliders(t) {
        const e = t.closest(Uc.flickityEnabled);
        if (!e) return;
        const i = window.theme.Flickity.data(e);
        requestAnimationFrame(() => i.resize());
      }
      renderCartDrawer(t = !0) {
        const e = document.querySelector(Uc.cartDrawerTemplate);
        e &&
          ((this.cartDrawer.innerHTML = e.innerHTML),
          this.assignArguments(),
          this.initCartUpdate(),
          this.cartEvents(),
          this.cartDrawerBody && (this.collapsible = new dt(this.cartDrawerBody)),
          (this.cartDrawerToggle = this.cartDrawer.querySelector(Uc.cartDrawerToggle)),
          this.cartDrawerToggle.addEventListener("click", this.cartDrawerToggleClickEvent),
          (this.isCartDrawerLoaded = !0),
          this.renderPairProducts(),
          document.dispatchEvent(new CustomEvent("theme:cart:loaded", { bubbles: !0 })),
          t && this.openCartDrawer());
      }
      openCartDrawer() {
        this.isCartDrawerOpen ||
          (this.isCartDrawerLoaded
            ? (document.dispatchEvent(new CustomEvent("theme:cart:open", { bubbles: !0 })),
              document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartDrawer })),
              document.dispatchEvent(
                new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartDrawerBody }),
              ),
              this.scrollToCartTop(),
              document.body.classList.add(Kc),
              this.cartDrawer.classList.add(Qc),
              this.cartDrawer.classList.remove(lh),
              requestAnimationFrame(() => this.animateCartItems("in")),
              this.cartToggleButtons.forEach((t) => {
                t.setAttribute(ph, !0);
              }),
              this.a11y.trapFocus({ container: this.cartDrawer }),
              this.observeAdditionalCheckoutButtons(),
              (this.isCartDrawerOpen = !0))
            : this.renderCartDrawer());
      }
      animateCartItems(t = "in") {
        const e = this.cart.querySelectorAll(Uc.aos);
        ("in" === t && e.forEach((t) => requestAnimationFrame(() => t.classList.add(oh))),
          "out" === t && e.forEach((t) => t.classList.remove(oh)));
      }
      closeCartDrawer() {
        if (!this.isCartDrawerOpen) return;
        (document.dispatchEvent(new CustomEvent("theme:cart:close", { bubbles: !0 })),
          this.cartErrorHolder.classList.remove(Yc),
          this.a11y.removeTrapFocus(),
          this.cartToggleButtons.forEach((t) => {
            t.setAttribute(ph, !1);
          }),
          document.body.classList.remove(Kc),
          this.cartDrawer.classList.remove(Qc),
          this.itemsHolder.classList.remove(nh));
        const t = (e) => {
          e.target === this.cartDrawer &&
            (this.animateCartItems("out"), this.cartDrawer.removeEventListener("transitionend", t));
        };
        this.cartDrawer.addEventListener("transitionend", t);
        !document.body.classList.contains(rh) ||
          requestAnimationFrame(() => {
            document.activeElement.blur();
          });
        (document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 400 })),
          (this.isCartDrawerOpen = !1));
      }
      toggleCartDrawer() {
        this.isCartDrawerOpen ? this.closeCartDrawer() : this.openCartDrawer();
      }
      cartDrawerToggleEvents() {
        this.cartDrawer &&
          (this.cartDrawer.addEventListener("keyup", (t) => {
            t.code === theme.keyboardKeys.ESCAPE && this.closeCartDrawer();
          }),
          (this.cartDrawerToggleClickEvent = (t) => {
            t.preventDefault();
            const e = t.target;
            ("false" === e.getAttribute(ph) && (this.a11y.state.trigger = e), this.toggleCartDrawer());
          }),
          (this.cartDrawerCloseEvent = (t) => {
            const e = t.target.matches(Uc.cartDrawerToggle),
              i = document.querySelector(Uc.cartDrawer).contains(t.target),
              s = t.target.closest(Uc.popupQuickView);
            e || i || s || this.closeCartDrawer();
          }),
          this.cartToggleButtons.forEach((t) => {
            t.addEventListener("click", this.cartDrawerToggleClickEvent);
          }),
          document.addEventListener("mousedown", this.cartDrawerCloseEvent));
      }
      toggleClassesOnContainers() {
        const t = this;
        (this.isCartPage
          ? this.buttonHolder.classList.toggle(jc, !t.hasItemsInCart())
          : (this.pairProductsHolder.classList.toggle(jc, !t.hasItemsInCart()),
            this.cartForm.classList.toggle(jc, !t.hasItemsInCart()),
            this.emptyMessageBottom.classList.toggle(jc, t.hasItemsInCart()),
            this.cartNoteHolder.classList.toggle(jc, !t.hasItemsInCart())),
          this.emptyMessage.classList.toggle(jc, t.hasItemsInCart()),
          this.itemsHolder.classList.toggle(jc, !t.hasItemsInCart()),
          this.cartItemsQty.classList.toggle(jc, !t.hasItemsInCart()));
      }
      build(t) {
        const e = t.querySelector(Uc.apiLineItems),
          i = t.querySelector(Uc.apiUpsellItems),
          s = Boolean(null === e && null === i),
          o = t.querySelector(Uc.apiCartPrice),
          n = t.querySelector(Uc.cartTotal);
        if (
          (this.priceHolder && o && (this.priceHolder.innerHTML = o.innerHTML),
          this.animateCartItems("out"),
          s
            ? ((this.itemsHolder.innerHTML = ""), this.pairProductsHolder && (this.pairProductsHolder.innerHTML = ""))
            : ((this.itemsHolder.innerHTML = e.innerHTML),
              this.pairProductsHolder && (this.pairProductsHolder.innerHTML = i.innerHTML),
              this.renderPairProducts()),
          (this.newTotalItems = e && e.querySelectorAll(Uc.item).length ? e.querySelectorAll(Uc.item).length : 0),
          (this.subtotal = n && n.hasAttribute(uh) ? parseInt(n.getAttribute(uh)) : 0),
          (this.cartCount = this.getCartItemCount()),
          this.cartMessage.length > 0 && this.updateProgress(),
          this.cartToggleButtons.forEach((t) => {
            (t.classList.remove(eh), this.newTotalItems > 0 && t.classList.add(eh));
          }),
          this.toggleErrorMessage(),
          this.updateItemsQuantity(this.cartCount),
          (this.cartTotalPrice.innerHTML =
            0 === this.subtotal
              ? window.theme.strings.free
              : window.theme.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
          this.totalItems !== this.newTotalItems &&
            ((this.totalItems = this.newTotalItems), this.toggleClassesOnContainers()),
          (this.isCartDrawerOpen || this.isCartPage) && this.itemsHolder.classList.add(nh),
          this.cartEvents(),
          this.initCartUpdate(),
          this.enableCartButtons(),
          this.resetButtonClasses(),
          this.removeLoadingClass(),
          document.dispatchEvent(new CustomEvent("theme:cart:added", { bubbles: !0 })),
          this.cartDrawer)
        ) {
          this.openCartDrawer();
          const t = (e) => {
            e.target === this.cartDrawer &&
              (this.animateCartItems("in"), this.cartDrawer.removeEventListener("transitionend", t));
          };
          this.cartDrawer.addEventListener("transitionend", t);
        }
        requestAnimationFrame(() => this.animateCartItems("in"));
      }
      getCartItemCount() {
        return this.cart
          ? Array.from(this.cart.querySelectorAll(Uc.qtyInput)).reduce((t, e) => t + parseInt(e.value), 0)
          : 0;
      }
      hasItemsInCart() {
        return this.totalItems > 0;
      }
      freeShippingMessageHandle(t) {
        this.cartMessage.length > 0 &&
          document.querySelectorAll(Uc.cartMessage).forEach((e) => {
            const i = e.hasAttribute(dh) && "true" === e.getAttribute(dh) && 0 !== t,
              s = e.querySelector(Uc.cartMessageDefault);
            (e.classList.toggle(th, t >= this.cartFreeLimitShipping && i),
              e.classList.toggle(Gc, 0 === t),
              s && s.classList.toggle(Gc, t >= this.cartFreeLimitShipping));
          });
      }
      updateProgress() {
        const t = (this.subtotal / this.cartFreeLimitShipping) * 100;
        let e = window.theme.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.moneyFormat);
        ((e.endsWith(".00") || e.endsWith(",00")) && (e = e.slice(0, -3)),
          theme.settings.currency_code_enable && (e += ` ${theme.current_iso_code}`),
          this.cartMessage.length > 0 &&
            document.querySelectorAll(Uc.cartMessage).forEach((i) => {
              const s = i.querySelectorAll(Uc.cartProgress),
                o = i.querySelector(Uc.leftToSpend);
              (o && (o.innerHTML = e),
                s.length &&
                  s.forEach((e, i) => {
                    (e.classList.toggle(Gc, this.subtotal / this.cartFreeLimitShipping >= 1),
                      e.style.setProperty("--progress-width", `${t}%`),
                      0 === i && e.setAttribute(yh, t));
                  }),
                this.freeShippingMessageHandle(this.subtotal));
            }));
      }
      renderPairProducts() {
        if (
          ((this.flktyUpsell = null),
          (this.pairProductsHolder = document.querySelector(Uc.pairProductsHolder)),
          (this.pairProducts = document.querySelector(Uc.pairProducts)),
          (this.upsellHolders = document.querySelectorAll(Uc.upsellHolder)),
          null === this.pairProductsHolder || void 0 === this.pairProductsHolder)
        )
          return;
        const t = this;
        if (this.upsellHolders.length > 1) {
          const e = new window.theme.Flickity(this.pairProducts, {
            wrapAround: !0,
            pageDots: !0,
            adaptiveHeight: !0,
            prevNextButtons: !1,
            on: {
              ready: function () {
                (new li(t.cart),
                  this.reloadCells(),
                  requestAnimationFrame(() => this.resize()),
                  t.upsellHolders.forEach((t) => {
                    if (!t.classList.contains(ch)) {
                      const e = t.querySelectorAll(Uc.links);
                      e.length &&
                        e.forEach((t) => {
                          t.setAttribute(Th, "-1");
                        });
                    }
                  }));
              },
            },
          });
          e.on("change", (t) => {
            e.cells.forEach((e, i) => {
              const s = e.element.querySelectorAll(Uc.links);
              s.length &&
                s.forEach((e) => {
                  e.setAttribute(Th, i === t ? "0" : "-1");
                });
            });
          });
        } else new li(this.cart);
      }
      updateItemsQuantity(t) {
        let e = theme.strings.cart_items_one,
          i = theme.strings.cart_items_many;
        ((e = e.split("}}")[1]),
          (i = i.split("}}")[1]),
          this.cartItemsQty && (this.cartItemsQty.textContent = 1 === t ? `${t} ${e}` : `${t} ${i}`));
      }
      observeAdditionalCheckoutButtons() {
        const t = this.cart.querySelector(Uc.additionalCheckoutButtons);
        if (t) {
          const e = new MutationObserver(() => {
            (this.a11y.removeTrapFocus(), this.a11y.trapFocus({ container: this.cart }), e.disconnect());
          });
          e.observe(t, { subtree: !0, childList: !0 });
        }
      }
      formSubmitHandler() {
        const t = document.querySelector(Uc.cartTermsCheckbox).checked,
          e = document.querySelector(Uc.termsErrorMessage);
        if (t) (e.classList.remove(Yc), this.cartCheckoutButton.removeAttribute(mh));
        else {
          if (document.querySelector(Uc.termsErrorMessage).length > 0) return;
          ((e.innerText = theme.strings.cart_acceptance_error),
            this.cartCheckoutButton.setAttribute(mh, !0),
            e.classList.add(Yc));
        }
      }
      resetButtonClasses() {
        const t = document.querySelectorAll(Uc.buttonAddToCart);
        t &&
          t.forEach((t) => {
            t.classList.contains(Jc) &&
              (t.classList.remove(Jc),
              t.classList.add(th),
              setTimeout(() => {
                (t.removeAttribute(mh), t.classList.remove(th));
              }, Wc.timers.addProductTimeout));
          });
      }
      addLoadingClass() {
        this.cartDrawer ? this.cartDrawer.classList.add(Jc) : this.itemsWrapper && this.itemsWrapper.classList.add(Jc);
      }
      removeLoadingClass() {
        this.cartDrawer
          ? this.cartDrawer.classList.remove(Jc)
          : this.itemsWrapper && this.itemsWrapper.classList.remove(Jc);
      }
      scrollToCartTop() {
        var t;
        this.cartDrawer
          ? this.cartDrawerBody.scrollTo({ top: 0, left: 0, behavior: "instant" })
          : window.scrollTo({
              top:
                (null === (t = this.outerSection) || void 0 === t ? void 0 : t.offsetTop) -
                this.headerInitialHeight -
                this.announcementBarHeight,
              left: 0,
              behavior: "smooth",
            });
      }
      unload() {
        (this.cartDrawerToggle && this.cartDrawerToggle.removeEventListener("click", this.cartDrawerToggleClickEvent),
          this.cartToggleButtons.forEach((t) => {
            t.removeEventListener("click", this.cartDrawerToggleClickEvent);
          }),
          document.removeEventListener("mousedown", this.cartDrawerCloseEvent),
          null !== this.collapsible && this.collapsible.onUnload());
      }
      constructor() {
        "/password" !== window.location.pathname && this.init();
      }
    };
  rl("cart-template", {
    onLoad() {
      Ph[this.id] = new xh();
    },
    onUnload() {
      "function" == typeof Ph[this.id].unload && Ph[this.id].unload();
    },
  });
  const Ih = "is-visible",
    Hh = document.querySelector("[data-scroll-top-button]");
  Hh &&
    (Hh.addEventListener("click", () => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }),
    document.addEventListener(
      "scroll",
      window.theme.throttle(() => {
        Hh.classList.toggle(Ih, window.pageYOffset > window.innerHeight);
      }, 150),
    ));
  const Fh = "details",
    Mh = "[data-popdown-body]",
    Dh = "[data-popdown-close]",
    Oh = "[data-popdown-toggle]",
    Bh = "[data-search-form-inner]",
    zh = "[data-popular-searches-link]",
    _h = "[data-site-header]",
    $h = "[data-nav]",
    Rh = "[data-nav-items-compress]",
    Vh = "[data-nav-icons]",
    Nh = "[data-mobile-menu]",
    Wh = "predictive-search",
    Uh = "search-form",
    jh = "data-popdown-in-header",
    Gh = "data-popdown-in-page",
    Kh = "aria-activedescendant",
    Qh = "aria-expanded",
    Xh = "open",
    Yh = "role",
    Jh = "search-opened",
    Zh = "site-header--menu-opened",
    td = "site-header--compress",
    ed = "is-open";
  let id = class extends HTMLElement {
    connectedCallback() {
      var t;
      (this.isPopdownInHeader &&
        (this.searchFormInner.addEventListener("transitionend", this.popdownTransitionCallbackEvent),
        this.details.addEventListener("keyup", (t) => "ESCAPE" === t.code.toUpperCase() && this.close()),
        this.details.addEventListener("toggle", this.detailsToggleCallbackEvent),
        this.popdownClose.addEventListener("click", (t) => this.close(t)),
        this.popdownToggle.addEventListener("click", (t) => this.onPopdownToggleClick(t)),
        this.popdownToggle.setAttribute(Yh, "button")),
      this.isPopdownInPage) &&
        (this.popdownClose.addEventListener("click", () => this.triggerPopdownClose()),
        this.searchFormWrapper.addEventListener("focusout", () => this.onFocusOut()),
        null === (t = this.searchFormWrapper.input) ||
          void 0 === t ||
          t.addEventListener("click", (t) => this.triggerPopdownOpen(t)));
      this.popularSearchesLink.forEach((t) => {
        t.addEventListener("click", (t) => {
          t.preventDefault();
          const e = t.target.textContent;
          ((this.searchFormWrapper.input.value = e), this.searchFormWrapper.submit());
        });
      });
    }
    onPopdownToggleClick(t) {
      const e = navigator.userAgent.includes("Chrome"),
        i = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      (e && !i && t.target.closest(Fh).setAttribute(Xh, ""),
        t.target.closest(Fh).hasAttribute(Xh) && (t.preventDefault(), this.close()));
    }
    detailsToggleCallback(t) {
      t.target.hasAttribute(Xh) && this.open();
    }
    popdownTransitionCallback(t) {
      t.target === this.searchFormInner &&
        (this.details.classList.contains(ed)
          ? "transform" === t.propertyName && this.a11y.trapFocus({ container: this.searchFormInner })
          : this.onClose());
    }
    onBodyClick(t) {
      var e;
      const i = this.contains(t.target);
      (null === (e = this.header) || void 0 === e ? void 0 : e.classList.contains(Zh)) || i || i || this.close();
    }
    onFocusOut() {
      this.predictiveSearch &&
        requestAnimationFrame(() => {
          this.searchFormWrapper.contains(document.activeElement) || this.searchFormWrapper.close();
        });
    }
    triggerPopdownOpen(t) {
      let e = matchMedia("(pointer:coarse)").matches;
      const i = window.innerWidth < theme.sizes.small,
        s = e || i;
      if ((i && window.Shopify.designMode && (e = !0), this.nav && this.mobileMenu && s)) {
        t.preventDefault();
        const i = this.header.classList.contains(td);
        let s = this.mobileMenu.querySelector(Oh);
        (e || (s = i ? this.nav.querySelector(`${Rh} ${Oh}`) : this.nav.querySelector(`${Vh} ${Oh}`)),
          setTimeout(() => {
            null == s || s.dispatchEvent(new Event("click", { bubbles: !0 }));
          }, 300));
      }
    }
    open() {
      ((this.onBodyClickEvent = (t) => this.onBodyClick(t)),
        this.searchFormWrapper.input.setAttribute(Qh, !0),
        document.body.classList.add(Jh),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.addEventListener("theme:resize", this.ensureClosingOnResizeEvent),
        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
        requestAnimationFrame(() => {
          this.details.classList.add(ed);
        }));
    }
    close(t) {
      const e = this.searchFormWrapper.input.getAttribute(Kh);
      (t && t.target === this.popdownClose && e && "" !== e) ||
        (this.a11y.removeTrapFocus(),
        this.details.classList.remove(ed),
        this.predictiveSearch && this.searchFormWrapper.close(),
        this.searchFormWrapper.handleFocusableDescendants(!0));
    }
    triggerPopdownClose() {
      (this.predictiveSearch && this.searchFormWrapper.close(),
        this.searchFormWrapper.popularSearches && requestAnimationFrame(() => document.activeElement.blur()));
    }
    onClose() {
      (this.details.removeAttribute(Xh),
        document.dispatchEvent(new CustomEvent("theme:search:close", { bubbles: !0 })),
        document.body.classList.remove(Jh),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.removeEventListener("theme:resize", this.ensureClosingOnResizeEvent),
        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })));
    }
    ensureClosingOnResize() {
      null === this.offsetParent && this.onClose();
    }
    constructor() {
      var t, e, i;
      (super(),
        (this.isPopdownInHeader = this.hasAttribute(jh)),
        (this.isPopdownInPage = this.hasAttribute(Gh)),
        (this.popdownBody = this.querySelector(Mh)),
        (this.popdownClose = this.querySelector(Dh)),
        (this.searchFormInner = this.querySelector(Bh)),
        (this.popularSearchesLink = this.querySelectorAll(zh)),
        (this.searchFormWrapper = this.querySelector(Uh) ? this.querySelector(Uh) : this.querySelector(Wh)),
        (this.predictiveSearch = this.searchFormWrapper.matches(Wh)),
        (this.header = document.querySelector(_h)),
        (this.headerSection = null === (t = this.header) || void 0 === t ? void 0 : t.parentNode),
        (this.nav = null === (e = this.header) || void 0 === e ? void 0 : e.querySelector($h)),
        (this.mobileMenu = null === (i = this.headerSection) || void 0 === i ? void 0 : i.querySelector(Nh)),
        (this.a11y = window.theme.a11y),
        (this.ensureClosingOnResizeEvent = () => this.ensureClosingOnResize()),
        (this.popdownTransitionCallbackEvent = (t) => this.popdownTransitionCallback(t)),
        (this.detailsToggleCallbackEvent = (t) => this.detailsToggleCallback(t)),
        this.isPopdownInHeader &&
          ((this.details = this.querySelector(Fh)), (this.popdownToggle = this.querySelector(Oh))));
    }
  };
  (customElements.define("search-popdown", id),
    (Shopify.Products = (function () {
      const t = {
        howManyToShow: 4,
        howManyToStoreInMemory: 10,
        wrapperId: "recently-viewed-products",
        section: null,
        onComplete: null,
      };
      let e = [],
        i = null,
        s = null;
      const o = new Date(),
        n = new Date();
      n.setTime(o.getTime() + 7776e6);
      const r = {
          configuration: {
            expires: n.toGMTString(),
            path: "/",
            domain: window.location.hostname,
            sameSite: "none",
            secure: !0,
          },
          name: "shopify_recently_viewed",
          write: function (t) {
            const e = encodeURIComponent(t.join(" "));
            document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
          },
          read: function () {
            let t = [],
              e = null;
            return (
              -1 !== document.cookie.indexOf("; ") &&
                document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                (e = document.cookie
                  .split("; ")
                  .find((t) => t.startsWith(this.name))
                  .split("=")[1]),
              null !== e && (t = decodeURIComponent(e).split(" ")),
              t
            );
          },
          destroy: function () {
            document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
          },
          remove: function (t) {
            const e = this.read(),
              i = e.indexOf(t);
            -1 !== i && (e.splice(i, 1), this.write(e));
          },
        },
        a = (e, i, o, n) => {
          i.length && e < t.howManyToShow
            ? fetch(`${window.theme.routes.root}products/${i[0]}?section_id=api-product-grid-item`)
                .then((t) => t.text())
                .then((t) => {
                  const s = 150 * e,
                    l = o.id ? `#${o.id}` : "",
                    c = document.createElement("div");
                  let h = t;
                  if (h.includes("data-unpublished")) return (r.remove(i[0]), i.shift(), void a(e, i, o, n));
                  ((h = h.includes("||itemAosDelay||") ? h.replaceAll("||itemAosDelay||", s) : h),
                    (h = h.includes("||itemAosAnchor||") ? h.replaceAll("||itemAosAnchor||", l) : h),
                    (c.innerHTML = h),
                    (o.innerHTML += c.querySelector("[data-api-content]").innerHTML),
                    i.shift(),
                    e++,
                    a(e, i, o, n));
                })
                .catch(() => {
                  (r.remove(i[0]), i.shift(), a(e, i, o, n));
                })
            : ((e, i) => {
                Xo(e, !0);
                const o = r.read().length;
                if (Shopify.recentlyViewed && s && o && o < s && e.children.length) {
                  let t = [],
                    i = [],
                    s = 0;
                  for (const e in Shopify.recentlyViewed) {
                    s += 1;
                    const o = Shopify.recentlyViewed[e].split(" "),
                      n = parseInt(e.split("_")[1]);
                    ((t = [...t, ...o]),
                      (r.read().length === n || (s === Object.keys(Shopify.recentlyViewed).length && !i.length)) &&
                        (i = [...i, ...o]));
                  }
                  for (let s = 0; s < e.children.length; s++) {
                    const o = e.children[s];
                    (t.length && o.classList.remove(...t), i.length && o.classList.add(...i));
                  }
                }
                if (t.onComplete)
                  try {
                    t.onComplete(e, i);
                  } catch (t) {
                    console.log(t);
                  }
              })(o, n);
        };
      return {
        showRecentlyViewed: function (o) {
          const n = o || {};
          (Object.assign(t, n),
            (e = r.read()),
            (i = document.querySelector(`#${t.wrapperId}`)),
            (s = t.howManyToShow),
            (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
            t.howManyToShow && i && a(0, e, i, t.section));
        },
        getConfig: function () {
          return t;
        },
        clearList: function () {
          r.destroy();
        },
        recordRecentlyViewed: function (e) {
          const i = e || {};
          Object.assign(t, i);
          let s = r.read();
          if (-1 !== window.location.pathname.indexOf("/products/")) {
            let e = decodeURIComponent(window.location.pathname)
              .match(
                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/,
              )[0]
              .split("/products/")[1];
            t.handle && (e = t.handle);
            const i = s.indexOf(e);
            (-1 === i ? (s.unshift(e), (s = s.splice(0, t.howManyToStoreInMemory))) : (s.splice(i, 1), s.unshift(e)),
              r.write(s));
          }
        },
        hasProducts: r.read().length > 0,
      };
    })()));
  const sd = "[data-actions]",
    od = "[data-button]",
    nd = "[data-content]",
    rd = "[data-collapsible-container]",
    ad = "data-height",
    ld = "aria-expanded",
    cd = "is-open",
    hd = "is-enabled";
  let dd = class extends HTMLElement {
    connectedCallback() {
      (this.button.addEventListener("click", this.toggle),
        this.content.offsetHeight < this.initialHeight
          ? this.setHeight(this.content.offsetHeight)
          : this.setHeight(this.initialHeight),
        this.toggleActions(),
        document.addEventListener("theme:resize", this.toggleActionsEvent.bind(this)));
    }
    toggle() {
      const t = !this.classList.contains(cd),
        e = this.content.offsetHeight + 2 * this.actions.offsetHeight;
      (this.setHeight(t ? e : this.initialHeight),
        this.classList.toggle(cd, t),
        this.updateTabIndex(),
        this.dispatchEvent(
          new CustomEvent("theme:ellipsis:toggle", { bubbles: !0, detail: { isExpanded: t, dropdownHeight: e } }),
        ));
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize", this.toggleActions);
    }
    setHeight(t) {
      this.style.setProperty("--height", `${t}px`);
    }
    toggleActions() {
      (this.classList.toggle(hd, this.content.offsetHeight + this.actions.offsetHeight > this.initialHeight),
        this.updateTabIndex());
    }
    toggleActionsEvent() {
      "true" === this.closest(rd).getAttribute(ld) && this.toggleActions();
    }
    updateTabIndex() {
      const t = this.content.querySelectorAll("a"),
        e = this.actions.offsetHeight;
      (this.observer && this.observer.disconnect(),
        (this.observer = new IntersectionObserver(
          (t) => {
            t.forEach((t) => {
              t.isIntersecting ? t.target.setAttribute("tabindex", "0") : t.target.setAttribute("tabindex", "-1");
            });
          },
          { root: this, threshold: 1, rootMargin: `0px 0px -${e}px 0px` },
        )),
        t.forEach((t) => {
          this.observer.observe(t);
        }));
    }
    constructor() {
      (super(),
        (this.initialHeight = this.getAttribute(ad)),
        (this.content = this.querySelector(nd)),
        (this.actions = this.querySelector(sd)),
        (this.button = this.querySelector(od)),
        (this.toggle = this.toggle.bind(this)),
        (this.toggleActions = this.toggleActions.bind(this)));
    }
  };
  customElements.get("toggle-ellipsis") || customElements.define("toggle-ellipsis", dd);
  const ud = "form",
    pd = "[data-selector-wrapper]",
    md = "[data-popout-list]",
    gd = "[data-popout-toggle]",
    yd = "[data-popout-input]",
    fd = "[data-popout-option]",
    vd = "[data-popout-text]",
    wd = "[aria-current]",
    bd = "[data-product-image]",
    Sd = "[data-product-grid-item]",
    Ed = "[data-quick-view-item]",
    Ld = "[data-quick-view-foot]",
    kd = "[data-cart-item]",
    Ad = "[data-quantity-field]",
    Cd = "[data-cart-drawer]",
    qd = "[data-cart-message]",
    Td = "[data-cart-errors]",
    Pd = "[data-cart-drawer-body]",
    xd = "[data-items-holder]",
    Id = "selector-wrapper--open",
    Hd = "select-popout__list--top",
    Fd = "select-popout__list--visible",
    Md = "is-active",
    Dd = "--current",
    Od = "is-visible",
    Bd = "cart__item--open",
    zd = "aria-current",
    _d = "aria-expanded",
    $d = "data-value",
    Rd = "data-popout-prevent",
    Vd = "data-quantity-field",
    Nd = "data-quick-view-inner",
    Wd = "data-quick-view-focus",
    Ud = "data-popout-initialized",
    jd = "data-quantity-holder";
  customElements.get("popout-select") ||
    customElements.define(
      "popout-select",
      class extends HTMLElement {
        connectedCallback() {
          ((this.popout = this),
            (this.selectorWrapper = this.popout.closest(pd)),
            (this.popoutList = this.popout.querySelector(md)),
            (this.popoutToggle = this.popout.querySelector(gd)),
            (this.popoutText = this.popout.querySelector(vd)),
            (this.popoutInput = this.popout.querySelector(yd)),
            (this.popoutOptions = this.popout.querySelectorAll(fd)),
            (this.popoutPrevent = "true" === this.popout.getAttribute(Rd)),
            (this.cartItem = this.popoutList.closest(kd)),
            (this.popupToggleFocusoutEvent = (t) => this.popupToggleFocusout(t)),
            (this.popupListFocusoutEvent = (t) => this.popupListFocusout(t)),
            (this.popupToggleClickEvent = (t) => this.popupToggleClick(t)),
            (this.popoutKeyupEvent = (t) => this.popoutKeyup(t)),
            (this.popupOptionsClickEvent = (t) => this.popupOptionsClick(t)),
            (this._connectOptionsDispatchEvent = (t) => this._connectOptionsDispatch(t)),
            (this.bodyClick = this.bodyClick.bind(this)),
            (this.popoutTop = !1),
            this._connectOptions(),
            this._connectToggle(),
            this._onFocusOut(),
            this.popupListSetDimensions(),
            this.toggleListPosition());
        }
        popupToggleClick(t) {
          const e = "true" === t.currentTarget.getAttribute(_d);
          if (this.popoutList.closest(Sd)) {
            const t = this.popoutList.closest(Sd).querySelector(bd);
            t && t.classList.toggle(Od, !e);
          }
          (this.cartItem && this.cartItem.classList.toggle(Bd),
            t.currentTarget.setAttribute(_d, !e),
            this.popoutList.classList.toggle(Fd),
            this.toggleListPosition(),
            this.popupListSetDimensions());
        }
        popupToggleFocusout(t) {
          const e = "true" === this.popoutToggle.getAttribute(_d);
          if (!t.relatedTarget) return;
          const i = this.popout.contains(t.relatedTarget),
            s = t.relatedTarget.hasAttribute(Nd) || t.relatedTarget.hasAttribute(Wd);
          i || s || !e || this._hideList();
        }
        popupListFocusout(t) {
          const e = t.currentTarget.contains(t.relatedTarget);
          this.popoutList.classList.contains(Fd) && !e && this._hideList();
        }
        calc(t = "shouldBeOnTop") {
          const { headerHeight: e, stickyHeaderHeight: i, announcementBarHeight: s } = window.theme.readHeights(),
            o = this.popout.closest(Ed),
            n = this.popout.closest(Cd);
          let r = Math.floor(this.popout.getBoundingClientRect().top),
            a = e || 0,
            l = 0;
          (0 !== s && window.scrollY < s && (l = s), window.scrollY > l + e && (a = i));
          let c = window.innerHeight,
            h = a + l;
          if (o) {
            const t = o.querySelector(Ld),
              e = (null == t ? void 0 : t.offsetHeight) || 0,
              i = Math.floor(o.getBoundingClientRect().top);
            ((r -= i), (c -= e), (h = i), window.theme.isMobile() && (c = o.offsetHeight - e));
          }
          if (n) {
            const t = n.querySelector(qd),
              e = n.querySelector(Td),
              i = n.querySelector(Pd),
              s = n.querySelector(xd),
              o = (null == t ? void 0 : t.offsetHeight) || 0,
              a = (null == e ? void 0 : e.offsetHeight) || 0,
              l = (null == i ? void 0 : i.scrollHeight) || 0;
            ((r -= Math.floor(null == s ? void 0 : s.getBoundingClientRect().top)), (c = l - o - a), (h = 0));
          }
          let d = c - h;
          if ((o && window.theme.isMobile() && (d = c), "shouldBeOnTop" === t)) return d / 2 < r;
          if ("availableHeightAbove" === t) {
            const t = Math.floor(this.popoutToggle.getBoundingClientRect().top - 1);
            return ((h += 10), `${parseInt(t - h)}px`);
          }
          if ("availableHeightBelow" === t) {
            const t = Math.floor(this.popoutList.getBoundingClientRect().top - 1);
            return ((h = 10), `${parseInt(c - t - h)}px`);
          }
        }
        toggleListPosition() {
          const t = "true" === this.popoutToggle.getAttribute(_d),
            e = this.calc("shouldBeOnTop");
          var i;
          t && (null === (i = this.selectorWrapper) || void 0 === i || i.classList.add(Id));
          e
            ? (this.popoutList.classList.add(Hd), (this.popoutTop = !0))
            : (this.popoutList.classList.remove(Hd), (this.popoutTop = !1));
        }
        popupListSetDimensions() {
          (this.popoutList.style.setProperty("--max-height", "100vh"),
            requestAnimationFrame(() => {
              this.popoutTop
                ? this.popoutList.style.setProperty("--max-height", this.calc("availableHeightAbove"))
                : this.popoutList.style.setProperty("--max-height", this.calc("availableHeightBelow"));
            }));
        }
        popupOptionsClick(t) {
          if ("#" === t.target.closest(fd).attributes.href.value) {
            t.preventDefault();
            let e = "";
            if (
              (t.currentTarget.getAttribute($d) && (e = t.currentTarget.getAttribute($d)),
              !this.popoutInput &&
                this.popout.nextSibling.hasAttribute(jd) &&
                (this.popoutInput = this.popout.nextSibling.querySelector(Ad)),
              (this.popoutInput.value = e),
              this.popoutPrevent)
            ) {
              (this.popoutInput.dispatchEvent(new Event("change")),
                this.cartItem && this.popoutInput.dispatchEvent(new Event("input")),
                this.switchQuantityInputBehavior(t.detail.preventTrigger));
              const i = this.popoutList.querySelector(`[class*="${Dd}"]`);
              let s = Dd;
              if (i && i.classList.length)
                for (const t of i.classList)
                  if (t.includes(Dd)) {
                    s = t;
                    break;
                  }
              const o = this.popoutList.querySelector(`.${s}`);
              o && (o.classList.remove(`${s}`), t.currentTarget.parentElement.classList.add(`${s}`));
              const n = this.popoutList.querySelector(wd);
              (n && (n.removeAttribute(zd), t.currentTarget.setAttribute(zd, "true")),
                "" !== e && (this.popoutText.textContent = e),
                this.popupToggleFocusout(t),
                this.popupListFocusout(t));
            } else this._submitForm(e);
          }
        }
        switchQuantityInputBehavior(t = !0) {
          var e;
          if (t || !this.popoutInput.hasAttribute(Vd)) return;
          const i = this.popoutList.querySelector(`[${$d}="${this.popoutInput.value}"]`);
          i &&
            (i.parentElement.nextSibling ||
              (this.popout.classList.add(Md),
              null === (e = this.selectorWrapper) || void 0 === e || e.classList.remove(Id)));
        }
        popoutKeyup(t) {
          t.code === theme.keyboardKeys.ESCAPE && (this._hideList(), this.popoutToggle.focus());
        }
        bodyClick(t) {
          const e = this.popout.contains(t.target);
          this.popoutList.classList.contains(Fd) && !e && this._hideList();
        }
        _connectToggle() {
          (this.popout.setAttribute(Ud, ""), this.popoutToggle.addEventListener("click", this.popupToggleClickEvent));
        }
        _connectOptions() {
          this.popoutOptions.length &&
            this.popoutOptions.forEach((t) => {
              (t.addEventListener("theme:popout:click", this.popupOptionsClickEvent),
                t.addEventListener("click", this._connectOptionsDispatchEvent));
            });
        }
        _connectOptionsDispatch(t) {
          const e = new CustomEvent("theme:popout:click", {
            cancelable: !0,
            bubbles: !0,
            detail: { preventTrigger: !1 },
          });
          t.target.dispatchEvent(e) || t.preventDefault();
        }
        _onFocusOut() {
          (this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent),
            this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent),
            this.popout.addEventListener("keyup", this.popoutKeyupEvent),
            document.body.addEventListener("click", this.bodyClick));
        }
        _submitForm() {
          const t = this.popout.closest(ud);
          t && t.submit();
        }
        _hideList() {
          (this.popoutList.classList.remove(Fd),
            this.popoutToggle.setAttribute(_d, !1),
            this.toggleListPosition(),
            this.cartItem && this.cartItem.classList.remove(Bd));
        }
        disconnectedCallback() {
          (this.popoutOptions.length &&
            this.popoutOptions.forEach((t) => {
              (t.removeEventListener("theme:popout:click", this.popupOptionsClickEvent),
                t.removeEventListener("click", this._connectOptionsDispatchEvent));
            }),
            this.popoutToggle.removeEventListener("click", this.popupToggleClickEvent),
            this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusoutEvent),
            this.popoutList.removeEventListener("focusout", this.popupListFocusoutEvent),
            this.popout.removeEventListener("keyup", this.popoutKeyupEvent),
            document.body.removeEventListener("click", this.bodyClick));
        }
        constructor() {
          super();
        }
      },
    );
  const Gd = "[data-quantity-field]",
    Kd = "[data-quantity-button]",
    Qd = "[data-quantity-minus]",
    Xd = "[data-quantity-plus]",
    Yd = "[data-cart-item]",
    Jd = "read-only",
    Zd = "is-disabled";
  (customElements.get("quantity-counter") ||
    customElements.define(
      "quantity-counter",
      class extends HTMLElement {
        connectedCallback() {
          ((this.quantity = this),
            (this.cartItem = this.quantity.closest(Yd)),
            this.quantity &&
              ((this.field = this.quantity.querySelector(Gd)),
              (this.buttons = this.quantity.querySelectorAll(Kd)),
              (this.increaseButton = this.quantity.querySelector(Xd)),
              (this.quantityValue = Number(this.field.value || 0)),
              (this.cartItemID = this.field.getAttribute("data-id")),
              (this.maxValue =
                Number(this.field.getAttribute("max")) > 0 ? Number(this.field.getAttribute("max")) : null),
              (this.minValue = Number(this.field.getAttribute("min")) > 0 ? Number(this.field.getAttribute("min")) : 0),
              (this.disableIncrease = this.disableIncrease.bind(this)),
              (this.emptyField = !1),
              (this.updateQuantity = this.updateQuantity.bind(this)),
              (this.decrease = this.decrease.bind(this)),
              (this.increase = this.increase.bind(this)),
              this.disableIncrease(),
              this.quantity.classList.contains(Jd) || (this.changeValueOnClick(), this.changeValueOnInput())));
        }
        changeValueOnClick() {
          this.buttons.forEach((t) => {
            t.addEventListener("click", (t) => {
              (t.preventDefault(), (this.quantityValue = Number(this.field.value || 0)));
              const e = t.target,
                i = e.matches(Qd) || e.closest(Qd),
                s = e.matches(Xd) || e.closest(Xd);
              (i && this.decrease(), s && this.increase(), this.updateQuantity());
            });
          });
        }
        changeValueOnInput() {
          this.field.addEventListener("input", () => {
            ((this.quantityValue = this.field.value), this.updateQuantity());
          });
        }
        updateQuantity() {
          (this.maxValue < this.quantityValue && null !== this.maxValue && (this.quantityValue = this.maxValue),
            this.minValue > this.quantityValue && (this.quantityValue = this.minValue),
            (this.field.value = this.quantityValue),
            this.disableIncrease(),
            this.cartItem
              ? (document.dispatchEvent(new CustomEvent("theme:cart:update")), this.updateCart())
              : this.triggerInputChange());
        }
        decrease() {
          this.quantityValue > this.minValue ? this.quantityValue-- : (this.quantityValue = 0);
        }
        increase() {
          this.quantityValue++;
        }
        disableIncrease() {
          this.increaseButton.classList.toggle(Zd, this.quantityValue >= this.maxValue && null !== this.maxValue);
        }
        updateCart() {
          if ("" === this.quantityValue) return;
          const t = new CustomEvent("theme:cart:update", {
            bubbles: !0,
            detail: { id: this.cartItemID, quantity: this.quantityValue },
          });
          this.cartItem && this.cartItem.dispatchEvent(t);
        }
        triggerInputChange() {
          this.field.dispatchEvent(new Event("change"));
        }
        constructor() {
          super();
        }
      },
    ),
    (window.theme.flickitySmoothScrolling = function (t) {
      const e = window.theme.Flickity.data(t);
      e &&
        (e.on("dragStart", (t, e) => {
          document.ontouchmove = function (t) {
            t.preventDefault();
          };
        }),
        e.on("dragEnd", (t, e) => {
          document.ontouchmove = function (t) {
            return !0;
          };
        }));
    }),
    (theme.ProductModel = (function () {
      let t = {},
        e = {},
        i = {};
      const s = {
          productMediaWrapper: "[data-product-single-media-wrapper]",
          mediaGroup: "[data-product-single-media-group]",
          productXr: "[data-shopify-xr]",
          mediaId: "data-media-id",
          model3d: "data-shopify-model3d-id",
          modelViewer: "model-viewer",
          modelJson: "#ModelJson-",
          deferredMedia: "[data-deferred-media]",
          deferredMediaButton: "[data-deferred-media-button]",
        },
        o = { isLoading: "is-loading", mediaHidden: "media--hidden" };
      function n(t, n) {
        if (t.querySelector(s.deferredMedia).getAttribute("loaded")) return;
        t.classList.add(o.isLoading);
        const l = document.createElement("div");
        l.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
        const c = l.querySelector("model-viewer"),
          h = t.querySelector(s.deferredMedia);
        (h.appendChild(c), h.setAttribute("loaded", !0));
        const d = t.dataset.mediaId,
          u = c.dataset.modelId,
          p = t.closest(s.mediaGroup).parentElement.querySelector(s.productXr);
        ((i[n] = { element: p, defaultId: u }),
          (e[d] = { modelId: u, mediaId: d, sectionId: n, container: t, element: c }),
          window.ShopifyXR
            ? a()
            : window.Shopify.loadFeatures([
                { name: "shopify-xr", version: "1.0", onLoad: r },
                { name: "model-viewer-ui", version: "1.0", onLoad: a },
              ]));
      }
      function r(e) {
        if (e) console.warn(e);
        else if (window.ShopifyXR) {
          for (const e in t)
            if (t.hasOwnProperty(e)) {
              const i = t[e];
              if (i.loaded) continue;
              const o = document.querySelector(`${s.modelJson}${e}`);
              o && (window.ShopifyXR.addModels(JSON.parse(o.innerHTML)), (i.loaded = !0));
            }
          window.ShopifyXR.setupXRElements();
        } else
          document.addEventListener("shopify_xr_initialized", function () {
            r();
          });
      }
      function a(t) {
        if (t) console.warn(t);
        else
          for (const t in e)
            if (e.hasOwnProperty(t)) {
              const i = e[t];
              i.modelViewerUi || ((i.modelViewerUi = new Shopify.ModelViewerUI(i.element)), l(i));
            }
      }
      function l(t) {
        const e = i[t.sectionId];
        (t.container.addEventListener("theme:media:visible", function () {
          (e.element.setAttribute(s.model3d, t.modelId),
            window.theme.touch ||
              (t.modelViewerUi.play(),
              t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 })));
        }),
          t.container.addEventListener("theme:media:hidden", function () {
            t.modelViewerUi.pause();
          }),
          t.container.addEventListener("xrLaunch", function () {
            t.modelViewerUi.pause();
          }),
          t.element.addEventListener("load", () => {
            (e.element.setAttribute(s.model3d, t.modelId),
              t.container.classList.remove(o.isLoading),
              t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 }));
          }),
          t.element.addEventListener("shopify_model_viewer_ui_toggle_play", function () {
            (c(t.mediaId),
              setTimeout(() => {
                t.container.dispatchEvent(new CustomEvent("theme:media:play"), { bubbles: !0 });
              }, 50));
          }),
          t.element.addEventListener("shopify_model_viewer_ui_toggle_pause", function () {
            t.container.dispatchEvent(new CustomEvent("theme:media:pause"), { bubbles: !0 });
          }),
          c(t.mediaId));
      }
      function c(t) {
        const e = `[${s.mediaId}="${t}"]`,
          i = document.querySelectorAll(`${s.productMediaWrapper}:not(${e})`);
        i.length &&
          i.forEach((t) => {
            (t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(o.mediaHidden));
          });
      }
      return {
        init: function (e, i) {
          t[i] = { loaded: !1 };
          const o = e.querySelector(s.deferredMediaButton);
          o && o.addEventListener("click", n.bind(this, e, i));
        },
        loadContent: n,
        removeSectionModels: function (i) {
          for (const t in e)
            if (e.hasOwnProperty(t)) {
              e[t].sectionId === i && delete e[t];
            }
          (delete t[i], delete theme.mediaInstances[i]);
        },
      };
    })()),
    rl("collection-template", Hs));
  const tu = ".template-customers-addresses",
    eu = "[data-form]",
    iu = "[data-form-new]",
    su = "[data-button-new]",
    ou = "[data-button-edit]",
    nu = "[data-button-delete]",
    ru = "[data-button-cancel]",
    au = "data-form-edit",
    lu = "AddressCountryNew",
    cu = "AddressProvinceNew",
    hu = "AddressProvinceContainerNew",
    du = "[data-country-option]",
    uu = "AddressCountry",
    pu = "AddressProvince",
    mu = "AddressProvinceContainer",
    gu = 'input[type="text"]:not(.optional)',
    yu = "data-form-id",
    fu = "is-hidden",
    vu = "validation--showup";
  const wu = document.querySelector(tu);
  wu &&
    new (class {
      init() {
        if (this.addressNewForm) {
          const t = this.section,
            e = this.addressNewForm;
          this.customerAddresses();
          const i = t.querySelectorAll(su);
          i.length &&
            i.forEach((t) => {
              t.addEventListener("click", function (i) {
                (i.preventDefault(), t.classList.add(fu), e.classList.remove(fu));
              });
            });
          const s = t.querySelectorAll(ou);
          s.length &&
            s.forEach((e) => {
              e.addEventListener("click", function (e) {
                e.preventDefault();
                const i = this.getAttribute(yu);
                t.querySelector(`[${au}="${i}"]`).classList.toggle(fu);
              });
            });
          const o = t.querySelectorAll(nu);
          o.length &&
            o.forEach((t) => {
              t.addEventListener("click", function (t) {
                t.preventDefault();
                const e = this.getAttribute(yu);
                confirm(theme.strings.delete_confirm) &&
                  Shopify.postLink("/account/addresses/" + e, { parameters: { _method: "delete" } });
              });
            });
          const n = t.querySelectorAll(ru);
          n.length &&
            n.forEach((t) => {
              t.addEventListener("click", function (t) {
                (t.preventDefault(),
                  this.closest(eu).classList.add(fu),
                  document.querySelector(su).classList.remove(fu));
              });
            });
        }
      }
      customerAddresses() {
        (Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(lu, cu, { hideElement: hu }),
          this.section.querySelectorAll(du).forEach((t) => {
            const e = t.getAttribute(yu),
              i = `${uu}_${e}`,
              s = `${pu}_${e}`,
              o = `${mu}_${e}`;
            new Shopify.CountryProvinceSelector(i, s, { hideElement: o });
          }));
      }
      validate() {
        this.accountForms.forEach((t) => {
          const e = t.querySelector("form"),
            i = e.querySelectorAll(gu);
          e.addEventListener("submit", (t) => {
            let e = !1;
            (i.forEach((t) => {
              t.value ? t.nextElementSibling.classList.remove(vu) : (t.nextElementSibling.classList.add(vu), (e = !0));
            }),
              e && t.preventDefault());
          });
        });
      }
      constructor(t) {
        ((this.section = t),
          (this.addressNewForm = this.section.querySelector(iu)),
          (this.accountForms = this.section.querySelectorAll(eu)),
          this.init(),
          this.validate());
      }
    })(wu);
  const bu = "[data-account-form]",
    Su = "[data-show-reset]",
    Eu = "[data-hide-reset]",
    Lu = "[data-recover-password]",
    ku = "[data-login-form]",
    Au = "[data-recover-success]",
    Cu = "[data-recover-success-text]",
    qu = "#recover",
    Tu = "is-hidden";
  const Pu = document.querySelector(bu);
  (Pu &&
    new (class {
      init() {
        (window.location.hash == qu ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(),
          this.success && this.successText.classList.remove(Tu),
          this.showButton.addEventListener(
            "click",
            (t) => {
              (t.preventDefault(), this.showRecoverPasswordForm());
            },
            !1,
          ),
          this.hideButton.addEventListener(
            "click",
            (t) => {
              (t.preventDefault(), this.hideRecoverPasswordForm());
            },
            !1,
          ));
      }
      showRecoverPasswordForm() {
        return (this.recover.classList.remove(Tu), this.login.classList.add(Tu), (window.location.hash = qu), !1);
      }
      hideRecoverPasswordForm() {
        return (this.login.classList.remove(Tu), this.recover.classList.add(Tu), (window.location.hash = ""), !1);
      }
      constructor(t) {
        ((this.form = t),
          (this.showButton = t.querySelector(Su)),
          (this.hideButton = t.querySelector(Eu)),
          (this.recover = t.querySelector(Lu)),
          (this.login = t.querySelector(ku)),
          (this.success = t.querySelector(Au)),
          (this.successText = t.querySelector(Cu)),
          this.init());
      }
    })(Pu),
    rl("search-template", [Hs, po]));
  const xu = "[data-ticker-scale]",
    Iu = "[data-ticker-text]",
    Hu = "data-clone",
    Fu = "data-marquee-speed",
    Mu = "ticker--animated",
    Du = "ticker--unloaded",
    Ou = "ticker__comparitor",
    Bu = 1.63,
    zu = 100;
  let _u = class {
    listen() {
      (document.addEventListener("theme:resize:width", this.resizeEvent), this.checkWidth());
    }
    checkWidth() {
      const t = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
      if (this.frame.clientWidth - t < this.comparitor.clientWidth || this.stopClone) {
        if (1 === this.scale.childElementCount) {
          if (
            (this.text.classList.add(Mu),
            (this.clone = this.text.cloneNode(!0)),
            this.clone.setAttribute(Hu, ""),
            this.scale.appendChild(this.clone),
            this.stopClone)
          )
            for (let t = 0; t < 10; t++) {
              const t = this.text.cloneNode(!0);
              (t.setAttribute(Hu, ""), this.scale.appendChild(t));
            }
          let t = this.frame.getAttribute(Fu);
          null === t && (t = 100);
          const e = Bu * (100 / parseInt(t, 10)),
            i = (this.text.clientWidth / zu) * e;
          this.scale.style.setProperty("--animation-time", `${i}s`);
        }
      } else {
        this.text.classList.add(Mu);
        let t = this.scale.querySelector(`[${Hu}]`);
        (t && this.scale.removeChild(t), this.text.classList.remove(Mu));
      }
    }
    unload() {
      document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
    constructor(t, e = !1) {
      ((this.frame = t),
        (this.stopClone = e),
        (this.scale = this.frame.querySelector(xu)),
        (this.text = this.frame.querySelector(Iu)),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(Ou),
        this.frame.appendChild(this.comparitor),
        this.scale.classList.remove(Du),
        (this.resizeEvent = window.theme.debounce(() => this.checkWidth(), 100)),
        this.listen());
    }
  };
  const $u = "[data-parallax]",
    Ru = ".shopify-section",
    Vu = "[data-main]",
    Nu = "is-disabled",
    Wu = "main-content",
    Uu = "shopify-section",
    ju = "section-footer--visible",
    Gu = "card-scrolling-hidden",
    Ku = "sticky-top-zero",
    Qu = "data-parallax",
    Xu = "data-parallax-intensity",
    Yu = "data-parallax-static",
    Ju = "data-parallax-single",
    Zu = "data-parallax-disable-on-mobile",
    tp = "data-parallax-rounded-corners",
    ep = "data-parallax-rounded-corners-large",
    ip = {};
  let sp = class {
    assignFooterArguments() {
      this.animations.includes("footer") &&
        ((this.shopifySection = this.container.closest(Ru)),
        (this.footerPrevSectionOffset = 0),
        this.container.hasAttribute(tp) &&
          ((this.footerPrevSectionOffset = 8), this.container.hasAttribute(ep) && (this.footerPrevSectionOffset = 34)),
        (this.prevSection = this.container.parentNode.previousElementSibling),
        !this.prevSection ||
          this.prevSection.classList.contains(Uu) ||
          this.prevSection.classList.contains(Wu) ||
          (this.prevSection = this.main),
        requestAnimationFrame(() => {
          ((this.containerHeight = this.container.offsetHeight),
            (this.footerOffset = 0.15 * this.containerHeight),
            (this.cachedPosition = this.footerOffset),
            (this.cachedPercentage = 0));
        }));
    }
    assignCardScrollingArguments() {
      if (!this.animations.includes("card-scrolling")) return;
      let { stickyHeaderHeight: t } = window.theme.readHeights();
      if (
        ((this.headerHeight = t || 0),
        (this.shopifySection = this.container.closest(Ru)),
        (this.nextSection = this.shopifySection.nextElementSibling),
        (this.cardScrollingStickyTop = this.headerHeight || 0),
        (this.cardScrollingMarginTop = this.nextSection
          ? parseInt(window.getComputedStyle(this.nextSection).getPropertyValue("margin-top"))
          : 0),
        (this.after = !1),
        (this.prevSection = this.shopifySection.previousElementSibling),
        this.prevSection)
      ) {
        const t = this.firstSection.id,
          e = this.prevSection.matches(`#${t}`),
          i = this.prevSection.offsetHeight;
        this.shopifySection.classList.toggle(Ku, e && i <= 2 * this.headerHeight);
      }
      this.opacityValue = (t) =>
        t
          ? Boolean(t <= 0)
            ? 0
            : Boolean(t > 0 && t <= 100)
              ? Number(t / 100).toFixed(4)
              : Boolean(t > 100)
                ? 1
                : void 0
          : 0;
    }
    init() {
      (this.updateParallax(),
        document.addEventListener("theme:scroll", this.scrollEvent),
        document.addEventListener("theme:resize", this.resizeEvent),
        document.addEventListener("theme:parallax:refresh", this.refreshEvent));
    }
    updateParallax() {
      this.container.classList.contains(Nu) ||
        (this.disableOnMobile && window.theme.isMobile()) ||
        ((this.scrollTop = Math.round(window.scrollY)),
        (this.scrollBottom = this.scrollTop + this.viewportHeight),
        (this.elementOffsetTopPoint = Math.round(this.container.getBoundingClientRect().top + this.scrollTop)),
        window.Shopify.designMode &&
          (this.assignCardScrollingArguments(), (this.containerHeight = this.container.offsetHeight)),
        (this.elementOffsetBottomPoint = this.elementOffsetTopPoint + this.containerHeight),
        (this.isBottomOfElementPassed = this.elementOffsetBottomPoint < this.scrollTop),
        (this.isTopOfElementReached = this.elementOffsetTopPoint < this.scrollBottom),
        (this.isInView = this.isTopOfElementReached && !this.isBottomOfElementPassed),
        this.adjustCalculations(),
        this.toggleVisibility(),
        this.isInView &&
          ((this.scrollProgress = this.scrollBottom - this.elementOffsetTopPoint),
          (this.percentage = (100 * (this.scrollProgress - this.containerHeight / 2)) / this.viewportHeight),
          (this.percentageFull = Number(this.scrollProgress / this.containerHeight).toFixed(2)),
          (this.percentageVisible = Number(
            (100 * this.scrollProgress) / (this.viewportHeight + this.containerHeight),
          ).toFixed(2)),
          this.animations.includes("circle") && this.animateCircleText(),
          (this.animations.includes("horizontal") ||
            this.animations.includes("vertical") ||
            this.animations.includes("diagonal")) &&
            this.animateOverlappingImages(),
          (this.animations.includes("offset-ltr") || this.animations.includes("offset-rtl")) && this.offsetX(),
          this.animations.includes("card-scrolling") && this.cardScrollingEffect(),
          this.animations.includes("zoom-on-scroll") && this.zoomInOut(),
          this.animations.includes("footer") && this.animateFooter()));
    }
    adjustCalculations() {
      var t;
      (this.animations.includes("card-scrolling") &&
        ((this.currentSectionTop = this.shopifySection.getBoundingClientRect().top),
        this.nextSection
          ? ((this.nextSectionTop = this.nextSection.getBoundingClientRect().top),
            (this.offsetTop = this.nextSectionTop - this.containerHeight - this.cardScrollingMarginTop))
          : ((this.nextSectionTop = this.currentSectionTop + this.containerHeight),
            (this.offsetTop = this.currentSectionTop)),
        (this.distance = Math.floor(this.currentSectionTop - this.headerHeight)),
        (this.after = Boolean(
          Math.round(
            this.nextSectionTop - this.headerHeight - this.cardScrollingMarginTop + 0.1 * this.viewportHeight,
          ) < 0,
        )),
        (this.isInView = this.isTopOfElementReached && !this.after)),
      this.animations.includes("footer")) &&
        ((this.elementOffsetTopPoint = Math.round(
          (null === (t = this.prevSection) || void 0 === t ? void 0 : t.getBoundingClientRect().bottom) -
            this.footerPrevSectionOffset +
            this.scrollTop,
        )),
        (this.elementOffsetBottomPoint = this.elementOffsetTopPoint + this.containerHeight),
        (this.isBottomOfElementPassed = this.elementOffsetBottomPoint < this.scrollTop),
        (this.isTopOfElementReached = this.elementOffsetTopPoint < this.scrollBottom),
        (this.isInView = this.isTopOfElementReached && !this.isBottomOfElementPassed),
        (this.isApproaching = Math.round(this.elementOffsetTopPoint - this.viewportHeight / 2) < this.scrollBottom));
    }
    toggleVisibility() {
      (this.animations.includes("card-scrolling") && this.shopifySection.classList.toggle(Gu, this.after),
        this.animations.includes("footer") &&
          (Boolean(this.isApproaching || this.isInView)
            ? this.shopifySection.classList.add(ju)
            : this.shopifySection.classList.remove(ju)));
    }
    cardScrollingEffect() {
      const t = (this.offsetTop / this.containerHeight) * -100;
      this.container.style.setProperty("--card-scrolling-overlay", this.opacityValue(t));
    }
    zoomInOut() {
      if (this.animations.includes("card-scrolling") && this.nextSection) {
        const t = this.nextSectionTop - this.headerHeight - this.cardScrollingMarginTop - this.containerHeight,
          e = Math.round(t + this.scrollTop),
          i = this.scrollBottom - e;
        this.percentageVisible = Number(
          (100 * i) / (this.viewportHeight + this.containerHeight + this.cardScrollingMarginTop),
        ).toFixed(2);
      }
      const t = (0.2 * this.percentageVisible) / 100;
      let e = Number(1 + t).toFixed(4);
      ((e = e > 1 ? e : 1), this.container.style.setProperty("--scale", e));
    }
    offsetX() {
      const t = this.container.hasAttribute(Yu),
        e = this.container.getAttribute(Xu) || 100;
      let i = this.animations.includes("offset-ltr") ? e : 0;
      t && (i = e / 2);
      const s = this.animations.includes("offset-ltr") ? 1 : -1,
        o = (e * this.percentageVisible) / 100 - i,
        n = Number(o * s).toFixed(2);
      this.container.style.setProperty("--offsetX", `${n}%`);
    }
    updateHeight() {
      if (this.animations.includes("card-scrolling")) {
        let { stickyHeaderHeight: t } = window.theme.readHeights();
        if (
          ((this.headerHeight = t || 0),
          (this.cardScrollingStickyTop = this.headerHeight || 0),
          (this.cardScrollingMarginTop = this.nextSection
            ? parseInt(window.getComputedStyle(this.nextSection).getPropertyValue("margin-top"))
            : 0),
          (this.containerHeight = this.container.offsetHeight),
          (this.prevSection = this.shopifySection.previousElementSibling),
          this.prevSection)
        ) {
          const t = this.firstSection.id,
            e = this.prevSection.matches(`#${t}`),
            i = this.prevSection.offsetHeight;
          this.shopifySection.classList.toggle(Ku, e && i <= 2 * this.headerHeight);
        }
      }
      const t = matchMedia("(min-width: 1024px)").matches;
      (this.orientation !== window.theme.getScreenOrientation() || t) &&
        ((this.viewportHeight = Math.round(Math.max(document.documentElement.clientHeight, window.innerHeight || 0))),
        (this.containerHeight = this.container.offsetHeight),
        (this.orientation = window.theme.getScreenOrientation()));
    }
    animateCircleText() {
      const t = ((70 * this.percentage) / 100) * -1;
      this.percentage > 0 && this.container.style.setProperty("--rotate", `${35 + t}deg`);
    }
    animateOverlappingImages() {
      const t = 0.25 * this.container.getAttribute(Xu),
        e = t / 2,
        i = this.container.hasAttribute(Ju),
        s = (t * this.percentage) / 100;
      let o = 0,
        n = 0,
        r = 0,
        a = 0;
      ((this.animations.includes("horizontal") || this.animations.includes("diagonal")) &&
        ((o = -1 * e + s), (r = e - s)),
        (this.animations.includes("vertical") || this.animations.includes("diagonal")) &&
          ((n = e - s), (a = -1 * e + s)),
        this.container.style.setProperty("--transformX-primary", `${o}%`),
        this.container.style.setProperty("--transformY-primary", `${n}%`),
        i ||
          (this.container.style.setProperty("--transformX-secondary", `${r}%`),
          this.container.style.setProperty("--transformY-secondary", `${a}%`)));
    }
    animateFooter() {
      const t = this.footerOffset * this.percentageFull,
        e = Number((t / this.footerOffset) * 100).toFixed(2),
        i = new WebKitCSSMatrix(window.getComputedStyle(this.container).transform),
        s = Number(i.m42).toFixed(2);
      let o = Number(this.footerOffset - t).toFixed(2);
      (this.percentageFull >= 1 && (o = 0),
        s !== o &&
          this.cachedPercentage !== e &&
          (this.container.style.setProperty("--transformY", `${o}`),
          (this.cachedPercentage = e),
          (this.cachedPosition = o)));
    }
    unload() {
      (document.removeEventListener("theme:scroll", this.scrollEvent),
        document.removeEventListener("theme:resize", this.resizeEvent),
        document.removeEventListener("theme:parallax:refresh", this.refreshEvent));
    }
    refresh() {
      (this.assignFooterArguments(), this.assignCardScrollingArguments(), this.updateParallax());
    }
    constructor(t) {
      ((this.container = t),
        (this.percentage = 0),
        (this.percentageFull = 0),
        (this.animation = this.container.getAttribute(Qu)),
        (this.animations = this.animation.split(",")),
        (this.disableOnMobile = this.container.hasAttribute(Zu)),
        (this.viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)),
        (this.containerHeight = this.container.offsetHeight),
        (this.main = document.querySelector(Vu)),
        (this.firstSection = this.main.children[0]),
        (this.orientation = window.theme.getScreenOrientation()),
        (this.scrollEvent = () => this.updateParallax()),
        (this.resizeEvent = () => this.updateHeight()),
        (this.refreshEvent = () => this.refresh()),
        this.assignFooterArguments(),
        this.assignCardScrollingArguments(),
        requestAnimationFrame(() => this.init()));
    }
  };
  const op = {
      onLoad() {
        ip[this.id] = [];
        this.container.querySelectorAll($u).forEach((t) => {
          ip[this.id].push(new sp(t));
        });
      },
      onUnload() {
        ip[this.id].forEach((t) => {
          "function" == typeof t.unload && t.unload();
        });
      },
    },
    np = "[data-announcement]",
    rp = "[data-announcement-slide]",
    ap = "[data-ticker-frame]",
    lp = "[data-slide]",
    cp = "[data-slider]",
    hp = "[data-static]",
    dp = "[data-ticker-scale]",
    up = "[data-ticker-text]",
    pp = "[data-parallax]",
    mp = "text-highlight",
    gp = "data-slide",
    yp = "data-slider-speed",
    fp = "data-slider-arrows",
    vp = "data-stop",
    wp = "style",
    bp = "data-target-referrer",
    Sp = "clip-path",
    Ep = "desktop",
    Lp = "mobile",
    kp = "ticker--animated",
    Ap = "is-disabled",
    Cp = "clipPath",
    qp = {};
  const Tp = {
    onLoad() {
      qp[this.id] = [];
      const t = this.container.querySelector(np);
      t &&
        qp[this.id].push(
          new (class {
            init() {
              (this.removeAnnouncement(),
                this.slider &&
                  (this.initSlider(), document.addEventListener("theme:resize:width", this.initSlider.bind(this))),
                this.static && (this.initTickers(), this.tickerAnimationPause()),
                this.slider || this.static || (this.initTickers(!0), this.tickerAnimationPause()),
                this.updateSVGClipPathIDs());
            }
            removeAnnouncement() {
              for (let t = 0; t < this.slides.length; t++) {
                const e = this.slides[t];
                e.hasAttribute(bp) &&
                  (-1 !== this.locationPath.indexOf(e.getAttribute(bp)) ||
                    window.Shopify.designMode ||
                    e.parentNode.removeChild(e));
              }
            }
            checkSlidesClasses(t, e) {
              if (0 !== t.length) {
                const i = e.querySelectorAll(`${lp}.${Lp}`),
                  s = e.querySelectorAll(`${lp}.${Ep}`);
                t.length === i.length
                  ? e.parentNode.classList.add(Lp)
                  : t.length === s.length && e.parentNode.classList.add(Ep);
              }
            }
            initSlider() {
              const t = this.slider.querySelectorAll(lp),
                e = this.slider.hasAttribute(fp);
              if ((this.checkSlidesClasses(t, this.barHolder), t)) {
                let t = `${lp}`;
                ((t = window.innerWidth < theme.sizes.small ? `${lp}:not(.${Ep})` : `${lp}:not(.${Lp})`),
                  null != this.flkty && this.flkty.destroy(),
                  (this.flkty = new window.theme.Flickity(this.slider, {
                    cellSelector: t,
                    pageDots: !1,
                    prevNextButtons: e,
                    wrapAround: !0,
                    autoPlay: parseInt(this.slider.getAttribute(yp), 10),
                    on: {
                      ready: () => {
                        setTimeout(() => {
                          this.slider.dispatchEvent(
                            new CustomEvent("slider-is-loaded", { bubbles: !0, detail: { slider: this } }),
                          );
                        }, 10);
                      },
                      change: (t) => {
                        this.flkty.cells.forEach((e, i) => {
                          e.element.querySelectorAll(mp).forEach((e) => {
                            e.setTriggerAttribute(Boolean(i === t));
                          });
                        });
                      },
                    },
                  })),
                  this.flkty.reposition());
              }
              this.slider.addEventListener("slider-is-loaded", () => {
                (this.initTickers(), this.updateSVGClipPathIDs());
              });
            }
            initTickers(t = !1) {
              this.barHolder.querySelectorAll(ap).forEach((e) => {
                const i = new _u(e, t);
                this.tickers.push(i);
                const s = e.querySelectorAll(lp);
                this.checkSlidesClasses(s, this.barHolder);
              });
            }
            toggleTicker(t, e) {
              const i = t.target.closest(dp),
                s = document.querySelector(`[${gp}="${t.detail.blockId}"]`);
              (e &&
                s &&
                (i.setAttribute(vp, ""),
                i.querySelectorAll(up).forEach((t) => {
                  (t.classList.remove(kp),
                    (t.style.transform = `translate3d(${-(s.offsetLeft - parseInt(getComputedStyle(s).marginLeft, 10))}px, 0, 0)`));
                })),
                !e &&
                  s &&
                  (i.querySelectorAll(up).forEach((t) => {
                    (t.classList.add(kp), t.removeAttribute(wp));
                  }),
                  i.removeAttribute(vp),
                  this.static && document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 }))));
            }
            tickerAnimationPause() {
              let t = 0,
                e = !1;
              const i = this.barHolder.querySelector(rp);
              (i.addEventListener("mouseenter", () => {
                ((e = !0),
                  (t = setTimeout(() => {
                    (e &&
                      i.querySelectorAll(up).forEach((t) => {
                        t.style.animationPlayState = "paused";
                      }),
                      clearTimeout(t));
                  }, 500)));
              }),
                i.addEventListener("mouseleave", () => {
                  ((e = !1),
                    i.querySelectorAll(up).forEach((t) => {
                      t.style.animationPlayState = "running";
                    }));
                }));
            }
            updateSVGClipPathIDs() {
              this.barHolder.querySelectorAll(lp).forEach((t, e) => {
                const i = t.querySelector(Cp);
                if (i) {
                  const s = `${i.id}_${e}`;
                  i.id = s;
                  const o = t.querySelector(`g[${Sp}]`);
                  o && o.setAttribute(Sp, `url(#${s})`);
                }
              });
            }
            onBlockSelect(t) {
              const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
              (this.slider && null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer()),
                this.slider || this.toggleTicker(t, !0),
                this.parallax && (this.parallax.style.setProperty("--offsetX", "0%"), this.parallax.classList.add(Ap)));
            }
            onBlockDeselect(t) {
              (this.slider && null !== this.flkty && this.flkty.unpausePlayer(),
                this.slider || this.toggleTicker(t, !1),
                this.parallax &&
                  (this.parallax.classList.remove(Ap), document.dispatchEvent(new CustomEvent("theme:scroll"))));
            }
            onUnload() {
              (document.removeEventListener("theme:resize:width", this.initSlider.bind(this)),
                this.tickers.length > 0 &&
                  this.tickers.forEach((t) => {
                    t.unload();
                  }));
            }
            constructor(t) {
              ((this.barHolder = t),
                (this.locationPath = location.href),
                (this.slides = this.barHolder.querySelectorAll(lp)),
                (this.slider = this.barHolder.querySelector(cp)),
                (this.static = this.barHolder.querySelector(hp)),
                (this.parallax = this.barHolder.querySelector(pp)),
                (this.tickers = []),
                (this.flkty = null),
                this.init());
            }
          })(t),
        );
    },
    onBlockSelect(t) {
      qp[this.id].length &&
        qp[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
    },
    onBlockDeselect(t) {
      qp[this.id].length &&
        qp[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockDeselect(t);
        });
    },
    onUnload() {
      qp[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  (rl("announcement-bar", Tp), rl("marquee", [Tp, op]));
  const Pp = "[data-hover-disclosure]",
    xp = "[data-site-header]",
    Ip = "[data-top-link]",
    Hp = "[data-header-background]",
    Fp = "[data-nav-item]",
    Mp = "is-visible",
    Dp = "grandparent",
    Op = "site-header--menu-opened",
    Bp = "has-scrolled",
    zp = "site-header--hovered",
    _p = "site-header--compress",
    $p = "megamenu-opened",
    Rp = "data-hover-disclosure-toggle",
    Vp = "aria-haspopup",
    Np = "aria-expanded",
    Wp = "aria-controls";
  let Up = {};
  const jp = {
      onLoad() {
        Up[this.id] = [];
        this.container.querySelectorAll(Pp).forEach((t) => {
          Up[this.id].push(
            new (class {
              setBackgroundHeight() {
                ((this.hasScrolled = this.body.classList.contains(Bp)),
                  (this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight),
                  this.grandparent
                    ? ((this.dropdown.style.height = "auto"),
                      (this.dropdownHeight = this.dropdown.offsetHeight + this.headerHeight))
                    : (this.dropdownHeight = this.headerHeight),
                  this.background.style.setProperty("--header-background-height", `${this.dropdownHeight}px`),
                  window.innerWidth < theme.sizes.small && this.hideDisclosure());
              }
              showDisclosure() {
                (this.setBackgroundHeight(),
                  document.addEventListener("theme:resize", this.setBackgroundHeightEvent),
                  this.trigger.setAttribute(Np, !0),
                  this.trigger.classList.add(Mp),
                  this.header.classList.add(Op),
                  this.trigger.classList.contains(Dp) && this.body.classList.add($p),
                  this.updateHeaderHover());
              }
              hideDisclosure() {
                (this.background.style.removeProperty("--header-background-height"),
                  document.removeEventListener("theme:resize", this.setBackgroundHeightEvent),
                  this.trigger.classList.remove(Mp),
                  this.trigger.setAttribute(Np, !1),
                  this.header.classList.remove(Op),
                  this.body.classList.remove($p));
              }
              updateHeaderHover() {
                requestAnimationFrame(() => {
                  const t = this.header.matches(":hover"),
                    e = this.header.classList.contains(zp);
                  t && !e && this.header.classList.add(zp);
                });
              }
              handleTablets() {
                this.trigger.addEventListener("touchstart", (t) => {
                  if (!this.trigger.classList.contains(Mp)) {
                    t.preventDefault();
                    const e = this.header.querySelectorAll(`.${Mp}${Fp}`);
                    if (e.length > 0)
                      return void e.forEach((t) => {
                        if (t !== this.trigger) {
                          t.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
                          const e = () => {
                            (requestAnimationFrame(() => {
                              this.showDisclosure();
                            }),
                              t.removeEventListener("transitionend", e));
                          };
                          t.addEventListener("transitionend", e);
                        }
                      });
                    this.showDisclosure();
                  }
                });
              }
              connectHoverToggle() {
                (this.trigger.addEventListener("mouseenter", () => this.showDisclosure()),
                  this.link.addEventListener("focus", () => this.showDisclosure()),
                  this.trigger.addEventListener("mouseleave", () => this.hideDisclosure()),
                  this.trigger.addEventListener("focusout", (t) => {
                    this.trigger.contains(t.relatedTarget) || this.hideDisclosure();
                  }),
                  this.disclosure.addEventListener("keyup", (t) => {
                    t.code === theme.keyboardKeys.ESCAPE && this.hideDisclosure();
                  }));
              }
              onBlockSelect(t) {
                if (this.disclosure.contains(t.target)) {
                  const e = matchMedia("(pointer:coarse)").matches;
                  let i = !1;
                  (((window.innerWidth < theme.sizes.small && window.Shopify.designMode) ||
                    this.header.classList.contains(_p)) &&
                    (i = !0),
                    e || i || this.showDisclosure(t));
                }
              }
              onBlockDeselect(t) {
                this.disclosure.contains(t.target) && this.hideDisclosure();
              }
              constructor(t) {
                ((this.disclosure = t),
                  (this.body = document.body),
                  (this.header = t.closest(xp)),
                  (this.key = this.disclosure.id),
                  (this.trigger = document.querySelector(`[${Rp}='${this.key}']`)),
                  (this.link = this.trigger.querySelector(Ip)),
                  (this.grandparent = this.trigger.classList.contains(Dp)),
                  (this.background = document.querySelector(Hp)),
                  this.trigger.setAttribute(Vp, !0),
                  this.trigger.setAttribute(Np, !1),
                  this.trigger.setAttribute(Wp, this.key),
                  (this.dropdown = this.trigger.querySelector(Pp)),
                  (this.setBackgroundHeightEvent = () => this.setBackgroundHeight()),
                  this.connectHoverToggle(),
                  this.handleTablets());
              }
            })(t),
          );
        });
      },
      onBlockSelect(t) {
        Up[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        Up[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
    Gp = "[data-site-header]",
    Kp = "[data-announcement-wrapper]",
    Qp = "[data-collection-filters]",
    Xp = "[data-logo-text-link]",
    Yp = "[data-mobile-menu-trigger]",
    Jp = "[data-nav]",
    Zp = "[data-nav-item]",
    tm = "[data-wrapper]",
    em = "[data-header-background]",
    im = "[data-cart-page]",
    sm = "[data-takes-space]",
    om = {
      jsDrawerOpenAll: ["js-drawer-open", "js-drawer-open-cart", "js-quick-view-visible", "js-quick-view-from-cart"],
      headerTransparent: "site-header--transparent",
      headerHovered: "site-header--hovered",
      headerMenuOpened: "site-header--menu-opened",
      hasScrolled: "has-scrolled",
      hideHeader: "hide-header",
      headerCompress: "site-header--compress",
      isVisible: "is-visible",
      isOpen: "is-open",
      searchOpened: "search-opened",
      noOutline: "no-outline",
      cloneClass: "js__header__clone",
      drawerOpen: "js-drawer-open",
    },
    nm = "data-nav-alignment",
    rm = "data-header-sticky",
    am = {};
  rl("header", [
    {
      onLoad() {
        am[this.id] = new (class {
          updateHeaderHover() {
            requestAnimationFrame(() => {
              const t = this.header.matches(":hover"),
                e = this.header.classList.contains(om.headerHovered);
              t && !e && this.header.classList.add(om.headerHovered);
            });
          }
          handleTouchstart(t) {
            const e = this.header.contains(t.target),
              i = this.header.querySelector(`.${om.isVisible}${Zp}`);
            !e && i && i.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
          }
          handleTextLinkLogos() {
            if (null === this.logoTextLink) return;
            const t = this.header.offsetHeight;
            (document.documentElement.style.setProperty("--header-height", `${t}px`),
              document.documentElement.style.setProperty("--header-sticky-height", `${t}px`));
          }
          initStickyHeader() {
            if (
              ((this.headerSticky = this.header.hasAttribute(rm)),
              (this.hasScrolled = !1),
              (this.hasCollectionFilters = document.querySelector(Qp)),
              (this.position = this.header.dataset.position),
              "fixed" === this.position && !this.hasCollectionFilters)
            )
              return (this.headerState(), void document.addEventListener("theme:scroll", this.headerStateEvent));
            (document.body.classList.remove(om.hasScrolled),
              window.isHeaderTransparent && this.header.classList.add(om.headerTransparent));
          }
          headerState(t) {
            const e = parseInt(this.header.dataset.height || this.header.offsetHeight),
              i = document.querySelector(Kp),
              s = e + (i ? i.offsetHeight : 0),
              o = window.pageYOffset || document.documentElement.scrollTop,
              n = t && t.detail && t.detail.up;
            ((this.hasScrolled = o > s), document.body.classList.toggle(om.hasScrolled, this.hasScrolled));
            const r = o < s + window.stickyHeaderHeight && n;
            if ((document.body.classList.toggle(om.hideHeader, r), window.isHeaderTransparent)) {
              const t = !this.hasScrolled || r;
              this.header.classList.toggle(om.headerTransparent, t);
            }
            if (this.header.classList.contains(om.headerHovered)) {
              const t = this.hasScrolled ? window.stickyHeaderHeight : e;
              this.background.style.setProperty("--header-background-height", `${t}px`);
              const i = this.header.querySelector(`.${om.isVisible}${Zp}`);
              i && i.dispatchEvent(new Event("mouseenter", { bubbles: !0 }));
            }
          }
          handleBackgroundEvents() {
            (this.headerWrapper.addEventListener("mouseenter", this.updateBackgroundHeightEvent),
              this.headerWrapper.addEventListener("mouseleave", this.updateBackgroundHeightEvent),
              this.header.addEventListener("focusout", this.updateBackgroundHeightEvent),
              document.addEventListener("theme:cart:close", this.updateBackgroundHeightEvent),
              document.addEventListener("theme:search:close", this.updateBackgroundHeightEvent));
          }
          updateBackgroundHeight(t) {
            const e = matchMedia("(pointer:fine)").matches,
              i = !document.body.classList.contains(om.noOutline),
              s = e && !i;
            if (!t) return;
            let o = om.jsDrawerOpenAll.some((t) => document.body.classList.contains(t));
            (("mouseenter" === t.type || o) &&
              ((this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight),
              this.header.classList.add(om.headerHovered),
              this.header.classList.contains(om.headerMenuOpened) ||
                this.background.style.setProperty("--header-background-height", `${this.headerHeight}px`)),
              "mouseenter" !== t.type &&
                requestAnimationFrame(() => {
                  if (((o = om.jsDrawerOpenAll.some((t) => document.body.classList.contains(t))), o)) return;
                  if ("focusout" === t.type && !e) return;
                  if ("theme:search:close" === t.type && !s) return;
                  if (this.hasScrolled) return;
                  const n = null === document.activeElement.closest(Gp),
                    r = document.body.classList.contains(om.searchOpened),
                    a = this.header.classList.contains(om.headerMenuOpened);
                  r ||
                    a ||
                    (("focusout" !== t.type || n) &&
                      (this.header.classList.remove(om.headerHovered),
                      this.background.style.setProperty("--header-background-height", "0px"),
                      i || document.activeElement.blur()));
                }));
          }
          listenWidth() {
            (document.addEventListener("theme:resize", this.checkWidthEvent), this.checkWidth());
          }
          checkWidth() {
            window.innerWidth < this.minWidth
              ? this.header.classList.add(om.headerCompress)
              : this.header.classList.remove(om.headerCompress);
          }
          getMinWidth() {
            const t = this.headerWrapper.currentStyle || window.getComputedStyle(this.headerWrapper),
              e = 2 * parseInt(t.paddingLeft),
              i = this.header.cloneNode(!0);
            (i.classList.add(om.cloneClass), document.body.appendChild(i));
            const s = i.querySelectorAll(sm),
              o = (function (t, e) {
                let i = [];
                t.forEach((t) => {
                  i.push(t.clientWidth);
                });
                let [s, o, n] = i;
                if ("left" === e) {
                  const t = s;
                  ((s = o), (o = t));
                }
                return ("right" !== e && (s > n ? (n = s) : (s = n)), s + o + n);
              })(s, this.header.getAttribute(nm));
            return (document.body.removeChild(i), o + 20 * s.length + e);
          }
          initMobileNavToggle() {
            var t;
            null === (t = this.mobileMenuTrigger) ||
              void 0 === t ||
              t.addEventListener("click", () => {
                if (!document.body.classList.contains(om.drawerOpen)) {
                  if (document.body.classList.contains(om.searchOpened))
                    return void document.addEventListener("theme:search:close", this.triggerDrawerOpeningEvent);
                  this.triggerDrawerOpening(this.mobileMenuTrigger);
                }
              });
          }
          triggerDrawerOpening(t) {
            (document.dispatchEvent(new CustomEvent("theme:drawer:opening", { bubbles: !0, detail: { element: t } })),
              document.removeEventListener("theme:search:close", this.triggerDrawerOpeningEvent));
          }
          onUnload() {
            (document.documentElement.style.removeProperty("--header-height"),
              document.documentElement.style.removeProperty("--header-sticky-height"),
              this.initStickyHeader(),
              document.body.classList.remove(...om.jsDrawerOpenAll),
              document.removeEventListener("theme:scroll", this.headerStateEvent),
              document.removeEventListener("theme:resize", this.checkWidthEvent),
              document.removeEventListener("theme:cart:close", this.updateBackgroundHeightEvent),
              document.removeEventListener("theme:search:close", this.updateBackgroundHeightEvent),
              document.body.removeEventListener("touchstart", this.handleTouchstartEvent),
              document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
              "function" == typeof window.cart.unload && window.cart.unload());
          }
          constructor(t) {
            ((this.container = t),
              (this.background = document.querySelector(em)),
              (this.header = t),
              (this.headerWrapper = t.querySelector(tm)),
              (this.logoTextLink = t.querySelector(Xp)),
              (this.nav = t.querySelector(Jp)),
              (this.mobileMenuTrigger = t.querySelector(Yp)),
              (this.headerStateEvent = (t) => this.headerState(t)),
              (this.handleTouchstartEvent = (t) => this.handleTouchstart(t)),
              (this.updateBackgroundHeightEvent = (t) => this.updateBackgroundHeight(t)),
              (this.triggerDrawerOpeningEvent = () => this.triggerDrawerOpening(this.mobileMenuTrigger)),
              Va(),
              (this.minWidth = this.getMinWidth()),
              (this.checkWidthEvent = () => this.checkWidth()),
              this.listenWidth(),
              this.initMobileNavToggle(),
              this.handleTextLinkLogos(),
              this.initStickyHeader(),
              this.handleBackgroundEvents(),
              document.querySelector(im) || (window.cart = new xh()),
              document.body.addEventListener("touchstart", this.handleTouchstartEvent, { passive: !0 }),
              this.updateHeaderHover());
          }
        })(this.container);
      },
      onUnload() {
        am[this.id].onUnload();
      },
    },
    jp,
  ]);
  const lm = "[data-collapsible-trigger]",
    cm = "is-expanded";
  rl("accordions", [
    {
      onBlockSelect(t) {
        const e = t.target.querySelector(lm);
        requestAnimationFrame(() => {
          e.classList.contains(cm) || e.dispatchEvent(new Event("click"));
        });
      },
    },
    ut,
  ]);
  const hm = "[data-share-button]",
    dm = "[data-share-button-tooltip]",
    um = "is-visible",
    pm = "is-hiding",
    mm = {};
  const gm = {
    onLoad() {
      mm[this.id] = new (class {
        init() {
          this.button &&
            this.button.addEventListener("click", () => {
              let t = window.location.href;
              (this.button.dataset.shareLink && (t = this.button.dataset.shareLink),
                this.tooltip.classList.contains(um) ||
                  navigator.clipboard.writeText(t).then(() => {
                    (this.tooltip.classList.add(um),
                      setTimeout(() => {
                        (this.tooltip.classList.add(pm),
                          this.tooltip.classList.remove(um),
                          this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                          (this.hideTransitionTimeout = setTimeout(() => {
                            this.tooltip.classList.remove(pm);
                          }, this.transitionSpeed)));
                      }, 1500));
                  }));
            });
        }
        constructor(t) {
          ((this.container = t),
            (this.button = this.container.querySelector(hm)),
            (this.tooltip = this.container.querySelector(dm)),
            (this.transitionSpeed = 200),
            (this.hideTransitionTimeout = 0),
            this.init());
        }
      })(this.container);
    },
  };
  rl("article", [gm]);
  const ym = "[data-video-play]",
    fm = "data-video-play";
  const vm = {
      onLoad() {
        new (class {
          init() {
            this.videoPlay.length &&
              this.videoPlay.forEach((t) => {
                t.addEventListener("click", (e) => {
                  if (t.hasAttribute(fm) && "" !== t.getAttribute(fm).trim()) {
                    e.preventDefault();
                    const i = [{ html: t.getAttribute(fm) }],
                      s = { mainClass: "pswp--video" };
                    ((this.a11y.state.trigger = t), new window.theme.LoadPhotoswipe(i, s));
                  }
                });
              });
          }
          constructor(t) {
            ((this.container = t),
              (this.videoPlay = this.container.querySelectorAll(ym)),
              (this.a11y = window.theme.a11y),
              this.init());
          }
        })(this.container);
      },
    },
    wm = "[data-banner-image]",
    bm = "[data-banner-title]",
    Sm = ".lazy-image",
    Em =
      '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
    Lm = ".text-reveal__cropper",
    km = "[data-aos]",
    Am = "banner--no-cached-images",
    Cm = "banner--img-loaded",
    qm = "img-in",
    Tm = "overflow-hidden",
    Pm = "text-highlight-wrapper",
    xm = {};
  rl("banner-image", [
    {
      onLoad() {
        xm[this.id] = new (class {
          init() {
            if (
              (this.handleImageAnimation(!0),
              this.container.matches(Em) && (this.parallax = new sp(this.container)),
              this.title && !this.title.classList.contains(Pm))
            ) {
              const t = this.title.querySelector(km);
              if (!t) return;
              const e = t.closest(Lm);
              (null == e || e.classList.add(Tm),
                _l(t).then(() => {
                  null == e || e.classList.remove(Tm);
                }));
            }
          }
          handleImageAnimation(t = !1) {
            if (!t) return (this.container.classList.remove(Am), void this.container.classList.remove(Cm));
            const e = this.container.querySelector(wm).querySelectorAll(Sm),
              i = this.container.classList.contains(qm);
            if (e.length && !i) {
              this.container.classList.add(Am);
              const t = (i) => {
                (requestAnimationFrame(() => this.container.classList.add(Cm)),
                  e[0].removeEventListener("transitionend", t));
              };
              e[0].addEventListener("transitionend", t);
            }
          }
          onReorder() {
            this.handleImageAnimation(!1);
          }
          onUnload() {
            (this.handleImageAnimation(!1), this.parallax && (this.parallax.unload(), (this.parallax = null)));
          }
          constructor(t) {
            ((this.container = t.container),
              (this.title = this.container.querySelector(bm)),
              (this.parallax = null),
              this.init());
          }
        })(this);
      },
      onReorder(t) {
        xm[this.id].onReorder(t);
      },
      onUnload(t) {
        xm[this.id].onUnload(t);
      },
    },
    vm,
  ]);
  const Im = "[data-scroll-spy]",
    Hm = "is-selected",
    Fm = "is-full-height",
    Mm = "data-scroll-spy",
    Dm = "data-scroll-spy-prevent",
    Om = "data-scroll-spy-mobile",
    Bm = "data-scroll-spy-desktop",
    zm = {};
  const _m = {
      onLoad() {
        zm[this.id] = [];
        this.container.querySelectorAll(Im).forEach((t) => {
          const e = this.container.querySelector(t.getAttribute(Mm));
          zm[this.id].push(
            new (class {
              init() {
                (this.onScroll(),
                  document.addEventListener("theme:scroll", this.scrollCallback),
                  document.addEventListener("theme:resize:width", this.scrollCallback));
              }
              isEligible() {
                return (
                  !this.container.hasAttribute(Dm) &&
                  ((window.theme.isMobile() && this.anchor.hasAttribute(Om)) ||
                    (window.theme.isDesktop() && this.anchor.hasAttribute(Bm)) ||
                    (!this.anchor.hasAttribute(Bm) && !this.anchor.hasAttribute(Om)))
                );
              }
              onScroll() {
                if (!this.isEligible()) return;
                ((this.top = this.element.getBoundingClientRect().top),
                  (this.bottom = this.element.getBoundingClientRect().bottom));
                const t = Math.round(window.innerHeight),
                  e = Math.round(window.scrollY),
                  i = e + t,
                  s = Math.round(this.top + e),
                  o = this.element.offsetHeight;
                if (!(s < i) || s + o < e) return;
                (this.anchor.parentNode.offsetHeight <= o
                  ? this.container.style.setProperty("--sticky-position", window.innerHeight / 2 - o / 2 + "px")
                  : this.container.classList.add(Fm),
                  (this.anchorTop = this.anchor.getBoundingClientRect().top),
                  (this.anchorBottom = this.anchor.getBoundingClientRect().bottom));
                const n = this.top < this.anchorTop,
                  r = this.bottom < this.anchorBottom;
                n &&
                  !r &&
                  (this.anchors.forEach((t) => {
                    t.matches(this.anchorSelector) || t.classList.remove(Hm);
                  }),
                  this.anchor.classList.add(Hm));
              }
              onUnload() {
                (document.removeEventListener("theme:scroll", this.scrollCallback),
                  document.removeEventListener("theme:resize:width", this.scrollCallback));
              }
              constructor(t, e) {
                ((this.container = t),
                  (this.element = e),
                  this.element &&
                    ((this.anchorSelector = `[${Mm}="#${this.element.id}"]`),
                    (this.anchor = this.container.querySelector(this.anchorSelector)),
                    (this.anchors = this.container.querySelectorAll(`[${Mm}]`)),
                    this.anchor && ((this.scrollCallback = () => this.onScroll()), this.init())));
              }
            })(this.container, e),
          );
        });
      },
      onUnload() {
        zm[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    $m = "[data-banner]",
    Rm = "[data-slider-content]",
    Vm = "[data-slider-media]",
    Nm = "a, button",
    Wm = "data-index",
    Um = "tabindex",
    jm = "data-slider-single-image",
    Gm = "data-scroll-spy-prevent",
    Km = "is-selected",
    Qm = "row",
    Xm = "columns";
  let Ym = {};
  (rl("banner-with-text-columns", [
    {
      onLoad() {
        Ym[this.id] = new (class {
          listen() {
            (document.addEventListener("theme:resize:width", this.onResizeCallback),
              this.links.forEach((t) => {
                t.addEventListener("focus", () => {
                  const e = Number(t.closest($m).getAttribute(Wm));
                  window.innerWidth >= theme.sizes.small && this.sync(e);
                });
              }),
              this.banners.forEach((t) => {
                (t.addEventListener("mouseenter", () => {
                  const e = Number(t.getAttribute(Wm));
                  window.innerWidth >= theme.sizes.small && !window.theme.touch && this.sync(e);
                }),
                  t.addEventListener("pointerup", () => {
                    const e = Number(t.getAttribute(Wm));
                    window.innerWidth >= theme.sizes.small && window.theme.touch && this.sync(e);
                  }));
              }));
          }
          handleColumnsLayout() {
            if (this.sliderContent.children.length <= 1) return;
            let t = window.innerWidth < window.theme.sizes.small;
            (this.sliderMedia.children.length > 1 &&
              ((this.flktyMedia = new window.theme.Flickity(this.sliderMedia, {
                draggable: !1,
                wrapAround: !1,
                fade: !0,
                prevNextButtons: !1,
                adaptiveHeight: !1,
                pageDots: !1,
                setGallerySize: !1,
                on: {
                  change: (t) => {
                    this.handleGroupItemsNavigation(t, this.flktyContent);
                  },
                },
              })),
              window.theme.flickitySmoothScrolling(this.sliderMedia)),
              (this.flktyContent = new window.theme.Flickity(this.sliderContent, {
                draggable: t,
                prevNextButtons: !1,
                pageDots: !0,
                cellAlign: "left",
                adaptiveHeight: !1,
                imagesLoaded: !0,
                on: {
                  ready: () => {
                    (this.listen(), this.slidesTabIndex());
                  },
                  change: (t) => {
                    (window.innerWidth < theme.sizes.small && !this.singleImageEnabled && this.flktyMedia.select(t),
                      this.slidesTabIndex(),
                      this.handleGroupItemsNavigation(t, this.flktyMedia));
                  },
                },
              })),
              window.theme.flickitySmoothScrolling(this.sliderContent));
          }
          handleRowLayout() {
            if (this.sliderMedia.children.length <= 1 || window.theme.isMobile())
              return (this.updateState(0), void this.listen());
            this.initMediaSlider();
          }
          initMediaSlider() {
            ((this.flktyMedia = new window.theme.Flickity(this.sliderMedia, {
              draggable: !0,
              wrapAround: !1,
              fade: !0,
              prevNextButtons: !1,
              adaptiveHeight: !1,
              pageDots: !1,
              setGallerySize: !1,
              on: {
                ready: () => {
                  (this.updateState(0), this.listen());
                },
                change: (t) => {
                  this.updateState(t);
                },
              },
            })),
              window.theme.flickitySmoothScrolling(this.sliderMedia));
          }
          handleGroupItemsNavigation(t, e = null) {
            null !== e &&
              requestAnimationFrame(() => {
                t !== e.selectedIndex && e.select(t);
              });
          }
          slidesTabIndex() {
            this.sliderContent &&
              window.theme.Flickity.data(this.sliderContent).cells.forEach((t) => {
                let e = "-1";
                (t.element.classList.contains(Km) && (e = "0"),
                  t.element.querySelectorAll(Nm).forEach((t) => {
                    t.setAttribute(Um, e);
                  }));
              });
          }
          sync(t = 0) {
            (this.appearance === Xm ? this.flktyContent.selectCell(t) : this.updateState(t),
              this.flktyMedia && this.flktyMedia.selectCell(t));
          }
          updateState(t = 0) {
            this.banners.forEach((e) => {
              const i = Number(e.getAttribute(Wm));
              e.classList.toggle(Km, i === t);
            });
          }
          handleSlidersOnResize() {
            if (this.appearance === Qm) {
              if (window.theme.isMobile() && this.flktyMedia)
                return (this.flktyMedia.destroy(), void (this.flktyMedia = null));
              if (window.theme.isDesktop() && !this.flktyMedia) return void this.initMediaSlider();
            }
            (this.flktyContent && (this.flktyContent.resize(), this.toggleDraggable()),
              this.flktyMedia && this.flktyMedia.resize());
          }
          toggleDraggable() {
            ((this.flktyContent.options.draggable = window.innerWidth < window.theme.sizes.small),
              this.flktyContent.updateDraggable());
          }
          onBlockSelect(t) {
            const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
            if ((this.sync(e), this.appearance === Qm)) {
              const t = this.sliderMedia.children[e],
                i = Math.round(t.getBoundingClientRect().top);
              (this.container.setAttribute(Gm, ""),
                setTimeout(() => window.theme.scrollTo(i), 400),
                setTimeout(() => this.container.removeAttribute(Gm), 1e3));
            }
          }
          onUnload() {
            document.removeEventListener("theme:resize:width", this.onResizeCallback);
          }
          constructor(t) {
            var e;
            ((this.container = t.container),
              (this.sliderContent = this.container.querySelector(Rm)),
              (this.singleImageEnabled =
                null === (e = this.sliderContent) || void 0 === e ? void 0 : e.hasAttribute(jm)),
              (this.banners = this.container.querySelectorAll($m)),
              (this.links = this.container.querySelectorAll("a")),
              (this.sliderMedia = this.container.querySelector(Vm)),
              (this.flktyContent = null),
              (this.flktyMedia = null),
              (this.onResizeCallback = () => this.handleSlidersOnResize()),
              (this.appearance = this.container.dataset.appearance),
              this.appearance === Xm ? this.handleColumnsLayout() : this.handleRowLayout());
          }
        })(this);
      },
      onBlockSelect(t) {
        Ym[this.id].onBlockSelect(t);
      },
    },
    _m,
  ]),
    rl("blog-posts", Hi));
  const Jm = "[data-slider]",
    Zm = "[data-slider-item]",
    tg = "[data-media-container]",
    eg = "a, button",
    ig = ".flickity-button",
    sg = "carousel--inactive",
    og = "carousel--resize",
    ng = "tabindex",
    rg = {};
  const ag = {
    onLoad() {
      rg[this.id] = new (class {
        initSlider() {
          (this.slider.classList.remove(sg),
            (this.flkty = new window.theme.Flickity(this.slider, {
              pageDots: !1,
              cellAlign: "left",
              groupCells: !0,
              contain: !0,
              on: {
                ready: () => {
                  (this.setSliderArrowsPosition(this.slider),
                    setTimeout(() => {
                      (this.changeTabIndex(), this.flkty.resize());
                    }, 0));
                },
                change: () => {
                  this.changeTabIndex();
                },
              },
            })),
            this.createResizeClass());
        }
        createResizeClass() {
          if ("function" == typeof window.theme.Flickity.prototype._createResizeClass) return;
          ((window.theme.Flickity.prototype._createResizeClass = function () {
            this.element.classList.add(og);
          }),
            window.theme.Flickity.createMethods.push("_createResizeClass"));
          const t = window.theme.Flickity.prototype.resize;
          window.theme.Flickity.prototype.resize = function () {
            (this.element.classList.remove(og), t.call(this), this.element.classList.add(og));
          };
        }
        destroySlider() {
          (this.slider.classList.add(sg), null !== this.flkty && (this.flkty.destroy(), (this.flkty = null)));
        }
        checkSlidesSize() {
          const t =
            this.container.querySelector(Zm).currentStyle || window.getComputedStyle(this.container.querySelector(Zm));
          this.gutter = parseInt(t.marginRight);
          const e = this.slider.offsetWidth < this.getItemsWidth();
          window.innerWidth >= theme.sizes.small && e ? this.initSlider() : this.destroySlider();
        }
        changeTabIndex() {
          const t = this.flkty.selectedIndex;
          this.flkty.slides.forEach((e, i) => {
            e.cells.forEach((e) => {
              e.element.querySelectorAll(eg).forEach((e) => {
                e.setAttribute(ng, t === i ? "0" : "-1");
              });
            });
          });
        }
        getItemsWidth() {
          let t = 0;
          const e = this.slider.querySelectorAll(Zm);
          return (
            e.length &&
              e.forEach((e) => {
                t += e.offsetWidth + this.gutter;
              }),
            t
          );
        }
        listen() {
          this.slider &&
            (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize));
        }
        setSliderArrowsPosition(t) {
          const e = t.querySelectorAll(ig),
            i = t.querySelectorAll(tg);
          let s = 0;
          (i.forEach((t) => {
            t.offsetHeight > s && (s = t.offsetHeight);
          }),
            e.length &&
              s > 0 &&
              e.forEach((t) => {
                t.style.top = s / 2 + "px";
              }));
        }
        onBlockSelect(t) {
          if (null !== this.flkty) {
            const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
              i = parseInt(this.flkty.slides[0].cells.length),
              s = Math.floor(e / i),
              o = t.target.closest(Jm);
            if (!t.detail.load) return void this.flkty.select(s);
            const n = () => {
              (requestAnimationFrame(() => {
                (this.flkty.select(s), this.setSliderArrowsPosition(o));
              }),
                this.flkty.element.removeEventListener("transitionend", n));
            };
            this.flkty.element.addEventListener("transitionend", n);
          } else {
            const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
              i = parseInt(e.paddingLeft),
              s = t.target.offsetLeft - i;
            this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
          }
        }
        onUnload() {
          document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize);
        }
        constructor(t) {
          ((this.container = t.container),
            (this.slider = this.container.querySelector(Jm)),
            (this.flkty = null),
            (this.gutter = 0),
            (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
            this.listen());
        }
      })(this);
    },
    onUnload(t) {
      rg[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      rg[this.id].onBlockSelect(t);
    },
  };
  rl("columns-with-image", [ag, vm]);
  const lg = "[data-form-message-close]",
    cg = "[data-form-message]",
    hg = "hide-down",
    dg = "notification-visible";
  let ug = {};
  rl("contact-form", {
    onLoad() {
      ug[this.id] = new (class {
        hidePopups() {
          document.body.classList.add(dg);
        }
        showPopups() {
          document.body.classList.remove(dg);
        }
        closeFormMessage() {
          this.closeButton.addEventListener("click", this.closeMessage.bind(this));
        }
        closeMessage(t) {
          (t.preventDefault(), this.messageWrapper.classList.add(hg), this.showPopups());
        }
        autoHideMessage() {
          setTimeout(() => {
            (this.messageWrapper.classList.add(hg), this.showPopups());
          }, 1e4);
        }
        constructor(t) {
          ((this.container = t.container),
            (this.closeButton = this.container.querySelector(lg)),
            (this.messageWrapper = this.container.querySelector(cg)),
            this.messageWrapper && (this.hidePopups(), this.closeFormMessage(), this.autoHideMessage()));
        }
      })(this);
    },
  });
  const pg = "time",
    mg = "[data-days]",
    gg = "[data-hours]",
    yg = "[data-minutes]",
    fg = "[data-seconds]",
    vg = "[data-section-type]",
    wg = ".shopify-section",
    bg = "[data-product-timer]",
    Sg = "[data-aos]",
    Eg = "countdown-timer--show-message",
    Lg = "aos-animate",
    kg = "countdown",
    Ag = "data-expiration-behavior",
    Cg = "data-leading-zero",
    qg = "hide",
    Tg = "show-message";
  let Pg = class extends HTMLElement {
    connectedCallback() {
      this.init();
    }
    disconnectedCallback() {
      this.stopTimer();
    }
    init() {
      isNaN(this.endDate) || this.endDate <= Date.now()
        ? this.onComplete()
        : (this.section.classList.contains(kg) && this.onLoad(!0), (this.interval = setInterval(this.update, 1e3)));
    }
    stopTimer() {
      clearInterval(this.interval);
    }
    convertTime(t) {
      const e = this.formatDigits(parseInt(t / this.daysInMs, 10));
      t -= e * this.daysInMs;
      const i = this.formatDigits(parseInt(t / this.hoursInMs, 10));
      t -= i * this.hoursInMs;
      const s = this.formatDigits(parseInt(t / this.minutesInMs, 10));
      t -= s * this.minutesInMs;
      return { days: e, hours: i, minutes: s, seconds: this.formatDigits(parseInt(t / this.secondsInMs, 10)) };
    }
    formatDigits(t) {
      return (t < 10 && this.leadingZero && (t = "0" + t), t);
    }
    render(t) {
      ((this.days.textContent = t.days),
        (this.hours.textContent = t.hours),
        (this.minutes.textContent = t.minutes),
        (this.seconds.textContent = t.seconds));
    }
    onComplete() {
      (this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
        this.shouldHideOnComplete &&
          !window.Shopify.designMode &&
          (this.productTimer ? this.productTimer.remove() : this.shopifySection.remove(),
          document.dispatchEvent(new CustomEvent("theme:parallax:refresh"))),
        this.shouldShowMessage && this.classList.add(Eg));
    }
    triggerAnimations() {
      "false" != theme.settings.animations &&
        this.section.querySelectorAll(Sg).forEach((t) => {
          this.isAnimated && t.classList.add(Lg);
        });
    }
    removeAnimations() {
      this.section.querySelectorAll(Sg).forEach((t) => {
        requestAnimationFrame(() => {
          t.classList.contains(Lg) && (t.classList.remove(Lg), (this.isAnimated = !0));
        });
      });
    }
    onLoad(t) {
      t ? this.removeAnimations() : ((this.isLoading = !1), this.triggerAnimations());
    }
    update() {
      const t = Date.now(),
        e = this.endDate - t;
      if (e <= 0) return (this.stopTimer(), void this.onComplete());
      const i = this.convertTime(e);
      (this.render(i), this.isLoading && this.onLoad(!1));
    }
    constructor() {
      (super(),
        (this.section = this.closest(vg)),
        (this.shopifySection = this.closest(wg)),
        (this.productTimer = this.closest(bg)),
        (this.expirationBehavior = this.getAttribute(Ag)),
        (this.leadingZero = this.hasAttribute(Cg)),
        (this.time = this.querySelector(pg)),
        (this.endDate = Date.parse(this.time.dateTime)),
        (this.days = this.querySelector(mg)),
        (this.hours = this.querySelector(gg)),
        (this.minutes = this.querySelector(yg)),
        (this.seconds = this.querySelector(fg)),
        (this.daysInMs = 864e5),
        (this.hoursInMs = this.daysInMs / 24),
        (this.minutesInMs = this.hoursInMs / 60),
        (this.secondsInMs = this.minutesInMs / 60),
        (this.isLoading = !0),
        (this.shouldHideOnComplete = this.expirationBehavior === qg),
        (this.shouldShowMessage = this.expirationBehavior === Tg),
        (this.isAnimated = !1),
        (this.update = this.update.bind(this)));
    }
  };
  (rl("countdown", [vm, op]), customElements.get("countdown-timer") || customElements.define("countdown-timer", Pg));
  const xg = "[data-video-id]",
    Ig = "[data-video-player]",
    Hg = "[data-video-template]",
    Fg = "[data-video-autoplay]",
    Mg = "[data-video-wrapper]",
    Dg = "[data-video-bg-play]",
    Og = "is-loading",
    Bg = "is-paused",
    zg = {};
  const _g = {
    onLoad() {
      zg[this.id] = [];
      this.container.querySelectorAll(Mg).forEach((t) => {
        zg[this.id].push(
          new (class {
            init() {
              this.videoId &&
                (new IntersectionObserver(
                  (t, e) => {
                    t.forEach((t) => {
                      if (t.isIntersecting) {
                        const i = this.videoTemplate.innerHTML;
                        ((this.videoPlayer.innerHTML = i),
                          (this.video = this.container.querySelector(Fg)),
                          this.container.classList.add(Bg),
                          this.listen(),
                          e.unobserve(t.target));
                      }
                    });
                  },
                  { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] },
                ).observe(this.videoPlayer),
                this.videoPlayButton.addEventListener("click", (t) => {
                  var e;
                  (t.preventDefault(), null === (e = this.video) || void 0 === e || e.play());
                }));
            }
            listen() {
              (this.video.addEventListener("playing", () => {
                (this.videoPlayer.classList.remove(Og), this.container.classList.remove(Bg));
              }),
                this.container.addEventListener(
                  "touchstart",
                  () => {
                    this.video.play();
                  },
                  { passive: !0 },
                ));
            }
            constructor(t) {
              ((this.container = t),
                (this.videoId = this.container.querySelector(xg)),
                (this.videoPlayer = this.container.querySelector(Ig)),
                (this.videoTemplate = this.container.querySelector(Hg)),
                (this.videoPlayButton = this.container.querySelector(Dg)),
                this.init());
            }
          })(t),
        );
      });
    },
  };
  let $g = class {
    write() {
      ((-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t) => t.startsWith(this.name))) {
        return document.cookie
          .split("; ")
          .find((t) => t.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    constructor(t, e) {
      ((this.configuration = {
        expires: null,
        path: "/",
        domain: window.location.hostname,
        sameSite: "none",
        secure: !0,
      }),
        (this.name = t),
        (this.value = e));
    }
  };
  const Rg = "[data-newsletter-form]",
    Vg = "[data-popup]",
    Ng = "section",
    Wg = "footer",
    Ug = ".shopify-section",
    jg = "has-success",
    Gg = "has-error",
    Kg = "section-footer--parallax",
    Qg = "newsletter_form_id",
    Xg = {};
  const Yg = {
      onLoad() {
        Xg[this.id] = [];
        this.container.querySelectorAll(Rg).forEach((t) => {
          Xg[this.id].push(
            new (class {
              init() {
                (this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage());
              }
              newsletterSubmitEvent(t) {
                this.stopSubmit &&
                  (t.preventDefault(),
                  this.removeStorage(),
                  this.writeStorage(),
                  (this.stopSubmit = !1),
                  this.newsletter.submit());
              }
              checkForChallengePage() {
                this.isChallengePage = window.location.pathname === theme.routes.root + "challenge";
              }
              writeStorage() {
                void 0 !== this.sessionStorage && this.sessionStorage.setItem(Qg, this.newsletter.id);
              }
              readStorage() {
                this.formID = this.sessionStorage.getItem(Qg);
              }
              removeStorage() {
                this.sessionStorage.removeItem(Qg);
              }
              showMessage() {
                if ((this.readStorage(), this.newsletter.id === this.formID)) {
                  const t = document.getElementById(this.formID),
                    e = -1 !== window.location.search.indexOf("?customer_posted=true"),
                    i = -1 !== window.location.search.indexOf("accepts_marketing");
                  (e
                    ? (t.classList.remove(Gg),
                      t.classList.add(jg),
                      this.popup &&
                        ((this.cookie = new $g(this.popup.dataset.cookieName, "user_has_closed")), this.cookie.write()))
                    : i && (t.classList.remove(jg), t.classList.add(Gg)),
                    (e || i) && this.scrollToForm(t));
                }
              }
              scrollToForm(t) {
                let { stickyHeaderHeight: e } = window.theme.readHeights();
                const i = e || 0,
                  s = t.closest(Ng),
                  o = t.closest(Wg);
                visibilityHelper.isElementPartiallyVisible(t) ||
                  visibilityHelper.isElementTotallyVisible(t) ||
                  setTimeout(() => {
                    let e = window.scrollY,
                      n = t.getBoundingClientRect().top;
                    s
                      ? (n = s.getBoundingClientRect().top)
                      : o && o.closest(Ug).classList.contains(Kg) && ((n = document.body.scrollHeight), (e = 0));
                    const r = n - i + e;
                    window.scrollTo({ top: r, left: 0, behavior: "smooth" });
                  }, 400);
              }
              onUnload() {
                this.newsletter.removeEventListener("submit", this.newsletterSubmit);
              }
              constructor(t) {
                ((this.newsletter = t),
                  (this.sessionStorage = window.sessionStorage),
                  (this.popup = this.newsletter.closest(Vg)),
                  (this.stopSubmit = !0),
                  (this.isChallengePage = !1),
                  (this.formID = null),
                  (this.formIdSuccess = null),
                  this.checkForChallengePage(),
                  (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                  this.isChallengePage || this.init());
              }
            })(t),
          );
        });
      },
      onUnload() {
        Xg[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    Jg = "[data-product]",
    Zg = "[data-slider]",
    ty = "[data-slide]",
    ey = "[data-product-media-container]",
    iy = ".flickity-button",
    sy = "a, button",
    oy = "tabindex",
    ny = {};
  const ry = {
    onLoad() {
      ny[this.id] = new (class {
        checkSlider() {
          window.innerWidth >= theme.sizes.small
            ? this.productSlider.forEach((t) => {
                this.initProductSlider(t);
              })
            : this.productSlider.forEach((t) => {
                this.destroyProductSlider(t);
              });
        }
        changeTabIndex(t) {
          const e = t.dataset.slider,
            i = this.flkty[e].selectedIndex;
          this.flkty[e].slides.forEach((t, e) => {
            t.cells.forEach((t) => {
              t.element.querySelectorAll(sy).forEach((t) => {
                t.setAttribute(oy, i === e ? "0" : "-1");
              });
            });
          });
        }
        initProductSlider(t) {
          const e = t.querySelectorAll(ty).length,
            i = t.dataset.slider;
          e > 1 &&
            (void 0 !== this.flkty[i] && this.flkty[i].isActive
              ? this.setSliderArrowsPosition(t)
              : (this.flkty[i] = new window.theme.Flickity(t, {
                  prevNextButtons: !0,
                  adaptiveHeight: !0,
                  pageDots: !0,
                  wrapAround: !0,
                  on: {
                    ready: () => {
                      (this.setSliderArrowsPosition(t),
                        setTimeout(() => {
                          this.changeTabIndex(t);
                        }, 0));
                    },
                    change: () => {
                      this.changeTabIndex(t);
                    },
                  },
                })));
        }
        destroyProductSlider(t) {
          const e = t.dataset.slider;
          "object" == typeof this.flkty[e] && this.flkty[e].destroy();
        }
        setSliderArrowsPosition(t) {
          const e = t.querySelectorAll(iy),
            i = t.querySelector(ey);
          e.length &&
            i &&
            e.forEach((t) => {
              t.style.top = i.offsetHeight / 2 + "px";
            });
        }
        resizeSlider(t) {
          const e = t.target,
            i = window.theme.Flickity.data(e) || null;
          i && i.resize();
        }
        listen() {
          (this.checkSlider(),
            document.addEventListener("theme:resize:width", this.checkSliderOnResize),
            this.productSlider.forEach((t) => {
              t.addEventListener("theme:slider:resize", this.resizeSliderEvent);
            }));
        }
        onUnload() {
          if (this.flkty) for (const t in this.flkty) this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
          (document.removeEventListener("theme:resize:width", this.checkSliderOnResize),
            this.productSlider.forEach((t) => {
              t.removeEventListener("theme:slider:resize", this.resizeSliderEvent);
            }));
        }
        constructor(t) {
          ((this.container = t),
            (this.product = this.container.querySelectorAll(Jg)),
            (this.productSlider = this.container.querySelectorAll(Zg)),
            (this.checkSliderOnResize = () => this.checkSlider()),
            (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
            (this.flkty = []),
            (this.videoObj = []),
            (this.quickViewObj = []),
            this.listen());
        }
      })(this.container);
    },
    onUnload(t) {
      ny[this.id].onUnload(t);
    },
  };
  rl("custom-content", [ry, Yg, vm, Nt, _g, mi]);
  const ay = "[data-slider]",
    ly = "[data-slide]",
    cy = "[data-product-media-container]",
    hy = "a, button",
    dy = ".flickity-button",
    uy = "[data-promo]",
    py = "[data-product-block]",
    my = "carousel",
    gy = "carousel--inactive",
    yy = "is-last-slide-visible",
    fy = "featured-collection",
    vy = "collection-promo--full",
    wy = "collection-promo--two-columns",
    by = "data-slider-id",
    Sy = "data-slider-show-image",
    Ey = "tabindex",
    Ly = {};
  let ky = class {
    initSlider(t) {
      const e = t.getAttribute(by);
      (t.classList.remove(gy),
        void 0 !== this.flkty[e] && this.flkty[e].isActive
          ? this.setSliderArrowsPosition(t)
          : ((this.flkty[e] = new window.theme.Flickity(t, {
              pageDots: !1,
              cellSelector: ly,
              cellAlign: "left",
              groupCells: !0,
              contain: !0,
              wrapAround: !1,
              adaptiveHeight: !1,
              on: {
                ready: () => {
                  (this.setSliderArrowsPosition(t),
                    setTimeout(() => {
                      this.changeTabIndex(t);
                    }, 0));
                },
                change: () => {
                  this.changeTabIndex(t);
                },
              },
            })),
            this.handleLastSlideOverlayOnTablet(t)));
    }
    destroySlider(t) {
      const e = t.getAttribute(by);
      (t.classList.contains(my) && t.classList.add(gy), "object" == typeof this.flkty[e] && this.flkty[e].destroy());
    }
    resetSlider(t) {
      const e = t.target,
        i = e.getAttribute(by);
      "object" == typeof this.flkty[i] ? this.flkty[i].select(0, !1, !0) : e.scrollTo({ left: 0, behavior: "instant" });
    }
    resizeSlider(t) {
      const e = t.target,
        i = window.theme.Flickity.data(e) || null;
      i && i.resize();
    }
    checkSlidesSize() {
      this.sliders.length &&
        this.sliders.forEach((t) => {
          const e = this.columns,
            i = window.innerWidth >= theme.sizes.large,
            s = window.innerWidth >= theme.sizes.large && window.innerWidth < theme.sizes.widescreen,
            o = window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large;
          let n = t.querySelectorAll(ly).length;
          const r = t.querySelectorAll(uy);
          (r.length &&
            i &&
            r.forEach((t) => {
              t.classList.contains(vy) ? (n += e - 1) : t.classList.contains(wy) && (n += 1);
            }),
            t.hasAttribute(Sy) && (n += 1),
            (i && n > e) || (s && n > 3) || (o && n > 2)
              ? (this.initSlider(t), this.getTallestProductGridItem(t))
              : this.destroySlider(t));
        });
    }
    changeTabIndex(t) {
      const e = t.getAttribute(by),
        i = this.flkty[e].selectedIndex;
      this.flkty[e].slides.forEach((t, e) => {
        t.cells.forEach((t) => {
          t.element.querySelectorAll(hy).forEach((t) => {
            t.setAttribute(Ey, i === e ? "0" : "-1");
          });
        });
      });
    }
    setSliderArrowsPosition(t) {
      const e = t.querySelectorAll(dy),
        i = t.querySelector(cy);
      e.length &&
        i &&
        e.forEach((t) => {
          t.style.top = i.offsetHeight / 2 + "px";
        });
    }
    handleLastSlideOverlayOnTablet(t) {
      const e = t.getAttribute(by);
      this.flkty[e].on("select", () => {
        if (!(window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large)) return;
        const i = this.flkty[e].selectedIndex,
          s = this.flkty[e].slides.length - 1 === i;
        t.parentNode.classList.toggle(yy, s);
      });
    }
    getTallestProductGridItem(t) {
      if (t.querySelectorAll(uy).length) {
        const e = t.querySelectorAll(py),
          i = Math.max(...Array.from(e).map((t) => t.offsetHeight));
        t.style.setProperty("--carousel-promo-height", `${i}px`);
      }
    }
    handleLastSlideOverlayOnMobile() {
      this.sliders.forEach((t) => {
        t.addEventListener("scroll", (e) => {
          if (!(window.innerWidth < theme.sizes.small)) return;
          const i = e.target.offsetWidth,
            s = Array.from(t.children).pop().getBoundingClientRect().left + 80 < i;
          t.parentNode.classList.toggle(yy, s);
        });
      });
    }
    listen() {
      this.sliders.length &&
        (this.checkSlidesSize(),
        document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
        this.sliders.forEach((t) => {
          (t.addEventListener("theme:tab:change", this.resetSliderEvent),
            t.addEventListener("theme:slider:resize", this.resizeSliderEvent));
        }));
    }
    onBlockSelect(t) {
      const e = t.target.closest(ay),
        i = window.theme.Flickity.data(e) || null;
      if (!e) return;
      let s = t.target.parentNode,
        o = t.target;
      if (
        (this.container.classList.contains(fy) && ((s = s.parentNode), (o = o.parentNode)), null !== i && i.isActive)
      ) {
        const n = parseInt([...s.children].indexOf(o)),
          r = parseInt(i.slides[0].cells.length),
          a = Math.floor(n / r);
        if (!t.detail.load) return void this.flkty.select(a);
        const l = () => {
          (requestAnimationFrame(() => {
            (i.select(a), this.setSliderArrowsPosition(e));
          }),
            i.element.removeEventListener("transitionend", l));
        };
        i.element.addEventListener("transitionend", l);
      } else {
        const t = e.currentStyle || window.getComputedStyle(e),
          i = parseInt(t.paddingLeft),
          s = o.offsetLeft - i;
        e.scrollTo({ top: 0, left: s, behavior: "smooth" });
      }
    }
    onUnload() {
      if (this.flkty) for (const t in this.flkty) this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
      (document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
        this.sliders.length &&
          this.sliders.forEach((t) => {
            (t.removeEventListener("theme:tab:change", this.resetSliderEvent),
              t.removeEventListener("theme:slider:resize", this.resizeSliderEvent));
          }));
    }
    constructor(t) {
      ((this.container = t),
        (this.columns = parseInt(this.container.dataset.columns)),
        (this.sliders = this.container.querySelectorAll(ay)),
        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
        (this.resetSliderEvent = (t) => this.resetSlider(t)),
        (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
        (this.flkty = []),
        this.listen(),
        this.handleLastSlideOverlayOnMobile());
    }
  };
  const Ay = {
    onLoad() {
      Ly[this.id] = [];
      this.container.querySelectorAll(ay).forEach((t) => {
        Ly[this.id].push(new ky(this.container));
      });
    },
    onUnload() {
      Ly[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
    onBlockSelect(t) {
      Ly[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
  };
  (rl("featured-collection", [mi, Nt, Ay]), rl("featured-video", [vm, _g]));
  const Cy = "[data-shop-pay-wrapper]",
    qy = "shop-login-button",
    Ty = "shop-follow-button",
    Py = "follow-on-shop-button",
    xy = "heart-icon",
    Iy = "shop-logo",
    Hy = {};
  const Fy = {
      onLoad() {
        Hy[this.id] = new (class {
          init() {
            if (!this.shopLoginButton || !this.shopPayWrapper) return;
            const t = this.shopPayWrapper.dataset.bg || "transparent",
              e = this.shopPayWrapper.dataset.text || "#fff",
              i = this.shopPayWrapper.dataset.hover || "#fff";
            ((this.mainButtonStyles = `\n      :host {\n        --bg-color: ${t};\n        --text-color: ${e};\n        --hover-color: ${i};\n      }\n\n      .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--text-color);\n        transition: border 0.3s ease;\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n\n      .button {\n        background: transparent;\n        color: var(--text-color);\n      }\n\n      .following-text {\n        color: var(--text-color);\n      }\n\n      .button--following:focus-visible,\n      .button--following:hover {\n        background: var(--bg-color);\n      }\n\n      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,\n      .button:not(.button--following):hover .follow-icon-wrapper:before {\n        background: var(--bg-color);\n        border-color: var(--hover-color);\n      }\n    `),
              (this.svgIconsStyles = `\n      :host {\n        color: ${e};\n      }\n    `),
              customElements.whenDefined(qy).then((t) => {
                requestAnimationFrame(() => {
                  const t = this.shopLoginButton.shadowRoot,
                    e = null == t ? void 0 : t.querySelector(Ty),
                    i = null == e ? void 0 : e.shadowRoot,
                    s = null == i ? void 0 : i.querySelector(Py),
                    o = null == s ? void 0 : s.shadowRoot;
                  o && this.overwriteStyles(o.host.shadowRoot, this.mainButtonStyles);
                  const n = o.querySelector(xy),
                    r = null == n ? void 0 : n.shadowRoot,
                    a = o.querySelector(Iy),
                    l = null == a ? void 0 : a.shadowRoot;
                  (r && this.overwriteStyles(r.host.shadowRoot, this.svgIconsStyles),
                    l && this.overwriteStyles(l.host.shadowRoot, this.svgIconsStyles));
                });
              }));
          }
          overwriteStyles(t, e) {
            let i = document.createElement("style");
            ((i.innerHTML = e), t.appendChild(i));
          }
          constructor(t) {
            ((this.container = t),
              (this.shopPayWrapper = document.querySelector(Cy)),
              (this.shopLoginButton = document.querySelector(qy)),
              this.init());
          }
        })(this.container);
      },
    },
    My = ":scope > [data-wave]",
    Dy = "[data-main]",
    Oy = "[data-collapsible-trigger-mobile]",
    By = '[data-parallax="footer"]',
    zy = "is-expanded",
    _y = "wavy",
    $y = "parallax-shadow",
    Ry = "parallax-rounded-corners",
    Vy = "main-content--parallax",
    Ny = "section-footer--parallax",
    Wy = "section-footer--visible",
    Uy = "main-content",
    jy = "shopify-section",
    Gy = "body--rounded-corners-large",
    Ky = "--bg",
    Qy = "--footer-bg",
    Xy = "data-parallax",
    Yy = "data-parallax-wavy",
    Jy = "data-parallax-rounded-corners",
    Zy = "data-parallax-rounded-corners-large",
    tf = "data-parallax-disable-on-safari",
    ef = {};
  rl("footer", [
    Yg,
    ut,
    {
      onLoad() {
        ef[this.id] = new (class {
          init() {
            const t = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && this.container.hasAttribute(tf),
              e = this.isViewportSmaller() || window.innerWidth < theme.sizes.small || t,
              i = document.body;
            i.classList.remove(Gy);
            const s = getComputedStyle(this.container).getPropertyValue(Ky);
            this.parentContainer.style.setProperty("--footer-parallax-height", "auto");
            let o = this.parentContainer.previousElementSibling;
            if (o) {
              if ((o.classList.contains(jy) || o.classList.contains(Uy) || (o = this.main), this.wavyEnabled && !e)) {
                [...o.querySelectorAll(My)].map((t) => t.remove());
                const t = this.container.querySelector(My);
                (o.append(t.cloneNode(!0)), o.classList.add(_y), this.container.classList.remove(_y));
              } else
                this.container.hasAttribute(Jy) && !this.wavyEnabled
                  ? (o.classList.toggle(Ry, !e),
                    o.classList.toggle($y, !e),
                    this.container.hasAttribute(Zy) && i.classList.toggle(Gy, !e))
                  : e || o.classList.add($y);
              o.style.setProperty(Qy, s);
            }
            e ||
              (this.main.classList.add(Vy),
              this.parentContainer.classList.add(Ny),
              this.parentContainer.style.setProperty("--footer-parallax-height", `${this.container.clientHeight}px`),
              (this.footerParallax = new sp(this.container)));
          }
          resize() {
            (this.parentContainer.style.setProperty("--footer-parallax-height", "auto"),
              (this.isViewportSmaller() || window.innerWidth < theme.sizes.small || !this.footerParallax) &&
                this.onUnload(!0),
              this.parentContainer.style.setProperty("--footer-parallax-height", `${this.container.clientHeight}px`));
          }
          isViewportSmaller() {
            const t = Math.round(Math.max(document.documentElement.clientHeight, window.innerHeight || 0)),
              e = this.container.clientHeight;
            let i = 0;
            return (this.wavyEnabled && (i = 50), t < e + i);
          }
          onBlockSelect(t) {
            const e = t.target.querySelector(Oy);
            requestAnimationFrame(() => {
              e && !e.classList.contains(zy) && e.dispatchEvent(new Event("click"));
            });
          }
          onBlockDeselect(t) {
            const e = t.target.querySelector(Oy);
            requestAnimationFrame(() => {
              e && e.classList.contains(zy) && e.dispatchEvent(new Event("click"));
            });
          }
          onUnload(t = !1) {
            (document.removeEventListener("theme:resize", this.resizeEvent),
              document.removeEventListener("theme:footer:unload", this.unloadEvent),
              this.footerParallax && (this.footerParallax.unload(), t && tl(this.parentContainer)),
              (this.footerParallax || t) &&
                setTimeout(() => {
                  const t = Shopify.theme.sections.instances,
                    e = document.querySelectorAll(By),
                    i = t.filter((t) => t.container === e[0]);
                  (this.main.classList.remove(Vy),
                    this.parentContainer.classList.remove(Ny),
                    this.parentContainer.classList.remove(Wy),
                    i[0] && i[0].onLoad());
                }));
          }
          constructor(t) {
            ((this.container = t.container),
              (this.main = document.querySelector(Dy)),
              (this.footerParallax = null),
              (this.wavyEnabled = this.container.hasAttribute(Yy)),
              (this.parentContainer = this.container.parentNode),
              (this.resizeEvent = () => this.resize()),
              (this.unloadEvent = () => this.onUnload()),
              requestIdleCallback(() => {
                this.container.hasAttribute(Xy) &&
                  !this.main.classList.contains(Vy) &&
                  (this.init(),
                  document.addEventListener("theme:resize", this.resizeEvent),
                  document.addEventListener("theme:footer:unload", this.unloadEvent));
              }));
          }
        })(this);
      },
      onBlockSelect(t) {
        ef[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        ef[this.id].onBlockDeselect(t);
      },
      onReorder() {
        ef[this.id].onUnload();
      },
      onUnload() {
        ef[this.id].onUnload();
      },
    },
    Fy,
  ]);
  const sf = "[data-slider]";
  let of = {};
  rl("icons-row", {
    onLoad() {
      of[this.id] = new (class {
        onBlockSelect(t) {
          const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
            i = parseInt(e.paddingLeft),
            s = t.target.offsetLeft - i;
          this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
        }
        constructor(t) {
          ((this.container = t.container), (this.slider = this.container.querySelector(sf)));
        }
      })(this);
    },
    onBlockSelect(t) {
      of[this.id].onBlockSelect(t);
    },
  });
  const nf = "[data-accordion-item]",
    rf = "[data-accordion-button]",
    af = "is-active",
    lf = "to-animate",
    cf = "is-animating",
    hf = {};
  rl("image-accordions", {
    onLoad() {
      hf[this.id] = new (class {
        init() {
          (this.triggerLoadingAnimation(),
            this.imageAccordionsItems.forEach((t) => {
              t.addEventListener("mouseenter", this.accordionExpandEvent.bind(this, t));
            }),
            this.buttons.forEach((t) => {
              t.addEventListener("focusin", this.accordionFocusEvent.bind(this, t));
            }));
        }
        triggerLoadingAnimation() {
          if ("false" == theme.settings.animationsEnabled || window.theme.isMobile()) return;
          const t = (e) => {
              "expandAccordion" === e.animationName &&
                (this.accordionExpand(this.imageAccordionsItems[0]),
                this.container.classList.remove(lf),
                this.container.classList.remove(cf),
                this.container.removeEventListener("animationend", t));
            },
            e = (t) => {
              requestAnimationFrame(() => {
                t.target === this.container &&
                  (this.container.classList.add(cf), this.container.removeEventListener("transitionend", e));
              });
            };
          (this.container.addEventListener("transitionend", e, { signal: this.controller.signal }),
            this.container.addEventListener("animationend", t, { signal: this.controller.signal }));
        }
        accordionExpand(t) {
          t.classList.contains(af) ||
            (this.imageAccordionsItems.forEach((t) => {
              t.classList.remove(af);
            }),
            t.classList.add(af));
        }
        accordionFocus(t) {
          t.closest(nf).dispatchEvent(new Event("mouseenter"));
        }
        onBlockSelect(t) {
          const e = t.target;
          e &&
            (this.controller.abort(),
            this.container.classList.remove(lf, cf),
            this.accordionExpand(e),
            window.theme.isMobile() && e.parentNode.scrollTo({ top: 0, left: e.offsetLeft, behavior: "smooth" }));
        }
        constructor(t) {
          ((this.container = t.container),
            (this.controller = new AbortController()),
            (this.imageAccordionsItems = this.container.querySelectorAll(nf)),
            (this.buttons = this.container.querySelectorAll(rf)),
            (this.accordionExpandEvent = (t) => this.accordionExpand(t)),
            (this.accordionFocusEvent = (t) => this.accordionFocus(t)),
            this.init());
        }
      })(this);
    },
    onBlockSelect(t) {
      hf[this.id].onBlockSelect(t);
    },
  });
  const df = "[data-collapsible-trigger]",
    uf = "is-expanded",
    pf = {};
  (rl("image-with-text", [
    vm,
    {
      onLoad() {
        pf[this.id] = new (class {
          onBlockSelect(t) {
            const e = t.target.querySelector(df);
            requestAnimationFrame(() => {
              e && !e.classList.contains(uf) && e.dispatchEvent(new Event("click"));
            });
          }
          constructor(t) {
            this.container = t.container;
          }
        })(this);
      },
      onBlockSelect(t) {
        pf[this.id].onBlockSelect(t);
      },
    },
    ut,
  ]),
    rl("list-collections", Ay));
  const mf = {},
    gf = "[data-slider-gallery]",
    yf = "[data-slider-info]",
    ff = "[data-slide-item]";
  rl("locations", {
    onLoad() {
      mf[this.id] = new (class {
        initSlider() {
          const t = this.container.querySelectorAll(ff).length;
          ((this.flkty = window.theme.Flickity.data(this.slider)),
            (this.flktyNav = window.theme.Flickity.data(this.sliderNav)),
            t <= 1 ||
              ((this.flkty = new window.theme.Flickity(this.slider, {
                fade: !0,
                wrapAround: !0,
                adaptiveHeight: !0,
                prevNextButtons: !1,
                pageDots: !1,
              })),
              window.theme.flickitySmoothScrolling(this.slider),
              (this.flktyNav = new window.theme.Flickity(this.sliderNav, {
                fade: !0,
                wrapAround: !0,
                imagesLoaded: !0,
                asNavFor: this.slider,
                prevNextButtons: !0,
                pageDots: !1,
              })),
              this.enableAdaptiveHeight(),
              document.addEventListener("theme:resize", this.resizeEvent),
              this.flktyNav.on("change", () => {
                if ((this.flkty.selectCell(this.flktyNav.selectedIndex), window.theme.isMobile())) {
                  let { stickyHeaderHeight: t } = window.theme.readHeights();
                  const e = t || 0,
                    i = Math.round(window.scrollY),
                    s = Math.round(this.container.getBoundingClientRect().top + i - e);
                  window.scrollTo({ top: s, left: 0, behavior: "smooth" });
                }
              }),
              this.flkty.on("change", () => {
                this.flktyNav.selectCell(this.flkty.selectedIndex);
              })));
        }
        enableAdaptiveHeight() {
          ((this.flktyNav.options.adaptiveHeight = !1),
            window.theme.isMobile() && (this.flktyNav.options.adaptiveHeight = !0),
            this.flktyNav.resize());
        }
        onBlockSelect(t) {
          const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
          (null !== this.flkty && this.flkty.select(e), null !== this.flktyNav && this.flktyNav.select(e));
        }
        onUnload() {
          document.removeEventListener("theme:resize", this.resizeEvent);
        }
        constructor(t) {
          ((this.container = t.container),
            (this.slider = this.container.querySelector(gf)),
            (this.sliderNav = this.container.querySelector(yf)),
            (this.flkty = null),
            (this.flktyNav = null),
            (this.resizeEvent = () => this.enableAdaptiveHeight()),
            this.initSlider());
        }
      })(this);
    },
    onBlockSelect(t) {
      mf[this.id].onBlockSelect(t);
    },
    onUnload() {
      mf[this.id].onUnload();
    },
  });
  const vf = {},
    wf = "[data-slider]",
    bf = "[data-slide-item]",
    Sf = "[data-stl-hotspots-item]",
    Ef = "[data-pointer]",
    Lf = "[data-pointer-bubble]",
    kf = "[data-product-media-container]",
    Af = "[data-quick-view-item-holder]",
    Cf = ".flickity-button",
    qf = "a, button",
    Tf = "[data-tooltip]",
    Pf = "data-products",
    xf = "data-pointer",
    If = "data-hotspot",
    Hf = "tabindex",
    Ff = "product-grid-item__image--hovered",
    Mf = "is-selected",
    Df = "is-active",
    Of = "on-hover",
    Bf = "pswp--open";
  const zf = {
    onLoad() {
      vf[this.id] = new (class {
        listen() {
          (this.slider &&
            (this.checkSlidesSize(),
            document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
            this.slider.addEventListener("theme:slider:resize", this.resizeSliderEvent)),
            this.pointers.forEach((t) => {
              (t.addEventListener("click", this.pointersInit),
                t.addEventListener("mouseover", this.pointersOver),
                t.addEventListener("mouseleave", this.pointersOut));
            }),
            this.pointerBubbles.forEach((t, e) => {
              (t.addEventListener("click", (t) => [...this.pointers][e].dispatchEvent(new Event(t.type))),
                t.addEventListener("mouseover", (t) => [...this.pointers][e].dispatchEvent(new Event(t.type))),
                t.addEventListener("mouseleave", (t) => [...this.pointers][e].dispatchEvent(new Event(t.type))));
            }));
        }
        checkSlidesSize() {
          const t = window.innerWidth < theme.sizes.small,
            e = window.innerWidth >= theme.sizes.large,
            i = window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large,
            s = Boolean(e && this.slides.length > this.productOnRow),
            o = Boolean(i && this.slides.length > 2);
          (this.initTooltips(),
            t ? this.destroySlider() : s || o ? this.initSlider() : (this.destroySlider(), this.slidesTabIndex()));
        }
        initTooltips() {
          ((this.tooltips = this.container.querySelectorAll(Tf)),
            this.tooltips.forEach((t) => {
              new Vt(t);
            }));
        }
        initSlider() {
          null !== this.flkty
            ? this.setSliderArrowsPosition()
            : (this.flkty = new window.theme.Flickity(this.slider, {
                prevNextButtons: !0,
                wrapAround: !0,
                adaptiveHeight: !1,
                cellAlign: "left",
                groupCells: !1,
                contain: !0,
                on: {
                  ready: () => {
                    (this.slidesTabIndex(), this.setSliderArrowsPosition(), this.dotPointers());
                  },
                  change: () => {
                    (this.slidesTabIndex(), this.dotPointers());
                  },
                },
              }));
        }
        setSliderArrowsPosition() {
          if (!(window.innerWidth >= theme.sizes.small)) return;
          const t = this.slider.querySelectorAll(Cf),
            e = this.slider.querySelector(kf);
          t.length &&
            e &&
            t.forEach((t) => {
              t.style.top = e.offsetHeight / 2 + "px";
            });
        }
        slidesTabIndex() {
          this.slides.length < this.productOnRow + 1
            ? this.slider.querySelectorAll(qf).forEach((t) => {
                t.setAttribute(Hf, "0");
              })
            : window.theme.Flickity.data(this.slider).cells.forEach((t) => {
                let e = "-1";
                (t.element.classList.contains(Mf) && (e = "0"),
                  t.element.querySelectorAll(qf).forEach((t) => {
                    t.setAttribute(Hf, e);
                  }));
              });
        }
        destroySlider() {
          "object" == typeof this.flkty && null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
        }
        resizeSlider(t) {
          const e = t.target,
            i = window.theme.Flickity.data(e) || null;
          i && i.resize();
        }
        dotPointers(t) {
          if (0 === this.pointers.length) return;
          if ((this.sTLHotspotsItems.forEach((t) => t.classList.remove(Of)), t)) {
            var e;
            const i = t.target.getAttribute(xf);
            return void (null === (e = this.flkty) || void 0 === e || e.select(i));
          }
          const i = null == this.flkty ? 0 : this.flkty.selectedIndex;
          i >= 0 && this.sTLHotspotsItems[i].classList.add(Of);
        }
        dotPointerIn(t) {
          const e = t.target.getAttribute(xf),
            i = this.slides[e].querySelector(kf),
            s = matchMedia("(pointer:coarse)").matches;
          (window.innerWidth < theme.sizes.small || s || this.observeImage(i),
            this.pointers[e].style.setProperty("--target-animation", "none"));
        }
        dotPointerOut(t) {
          const e = t.target.getAttribute(xf),
            i = this.slides[e].querySelector(kf);
          (i.classList.remove(Ff),
            i.dispatchEvent(new Event("mouseleave")),
            this.observer && this.observer.disconnect(),
            this.pointers.forEach((t) => {
              t.style.removeProperty("--target-animation");
            }));
        }
        observeImage(t) {
          ((this.observer = new IntersectionObserver(
            (t, e) => {
              t.forEach((t) => {
                const e = t.target;
                0 == t.intersectionRatio || (e.dispatchEvent(new Event("mouseenter")), e.classList.add(Ff));
              });
            },
            { root: this.slider, threshold: [0.95, 1] },
          )),
            this.observer.observe(t));
        }
        triggerClick(t) {
          requestAnimationFrame(() => t.dispatchEvent(new Event("click")));
        }
        destroyQuickViewPopup() {
          var t, e;
          const i =
            null === (t = this.quickViewPopup) || void 0 === t || null === (e = t.loadPhotoswipe) || void 0 === e
              ? void 0
              : e.pswpElement;
          i && i.classList.contains(Bf) && this.quickViewPopup.loadPhotoswipe.popup.close();
        }
        onBlockSelect(t) {
          this.debouncedBlockSelectCallback(t);
        }
        debouncedBlockSelect(t) {
          var e, i;
          const s =
            null === (e = this.quickViewPopup) || void 0 === e || null === (i = e.loadPhotoswipe) || void 0 === i
              ? void 0
              : i.pswpElement;
          s
            ? setTimeout(() => {
                if (s.classList.contains(Bf)) {
                  const e = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(
                      `[${If}="${t.target.getAttribute(If)}"]`,
                    ),
                    i = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(Af);
                  (e.classList.add(Df),
                    i.forEach((t) => {
                      t !== e && t.classList.remove(Df);
                    }));
                } else this.triggerClick(t.target);
              })
            : setTimeout(() => this.triggerClick(t.target), 400);
        }
        onUnload() {
          (this.destroyQuickViewPopup(),
            document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
            this.slider && this.slider.removeEventListener("theme:slider:resize", this.resizeSliderEvent));
        }
        onDeselect() {
          this.destroyQuickViewPopup();
        }
        constructor(t) {
          var e;
          ((this.container = t),
            (this.slider = this.container.querySelector(wf)),
            (this.productOnRow = Number(null === (e = this.slider) || void 0 === e ? void 0 : e.getAttribute(Pf)) || 3),
            (this.slides = this.container.querySelectorAll(bf)),
            (this.sTLHotspotsItems = this.container.querySelectorAll(Sf)),
            (this.pointers = this.container.querySelectorAll(Ef)),
            (this.pointerBubbles = this.container.querySelectorAll(Lf)),
            (this.flkty = null),
            (this.observer = null),
            (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
            (this.resizeSliderEvent = (t) => this.resizeSlider(t)),
            (this.pointersInit = (t) => this.dotPointers(t)),
            (this.pointersOver = (t) => this.dotPointerIn(t)),
            (this.pointersOut = (t) => this.dotPointerOut(t)),
            (this.debouncedBlockSelectCallback = window.theme.debounce((t) => this.debouncedBlockSelect(t), 500)),
            (this.quickViewPopup = new li(this.container)),
            this.listen());
        }
      })(this.container);
    },
    onUnload() {
      vf[this.id].onUnload();
    },
    onBlockSelect(t) {
      vf[this.id].onBlockSelect(t);
    },
    onDeselect() {
      vf[this.id].onDeselect();
    },
  };
  rl("look", [zf]);
  const _f = "[data-grid]",
    $f = "[data-item]",
    Rf = "[data-item-content-inner]",
    Vf = ".carousel--mobile",
    Nf = "[data-aos], [data-aos-anchor]",
    Wf = "data-aos-anchor",
    Uf = "data-aos-trigger",
    jf = "data-slider-mobile",
    Gf = "aos-animate";
  let Kf = {};
  rl("mosaic", {
    onLoad() {
      Kf[this.id] = new (class {
        onResize() {
          this.updateAOSAnchors();
        }
        updateAOSAnchors() {
          if (
            "false" != theme.settings.animationsEnabled &&
            window.theme.isMobile() &&
            this.hasSliderMobile &&
            this.carouselMobile &&
            this.items.length > 1
          ) {
            const t = this.items[0],
              e = t.querySelector(Rf),
              i = t.id,
              s = e ? e.id : i;
            (t.setAttribute(Uf, `#${i}`),
              null == e || e.setAttribute(Uf, `#${s}`),
              this.items.forEach((t) => {
                const e = t.querySelectorAll(Nf),
                  o = t.querySelector(Rf);
                (t.setAttribute(Wf, `#${i}`),
                  null == o || o.setAttribute(Wf, `#${s}`),
                  e.forEach((t) => t.setAttribute(Wf, `#${s}`)));
              }));
          }
        }
        triggerAOS(t) {
          "false" != theme.settings.animationsEnabled &&
            t &&
            ([...t.querySelectorAll(Nf)].some((t) => t.classList.contains(Gf)) ||
              this.items.forEach((t) => {
                const e = t.querySelectorAll(Nf);
                (t.classList.add(Gf), e.forEach((t) => t.classList.add(Gf)));
              }));
        }
        onBlockSelect(t) {
          const e = t.target,
            i = e.closest(_f),
            s = i.currentStyle || window.getComputedStyle(i),
            o = parseInt(s.paddingLeft),
            n = e.offsetLeft - o,
            r = this.items[0];
          (e.matches(`#${r.id}`) || this.triggerAOS(e),
            setTimeout(() => {
              i.scrollTo({ top: 0, left: n, behavior: "smooth" });
            }, 500));
        }
        onUnload() {
          document.removeEventListener("theme:resize:width", this.onResizeCallback);
        }
        constructor(t) {
          ((this.container = t.container),
            (this.hasSliderMobile = this.container.hasAttribute(jf)),
            (this.carouselMobile = this.container.querySelector(Vf)),
            (this.items = this.container.querySelectorAll($f)),
            (this.onResizeCallback = () => this.onResize()),
            this.updateAOSAnchors(),
            document.addEventListener("theme:resize:width", this.onResizeCallback));
        }
      })(this);
    },
    onUnload() {
      Kf[this.id].onUnload();
    },
    onBlockSelect(t) {
      Kf[this.id].onBlockSelect(t);
    },
  });
  const Qf = "[data-slider]",
    Xf = "[data-slide]",
    Yf = "a, button",
    Jf = "flickity-enabled",
    Zf = "carousel",
    tv = "carousel--resize",
    ev = "carousel--inactive",
    iv = "is-selected",
    sv = "text-center",
    ov = "data-section-id",
    nv = "tabindex",
    rv = {};
  (rl("multicolumns", {
    onLoad() {
      rv[this.id] = new (class {
        init() {
          (this.handleSliderState(), this.listen());
        }
        onResize() {
          (this.handleSliderState(),
            null !== this.flkty &&
              (this.flkty.resize(), this.flkty.size.width >= this.flkty.slideableWidth && this.destroySlider()));
        }
        handleSliderState() {
          !this.slider.classList.contains(ev) || window.theme.isMobile()
            ? 1 === this.slides.length && window.theme.isMobile()
              ? this.destroySlider()
              : (this.flkty || this.initSlider(),
                this.flkty.slideableWidth < this.flkty.size.width && this.destroySlider())
            : this.destroySlider();
        }
        initSlider() {
          const t = this.slider.classList.contains(sv);
          (this.slider.classList.remove(ev),
            (this.flkty = new window.theme.Flickity(this.slider, {
              cellSelector: Xf,
              prevNextButtons: !0,
              pageDots: !0,
              groupCells: !0,
              cellAlign: t ? "center" : "left",
              contain: !0,
              adaptiveHeight: !1,
              draggable: !0,
              on: {
                ready: () => {
                  this.slidesTabIndex();
                },
                change: () => {
                  this.slidesTabIndex();
                },
              },
            })),
            this.createResizeClass());
        }
        createResizeClass() {
          if ("function" == typeof window.theme.Flickity.prototype._createResizeClass) return;
          ((window.theme.Flickity.prototype._createResizeClass = function () {
            this.element.classList.add(tv);
          }),
            window.theme.Flickity.createMethods.push("_createResizeClass"));
          const t = window.theme.Flickity.prototype.resize;
          window.theme.Flickity.prototype.resize = function () {
            (this.element.classList.remove(tv), t.call(this), this.element.classList.add(tv));
          };
        }
        slidesTabIndex() {
          window.theme.Flickity.data(this.slider).cells.forEach((t) => {
            let e = "-1";
            (t.element.classList.contains(iv) && (e = "0"),
              t.element.querySelectorAll(Yf).forEach((t) => {
                t.setAttribute(nv, e);
              }));
          });
        }
        destroySlider() {
          this.slider.classList.contains(Jf) &&
            (this.slider.classList.contains(Zf) && this.slider.classList.add(ev),
            null !== this.flkty && (this.flkty.destroy(), (this.flkty = null)));
        }
        listen() {
          document.addEventListener("theme:resize:width", this.onResizeCallback);
        }
        onBlockSelect(t) {
          if (this.flkty && this.flkty.isActive) {
            const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
              i = parseInt(this.flkty.slides[0].cells.length),
              s = Math.floor(e / i);
            if (!t.detail.load) return void this.flkty.select(s);
            const o = () => {
              (requestAnimationFrame(() => {
                this.flkty.select(s);
              }),
                this.flkty.element.removeEventListener("transitionend", o));
            };
            this.flkty.element.addEventListener("transitionend", o);
          }
        }
        onUnload() {
          document.removeEventListener("theme:resize:width", this.onResizeCallback);
        }
        constructor(t) {
          ((this.container = t.container),
            (this.sectionId = this.container.getAttribute(ov)),
            (this.slider = this.container.querySelector(Qf)),
            this.slider &&
              ((this.slides = this.slider.querySelectorAll(Xf)),
              (this.flkty = null),
              (this.onResizeCallback = () => this.onResize()),
              this.init()));
        }
      })(this);
    },
    onUnload(t) {
      rv[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      rv[this.id].onBlockSelect(t);
    },
  }),
    rl("newsletter", Yg),
    rl("overlapping-images", [vm, op]));
  const av = "[data-toggle-admin]",
    lv = "[data-toggle-newsletter]",
    cv = "[data-form-admin]",
    hv = "[data-form-newsletter]";
  let dv = {};
  rl("password-template", {
    onLoad() {
      dv[this.id] = new (class {
        init() {
          (this.toggleAdmin.addEventListener("click", (t) => {
            (t.preventDefault(), this.showPasswordForm());
          }),
            this.toggleNewsletter.addEventListener("click", (t) => {
              (t.preventDefault(), this.hidePasswordForm());
            }),
            "#login" == window.location.hash || this.adminErrors ? this.showPasswordForm() : this.hidePasswordForm());
        }
        showPasswordForm() {
          (Xo(this.adminForm), Yo(this.newsletterForm), (window.location.hash = "#login"));
        }
        hidePasswordForm() {
          (Xo(this.newsletterForm), Yo(this.adminForm), (window.location.hash = ""));
        }
        constructor(t) {
          ((this.container = t.container),
            (this.toggleAdmin = this.container.querySelector(av)),
            (this.toggleNewsletter = this.container.querySelector(lv)),
            (this.adminForm = this.container.querySelector(cv)),
            (this.newsletterForm = this.container.querySelector(hv)),
            (this.adminErrors = this.adminForm.querySelector(".errors")),
            (this.newsletterErrors = this.newsletterForm.querySelector(".errors")),
            this.init());
        }
      })(this);
    },
  });
  const uv = "[data-large-promo]",
    pv = "[data-large-promo-inner]",
    mv = "[data-tracking-consent]",
    gv = "[data-tracking-consent-inner]",
    yv = "[data-confirm-cookies]",
    fv = "[data-popup-bar]",
    vv = "[data-popup-bar-holder]",
    wv = "[data-popup-bar-toggle]",
    bv = "[data-popup-body]",
    Sv = "[data-popup-close]",
    Ev = "[data-popup-underlay]",
    Lv = "[data-newsletter-form]",
    kv = "data-target-referrer",
    Av = "data-prevent-scroll-lock",
    Cv = "has-success",
    qv = "has-error",
    Tv = "selected",
    Pv = "has-block-selected",
    xv = "popup--expanded",
    Iv = "popup--visible",
    Hv = "mobile",
    Fv = "desktop",
    Mv = "popup--bar",
    Dv = "popup-bar-is-visible";
  let Ov = {},
    Bv = 0,
    zv = 0,
    _v = [],
    $v = class {
      always() {
        this.showPopup();
      }
      delayed(t = 10) {
        setTimeout(() => {
          this.showPopup();
        }, 1e3 * t);
      }
      bottom() {
        document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
      }
      idle() {
        if (!(!0 === this.checkPopupTarget())) return;
        let t = 0;
        const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
          i = ["load", "resize", "scroll"],
          s = () => {
            ((t = setTimeout(() => {
              ((t = 0), this.showPopup());
            }, 6e4)),
              e.forEach((t) => {
                document.addEventListener(t, o);
              }),
              i.forEach((t) => {
                window.addEventListener(t, o);
              }));
          },
          o = () => {
            (t && clearTimeout(t),
              e.forEach((t) => {
                document.removeEventListener(t, o);
              }),
              i.forEach((t) => {
                window.removeEventListener(t, o);
              }),
              s());
          };
        s();
      }
      showPopup() {
        const t = { id: this.popup.id, body: this.popupBody };
        _v.push(t);
        if (!0 === this.checkPopupTarget()) {
          if (
            ((zv += 1),
            this.popup.classList.add(Iv),
            this.popup.classList.contains(Mv) && document.body.classList.add(Dv),
            this.a11y.trapFocus({ container: this.popupBody }),
            this.popup.hasAttribute(Av))
          )
            return !1;
          this.scrollLock();
        }
      }
      checkPopupTarget() {
        const t = this.popup.parentNode.classList.contains(Hv),
          e = this.popup.parentNode.classList.contains(Fv);
        return !((t && window.innerWidth >= theme.sizes.small) || (e && window.innerWidth < theme.sizes.small));
      }
      scrollLock() {
        document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }));
      }
      showPopupOnScroll() {
        window.scrollY + window.innerHeight >= document.body.clientHeight &&
          (this.showPopup(), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent));
      }
      onUnload() {
        document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
      }
      constructor(t, e) {
        if (
          ((this.popupContainer = t),
          (this.popup = e),
          (this.popupBody = e.querySelector(bv)),
          (this.delay = t.dataset.popupDelay),
          (this.isSubmitted =
            -1 !== window.location.href.indexOf("accepts_marketing") ||
            -1 !== window.location.href.indexOf("customer_posted=true")),
          (this.a11y = window.theme.a11y),
          (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
          ("always" === this.delay || this.isSubmitted) && this.always(),
          this.delay && this.delay.includes("delayed") && !this.isSubmitted)
        ) {
          const t = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
          this.delayed(t);
        }
        ("bottom" !== this.delay || this.isSubmitted || this.bottom(),
          "idle" !== this.delay || this.isSubmitted || this.idle());
      }
    },
    Rv = class {
      constructor(t) {
        if (((this.popupContainer = t), (this.locationPath = location.href), !this.popupContainer.hasAttribute(kv)))
          return !1;
        -1 !== this.locationPath.indexOf(this.popupContainer.getAttribute(kv)) ||
          window.Shopify.designMode ||
          this.popupContainer.parentNode.removeChild(this.popupContainer);
      }
    };
  rl("popups", [
    {
      onLoad() {
        ((Ov[this.id] = []), window.Shopify.designMode && (zv = 0));
        const t = this.container.querySelectorAll(uv);
        t.length &&
          t.forEach((t) => {
            Ov[this.id].push(
              new (class {
                init() {
                  (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                    (window.Shopify.designMode ? this.showPopup() : new $v(this.popupContainer, this.popup),
                    this.form &&
                      setTimeout(() => {
                        this.form.classList.contains(Cv) && (this.showPopupIfNoCookie(), (zv -= 1));
                      }),
                    this.initClosers());
                }
                checkPopupTarget() {
                  const t = this.popup.parentNode.classList.contains(Hv),
                    e = this.popup.parentNode.classList.contains(Fv);
                  return !(
                    (t && window.innerWidth >= theme.sizes.small) ||
                    (e && window.innerWidth < theme.sizes.small)
                  );
                }
                showPopupIfNoCookie() {
                  this.showPopup();
                }
                initClosers() {
                  (this.close.addEventListener("click", this.closePopup.bind(this)),
                    this.underlay.addEventListener("click", this.closePopup.bind(this)),
                    this.popupContainer.addEventListener("keyup", (t) => {
                      t.code === theme.keyboardKeys.ESCAPE && this.closePopup(t);
                    }));
                }
                closePopup(t) {
                  (t.preventDefault(), this.hidePopup(), this.cookie.write());
                }
                scrollLock() {
                  (this.resetScrollUnlock(),
                    this.a11y.trapFocus({ container: this.popupBody }),
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }),
                    ));
                }
                scrollUnlock() {
                  (this.resetScrollUnlock(),
                    (Bv = setTimeout(() => {
                      document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                    }, 300)));
                }
                resetScrollUnlock() {
                  Bv && clearTimeout(Bv);
                }
                showPopup() {
                  const t = !0 === this.checkPopupTarget(),
                    e = { id: this.popupId, body: this.popup };
                  (_v.push(e), t && ((zv += 1), this.popup.classList.add(Iv), this.scrollLock()));
                }
                hidePopup() {
                  this.popup.classList.remove(Iv);
                  const t = _v.findIndex((t) => t.id === this.popupId);
                  if (((zv -= 1), _v.splice(t, 1), 1 == zv && document.body.classList.contains(Dv)))
                    this.scrollUnlock();
                  else if (zv < 1) (this.scrollUnlock(), this.a11y.removeTrapFocus());
                  else if (_v.length > 0) {
                    const t = _v[_v.length - 1].body;
                    this.a11y.trapFocus({ container: t });
                  }
                }
                onBlockSelect(t) {
                  this.popupContainer.contains(t.target) &&
                    !this.popup.classList.contains(Iv) &&
                    (this.popup.classList.add(Tv), this.popupContainer.classList.add(Pv), this.showPopup());
                }
                onBlockDeselect(t) {
                  this.popupContainer.contains(t.target) &&
                    (this.popup.classList.remove(Tv), this.popupContainer.classList.remove(Pv), this.hidePopup());
                }
                onUnload() {
                  this.scrollUnlock();
                }
                onDeselect() {
                  (this.popup.classList.remove(Tv), this.popupContainer.classList.remove(Pv), this.hidePopup());
                }
                constructor(t) {
                  ((this.popupContainer = t),
                    (this.popup = this.popupContainer.querySelector(pv)),
                    (this.popupBody = this.popup.querySelector(bv)),
                    (this.popupId = this.popup.id),
                    (this.close = this.popup.querySelector(Sv)),
                    (this.underlay = this.popup.querySelector(Ev)),
                    (this.form = this.popup.querySelector(Lv)),
                    (this.cookie = new $g(this.popupContainer.dataset.cookieName, "user_has_closed")),
                    (this.isTargeted = new Rv(this.popupContainer)),
                    (this.a11y = window.theme.a11y),
                    this.init());
                }
              })(t),
            );
          });
        const e = this.container.querySelectorAll(fv);
        e.length &&
          e.forEach((t) => {
            Ov[this.id].push(
              new (class {
                init() {
                  (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                    (window.Shopify.designMode ? this.showPopup() : new $v(this.popupContainer, this.popup),
                    this.initPopupToggleButton(),
                    this.initClosers(),
                    this.form &&
                      setTimeout(() => {
                        (this.form.classList.contains(Cv) && this.showPopupIfNoCookie(),
                          this.form.classList.contains(qv) && this.toggle.dispatchEvent(new Event("click")));
                      }));
                }
                checkPopupTarget() {
                  const t = this.popup.parentNode.classList.contains(Hv),
                    e = this.popup.parentNode.classList.contains(Fv);
                  return !(
                    (t && window.innerWidth >= theme.sizes.small) ||
                    (e && window.innerWidth < theme.sizes.small)
                  );
                }
                showPopupIfNoCookie() {
                  (this.showPopup(), this.toggle.dispatchEvent(new Event("click")));
                }
                initPopupToggleButton() {
                  this.toggle.addEventListener("click", (t) => {
                    (t.preventDefault(),
                      this.popup.classList.toggle(xv),
                      this.popup.classList.contains(xv) ? this.scrollLock() : this.scrollUnlock());
                  });
                }
                showPopup() {
                  const t = { id: this.popupId, body: this.popup };
                  (_v.push(t),
                    this.a11y.trapFocus({ container: this.popupBody }),
                    !0 === this.checkPopupTarget() &&
                      ((zv += 1), document.body.classList.add(Dv), this.popup.classList.add(Iv)));
                }
                hidePopup() {
                  (this.popup.classList.remove(Iv), document.body.classList.remove(Dv));
                  const t = _v.findIndex((t) => t.id === this.popupId);
                  if ((_v.splice(t, 1), zv >= 1 && (zv -= 1), zv < 1))
                    (this.scrollUnlock(), this.a11y.removeTrapFocus());
                  else if (_v.length > 0) {
                    const t = _v[_v.length - 1].body;
                    this.a11y.trapFocus({ container: t });
                  }
                }
                initClosers() {
                  (this.close.addEventListener("click", this.closePopup.bind(this)),
                    this.underlay.addEventListener("click", () => this.toggle.dispatchEvent(new Event("click"))),
                    this.popupContainer.addEventListener("keyup", (t) => {
                      t.code === theme.keyboardKeys.ESCAPE && (this.popup.classList.remove(xv), this.scrollUnlock());
                    }));
                }
                closePopup(t) {
                  (t.preventDefault(), this.cookie.write(), this.hidePopup());
                }
                scrollLock() {
                  document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popupBody }));
                }
                scrollUnlock() {
                  (this.resetScrollUnlock(),
                    (Bv = setTimeout(() => {
                      document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                    }, 300)));
                }
                resetScrollUnlock() {
                  Bv && clearTimeout(Bv);
                }
                onBlockSelect(t) {
                  this.popupContainer.contains(t.target) &&
                    !this.popup.classList.contains(Iv) &&
                    (this.showPopup(),
                    this.popup.classList.add(xv),
                    this.popup.classList.add(Tv),
                    this.popup.parentNode.classList.add(Pv),
                    this.resetScrollUnlock(),
                    this.scrollLock());
                }
                onBlockDeselect(t) {
                  this.popupContainer.contains(t.target) &&
                    (this.popup.classList.remove(xv),
                    this.popup.classList.remove(Tv),
                    this.popup.parentNode.classList.remove(Pv),
                    this.hidePopup());
                }
                onUnload() {
                  this.scrollUnlock();
                }
                onDeselect() {
                  (this.popup.classList.remove(xv),
                    this.popup.classList.remove(Tv),
                    this.popup.parentNode.classList.remove(Pv),
                    this.hidePopup());
                }
                constructor(t) {
                  ((this.popupContainer = t),
                    (this.popup = this.popupContainer.querySelector(vv)),
                    (this.popupBody = this.popup.querySelector(bv)),
                    (this.popupId = this.popup.id),
                    (this.close = this.popup.querySelector(Sv)),
                    (this.underlay = this.popup.querySelector(Ev)),
                    (this.toggle = this.popup.querySelector(wv)),
                    (this.cookie = new $g(this.popupContainer.dataset.cookieName, "user_has_closed")),
                    (this.form = this.popup.querySelector(Lv)),
                    (this.isTargeted = new Rv(this.popupContainer)),
                    (this.a11y = window.theme.a11y),
                    this.init());
                }
              })(t),
            );
          });
        const i = this.container.querySelectorAll(mv);
        i.length &&
          i.forEach((t) => {
            Ov[this.id].push(
              new (class {
                init() {
                  (this.enableTracking && this.showPopup(), this.clickEvents());
                }
                clickEvents() {
                  (this.close.addEventListener("click", (t) => {
                    (t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, () => this.hidePopup()));
                  }),
                    this.acceptButton.addEventListener("click", (t) => {
                      (t.preventDefault(),
                        window.Shopify.customerPrivacy.setTrackingConsent(!0, () => this.hidePopup()));
                    }),
                    document.addEventListener("trackingConsentAccepted", () => {
                      console.log("trackingConsentAccepted event fired");
                    }));
                }
                showPopup() {
                  const t = { id: this.popupId, body: this.popup };
                  (_v.push(t), this.popup.classList.add(Iv), this.a11y.trapFocus({ container: this.popup }));
                }
                hidePopup() {
                  this.popup.classList.remove(Iv);
                  const t = _v.findIndex((t) => t.id === this.popupId);
                  if ((_v.splice(t, 1), zv < 1)) this.a11y.removeTrapFocus();
                  else if (_v.length > 0) {
                    const t = _v[_v.length - 1].body;
                    this.a11y.trapFocus({ container: t });
                  }
                }
                onBlockSelect(t) {
                  this.popupContainer.contains(t.target) &&
                    this.enableTracking &&
                    !this.popup.classList.contains(Iv) &&
                    (this.showPopup(), this.popup.classList.add(Tv), this.popup.parentNode.classList.add(Pv));
                }
                onBlockDeselect(t) {
                  this.popupContainer.contains(t.target) &&
                    (this.popup.classList.remove(Tv), this.popupContainer.classList.remove(Pv), this.hidePopup());
                }
                onDeselect() {
                  (this.popup.classList.remove(Tv), this.popupContainer.classList.remove(Pv), this.hidePopup());
                }
                constructor(t) {
                  ((this.popupContainer = t),
                    (this.popup = this.popupContainer.querySelector(gv)),
                    (this.popupId = this.popup.id),
                    (this.close = this.popup.querySelector(Sv)),
                    (this.acceptButton = this.popup.querySelector(yv)),
                    (this.enable = "true" === this.popupContainer.dataset.enable),
                    (this.a11y = window.theme.a11y),
                    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (t) => {
                      if (t) throw t;
                      const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                        i = window.Shopify.customerPrivacy.getTrackingConsent();
                      ((this.enableTracking = !e && "no_interaction" === i && this.enable),
                        window.Shopify.designMode && (this.enableTracking = !0),
                        this.init());
                    }));
                }
              })(t),
            );
          });
      },
      onDeselect() {
        Ov[this.id].forEach((t) => {
          "function" == typeof t.onDeselect && t.onDeselect();
        });
      },
      onBlockSelect(t) {
        Ov[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        Ov[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
      onUnload(t) {
        Ov[this.id].forEach((e) => {
          "function" == typeof e.onUnload && e.onUnload(t);
        });
      },
    },
    Yg,
  ]);
  const Vv = "[data-press-items]",
    Nv = "[data-logo-slider]",
    Wv = "[data-logo-slide]",
    Uv = "a, button",
    jv = "data-logo-index",
    Gv = "tabindex";
  let Kv = {};
  const Qv = {
    onLoad() {
      Kv[this.id] = new (class {
        checkSlides() {
          const t = this.container.offsetWidth,
            e = this.container.querySelectorAll(Wv),
            i = window.theme.Flickity.data(this.sliderNav) || null;
          null !== i &&
            ((i.options.draggable = !1),
            (i.options.wrapAround = !1),
            (i.options.contain = !0),
            this.getSlidesWidth() > t &&
              e.length > 2 &&
              ((i.options.draggable = !0), (i.options.wrapAround = !0), (i.options.contain = !1)),
            i.resize(),
            i.updateDraggable());
        }
        getSlidesWidth() {
          const t = this.container.querySelectorAll(Wv);
          let e = 0;
          return (
            t.length &&
              t.forEach((t) => {
                e += t.offsetWidth;
              }),
            e
          );
        }
        initSlider() {
          let t = window.theme.Flickity.data(this.slider) || null,
            e = window.theme.Flickity.data(this.sliderNav) || null;
          const i = parseInt(this.container.dataset.duration),
            s = "true" === this.container.dataset.autoplay && i;
          ((t = new window.theme.Flickity(this.slider, {
            fade: !0,
            wrapAround: !0,
            adaptiveHeight: !1,
            prevNextButtons: !1,
            pageDots: !1,
            autoPlay: s,
            on: {
              ready: () => {
                requestAnimationFrame(() => {
                  document.dispatchEvent(new CustomEvent("theme:resize:width"));
                });
              },
            },
          })),
            (e = new window.theme.Flickity(this.sliderNav, {
              draggable: !1,
              wrapAround: !1,
              contain: !0,
              imagesLoaded: !0,
              asNavFor: this.slider,
              prevNextButtons: !1,
              adaptiveHeight: !1,
              pageDots: !1,
              on: {
                ready: () => {
                  const e = this.container.querySelectorAll(Wv);
                  (requestAnimationFrame(() => {
                    document.dispatchEvent(new CustomEvent("theme:resize:width"));
                  }),
                    e.forEach((e) => {
                      e.addEventListener("keyup", (i) => {
                        if (
                          i.code === theme.keyboardKeys.ENTER ||
                          i.code === theme.keyboardKeys.NUMPADENTER ||
                          i.code === theme.keyboardKeys.SPACE
                        ) {
                          const i = Number(e.getAttribute(jv));
                          t.selectCell(i);
                        }
                      });
                    }));
                },
              },
            })),
            window.theme.flickitySmoothScrolling(this.slider),
            window.theme.flickitySmoothScrolling(this.sliderNav),
            e.on("change", (e) => {
              t.selectCell(e);
            }),
            t.on("change", (e) => {
              t.cells.forEach((t, i) => {
                t.element.querySelectorAll(Uv).forEach((t) => {
                  t.setAttribute(Gv, i === e ? "0" : "-1");
                });
              });
            }));
        }
        resizeSlider() {
          const t = window.theme.Flickity.data(this.slider) || null,
            e = window.theme.Flickity.data(this.sliderNav) || null;
          null !== t && (t.resize(), null !== e && e.resize());
        }
        onBlockSelect(t) {
          const e = window.theme.Flickity.data(this.slider) || null,
            i = parseInt([...t.target.parentNode.children].indexOf(t.target));
          null !== e &&
            setTimeout(() => {
              (e.select(i), e.pausePlayer());
            });
        }
        onBlockDeselect() {
          const t = window.theme.Flickity.data(this.slider) || null;
          "true" === this.container.dataset.autoplay && null !== t && t.playPlayer();
        }
        onUnload() {
          (document.removeEventListener("theme:resize:width", this.checkSlidesEvent),
            document.removeEventListener("theme:resize:width", this.sliderResizeEvent));
        }
        constructor(t) {
          ((this.container = t.container),
            (this.slider = this.container.querySelector(Vv)),
            (this.sliderNav = this.container.querySelector(Nv)),
            (this.checkSlidesEvent = () => this.checkSlides()),
            (this.sliderResizeEvent = () => this.resizeSlider()),
            this.initSlider(),
            this.checkSlides(),
            this.resizeSlider(),
            document.addEventListener("theme:resize:width", this.checkSlidesEvent),
            document.addEventListener("theme:resize:width", this.sliderResizeEvent));
        }
      })(this);
    },
    onUnload(t) {
      Kv[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      Kv[this.id].onBlockSelect(t);
    },
    onBlockDeselect() {
      Kv[this.id].onBlockDeselect();
    },
  };
  rl("press", Qv);
  const Xv = "[data-product-single-media-slider]",
    Yv = "[data-product-info]",
    Jv = "[data-header-sticky]",
    Zv = "[data-header-height]",
    tw = "is-sticky",
    ew = "data-sticky-enabled";
  window.theme.variables = { productPageSticky: !1 };
  const iw = {};
  const sw = {
      onLoad() {
        iw[this.id] = new (class {
          init() {
            (this.stickyEnabled &&
              (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)),
              this.initSticky());
          }
          initSticky() {
            theme.variables.productPageSticky &&
              ((this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition())),
              this.productInfo.addEventListener("theme:form:sticky", (t) => {
                (this.removeAnimationFrame(),
                  (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t))));
              }),
              document.addEventListener("theme:scroll", this.scrollEvent));
          }
          scrollEvents(t) {
            (null !== t.detail && ((this.scrollTop = t.detail.position), (this.scrollDirectionDown = t.detail.down)),
              this.requestAnimationSticky ||
                (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition())));
          }
          resizeEvents() {
            (this.stickyScrollCheck(),
              document.removeEventListener("theme:scroll", this.scrollEvent),
              this.initSticky());
          }
          stickyScrollCheck() {
            const t =
                (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >=
                window.theme.sizes.large,
              e = this.container.querySelector(Yv);
            if (e)
              if (t) {
                const t = this.container.querySelector(Yv),
                  i = this.container.querySelector(Xv);
                if (!t || !i) return;
                t.offsetHeight < i.offsetHeight
                  ? ((theme.variables.productPageSticky = !0), e.classList.add(tw))
                  : ((theme.variables.productPageSticky = !1), e.classList.remove(tw));
              } else ((theme.variables.productPageSticky = !1), e.classList.remove(tw));
          }
          calculateStickyPosition(t = null) {
            const e = Boolean(t && t.detail),
              i = Boolean(e && t.detail.element && "accordion" === t.detail.element),
              s = this.productInfo.offsetHeight,
              o = window.innerHeight - s - this.defaultTopBottomSpacings,
              n = Math.abs(this.scrollTop - this.scrollLastPosition);
            (this.scrollDirectionDown ? (this.stickyScrollTop -= n) : (this.stickyScrollTop += n),
              this.stickyFormLoad &&
                (document.querySelector(Jv) && document.querySelector(Zv)
                  ? (this.stickyDefaultTop = parseInt(document.querySelector(Zv).getBoundingClientRect().height))
                  : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
                (this.stickyScrollTop = this.stickyDefaultTop)),
              (this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop)));
            const r = this.stickyScrollTop - this.currentPoint;
            ((this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + 0.5 * r),
              this.productInfo.style.setProperty("--sticky-top", `${this.currentPoint}px`),
              (this.scrollLastPosition = this.scrollTop),
              (this.stickyFormLoad = !1),
              (i && this.onChangeCounter <= 10) ||
              (i && this.stickyFormLastHeight !== s) ||
              (this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky)
                ? (i && (this.onChangeCounter += 1),
                  i && this.stickyFormLastHeight !== s && (this.onChangeCounter = 11),
                  (this.requestAnimationSticky = requestAnimationFrame(() => this.calculateStickyPosition(t))))
                : this.requestAnimationSticky && this.removeAnimationFrame(),
              (this.stickyFormLastHeight = s));
          }
          removeAnimationFrame() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null),
              (this.onChangeCounter = 0));
          }
          onUnload() {
            (this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent),
              theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent));
          }
          constructor(t) {
            ((this.container = t.container),
              (this.stickyEnabled = "true" === this.container.getAttribute(ew)),
              (this.productInfo = this.container.querySelector(Yv)),
              (this.stickyScrollTop = 0),
              (this.scrollLastPosition = 0),
              (this.stickyDefaultTop = 0),
              (this.currentPoint = 0),
              (this.defaultTopBottomSpacings = 30),
              (this.scrollTop = window.scrollY),
              (this.scrollDirectionDown = !0),
              (this.requestAnimationSticky = null),
              (this.stickyFormLoad = !0),
              (this.stickyFormLastHeight = null),
              (this.onChangeCounter = 0),
              (this.scrollEvent = (t) => this.scrollEvents(t)),
              (this.resizeEvent = (t) => this.resizeEvents(t)),
              this.init());
          }
        })(this);
      },
      onUnload() {
        iw[this.id].onUnload();
      },
    },
    ow = "[data-product-single-media-group]",
    nw = "[data-product-single-media-slider]",
    rw = "[data-zoom-wrapper]",
    aw = "pswp-zoom-gallery",
    lw = "pswp-zoom-gallery--single",
    cw = "is-moving",
    hw = "data-image-width",
    dw = "data-image-height";
  const uw = "[data-complementary-products]",
    pw = "[data-button-quick-view]",
    mw = "[data-complementary-slider]",
    gw = "a, button",
    yw = ".complementary-products__item",
    fw = "data-url",
    vw = "tabindex",
    ww = "is-selected";
  let bw = class extends HTMLElement {
    connectedCallback() {
      new IntersectionObserver(
        ((t, e) => {
          t[0].isIntersecting &&
            (e.unobserve(this),
            this.hasAttribute(fw) &&
              "" !== this.getAttribute(fw) &&
              fetch(this.getAttribute(fw))
                .then((t) => t.text())
                .then((t) => {
                  const e = document.createElement("div");
                  e.innerHTML = t;
                  const i = e.querySelector(uw);
                  (i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML),
                    e.querySelector(pw) && new li(this),
                    this.initComplementarySlider());
                })
                .catch((t) => {
                  console.error(t);
                }));
        }).bind(this),
        { rootMargin: "0px 0px 400px 0px" },
      ).observe(this);
    }
    initComplementarySlider() {
      const t = this.querySelector(mw);
      if (!t) return;
      const e = this.querySelectorAll(yw);
      if (e.length > 1) {
        const i = new window.theme.Flickity(t, {
          wrapAround: !0,
          pageDots: !0,
          adaptiveHeight: !0,
          prevNextButtons: !1,
          on: {
            ready: () => {
              e.forEach((t) => {
                if (!t.classList.contains(ww)) {
                  const e = t.querySelectorAll(gw);
                  e.length &&
                    e.forEach((t) => {
                      t.setAttribute(vw, "-1");
                    });
                }
              });
            },
          },
        });
        i.on("change", (t) => {
          i.cells.forEach((e, i) => {
            const s = e.element.querySelectorAll(gw);
            s.length &&
              s.forEach((e) => {
                e.setAttribute(vw, i === t ? "0" : "-1");
              });
          });
        });
      }
    }
    constructor() {
      super();
    }
  };
  const Sw = "[data-recipient-checkbox]",
    Ew = "[data-recipient-email]",
    Lw = "[data-recipient-name]",
    kw = "[data-recipient-message]",
    Aw = "[data-recipient-send-on]",
    Cw = "[data-recipient-control]",
    qw = "[data-recipient-offset]",
    Tw = "[data-product-form]",
    Pw = "[data-cart-drawer]",
    xw = "js-quick-view-visible";
  let Iw = class extends HTMLElement {
    connectedCallback() {
      this.recipientCheckbox &&
        (this.disableInputFields(),
        this.recipientCheckbox.addEventListener("change", this.onChangeEvent),
        document.addEventListener("theme:cart:added", this.onCartAddedEvent));
    }
    onChange(t) {
      if (!t.target.checked) return (this.clearInputFields(), void this.disableInputFields());
      this.enableInputFields();
    }
    onCartAdded() {
      const t = this.closest(Tw).offsetTop,
        e = document.body.classList.contains(xw);
      if (!(!0 === this.recipientCheckbox.checked)) return;
      e || window.scrollTo({ top: t, left: 0, behavior: "smooth" });
      const i = (t) => {
        t.target === this.cartDrawer &&
          (requestAnimationFrame(() => {
            ((this.recipientCheckbox.checked = !1), this.recipientCheckbox.dispatchEvent(new Event("change")));
          }),
          this.cartDrawer.removeEventListener("transitionend", i));
      };
      this.cartDrawer.addEventListener("transitionend", i);
    }
    inputFields() {
      return [this.recipientEmail, this.recipientName, this.recipientMessage, this.recipientSendOn];
    }
    disableableFields() {
      return [...this.inputFields(), this.recipientOffset];
    }
    clearInputFields() {
      this.inputFields().forEach((t) => (t.value = ""));
    }
    enableInputFields() {
      this.disableableFields().forEach((t) => (t.disabled = !1));
    }
    disableInputFields() {
      this.disableableFields().forEach((t) => (t.disabled = !0));
    }
    disconnectedCallback() {
      (this.recipientCheckbox.removeEventListener("change", this.onChangeEvent),
        document.removeEventListener("theme:cart:added", this.onCartAddedEvent));
    }
    constructor() {
      (super(),
        (this.recipientCheckbox = this.querySelector(Sw)),
        (this.recipientControl = this.querySelector(Cw)),
        (this.recipientControl.disabled = !0),
        (this.recipientEmail = this.querySelector(Ew)),
        (this.recipientName = this.querySelector(Lw)),
        (this.recipientMessage = this.querySelector(kw)),
        (this.recipientSendOn = this.querySelector(Aw)),
        (this.recipientOffset = this.querySelector(qw)),
        this.recipientOffset && (this.recipientOffset.value = new Date().getTimezoneOffset()),
        (this.cartDrawer = document.querySelector(Pw)),
        (this.onChangeEvent = (t) => this.onChange(t)),
        (this.onCartAddedEvent = () => this.onCartAdded()));
    }
  };
  const Hw = "[data-product-single-media-slider]",
    Fw = "[data-thumbnail-id]",
    Mw = "[data-product-single-media-thumbs]",
    Dw = "[data-product-single-media-wrapper]",
    Ow = "[data-model]",
    Bw = ".product-single__thumbnail-link",
    zw = "[data-deferred-media]",
    _w = "[data-deferred-media-button]",
    $w = "a, button",
    Rw = "[data-upsell-holder]",
    Vw = "[data-upsell-slider]",
    Nw = "[data-slider]",
    Ww = "[data-product-json]",
    Uw = "featured-product",
    jw = "featured-product--onboarding",
    Gw = "has-media-active",
    Kw = "is-selected",
    Qw = "media--hidden",
    Xw = "no-outline",
    Yw = "is-moving",
    Jw = "data-media-id",
    Zw = "data-section-id",
    tb = "data-thumbnail-id",
    eb = "data-tall-layout",
    ib = "loaded",
    sb = "tabindex",
    ob = "aria-hidden",
    nb = {};
  const rb = {
    onLoad() {
      nb[this.id] = new (class {
        productSlider() {
          (this.checkSlider(), document.addEventListener("theme:resize:width", this.checkSliderOnResize));
        }
        checkSlider() {
          !this.tallLayout || window.innerWidth < theme.sizes.large
            ? this.initProductSlider()
            : this.destroyProductSlider();
        }
        resizeFlickityNav() {
          null !== this.flktyNav && this.flktyNav.resize();
        }
        initProductSlider() {
          const t = this.container.querySelector(Hw),
            e = this.container.querySelector(Mw),
            i = this.container.querySelectorAll(Dw);
          if (
            i.length > 1 &&
            ((this.flkty = new window.theme.Flickity(t, {
              wrapAround: !0,
              pageDots: !1,
              adaptiveHeight: !0,
              on: {
                ready: () => {
                  (this.slidesAriaHidden(t),
                    i.forEach((t) => {
                      if (!t.classList.contains(Kw)) {
                        const e = t.querySelectorAll($w);
                        e.length &&
                          e.forEach((t) => {
                            t.setAttribute(sb, "-1");
                          });
                      }
                    }));
                },
                dragStart: () => {
                  t.classList.add(Yw);
                },
                dragMove: () => {
                  this.isFlickityDragging = !0;
                },
                staticClick: () => {
                  this.isFlickityDragging = !1;
                },
                change: () => {
                  this.slidesAriaHidden(t);
                },
                settle: (e) => {
                  const i = this.flkty.selectedElement.getAttribute(Jw);
                  (this.flkty.cells.forEach((t, i) => {
                    const s = t.element.querySelectorAll($w);
                    s.length &&
                      s.forEach((t) => {
                        t.setAttribute(sb, i === e ? "0" : "-1");
                      });
                  }),
                    this.switchMedia(i),
                    t.classList.remove(Yw));
                },
              },
            })),
            i.length &&
              i.forEach((t) => {
                (t.addEventListener("theme:media:play", () => {
                  ((this.flkty.options.draggable = !1), this.flkty.updateDraggable(), t.closest(Hw).classList.add(Gw));
                }),
                  t.addEventListener("theme:media:pause", () => {
                    ((this.flkty.options.draggable = !0),
                      this.flkty.updateDraggable(),
                      t.closest(Hw).classList.remove(Gw));
                  }));
              }),
            window.theme.flickitySmoothScrolling(t),
            null !== e)
          ) {
            this.flktyNav = new window.theme.Flickity(e, {
              asNavFor: t,
              contain: !0,
              pageDots: !1,
              prevNextButtons: !1,
              resize: !0,
              on: {
                ready: () => {
                  (e.setAttribute(sb, "-1"), this.slidesAriaHidden(e), requestAnimationFrame(this.flktyNavOnResize));
                },
                change: () => {
                  this.slidesAriaHidden(e);
                },
              },
            });
            const i = () => {
              (requestAnimationFrame(this.flktyNavOnResize),
                this.flktyNav.viewport.removeEventListener("transitionend", i));
            };
            (null !== this.flktyNav &&
              (document.addEventListener("theme:resize:width", this.flktyNavOnResize),
              this.flktyNav.viewport.addEventListener("transitionend", i)),
              window.theme.flickitySmoothScrolling(e));
            const s = this.container.querySelectorAll(Bw);
            s.length &&
              s.forEach((t) => {
                t.addEventListener("click", (t) => {
                  t.preventDefault();
                });
              });
          }
        }
        slidesAriaHidden(t) {
          window.theme.Flickity.data(t).cells.forEach((t) => t.element.setAttribute(ob, "false"));
        }
        destroyProductSlider() {
          null !== this.flkty &&
            (this.flkty.destroy(), this.flktyNav.destroy(), (this.flkty = null), (this.flktyNav = null));
        }
        initUpsellSlider() {
          const t = this.container.querySelector(Vw),
            e = this.container.querySelectorAll(Rw);
          if (e.length > 1) {
            const i = new window.theme.Flickity(t, {
              wrapAround: !0,
              pageDots: !0,
              adaptiveHeight: !0,
              prevNextButtons: !1,
              on: {
                ready: () => {
                  e.forEach((t) => {
                    if (!t.classList.contains(Kw)) {
                      const e = t.querySelectorAll($w);
                      e.length &&
                        e.forEach((t) => {
                          t.setAttribute(sb, "-1");
                        });
                    }
                  });
                },
              },
            });
            i.on("change", (t) => {
              i.cells.forEach((e, i) => {
                const s = e.element.querySelectorAll($w);
                s.length &&
                  s.forEach((e) => {
                    e.setAttribute(sb, i === t ? "0" : "-1");
                  });
              });
            });
          }
        }
        initFeatureSlider() {
          this.featureSliders.forEach((t) => {
            const e = Array.from(t.children);
            e.length > 1 &&
              new window.theme.Flickity(t, {
                wrapAround: !0,
                pageDots: !0,
                adaptiveHeight: !0,
                prevNextButtons: !1,
                on: {
                  ready: function () {
                    e.forEach((t) => {
                      if (!t.classList.contains(Kw)) {
                        const e = t.querySelectorAll($w);
                        e.length &&
                          e.forEach((t) => {
                            t.setAttribute(sb, "-1");
                          });
                      }
                    });
                  },
                },
              }).on("change", (t) => {
                e.forEach((e, i) => {
                  const s = e.querySelectorAll($w);
                  s.length &&
                    s.forEach((e) => {
                      e.setAttribute(sb, i === t ? "0" : "-1");
                    });
                });
              });
          });
        }
        handleMediaFocus(t) {
          if (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.TAB) return;
          const e = t.currentTarget.getAttribute(tb),
            i = this.container.querySelector(`[${Jw}="${e}"]`),
            s = parseInt([...i.parentNode.children].indexOf(i)),
            o = this.container.querySelector(Hw),
            n = this.container.querySelector(Mw),
            r = window.theme.Flickity.data(o) || null,
            a = window.theme.Flickity.data(n) || null;
          (r &&
            r.isActive &&
            s > -1 &&
            (t.code === theme.keyboardKeys.ENTER || t.code === theme.keyboardKeys.NUMPADENTER) &&
            r.select(s),
            a && a.isActive && s > -1 && a.select(s));
        }
        switchMedia(t) {
          const e = document.querySelectorAll(`${Dw}`),
            i = this.container.querySelector(`${Dw}[${Jw}="${t}"]`),
            s = !document.body.classList.contains(Xw);
          (e.length &&
            e.forEach((t) => {
              (t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }), t.classList.add(Qw));
            }),
            s && i.focus(),
            i.closest(Hw).classList.remove(Gw),
            i.classList.remove(Qw),
            i.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 }));
          const o = i.querySelector(zw);
          o && "true" !== o.getAttribute(ib) && i.querySelector(_w).dispatchEvent(new Event("click"));
        }
        initMediaSwitch() {
          const t = this.container.querySelectorAll(Fw);
          t.length &&
            t.forEach((t) => {
              (t.addEventListener("keyup", this.handleMediaFocus.bind(this)),
                t.addEventListener("click", (t) => {
                  t.preventDefault();
                }));
            });
        }
        initProductVideo() {
          this.videos = new G(this.container);
        }
        initProductModel() {
          const t = this.container.querySelectorAll(Ow);
          t.length &&
            t.forEach((t) => {
              theme.ProductModel.init(t, this.sectionId);
            });
        }
        initShopifyXrLaunch() {
          document.addEventListener("shopify_xr_launch", () => {
            this.container.querySelector(`${Ow}:not(.${Qw})`).dispatchEvent(new CustomEvent("xrLaunch"));
          });
        }
        onUnload() {
          (null !== this.flktyNav && document.removeEventListener("theme:resize:width", this.flktyNavOnResize),
            document.removeEventListener("theme:resize:width", this.checkSliderOnResize));
        }
        onBlockSelect(t) {
          const e = window.theme.Flickity.data(t.target.closest(Nw)),
            i = parseInt([...t.target.parentNode.children].indexOf(t.target));
          e && e.select(i);
        }
        constructor(t) {
          if (
            ((this.container = t.container),
            (this.sectionId = this.container.getAttribute(Zw)),
            (this.tallLayout = "true" === this.container.getAttribute(eb)),
            (this.featureSliders = this.container.querySelectorAll(Nw)),
            (this.flkty = null),
            (this.flktyNav = null),
            (this.isFlickityDragging = !1),
            (this.enableHistoryState = !this.container.classList.contains(Uw)),
            (this.checkSliderOnResize = () => this.checkSlider()),
            (this.flktyNavOnResize = () => this.resizeFlickityNav()),
            this.initUpsellSlider(),
            this.initFeatureSlider(),
            new li(this.container),
            this.container.classList.contains(jw))
          )
            return;
          const e = this.container.querySelector(Ww);
          if (e && e.innerHTML) {
            const t = JSON.parse(e.innerHTML).handle;
            let i = {};
            (t && (i = { handle: t }), Shopify.Products.recordRecentlyViewed(i));
          } else Shopify.Products.recordRecentlyViewed();
          (new (class {
            init() {
              this.zoomWrappers.length &&
                this.zoomWrappers.forEach((t, e) => {
                  t.addEventListener("click", (i) => {
                    (i.preventDefault(),
                      (this.slider && this.slider.classList.contains(cw)) ||
                        ((this.a11y.state.trigger = t), this.createZoom(e)));
                  });
                });
            }
            createZoom(t) {
              const e = this;
              let i = [],
                s = 0;
              this.zoomWrappers.forEach((o) => {
                const n = o.getAttribute("href"),
                  r = parseInt(o.getAttribute(hw)),
                  a = parseInt(o.getAttribute(dw));
                if ((i.push({ src: n, w: r, h: a, msrc: n }), (s += 1), e.zoomWrappers.length === s)) {
                  let e = `${aw}`;
                  1 === s && (e = `${aw} ${lw}`);
                  const o = {
                    barsSize: { top: 60, bottom: 60 },
                    history: !1,
                    focus: !1,
                    index: t,
                    mainClass: e,
                    showHideOpacity: !0,
                    showAnimationDuration: 250,
                    hideAnimationDuration: 250,
                    closeOnScroll: !1,
                    closeOnVerticalDrag: !1,
                    captionEl: !1,
                    closeEl: !0,
                    closeElClasses: ["caption-close"],
                    tapToClose: !1,
                    clickToCloseNonZoomable: !1,
                    maxSpreadZoom: 2,
                    loop: !0,
                    spacing: 0,
                    allowPanToNext: !0,
                    pinchToClose: !1,
                  };
                  new window.theme.LoadPhotoswipe(i, o);
                }
              });
            }
            constructor(t) {
              ((this.container = t),
                (this.mediaContainer = this.container.querySelector(ow)),
                (this.slider = this.container.querySelector(nw)),
                (this.zoomWrappers = this.container.querySelectorAll(rw)),
                (this.zoomEnable = "true" === this.mediaContainer.dataset.gallery),
                (this.a11y = window.theme.a11y),
                this.zoomEnable && this.init());
            }
          })(this.container),
            this.productSlider(),
            this.initMediaSwitch(),
            this.initProductVideo(),
            this.initProductModel(),
            this.initShopifyXrLaunch());
        }
      })(this);
    },
    onUnload: function () {
      nb[this.id].onUnload();
    },
    onBlockSelect(t) {
      nb[this.id].onBlockSelect(t);
    },
  };
  (rl("product-template", [xr, rb, Ve, Ne, gm, ut, Nt, Uo, sw]),
    rl("featured-product", [xr, rb, Ve, Ne, gm, ut, Nt, Uo, sw]),
    customElements.get("complementary-products") || customElements.define("complementary-products", bw),
    customElements.get("recipient-form") || customElements.define("recipient-form", Iw));
  const ab = "href",
    lb = "data-media-id",
    cb = "data-deferred-media-loaded",
    hb = "[data-product-content-wrapper]",
    db = "[data-product-single-media-wrapper]",
    ub = "[data-model]",
    pb = "[data-product-link]",
    mb = "[data-product-single-media-image]",
    gb = "[data-slider-contents]",
    yb = "[data-slider-images]",
    fb = "[data-tab-button]",
    vb = "[data-tab-item]",
    wb = "[data-circle-text]",
    bb = {
      aosAnimate: "aos-animate",
      tabButtonActive: "products-list__nav__button--active",
      tabItemActive: "products-list__item--active",
      mediaHidden: "media--hidden",
      isDisabled: "is-disabled",
    },
    Sb = {};
  rl("products-list", [
    {
      onLoad() {
        Sb[this.id] = new (class {
          listen() {
            (this.slidersImages.length > 0 || this.slidersContents.length > 0) &&
              document.addEventListener("theme:resize", this.sliderResizeEvent);
          }
          resizeSlider() {
            (this.flktyImages.length > 0 &&
              requestAnimationFrame(() => {
                this.flktyImages.forEach((t) => t.resize());
              }),
              this.flktyContent.length > 0 &&
                requestAnimationFrame(() => {
                  this.flktyContent.forEach((t) => t.resize());
                }));
          }
          initButtons() {
            this.tabButtons.length &&
              this.tabButtons.forEach((t) => {
                t.addEventListener("click", (e) => {
                  if (t.classList.contains(bb.tabButtonActive)) return;
                  const i = t.getAttribute(ab),
                    s = this.container.querySelector(i),
                    o = s.querySelector(db),
                    n = o ? o.dataset.mediaId : null,
                    r = s.querySelector(wb);
                  (this.tabButtons.forEach((t) => {
                    t.classList.remove(bb.tabButtonActive);
                  }),
                    this.tabItems.forEach((t) => {
                      const e = t.querySelector(wb);
                      (t.classList.remove(bb.tabItemActive),
                        null == e || e.classList.add(bb.isDisabled),
                        theme.settings.animationsEnabled &&
                          t.querySelectorAll(`.${bb.aosAnimate}`).forEach((t) => {
                            (t.classList.remove(bb.aosAnimate),
                              setTimeout(() => {
                                t.classList.add(bb.aosAnimate);
                              }));
                          }));
                    }),
                    t.classList.add(bb.tabButtonActive),
                    s.classList.add(bb.tabItemActive),
                    document.dispatchEvent(new CustomEvent("theme:resize")),
                    r && (r.classList.remove(bb.isDisabled), document.dispatchEvent(new CustomEvent("theme:scroll"))),
                    this.handleProductVideos(s, n),
                    e.preventDefault());
                });
              });
          }
          initSliders() {
            (this.slidersImages.forEach((t, e) => {
              const i = t.closest(vb).querySelector(gb),
                s = new window.theme.Flickity(t, {
                  fade: !0,
                  pageDots: !1,
                  prevNextButtons: !0,
                  wrapAround: !0,
                  adaptiveHeight: !0,
                  asNavFor: i,
                  on: {
                    change: (t) => {
                      this.flktyContent.length > 0 && this.flktyContent[e].select(t);
                    },
                  },
                });
              (s.on("settle", (e) => {
                const i = t.querySelectorAll(db);
                for (let t = 0; t < i.length; t++)
                  t === e
                    ? i[t].querySelector(mb).removeAttribute("tabindex")
                    : i[t].querySelector(mb).setAttribute("tabindex", "-1");
              }),
                this.flktyImages.push(s));
            }),
              this.slidersContents.forEach((t) => {
                const e = new window.theme.Flickity(t, {
                  fade: !0,
                  pageDots: !1,
                  prevNextButtons: !1,
                  wrapAround: !0,
                  adaptiveHeight: !0,
                });
                (e.on("settle", (e) => {
                  const i = t.querySelectorAll(hb);
                  for (let t = 0; t < i.length; t++)
                    t === e
                      ? i[t].querySelectorAll(pb).forEach((t) => {
                          t.removeAttribute("tabindex");
                        })
                      : i[t].querySelectorAll(pb).forEach((t) => {
                          t.setAttribute("tabindex", "-1");
                        });
                }),
                  this.flktyContent.push(e));
              }));
          }
          initProductVideos() {
            this.tabItems.forEach((t) => {
              t.classList.contains(bb.tabItemActive) && this.handleProductVideos(t);
            });
          }
          loadVideos(t, e = null) {
            new IntersectionObserver(
              (i, s) => {
                i.forEach((i) => {
                  if (i.isIntersecting) {
                    const o = new G(t);
                    (this.videos.push(o), t.setAttribute(cb, ""), this.playToggle(e), s.unobserve(i.target));
                  }
                });
              },
              { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] },
            ).observe(t);
          }
          handleProductVideos(t, e = null) {
            t.hasAttribute(cb) ? this.playToggle(e) : this.loadVideos(t, e);
          }
          playToggle(t) {
            this.videos.forEach((e) => {
              ("function" == typeof e.pauseContainerMedia &&
                t &&
                (e.pauseContainerMedia(t, this.container), this.switchMedia(t)),
                t || 0 !== Object.keys(e.players).length || this.pauseContainerMedia(this.container));
            });
          }
          switchMedia(t) {
            const e = this.container.querySelector(`${db}[${lb}="${t}"]`);
            (!document.body.classList.contains(bb.noOutline) && e.focus(),
              e.classList.remove(bb.mediaHidden),
              e.dispatchEvent(new CustomEvent("theme:media:visible"), { bubbles: !0 }));
          }
          pauseContainerMedia(t) {
            const e = t.querySelectorAll(db);
            0 !== e.length &&
              e.forEach((t) => {
                (t.dispatchEvent(new CustomEvent("theme:media:hidden"), { bubbles: !0 }),
                  t.classList.add(bb.mediaHidden));
              });
          }
          initProductModel() {
            const t = this.container.querySelectorAll(ub);
            t.length &&
              t.forEach((t) => {
                theme.ProductModel.init(t, this.sectionId);
              });
          }
          initShopifyXrLaunch() {
            document.addEventListener("shopify_xr_launch", () => {
              this.container.querySelector(`${ub}:not(.${bb.mediaHidden})`).dispatchEvent(new CustomEvent("xrLaunch"));
            });
          }
          onBlockSelect(t) {
            t.target.dispatchEvent(new Event("click"));
          }
          onUnload() {
            (this.slidersImages.length > 0 || this.slidersContents.length > 0) &&
              document.removeEventListener("theme:resize", this.sliderResizeEvent);
          }
          constructor(t) {
            ((this.container = t.container),
              (this.sectionId = this.container.dataset.sectionId),
              (this.tabButtons = this.container.querySelectorAll(fb)),
              (this.tabItems = this.container.querySelectorAll(vb)),
              (this.slidersImages = this.container.querySelectorAll(yb)),
              (this.slidersContents = this.container.querySelectorAll(gb)),
              (this.videos = []),
              (this.flktyImages = []),
              (this.flktyContent = []),
              (this.sliderResizeEvent = () => this.resizeSlider()),
              this.initButtons(),
              this.initSliders(),
              this.initProductVideos(),
              this.initProductModel(),
              this.initShopifyXrLaunch(),
              this.listen());
          }
        })(this);
      },
      onUnload() {
        Sb[this.id].onUnload();
      },
      onBlockSelect(t) {
        Sb[this.id].onBlockSelect(t);
      },
    },
    op,
  ]);
  const Eb = "[data-product-block]",
    Lb = "[data-related-products]",
    kb = "[data-recent-wrapper]",
    Ab = "[data-recently-viewed-wrapper]",
    Cb = "[data-slider]",
    qb = "[data-slide]",
    Tb = "[data-aos]",
    Pb = "[data-tabs-holder]",
    xb = "[data-tabs-link]",
    Ib = "[data-tab]",
    Hb = "[data-tooltip]",
    Fb = "data-section-id",
    Mb = "data-product-id",
    Db = "data-limit",
    Ob = "data-minimum",
    Bb = "data-tabs-link",
    zb = "data-column-mobile",
    _b = "hidden",
    $b = "aos-animate",
    Rb = "mobile--one-whole",
    Vb = "mobile--one-half",
    Nb = {};
  const Wb = {
    onLoad() {
      Nb[this.id] = new (class {
        related() {
          if (((this.relatedProducts = this.container.querySelector(Lb)), !this.relatedProducts)) return;
          const t = this.container.getAttribute(Fb),
            e = this.container.getAttribute(Mb),
            i = this.container.getAttribute(Db),
            s = `${theme.routes.product_recommendations_url}?section_id=${t}&limit=${i}&product_id=${e}`;
          fetch(s)
            .then((t) => {
              if (!t.ok) {
                const e = new Error(t.status);
                throw (this.hideRelated(), e);
              }
              return t.text();
            })
            .then((t) => {
              const e = document.createElement("div");
              e.innerHTML = t;
              const i = e.querySelector(Lb);
              i &&
                i.querySelectorAll(Eb).length &&
                ((this.relatedProducts.innerHTML = i.innerHTML),
                (this.relatedProductGrid = new pi(this.relatedProducts)),
                (this.relatedGridSlider = new ky(this.container)),
                this.initTooltips(this.relatedProducts));
            });
        }
        recent() {
          const t = this.container.querySelector(kb),
            e = t ? parseInt(t.getAttribute(Db)) : 4;
          Shopify.Products.showRecentlyViewed({
            howManyToShow: e,
            wrapperId: `recently-viewed-products-${this.sectionId}`,
            section: this.section,
            onComplete: (t, e) => {
              const i = e.container,
                s = i.querySelector(kb),
                o = i.querySelector(Ab),
                n = t.querySelectorAll(Eb),
                r = s.querySelectorAll(Tb),
                a = s.querySelector(Cb),
                l = s.hasAttribute(Ob) ? parseInt(s.getAttribute(Ob)) : 1,
                c = !o && n.length > 0,
                h = o && n.length >= l,
                d = null == a ? void 0 : a.getAttribute(zb);
              if (c || h) {
                ((this.recentProductGrid = new pi(s)),
                  this.initTooltips(s),
                  h && i.classList.remove(_b),
                  a &&
                    ((this.recentGridSlider = new ky(i)),
                    requestAnimationFrame(() => {
                      this.recentGridSlider.sliders.forEach((t) => {
                        (t.dispatchEvent(new CustomEvent("theme:slider:resize", { bubbles: !0 })),
                          this.recentGridSlider.setSliderArrowsPosition(t));
                      });
                    }),
                    a.querySelectorAll(qb).forEach((t) => {
                      2 == d
                        ? (t.classList.add(Vb), t.classList.remove(Rb))
                        : (t.classList.add(Rb), t.classList.remove(Vb));
                    })));
                let t = [];
                s.addEventListener("theme:target:animate", (e) => {
                  (t.push(e.detail),
                    t.length === r.length && requestAnimationFrame(() => r.forEach((t) => t.classList.add($b))));
                });
              }
            },
          });
        }
        hideRelated() {
          const t = this.relatedProducts.closest(Ib),
            e = this.relatedProducts.closest(Pb),
            i = e.querySelector(`[${Bb}="${t.dataset.tab}"]`);
          (t.remove(),
            i &&
              (i.remove(),
              e.querySelector(xb).dispatchEvent(new Event("click")),
              this.tabs.customScrollbar.unload(),
              requestAnimationFrame(() => {
                this.tabs.customScrollbar = new Pt(this.tabs.container);
              })));
        }
        initTooltips(t) {
          ((this.tooltips = t.querySelectorAll(Hb)),
            this.tooltips.forEach((t) => {
              new Vt(t);
            }));
        }
        onDeselect() {
          (this.relatedProductGrid && this.relatedProductGrid.onDeselect(),
            this.recentProductGrid && this.recentProductGrid.onDeselect());
        }
        onBlockSelect(t) {
          const e = t.target,
            i = this.container.querySelectorAll(Ib);
          !e ||
            i.length < 2 ||
            (e.dispatchEvent(new Event("click")),
            e.parentNode.scrollTo({ top: 0, left: e.offsetLeft - e.clientWidth, behavior: "smooth" }));
        }
        onUnload() {
          (this.relatedProductGrid && this.relatedProductGrid.onUnload(),
            this.relatedGridSlider && this.relatedGridSlider.onUnload(),
            this.recentProductGrid && this.recentProductGrid.onUnload(),
            this.recentGridSlider && this.recentGridSlider.onUnload());
        }
        constructor(t) {
          ((this.section = t),
            (this.sectionId = t.id),
            (this.container = t.container),
            this.related(),
            this.recent(),
            (this.tabs = new uo(this.container)));
        }
      })(this);
    },
    onDeselect() {
      Nb[this.id].onDeselect();
    },
    onBlockSelect(t) {
      Nb[this.id].onBlockSelect(t);
    },
    onUnload() {
      Nb[this.id].onUnload();
    },
  };
  (rl("related-products", Wb), rl("recent-products", Wb));
  const Ub = "[data-stl-hotspots-item]",
    jb = "[data-stl-hotspots-target]",
    Gb = "[data-stl-hotspots-trigger]",
    Kb = ".shopify-section",
    Qb = "[data-quick-view-item-holder]",
    Xb = "[data-product-block] a, [data-product-block] button",
    Yb = "data-hotspot",
    Jb = "data-stl-initial-open",
    Zb = "tabindex",
    tS = "aria-expanded",
    eS = "aos-animate",
    iS = "is-active",
    sS = "is-loading",
    oS = "pswp--open",
    nS = "block-selected";
  let rS = class extends HTMLElement {
    get items() {
      return [...this.querySelectorAll(Ub)];
    }
    get targets() {
      return [...this.querySelectorAll(jb)];
    }
    get triggers() {
      return [...this.querySelectorAll(Gb)];
    }
    attributeChangedCallback(t, e, i) {
      const s = "class" === t,
        o = i.includes(eS);
      let n = !0;
      (e && e.includes(eS) && (n = !1), s && o && n && this.animate());
    }
    connectedCallback() {
      ((this.animationsTimeout = null), (this.resetAnimations = !1), this.init(), this.listen());
    }
    init() {
      (theme.settings.animationsEnabled || this.animate(), this.initialOpen || this.focusables());
    }
    listen() {
      if (Shopify.designMode) {
        const t = this.closest(Kb);
        (t.addEventListener("shopify:section:select", () => this.restoreAnimations()),
          t.addEventListener("shopify:section:deselect", (t) => this.deselectAll(t)),
          t.addEventListener("shopify:block:deselect", () => this.restoreAnimations()),
          this.addEventListener("shopify:block:select", (t) => {
            (this.animationsTimeout && (clearTimeout(this.animationsTimeout), (this.animationsTimeout = null)),
              this.removeAnimations(),
              this.deselectAll(t),
              this.select(this.targets.indexOf(t.target)));
          }));
      }
      (this.targets.forEach((t) => {
        t.addEventListener("click", (t) => {
          (this.select(this.targets.indexOf(t.target)), this.restoreAnimations());
        });
      }),
        this.triggers.forEach((t) => {
          t.addEventListener("click", (t) => {
            const e = this.triggers.indexOf(t.target);
            (this.select(e),
              this.restoreAnimations(),
              window.theme.isMobile() &&
                this.dispatchEvent(new CustomEvent("stl:open-quick-view", { bubbles: !0, detail: { index: e } })));
          });
        }),
        this.addEventListener("keyup", (t) => this.onKeyup(t)));
    }
    animate() {
      if (!this.initialOpen) return;
      let t = 600;
      (Shopify.designMode && (t = 300), this.resetAnimations || setTimeout(() => this.select(0), t));
    }
    removeAnimations() {
      (this.items.forEach((t) => {
        (t.style.setProperty("--duration", "0s"), t.classList.add(nS));
      }),
        (this.resetAnimations = !0));
    }
    restoreAnimations() {
      Shopify.designMode &&
        (this.items.forEach((t) => t.classList.remove(nS)),
        (this.animationsTimeout = setTimeout(() => {
          (this.items.forEach((t) => {
            t.style.removeProperty("--duration");
          }),
            (this.resetAnimations = !1));
        }, 1e3)));
    }
    deselectAll(t = !1) {
      (this.items.forEach((e, i) => {
        (e.classList.remove(iS), 0 === i && this.initialOpen && t && !this.resetAnimations && e.classList.add(iS));
      }),
        setTimeout(() => this.focusables()));
    }
    select(t) {
      (this.items.forEach((e, i) => {
        (e.setAttribute("aria-current", t === i ? "true" : "false"), e.classList.toggle(iS, t === i));
      }),
        this.focusables());
    }
    focusables() {
      this.items.forEach((t, e) => {
        const i = t.classList.contains(iS),
          s = i ? "0" : "-1",
          o = !!i;
        (t.querySelectorAll(Xb).forEach((t) => t.setAttribute(Zb, s)), this.targets[e].setAttribute(tS, o));
      });
    }
    onKeyup(t) {
      t.code === theme.keyboardKeys.ESCAPE && (this.deselectAll(), t.target.closest(Ub).querySelector(jb).focus());
    }
    constructor() {
      (super(), (this.initialOpen = this.hasAttribute(Jb)));
    }
  };
  (!(function (t, e, i) {
    e in t ? Object.defineProperty(t, e, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = i);
  })(rS, "observedAttributes", ["class"]),
    customElements.get("stl-hotspots") || customElements.define("stl-hotspots", rS));
  let aS = class extends HTMLElement {
    get hotspots() {
      return this.querySelector("stl-hotspots");
    }
    get hotspotsTargets() {
      return [...this.querySelectorAll(jb)];
    }
    get hotspotsTriggers() {
      return [...this.querySelectorAll(Gb)];
    }
    connectedCallback() {
      (this.init(), this.listen());
    }
    disconnectedCallback() {}
    init() {
      ((this.quickViewPopup = new li(this)),
        (this.openQuickViewPopupCallback = window.theme.debounce((t) => this.openQuickViewPopup(t), 500)));
    }
    listen() {
      if (Shopify.designMode) {
        const t = this.closest(Kb);
        (t.addEventListener("shopify:section:unload", this.destroyQuickViewPopup.bind(this)),
          t.addEventListener("shopify:section:deselect", this.destroyQuickViewPopup.bind(this)),
          this.addEventListener("shopify:block:select", (t) => this.openQuickViewPopupCallback(t.target)));
      }
      this.hotspots &&
        (this.addEventListener("click", (t) => {
          Boolean(null !== t.target.closest(Ub)) || (this.hotspots.deselectAll(), this.hotspots.restoreAnimations());
        }),
        this.hotspots.addEventListener("stl:open-quick-view", (t) => {
          if (!window.theme.isMobile()) return;
          const e = this.hotspotsTargets[t.detail.index];
          this.openQuickViewPopup(e);
          const i = () => {
            var t, s;
            (this.hotspotsTriggers.forEach((t) => t.classList.add(sS)),
              null === (t = this.quickViewPopup.loadPhotoswipe) ||
                void 0 === t ||
                null === (s = t.popup) ||
                void 0 === s ||
                s.listen("destroy", () => {
                  (this.hotspotsTriggers.forEach((t) => t.classList.remove(sS)),
                    e.removeEventListener("theme:popup:init", i));
                }));
          };
          e.addEventListener("theme:popup:init", i);
        }));
    }
    openQuickViewPopup(t) {
      var e, i;
      if (!window.theme.isMobile()) return;
      const s =
        null === (e = this.quickViewPopup) || void 0 === e || null === (i = e.loadPhotoswipe) || void 0 === i
          ? void 0
          : i.pswpElement;
      s
        ? setTimeout(() => {
            if (s.classList.contains(oS)) {
              const e = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(`[${Yb}="${t.getAttribute(Yb)}"]`),
                i = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(Qb);
              (e.classList.add(iS),
                i.forEach((t) => {
                  t !== e && t.classList.remove(iS);
                }));
            } else this.triggerClick(t);
          })
        : setTimeout(() => this.triggerClick(t), 400);
    }
    triggerClick(t) {
      requestAnimationFrame(() => t.dispatchEvent(new Event("click")));
    }
    destroyQuickViewPopup() {
      var t, e;
      const i =
        null === (t = this.quickViewPopup) || void 0 === t || null === (e = t.loadPhotoswipe) || void 0 === e
          ? void 0
          : e.pswpElement;
      i && i.classList.contains(oS) && this.quickViewPopup.loadPhotoswipe.popup.close();
    }
    constructor() {
      super();
    }
  };
  customElements.get("shop-the-look") || customElements.define("shop-the-look", aS);
  const lS = {},
    cS = "[data-slider]",
    hS = "[data-item]",
    dS = "[data-button-show]",
    uS = "[data-button-hide]",
    pS = "[data-item-products]",
    mS = "[data-item-products-slider]",
    gS = "[data-item-product]",
    yS = "a, button",
    fS = "blog-item--active",
    vS = "blog-item__products--visible",
    wS = "flickity-enabled",
    bS = "is-selected",
    SS = {
      slider: "data-slider",
      slidePosition: "data-slide-position",
      sectionId: "data-section-id",
      tabIndex: "tabindex",
      ariaHidden: "aria-hidden",
    };
  const ES = {
    onLoad() {
      lS[this.id] = new (class {
        initSlider() {
          ((this.flkty = new window.theme.Flickity(this.slider, {
            prevNextButtons: !0,
            pageDots: !1,
            cellAlign: "left",
            wrapAround: !1,
            groupCells: !0,
            contain: !0,
            on: {
              ready: () => {
                this.handleFocus();
              },
            },
          })),
            this.flkty.on("change", () => {
              const t = this.container.querySelectorAll(hS);
              (this.handleFocus(),
                t.length &&
                  t.forEach((t) => {
                    const e = t.querySelector(pS);
                    (t.classList.remove(fS), e && t.querySelector(pS).classList.remove(vS));
                  }),
                this.flkty &&
                  !this.flkty.options.draggable &&
                  ((this.flkty.options.draggable = !0), this.flkty.updateDraggable()));
            }));
        }
        destroySlider() {
          null !== this.flkty && (this.flkty.destroy(), (this.flkty = null));
        }
        checkSlidesSize() {
          const t =
            this.container.querySelector(hS).currentStyle || window.getComputedStyle(this.container.querySelector(hS));
          this.gutter = parseInt(t.marginRight);
          const e = this.slider.offsetWidth + this.gutter < this.getItemsWidth();
          window.innerWidth >= theme.sizes.small && e ? this.initSlider() : this.destroySlider();
        }
        getItemsWidth() {
          let t = 0;
          const e = this.slider.querySelectorAll(hS);
          return (
            e.length &&
              e.forEach((e) => {
                t += e.offsetWidth + this.gutter;
              }),
            t
          );
        }
        bindButtons() {
          const t = this.container.querySelectorAll(mS),
            e = this.container.querySelectorAll(dS),
            i = this.container.querySelectorAll(uS);
          (e.length &&
            e.forEach((t) => {
              t.addEventListener("click", (e) => {
                (e.preventDefault(),
                  this.container.querySelectorAll(hS).forEach((t) => {
                    const e = t.querySelector(pS);
                    (t.classList.remove(fS),
                      e && (e.classList.remove(vS), this.changeTabIndex(e), this.changeAriaHidden(e, !0)));
                  }));
                const i = t.closest(hS),
                  s = i.querySelector(pS);
                if ((i.classList.add(fS), s)) {
                  (s.classList.add(vS), this.changeTabIndex(s, "enable"), this.changeAriaHidden(s, !1));
                  const t = s.querySelector(mS),
                    e = t.querySelectorAll(gS);
                  t.classList.contains(wS) &&
                    e.forEach((t) => {
                      const e = t.classList.contains(bS);
                      (t.setAttribute(SS.tabIndex, e ? "0" : "-1"), this.changeAriaHidden(t, !e));
                    });
                }
                (null !== this.flkty && ((this.flkty.options.draggable = !1), this.flkty.updateDraggable()),
                  (this.a11y.state.trigger = t));
              });
            }),
            i.length &&
              i.forEach((t) => {
                t.addEventListener("click", (e) => {
                  e.preventDefault();
                  const i = t.closest(hS),
                    s = i.querySelector(pS);
                  (i.classList.remove(fS),
                    s && (s.classList.remove(vS), this.changeTabIndex(s), this.changeAriaHidden(s, !0)),
                    null !== this.flkty && ((this.flkty.options.draggable = !0), this.flkty.updateDraggable()),
                    this.a11y.state.trigger.focus());
                });
              }),
            t.length &&
              t.forEach((t) => {
                t.querySelectorAll(gS).length > 1 &&
                  new window.theme.Flickity(t, {
                    prevNextButtons: !0,
                    contain: !0,
                    pageDots: !1,
                    wrapAround: !0,
                    on: {
                      change: (e) => {
                        t.querySelectorAll(gS).forEach((t, i) => {
                          const s = i === e;
                          (t.setAttribute(SS.tabIndex, s ? "0" : "-1"), this.changeAriaHidden(t, !s));
                        });
                      },
                    },
                  });
              }),
            this.slider.addEventListener("keyup", (t) => {
              if (t.code === theme.keyboardKeys.ESCAPE) {
                const e = t.target.hasAttribute(SS.slider)
                  ? t.target.querySelectorAll(hS)
                  : t.target.closest(cS).querySelectorAll(hS);
                (e.length &&
                  (e.forEach((t) => {
                    const e = t.querySelector(pS);
                    (t.classList.remove(fS),
                      e && (e.classList.remove(vS), this.changeTabIndex(e), this.changeAriaHidden(e, !0)));
                  }),
                  this.flkty && ((this.flkty.options.draggable = !0), this.flkty.updateDraggable())),
                  this.a11y.state.trigger.focus());
              }
            }));
        }
        handleFocus() {
          const t = this.container.querySelectorAll(hS);
          t.length &&
            t.forEach((t) => {
              const e = t.classList.contains(bS),
                i = t.querySelector(pS);
              e
                ? (this.changeTabIndex(t, "enable"), i && this.changeTabIndex(i))
                : (this.changeTabIndex(t), i && i.classList.remove(vS));
            });
        }
        listen() {
          (this.slider &&
            (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize)),
            document.addEventListener("mousedown", this.clickOutsideItemEvent));
        }
        changeAriaHidden(t, e) {
          t.setAttribute(SS.ariaHidden, !!e);
        }
        changeTabIndex(t, e = "") {
          const i = "enable" === e ? "0" : "-1";
          t.querySelectorAll(yS).forEach((t) => {
            t.setAttribute(SS.tabIndex, i);
          });
          const s = t.querySelectorAll(mS),
            o = t.querySelector(pS),
            n = t.classList.contains(vS);
          (s.forEach((t) => {
            (t.setAttribute(SS.tabIndex, n ? "0" : "-1"),
              t.querySelectorAll(gS).forEach((t) => {
                this.changeAriaHidden(t, !n);
              }));
          }),
            o && this.changeAriaHidden(o, !n));
        }
        onBlockSelect(t) {
          if (null !== this.flkty) {
            const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
              i = parseInt(this.flkty.slides[0].cells.length),
              s = Math.floor(e / i);
            if (!t.detail.load) return void this.flkty.select(s);
            const o = () => {
              (requestAnimationFrame(() => {
                this.flkty.select(s);
              }),
                this.flkty.element.removeEventListener("transitionend", o));
            };
            this.flkty.element.addEventListener("transitionend", o);
          } else {
            const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
              i = parseInt(e.paddingLeft),
              s = t.target.offsetLeft - i;
            this.slider.scrollTo({ top: 0, left: s, behavior: "smooth" });
          }
        }
        onUnload() {
          (document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize),
            document.removeEventListener("mousedown", this.clickOutsideItemEvent));
        }
        constructor(t) {
          ((this.container = t.container),
            (this.flkty = null),
            (this.slider = this.container.querySelector(cS)),
            (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
            (this.isFullWidth = this.container.hasAttribute(SS.fullWidth)),
            (this.gutter = 0),
            (this.a11y = window.theme.a11y),
            (this.clickOutsideItemEvent = (t) => {
              if (!t.target.matches(hS) && !t.target.closest(hS)) {
                const t = this.container.querySelectorAll(hS);
                t.length &&
                  t.forEach((t) => {
                    const e = t.querySelector(pS);
                    (e && (e.classList.remove(vS), this.changeTabIndex(e), this.changeAriaHidden(e, !0)),
                      t.classList.remove(fS));
                  });
              }
            }),
            this.bindButtons(),
            this.listen());
        }
      })(this);
    },
    onUnload(t) {
      lS[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      lS[this.id].onBlockSelect(t);
    },
  };
  rl("shoppable-blog", ES);
  const LS = "[data-scroll-down]",
    kS = "[data-site-header]",
    AS = "[data-slide]",
    CS = "a, button",
    qS = "[data-slider]",
    TS = ".lazy-image",
    PS = "text-highlight",
    xS =
      '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
    IS = "data-style",
    HS = "data-current-style",
    FS = "tabindex",
    MS = "site-header--fixed",
    DS = "slider--no-cached-images",
    OS = "slider--img-loaded",
    BS = "img-in",
    zS = "original-height",
    _S = "original-height-mobile",
    $S = "has-mobile-height",
    RS = {};
  rl("slider", [
    {
      onLoad() {
        RS[this.id] = new (class {
          initSlider() {
            const t = this.items.length,
              e = parseInt(this.container.dataset.duration),
              i = "true" === this.container.dataset.pageDots && t > 1,
              s = "true" === this.container.dataset.navArrows && t > 1;
            let o = "true" === this.container.dataset.autoplay;
            if ((o && (o = e), t > 1))
              ((this.flkty = new window.theme.Flickity(this.container, {
                fade: !0,
                cellSelector: AS,
                autoPlay: o,
                wrapAround: !0,
                adaptiveHeight: !0,
                setGallerySize: !0,
                imagesLoaded: !0,
                pageDots: i,
                prevNextButtons: s,
                dragThreshold: 25,
                on: {
                  ready: () => {
                    const t = this.items[0].getAttribute(IS);
                    (this.container.setAttribute(HS, t),
                      requestAnimationFrame(this.resizeEvent),
                      document.addEventListener("theme:vars", this.resizeEvent),
                      this.handleFirstSlideAnimation(!0));
                  },
                  change: (t) => {
                    const e = this.flkty.selectedElement.getAttribute(IS);
                    (this.container.setAttribute(HS, e),
                      this.handleFirstSlideAnimation(!1),
                      this.flkty.cells.forEach((e, i) => {
                        (e.element.querySelectorAll(CS).forEach((e) => {
                          e.setAttribute(FS, i === t ? "0" : "-1");
                        }),
                          e.element.querySelectorAll(PS).forEach((e) => {
                            e.setTriggerAttribute(Boolean(i === t));
                          }));
                      }));
                  },
                },
              })),
                window.theme.flickitySmoothScrolling(this.container));
            else if (1 === t) {
              const t = this.items[0].getAttribute(IS);
              this.container.setAttribute(HS, t);
            }
          }
          getTallestSlideItem() {
            if (this.items.length <= 1) return;
            this.container.style.removeProperty("--item-min-h");
            const t = [...this.items].map((t) => Math.floor(t.offsetHeight)),
              e = Math.max(...t),
              i = [...this.items].some((t) => t.classList.contains(zS)),
              s = [...this.items].some((t) => t.classList.contains(_S)),
              o = this.container.classList.contains($S);
            ((window.theme.isDesktop() && !i) ||
              (window.theme.isMobile() && !s && o) ||
              (window.theme.isMobile() && !i && !o)) &&
              [...this.items].some((t) => Math.floor(t.offsetHeight) !== e) &&
              this.container.style.setProperty("--item-min-h", `${e}px`);
          }
          handleFirstSlideAnimation(t = !1) {
            if (!t) return (this.container.classList.remove(DS), void this.container.classList.remove(OS));
            const e = this.items[0].querySelectorAll(TS),
              i = this.container.classList.contains(BS);
            if (e.length && !i) {
              this.container.classList.add(DS);
              const t = (i) => {
                (requestAnimationFrame(() => this.container.classList.add(OS)),
                  e[0].removeEventListener("transitionend", t));
              };
              e[0].addEventListener("transitionend", t);
            }
          }
          bindScrollButton() {
            const t = this.container.querySelector(LS);
            t &&
              t.addEventListener("click", (t) => {
                t.preventDefault();
                const e = this.header.classList.contains(MS) ? 60 : 0,
                  i = parseInt(Math.ceil(this.container.offsetTop + this.container.offsetHeight - e));
                window.scrollTo({ top: i, left: 0, behavior: "smooth" });
              });
          }
          onBlockSelect(t) {
            const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
            null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer());
          }
          onBlockDeselect(t) {
            "true" === t.target.closest(qS).dataset.autoplay && null !== this.flkty && this.flkty.playPlayer();
          }
          onReorder() {
            (this.handleFirstSlideAnimation(!1), null !== this.flkty && this.flkty.resize());
          }
          onUnload() {
            (document.removeEventListener("theme:resize:width", this.getTallestSlideItemOnResize),
              this.handleFirstSlideAnimation(!1),
              null !== this.flkty &&
                (document.removeEventListener("theme:vars", this.resizeEvent),
                this.flkty.destroy(),
                (this.flkty = null)),
              this.parallax && (this.parallax.unload(), (this.parallax = null)));
          }
          constructor(t) {
            ((this.container = t.container),
              (this.header = document.querySelector(kS)),
              (this.items = this.container.querySelectorAll(AS)),
              (this.flkty = null),
              (this.parallax = null),
              (this.resizeEvent = () => {
                this.flkty.resize();
              }),
              this.getTallestSlideItem(),
              this.initSlider(),
              this.bindScrollButton(),
              (this.getTallestSlideItemOnResize = () => this.getTallestSlideItem()),
              document.addEventListener("theme:resize:width", this.getTallestSlideItemOnResize),
              this.container.matches(xS) && (this.parallax = new sp(this.container)));
          }
        })(this);
      },
      onReorder(t) {
        RS[this.id].onReorder(t);
      },
      onUnload(t) {
        RS[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        RS[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        RS[this.id].onBlockDeselect(t);
      },
    },
    vm,
  ]);
  const VS = "[data-sticky-card-body]",
    NS = "[data-sticky-card-wrapper]",
    WS = "[data-sticky-card-content]",
    US = "[data-sticky-card-aside]",
    jS = "[data-sticky-card-text]",
    GS = "[data-sticky-card-media]",
    KS = "[data-sticky-vh]",
    QS = "is-stuck-up",
    XS = "has-passed-sticky",
    YS = "spillover",
    JS = "data-sticky-card-layout-mobile",
    ZS = {};
  rl("sticky-image-cards", {
    onLoad() {
      ZS[this.id] = new (class {
        init() {
          (requestAnimationFrame(() => {
            (this.calculateHeights(), this.onScroll());
          }),
            document.addEventListener("theme:scroll", this.onScrollCallback),
            document.addEventListener("theme:resize", this.onResizeCallback));
        }
        onScroll() {
          this.isEligible() && this.detectStickyPositions();
        }
        isEligible() {
          const t = Math.round(this.container.getBoundingClientRect().top + window.scrollY),
            e = t + this.container.offsetHeight < Math.round(window.scrollY);
          return t < Math.round(window.scrollY + window.innerHeight) && !e;
        }
        detectStickyPositions() {
          const t = Math.round(this.body.getBoundingClientRect().top - this.headerHeight - this.wrapperTop);
          [...this.wrapper].forEach((e, i) => {
            const s = Math.floor(e.getBoundingClientRect().top - this.headerHeight);
            if (this.isMobile) {
              if (i !== this.lastIndex) {
                const t = Math.floor(this.wrapper[i + 1].getBoundingClientRect().top - this.headerHeight);
                e.classList.toggle(XS, t <= this.stickyTop);
              }
              this.container.classList.toggle(`checkpoint-${i + 1}`, t <= -1 * this.cumulativeHeights[i]);
            }
            e.classList.toggle(QS, s <= this.stickyTop);
          });
        }
        calculateHeights() {
          let { stickyHeaderHeight: t } = window.theme.readHeights();
          ((this.headerHeight = t || 0),
            (this.spacingTop = parseInt(window.getComputedStyle(this.container).getPropertyValue("--padding")) || 20),
            (this.wrapperTop = parseInt(window.getComputedStyle(this.wrapper[0]).getPropertyValue("top")) || 0),
            (this.stickyTop = Math.floor(this.wrapperTop - this.headerHeight)),
            (this.gap = parseInt(window.getComputedStyle(this.aside).getPropertyValue("gap")) || 0),
            (this.viewportHeight = this.vh.offsetHeight),
            (this.lastIndex = [...this.wrapper].length - 1),
            (this.cumulativeHeights = []),
            this.isMobile && ((this.wrapperTop = this.spacingTop), (this.stickyTop = this.spacingTop)),
            this.textInContent &&
              (this.isDesktop &&
                this.textInContent.length > 0 &&
                this.textInContent.forEach((t, e) => {
                  (t.style.setProperty("--row-height", "auto"),
                    this.wrapper[e].style.setProperty("--row-height", "auto"));
                  const i = t.offsetHeight,
                    s = this.media[e].offsetHeight,
                    o = Math.max(i, s);
                  (t.style.setProperty("--row-height", `${o}px`),
                    this.wrapper[e].style.setProperty("--row-height", `${o}px`));
                }),
              [...this.wrapper].forEach((t, e) => {
                (t.style.setProperty("--item-height", "auto"),
                  t.style.setProperty("--item-double-height", "auto"),
                  requestAnimationFrame(() => {
                    const i = t.offsetHeight,
                      s = i + this.wrapperTop + this.headerHeight > this.viewportHeight,
                      o = [...this.wrapper].map((t) => (Number(t.dataset.index) >= e ? 0 : t.offsetHeight));
                    (this.cumulativeHeights.push(o.reduce((t, e) => t + e, 0)),
                      t.classList.toggle(YS, s),
                      s &&
                        this.isMobile &&
                        (t.style.setProperty("--item-height", `${i}px`),
                        t.style.setProperty("--item-double-height", 2 * i + "px")));
                  }));
              })));
        }
        onResize() {
          requestAnimationFrame(() => {
            ((this.isDesktop = Boolean(window.theme.getWindowWidth() >= window.theme.sizes.large)),
              (this.isMobile = window.theme.isMobile()));
            const t = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            let e = this.isDesktop || (!t && this.isMobile);
            (this.orientation !== window.theme.getScreenOrientation() &&
              t &&
              ((e = !0), (this.orientation = window.theme.getScreenOrientation())),
              e && this.calculateHeights());
          });
        }
        onUnload() {
          (document.removeEventListener("theme:scroll", this.onScrollCallback),
            document.removeEventListener("theme:resize", this.onResizeCallback));
        }
        onBlockSelect(t) {
          requestAnimationFrame(() => {
            const e = Number(t.target.dataset.index),
              i =
                Math.round(this.body.getBoundingClientRect().top + window.scrollY) +
                [...this.wrapper]
                  .map((t) => (Number(t.dataset.index) >= e ? 0 : t.offsetHeight))
                  .reduce((t, e) => t + e, 0) -
                (() =>
                  this.isMobile && "stacked" === this.layoutMobile
                    ? this.gap * e * -1 + this.gap / 2
                    : this.stickyTop)() -
                this.headerHeight;
            setTimeout(() => {
              window.scrollTo({ top: i, left: 0, behavior: "smooth" });
            }, 400);
          });
        }
        constructor(t) {
          var e;
          ((this.container = t.container),
            (this.body = this.container.querySelector(VS)),
            (this.wrapper = this.container.querySelectorAll(NS)),
            (this.content = this.container.querySelector(WS)),
            (this.aside = this.container.querySelector(US)),
            (this.text = this.container.querySelectorAll(jS)),
            (this.media = this.container.querySelectorAll(GS)),
            (this.textInContent = null === (e = this.content) || void 0 === e ? void 0 : e.querySelectorAll(jS)),
            (this.vh = this.container.querySelector(KS)),
            (this.layoutMobile = this.container.getAttribute(JS)),
            (this.isDesktop = Boolean(window.theme.getWindowWidth() >= window.theme.sizes.large)),
            (this.isMobile = window.theme.isMobile()),
            (this.orientation = window.theme.getScreenOrientation()),
            0 !== this.media.length &&
              ((this.onScrollCallback = () => this.onScroll()),
              (this.onResizeCallback = () => this.onResize()),
              this.init()));
        }
      })(this);
    },
    onUnload() {
      ZS[this.id].onUnload();
    },
    onBlockSelect(t) {
      ZS[this.id].onBlockSelect(t);
    },
  });
  const tE = "[data-sticky-wrapper]",
    eE = "[data-sticky-aside]",
    iE = "[data-sticky-inner]",
    sE = "[data-sticky-content]",
    oE = ".js-only [data-sticky-text]",
    nE = ".js-only [data-sticky-text-inner]",
    rE = ".js-only [data-sticky-image]",
    aE = "[data-sticky-images]",
    lE = ".image-wrapper",
    cE = ".sticky-images-and-text__video-wrapper",
    hE = "[data-sticky-dot]",
    dE = "text-highlight",
    uE = "data-sticky-with-gaps",
    pE = "data-sticky-single-text",
    mE = "data-index",
    gE = 0.5,
    yE = {
      horizontal: "horizontal",
      horizontalReversed: "horizontal-reversed",
      vertical: "vertical",
      verticalReversed: "vertical-reversed",
    },
    fE = {
      maxVisibility: "maximum-visibility-of-each-image-in-viewport",
      middleOfViewport: "image-in-the-middle-of-viewport",
    },
    vE = "is-active",
    wE = {};
  (rl("sticky-images-and-text", [
    {
      onLoad() {
        wE[this.id] = new (class {
          init() {
            (this.getTypeOfIntersecting(),
              this.observeImagesIntersecting(),
              this.calculateHeights(),
              (this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback)),
              requestAnimationFrame(() => {
                requestAnimationFrame(() => this.calculateHeights());
              }),
              document.addEventListener("theme:scroll", this.onScrollCallback),
              document.addEventListener("theme:resize:width", this.onResizeCallback),
              this.syncDots());
          }
          getTypeOfIntersecting() {
            ((this.typeOfIntersecting = fE.maxVisibility),
              (this.fractionOfViewport = this.image[0].offsetHeight / window.innerHeight),
              this.verticalScroll &&
                !window.theme.isMobile() &&
                this.fractionOfViewport < 0.6 &&
                (this.typeOfIntersecting = fE.middleOfViewport));
          }
          observeImagesIntersecting() {
            ((this.observersCollection = new Set()),
              (this.compareIntersectionRatio = []),
              (this.maxVisibility = 0),
              (this.observer = new IntersectionObserver(
                (t, e) => {
                  t.forEach((t) => {
                    const e = t.target.offsetHeight,
                      i = t.intersectionRatio,
                      s = t.isIntersecting,
                      o = { target: t.target, intersectionRatio: t.intersectionRatio },
                      n = this.typeOfIntersecting === fE.maxVisibility;
                    let r = gE;
                    (this.windowHeight <= e && (r = 0),
                      n &&
                        s &&
                        (this.observersCollection.forEach((e) => {
                          e.target === t.target && this.observersCollection.delete(e);
                        }),
                        this.observersCollection.add(o),
                        (this.compareIntersectionRatio = [...this.observersCollection].map((t) => t.intersectionRatio)),
                        (this.maxVisibility = Math.max(...this.compareIntersectionRatio))),
                      s &&
                        i > r &&
                        n &&
                        this.maxVisibility === i &&
                        ((this.maxVisibilityItem = [...this.observersCollection].find(
                          (t) => t.intersectionRatio === this.maxVisibility,
                        )),
                        (this.activeIndex = Number(this.maxVisibilityItem.target.dataset.index)),
                        this.lastActiveIndex !== this.activeIndex &&
                          (this.sync(), (this.lastActiveIndex = this.activeIndex))));
                  });
                },
                {
                  root: null,
                  rootMargin: "0px",
                  threshold: [0, 0.15, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.85, 1],
                },
              )),
              this.image.forEach((t) => this.observer.observe(t)));
          }
          onScroll() {
            (this.performAnimation ||
              (this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback)),
              this.typeOfIntersecting === fE.middleOfViewport &&
                this.image.forEach((t) => this.checkImagePositionInViewport(t)));
          }
          removeAnimationFrame() {
            this.performAnimation && (cancelAnimationFrame(this.performAnimation), (this.performAnimation = null));
          }
          checkImagePositionInViewport(t) {
            if (!t) return;
            const e = window.innerHeight,
              i = window.scrollY,
              s = i + e / 2,
              o = i + e,
              n = Math.round(t.getBoundingClientRect().top + i),
              r = n + t.offsetHeight;
            n < o &&
              !(r < i) &&
              s > n &&
              r > s &&
              ((this.activeIndex = Number(t.dataset.index)),
              this.lastActiveIndex !== this.activeIndex && (this.sync(), (this.lastActiveIndex = this.activeIndex)));
          }
          calculateImagesOffset() {
            const t = this.aside.getBoundingClientRect().top - this.headerHeight,
              e = t - this.innerStickyTop;
            let i = 0,
              s = 0;
            const o = this.hasShortImages ? e : t;
            ((i = o < 0 ? (o / this.bottomEndingPoint) * -1 * 100 : o >= 0 ? 0 : 100),
              (s = i > 100 ? 100 : i),
              (s *= this.image.length - 1),
              (window.theme.isMobile() || this.horizontalScroll) &&
                this.aside.style.setProperty("--translateX", `${Number(s * this.direction).toFixed(2)}%`),
              this.lastOffset !== s
                ? (this.performAnimation = requestAnimationFrame(this.calculateImagesOffsetCallback))
                : this.performAnimation && this.removeAnimationFrame(),
              (this.lastOffset = s));
          }
          calculateHeights() {
            let { stickyHeaderHeight: t, windowHeight: e } = window.theme.readHeights();
            if (((this.headerHeight = t || 0), (this.windowHeight = e || window.innerHeight), this.text.length > 0)) {
              const t = this.content
                  ? parseInt(window.getComputedStyle(this.content).getPropertyValue("padding-top"))
                  : 0,
                e = this.content
                  ? parseInt(window.getComputedStyle(this.content).getPropertyValue("padding-bottom"))
                  : 0,
                i = [...this.text].map((i) => i.offsetHeight + t + e),
                s = [...this.textInner].map((t) => t.offsetHeight),
                o = Math.max(...i),
                n = Math.max(...s),
                r = window.theme.isMobile() ? n : o,
                a = i.reduce((t, e) => t + e, 0),
                l = Math.floor(a / i.length) || this.text[0].offsetHeight;
              (this.container.style.removeProperty("--average-text-height"),
                this.container.style.setProperty("--average-text-height", `${l}px`),
                this.container.style.removeProperty("--highest-text"),
                this.container.style.setProperty("--highest-text", `${r}px`));
            }
            if (((this.imagesHeight = this.images.offsetHeight), (this.hasShortImages = !1), this.image.length > 0)) {
              const t = this.image[0].querySelector(lE),
                e = this.image[0].querySelector(cE),
                i = t || e;
              ((this.imgHeight = i ? i.offsetHeight : 0),
                (this.imgPadding = parseInt(window.getComputedStyle(this.image[0]).getPropertyValue("padding-top"))),
                this.container.style.removeProperty("--images-height"),
                this.container.style.setProperty("--images-height", `${this.imagesHeight}px`),
                this.container.style.removeProperty("--img-height"),
                this.container.style.setProperty("--img-height", `${this.imgHeight + 2 * this.imgPadding}px`));
            }
            ((this.asideHeight = this.aside.offsetHeight),
              (this.asidePadding = parseInt(window.getComputedStyle(this.aside).getPropertyValue("padding-top"))),
              (this.breathingSpace = (this.windowHeight - this.imagesHeight) / 2 / 2),
              (this.innerStickyTop =
                parseInt(window.getComputedStyle(this.inner).getPropertyValue("top")) -
                this.headerHeight -
                this.breathingSpace),
              (this.gutters = this.withGaps ? 2 * this.asidePadding : 0),
              (this.additionalSpace = window.theme.isMobile()
                ? this.withGaps
                  ? this.asidePadding + 10
                  : 10
                : this.gutters),
              (this.minHeightForEndingPoing = this.imagesHeight + this.additionalSpace),
              !window.theme.isMobile() &&
                this.horizontalScroll &&
                ((this.minHeightForEndingPoing = this.windowHeight - this.headerHeight),
                (this.hasShortImages = this.fractionOfViewport <= 0.6),
                this.hasShortImages &&
                  (this.minHeightForEndingPoing = this.imagesHeight - this.innerStickyTop + 3 * this.breathingSpace)),
              (this.bottomEndingPoint = this.asideHeight - this.minHeightForEndingPoing));
          }
          refreshImagesOffsetValues() {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                document.dispatchEvent(new CustomEvent("theme:scroll"));
              });
            });
          }
          onResize() {
            (this.calculateHeights(),
              requestAnimationFrame(() => this.calculateHeights()),
              this.getTypeOfIntersecting(),
              this.refreshImagesOffsetValues());
          }
          sync() {
            const t = this.singleText ? [] : this.text;
            ([...this.image, ...t, ...this.dot].forEach((t) => {
              const e = Number(t.getAttribute(mE));
              t.classList.toggle(vE, e === Number(this.activeIndex));
            }),
              this.textHighlight.forEach((t) => t.shouldAnimate()));
          }
          syncDots() {
            this.dot.forEach((t) => {
              t.addEventListener("click", (t) => {
                (t.preventDefault(), this.scrollTo(this.image[Number(t.target.dataset.index)]));
              });
            });
          }
          scrollTo(t, e = 0) {
            if (!t) return;
            const i = Number(t.dataset.index),
              s = Math.round(t.getBoundingClientRect().top + window.scrollY),
              o = t.offsetHeight,
              n = Math.round(this.wrapper.getBoundingClientRect().top + window.scrollY),
              r = this.aside.getBoundingClientRect().top - this.headerHeight,
              a = n + this.images.offsetHeight * i,
              l = Boolean((this.image[0].offsetHeight + this.gutters) / (window.innerHeight - this.headerHeight) >= 1);
            let c = a - this.headerHeight;
            if (
              (window.theme.isMobile() &&
                (c = r + window.scrollY + (this.bottomEndingPoint / (this.image.length - 1)) * i),
              this.horizontalScroll && window.theme.isDesktop() && !l)
            ) {
              const t = r - this.innerStickyTop;
              c =
                (this.hasShortImages ? t + window.scrollY : r + window.scrollY) +
                (this.bottomEndingPoint / (this.image.length - 1)) * i;
            }
            this.verticalScroll &&
              window.theme.isDesktop() &&
              ((c = s - this.headerHeight),
              this.typeOfIntersecting === fE.middleOfViewport &&
                (c = s - window.innerHeight / 2 + o / 2 - this.headerHeight));
            const h = { top: c, left: 0, behavior: "smooth" };
            e > 0 ? setTimeout(() => window.scrollTo(h), e) : window.scrollTo(h);
          }
          onUnload() {
            (this.image.forEach((t) => this.observer.unobserve(t)),
              document.removeEventListener("theme:scroll", this.onScrollCallback),
              document.removeEventListener("theme:resize:width", this.onResizeCallback));
          }
          onBlockSelect(t) {
            this.scrollTo(t.target, 500);
          }
          constructor(t) {
            ((this.container = t.container),
              (this.scrollDirection = this.container.dataset.scrollDirection),
              (this.horizontalScroll =
                this.scrollDirection === yE.horizontal || this.scrollDirection === yE.horizontalReversed),
              (this.verticalScroll =
                this.scrollDirection === yE.vertical || this.scrollDirection === yE.verticalReversed),
              (this.reverseDirection =
                this.scrollDirection === yE.horizontalReversed || this.scrollDirection === yE.verticalReversed),
              (this.direction = this.reverseDirection ? 1 : -1),
              (this.withGaps = this.container.hasAttribute(uE)),
              (this.singleText = this.container.hasAttribute(pE)),
              (this.image = this.container.querySelectorAll(rE)),
              (this.text = this.container.querySelectorAll(oE)),
              (this.textInner = this.container.querySelectorAll(nE)),
              (this.images = this.container.querySelector(aE)),
              (this.dot = this.container.querySelectorAll(hE)),
              (this.aside = this.container.querySelector(eE)),
              (this.inner = this.container.querySelector(iE)),
              (this.content = this.container.querySelector(sE)),
              (this.wrapper = this.container.querySelector(tE)),
              (this.textHighlight = this.container.querySelectorAll(dE)),
              (this.performAnimation = null),
              (this.lastOffset = 0),
              (this.activeIndex = 0),
              (this.lastActiveIndex = this.activeIndex),
              this.wrapper &&
                ((this.onScrollCallback = () => this.onScroll()),
                (this.onResizeCallback = () => this.onResize()),
                (this.calculateImagesOffsetCallback = () => this.calculateImagesOffset()),
                this.init()));
          }
        })(this);
      },
      onUnload() {
        wE[this.id].onUnload();
      },
      onBlockSelect(t) {
        wE[this.id].onBlockSelect(t);
      },
    },
    vm,
  ]),
    rl("subcollections", Ay),
    rl("tab-collections", [mi, Ay, po]));
  const bE = {},
    SE = "[data-slider]",
    EE = "[data-item]",
    LE = "a, button",
    kE = ".flickity-button",
    AE = "flickity-enabled",
    CE = "has-arrows",
    qE = "carousel--resize",
    TE = "flickity-button-holder",
    PE = "is-selected",
    xE = "data-section-id",
    IE = "tabindex";
  rl("testimonials", {
    onLoad() {
      bE[this.id] = new (class {
        init() {
          (this.checkSlideCount(), this.listen());
        }
        onResize() {
          (this.checkSlideCount(),
            null !== this.flkty &&
              (this.flkty.resize(), this.flkty.size.width >= this.flkty.slideableWidth && this.destroySlider()));
        }
        checkSlideCount() {
          const t = this.slides.length,
            e = Boolean(2 == t && window.innerWidth >= theme.sizes.small),
            i = Boolean(1 == t);
          if (!e && !i)
            return this.flkty
              ? void (
                  this.flkty &&
                  (this.flkty.isActive || this.initSlider(),
                  this.flkty.slideableWidth > this.flkty.size.width ? this.initSlider() : this.destroySlider())
                )
              : (this.initSlider(), void this.onResize());
          this.destroySlider();
        }
        initSlider() {
          ((this.flkty = new window.theme.Flickity(this.slider, {
            cellSelector: EE,
            prevNextButtons: !0,
            pageDots: !0,
            groupCells: !0,
            cellAlign: this.alignment,
            contain: !0,
            adaptiveHeight: !1,
            on: {
              ready: () => {
                (this.slidesTabIndex(),
                  requestAnimationFrame(() => {
                    this.slider.querySelectorAll(kE).forEach((t) => {
                      window.theme.wrap(t, TE);
                    });
                  }));
              },
              change: () => {
                this.slidesTabIndex();
              },
            },
          })),
            window.theme.isMobile() ? this.container.classList.remove(CE) : this.container.classList.add(CE),
            this.createResizeClass());
        }
        createResizeClass() {
          if ("function" == typeof window.theme.Flickity.prototype._createResizeClass) return;
          ((window.theme.Flickity.prototype._createResizeClass = function () {
            this.element.classList.add(qE);
          }),
            window.theme.Flickity.createMethods.push("_createResizeClass"));
          const t = window.theme.Flickity.prototype.resize;
          window.theme.Flickity.prototype.resize = function () {
            (this.element.classList.remove(qE), t.call(this), this.element.classList.add(qE));
          };
        }
        slidesTabIndex() {
          window.theme.Flickity.data(this.slider).cells.forEach((t) => {
            let e = "-1";
            (t.element.classList.contains(PE) && (e = "0"),
              t.element.querySelectorAll(LE).forEach((t) => {
                t.setAttribute(IE, e);
              }));
          });
        }
        destroySlider() {
          var t;
          this.slider.classList.contains(AE) &&
            (null !== this.flkty &&
              (null === (t = this.slider.querySelectorAll(kE)) ||
                void 0 === t ||
                t.forEach((t) => {
                  const e = t.parentNode;
                  e && e.classList.contains(TE) && (e.parentNode.insertBefore(t, e), e.parentNode.removeChild(e));
                }),
              this.flkty.destroy()),
            this.container.classList.remove(CE));
        }
        listen() {
          document.addEventListener("theme:resize:width", this.onResizeCallback);
        }
        onBlockSelect(t) {
          if (null !== this.flkty && this.flkty.isActive) {
            const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
              i = parseInt(this.flkty.slides[0].cells.length),
              s = Math.floor(e / i);
            if (!t.detail.load) return void this.flkty.select(s);
            const o = () => {
              (requestAnimationFrame(() => {
                this.flkty.select(s);
              }),
                this.flkty.element.removeEventListener("transitionend", o));
            };
            this.flkty.element.addEventListener("transitionend", o);
          }
        }
        onUnload() {
          document.removeEventListener("theme:resize:width", this.onResizeCallback);
        }
        constructor(t) {
          ((this.container = t.container),
            (this.sectionId = this.container.getAttribute(xE)),
            (this.slider = this.container.querySelector(SE)),
            (this.alignment = this.slider.dataset.sliderAlignment),
            this.slider &&
              ((this.slides = this.slider.querySelectorAll(EE)),
              (this.flkty = null),
              (this.onResizeCallback = () => this.onResize()),
              this.init()));
        }
      })(this);
    },
    onUnload(t) {
      bE[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      bE[this.id].onBlockSelect(t);
    },
  });
  const HE = "[data-hero-scrolling]",
    FE = "[data-banner-title]",
    ME = ".lazy-image",
    DE =
      '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
    OE = ".text-reveal__cropper",
    BE = "[data-aos]",
    zE = "[data-ticker-frame]",
    _E = "[data-ticker-scale]",
    $E = "[data-ticker-text]",
    RE = "data-shopify-editor-block",
    VE = "banner--no-cached-images",
    NE = "banner--img-loaded",
    WE = "img-in",
    UE = "overflow-hidden",
    jE = "text-highlight-wrapper",
    GE = "ticker--animated",
    KE = "data-stop",
    QE = "style",
    XE = {};
  rl("hero-scrolling", [
    {
      onLoad() {
        XE[this.id] = new (class {
          init() {
            if (
              (this.handleImageAnimation(!0),
              this.initTickers(!0),
              this.tickerAnimationPause(),
              this.container.matches(DE) && (this.parallax = new sp(this.container)),
              this.title && !this.title.classList.contains(jE))
            ) {
              const t = this.title.querySelector(BE);
              if (!t) return;
              const e = t.closest(OE);
              (null == e || e.classList.add(UE),
                _l(t).then(() => {
                  null == e || e.classList.remove(UE);
                }));
            }
          }
          initTickers(t = !1) {
            this.container.querySelectorAll(zE).forEach((e) => {
              const i = new _u(e, t);
              this.tickers.push(i);
            });
          }
          toggleTicker(t, e) {
            if ("scrolling_text" !== t.target.blockData.type) return;
            const i = t.target.closest(_E),
              s = i.querySelector(`[${RE}*="${t.target.blockData.id}"]`);
            (e &&
              s &&
              (i.setAttribute(KE, ""),
              i.querySelectorAll($E).forEach((t) => {
                (t.classList.remove(GE), (t.style.transform = `translate3d(${-s.offsetLeft}px, 0, 0)`));
              })),
              !e &&
                s &&
                (i.querySelectorAll($E).forEach((t) => {
                  (t.classList.add(GE), t.removeAttribute(QE));
                }),
                i.removeAttribute(KE),
                this.static && document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 }))));
          }
          onBlockSelect(t) {
            this.toggleTicker(t, !0);
          }
          onBlockDeselect(t) {
            this.toggleTicker(t, !1);
          }
          handleImageAnimation(t = !1) {
            if (!t) return (this.container.classList.remove(VE), void this.container.classList.remove(NE));
            const e = this.container.querySelector(HE).querySelectorAll(ME),
              i = this.container.classList.contains(WE);
            if (e.length && !i) {
              this.container.classList.add(VE);
              const t = (i) => {
                (requestAnimationFrame(() => this.container.classList.add(NE)),
                  e[0].removeEventListener("transitionend", t));
              };
              e[0].addEventListener("transitionend", t);
            }
          }
          onReorder() {
            this.handleImageAnimation(!1);
          }
          onUnload() {
            (this.handleImageAnimation(!1),
              this.parallax && (this.parallax.unload(), (this.parallax = null)),
              this.tickers.length > 0 &&
                this.tickers.forEach((t) => {
                  t.unload();
                }));
          }
          tickerAnimationPause() {
            let t = 0,
              e = !1;
            const i = this.container.querySelector(zE);
            i &&
              (i.addEventListener("mouseenter", () => {
                ((e = !0),
                  (t = setTimeout(() => {
                    (e &&
                      i.querySelectorAll($E).forEach((t) => {
                        t.style.animationPlayState = "paused";
                      }),
                      clearTimeout(t));
                  }, 500)));
              }),
              i.addEventListener("mouseleave", () => {
                ((e = !1),
                  i.querySelectorAll($E).forEach((t) => {
                    t.style.animationPlayState = "running";
                  }));
              }));
          }
          constructor(t) {
            ((this.container = t.container),
              (this.title = this.container.querySelector(FE)),
              (this.parallax = null),
              (this.tickers = []),
              this.init());
          }
        })(this);
      },
      onBlockSelect(t) {
        XE[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        XE[this.id].onBlockDeselect(t);
      },
      onReorder(t) {
        XE[this.id].onReorder(t);
      },
      onUnload(t) {
        XE[this.id].onUnload(t);
      },
    },
    vm,
  ]);
  const YE = "no-outline",
    JE = "[data-skip-content]",
    ZE = 'a[href="#"]';
  (document.documentElement.style.setProperty(
    "--scrollbar-width",
    `${(() => {
      const t = document.createElement("div");
      ((t.style.visibility = "hidden"),
        (t.style.overflow = "scroll"),
        (t.style.msOverflowStyle = "scrollbar"),
        document.body.appendChild(t));
      const e = document.createElement("div");
      t.appendChild(e);
      const i = t.offsetWidth - e.offsetWidth;
      return (t.parentNode.removeChild(t), i);
    })()}px`,
  ),
    document.addEventListener("DOMContentLoaded", function () {
      (al("*"),
        new (class {
          init() {
            ((this.body = document.body),
              (this.inPageLink = document.querySelector(JE)),
              (this.linkesWithOnlyHash = document.querySelectorAll(ZE)),
              (this.isFocused = !1),
              this.focusHash(),
              this.bindInPageLinks(),
              this.clickEvents(),
              this.focusEvents(),
              this.focusEventsOff());
          }
          clickEvents() {
            (this.inPageLink &&
              this.inPageLink.addEventListener("click", (t) => {
                t.preventDefault();
              }),
              this.linkesWithOnlyHash &&
                this.linkesWithOnlyHash.forEach((t) => {
                  t.addEventListener("click", (t) => {
                    t.preventDefault();
                  });
                }));
          }
          focusEvents() {
            document.addEventListener("keyup", (t) => {
              t.code === theme.keyboardKeys.TAB && (this.body.classList.remove(YE), (this.isFocused = !0));
            });
          }
          focusEventsOff() {
            document.addEventListener("mousedown", () => {
              (this.body.classList.add(YE), (this.isFocused = !1));
            });
          }
          forceFocus(t, e) {
            e = e || {};
            var i = t.tabIndex;
            ((t.tabIndex = -1),
              (t.dataset.tabIndex = i),
              t.focus(),
              void 0 !== e.className && t.classList.add(e.className),
              t.addEventListener("blur", function s(o) {
                (o.target.removeEventListener(o.type, s),
                  (t.tabIndex = i),
                  delete t.dataset.tabIndex,
                  void 0 !== e.className && t.classList.remove(e.className));
              }));
          }
          focusHash(t) {
            t = t || {};
            let e = window.location.hash;
            void 0 !== theme.settings.newHash && ((e = theme.settings.newHash), (window.location.hash = `#${e}`));
            const i = document.getElementById(e.slice(1));
            if (i && t.ignore && i.matches(t.ignore)) return !1;
            e && i && this.forceFocus(i, t);
          }
          bindInPageLinks(t) {
            return (
              (t = t || {}),
              Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((e) => {
                if ("#" === e.hash || "" === e.hash) return !1;
                if (t.ignore && e.matches(t.ignore)) return !1;
                if (((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                var i,
                  s = document.querySelector(e.hash);
                return (
                  !!s &&
                  (e.addEventListener("click", () => {
                    this.forceFocus(s, t);
                  }),
                  !0)
                );
              })
            );
          }
          constructor() {
            this.init();
          }
        })(),
        customElements.get("product-grid-item-swatch") ||
          "disabled" == window.theme.settings.colorSwatchesType ||
          customElements.define("product-grid-item-swatch", _e));
      "scrollBehavior" in document.documentElement.style || u({ url: theme.assets.smoothscroll });
    }));
})(themeVendor.ajaxinate, themeVendor.ScrollLock);
